(() => {
  var Xu = Object.defineProperty, qu = Object.defineProperties;
  var Uu = Object.getOwnPropertyDescriptors;
  var _o = Object.getOwnPropertySymbols;
  var Ku = Object.prototype.hasOwnProperty, Zu = Object.prototype.propertyIsEnumerable;
  var De = Math.pow, So = (t, e, i) => e in t ? Xu(t, e, { enumerable: true, configurable: true, writable: true, value: i }) : t[e] = i, we = (t, e) => {
    for (var i in e || (e = {})) Ku.call(e, i) && So(t, i, e[i]);
    if (_o) for (var i of _o(e)) Zu.call(e, i) && So(t, i, e[i]);
    return t;
  }, vi = (t, e) => qu(t, Uu(e));
  function Qu(t, e) {
    if (typeof t == "undefined" || !t.document) throw new Error("jQuery requires a window with a document");
    var i = [], n = Object.getPrototypeOf, r = i.slice, o = i.flat ? function(s) {
      return i.flat.call(s);
    } : function(s) {
      return i.concat.apply([], s);
    }, l = i.push, c = i.indexOf, d = {}, v = d.toString, b = d.hasOwnProperty, y = b.toString, _ = y.call(Object), p = {};
    function m(s) {
      return s == null ? s + "" : typeof s == "object" ? d[v.call(s)] || "object" : typeof s;
    }
    function C(s) {
      return s != null && s === s.window;
    }
    function S(s) {
      var a = !!s && s.length, u = m(s);
      return typeof s == "function" || C(s) ? false : u === "array" || a === 0 || typeof a == "number" && a > 0 && a - 1 in s;
    }
    var h = t.document, E = { type: true, src: true, nonce: true, noModule: true };
    function I(s, a, u) {
      u = u || h;
      var g, T = u.createElement("script");
      T.text = s;
      for (g in E) a && a[g] && (T[g] = a[g]);
      u.head.appendChild(T).parentNode && T.parentNode.removeChild(T);
    }
    var O = "4.0.0", L = /HTML$/i, f = function(s, a) {
      return new f.fn.init(s, a);
    };
    f.fn = f.prototype = { jquery: O, constructor: f, length: 0, toArray: function() {
      return r.call(this);
    }, get: function(s) {
      return s == null ? r.call(this) : s < 0 ? this[s + this.length] : this[s];
    }, pushStack: function(s) {
      var a = f.merge(this.constructor(), s);
      return a.prevObject = this, a;
    }, each: function(s) {
      return f.each(this, s);
    }, map: function(s) {
      return this.pushStack(f.map(this, function(a, u) {
        return s.call(a, u, a);
      }));
    }, slice: function() {
      return this.pushStack(r.apply(this, arguments));
    }, first: function() {
      return this.eq(0);
    }, last: function() {
      return this.eq(-1);
    }, even: function() {
      return this.pushStack(f.grep(this, function(s, a) {
        return (a + 1) % 2;
      }));
    }, odd: function() {
      return this.pushStack(f.grep(this, function(s, a) {
        return a % 2;
      }));
    }, eq: function(s) {
      var a = this.length, u = +s + (s < 0 ? a : 0);
      return this.pushStack(u >= 0 && u < a ? [this[u]] : []);
    }, end: function() {
      return this.prevObject || this.constructor();
    } }, f.extend = f.fn.extend = function() {
      var s, a, u, g, T, x, A = arguments[0] || {}, M = 1, w = arguments.length, $ = false;
      for (typeof A == "boolean" && ($ = A, A = arguments[M] || {}, M++), typeof A != "object" && typeof A != "function" && (A = {}), M === w && (A = this, M--); M < w; M++) if ((s = arguments[M]) != null) for (a in s) g = s[a], !(a === "__proto__" || A === g) && ($ && g && (f.isPlainObject(g) || (T = Array.isArray(g))) ? (u = A[a], T && !Array.isArray(u) ? x = [] : !T && !f.isPlainObject(u) ? x = {} : x = u, T = false, A[a] = f.extend($, x, g)) : g !== void 0 && (A[a] = g));
      return A;
    }, f.extend({ expando: "jQuery" + (O + Math.random()).replace(/\D/g, ""), isReady: true, error: function(s) {
      throw new Error(s);
    }, noop: function() {
    }, isPlainObject: function(s) {
      var a, u;
      return !s || v.call(s) !== "[object Object]" ? false : (a = n(s), a ? (u = b.call(a, "constructor") && a.constructor, typeof u == "function" && y.call(u) === _) : true);
    }, isEmptyObject: function(s) {
      var a;
      for (a in s) return false;
      return true;
    }, globalEval: function(s, a, u) {
      I(s, { nonce: a && a.nonce }, u);
    }, each: function(s, a) {
      var u, g = 0;
      if (S(s)) for (u = s.length; g < u && a.call(s[g], g, s[g]) !== false; g++) ;
      else for (g in s) if (a.call(s[g], g, s[g]) === false) break;
      return s;
    }, text: function(s) {
      var a, u = "", g = 0, T = s.nodeType;
      if (!T) for (; a = s[g++]; ) u += f.text(a);
      return T === 1 || T === 11 ? s.textContent : T === 9 ? s.documentElement.textContent : T === 3 || T === 4 ? s.nodeValue : u;
    }, makeArray: function(s, a) {
      var u = a || [];
      return s != null && (S(Object(s)) ? f.merge(u, typeof s == "string" ? [s] : s) : l.call(u, s)), u;
    }, inArray: function(s, a, u) {
      return a == null ? -1 : c.call(a, s, u);
    }, isXMLDoc: function(s) {
      var a = s && s.namespaceURI, u = s && (s.ownerDocument || s).documentElement;
      return !L.test(a || u && u.nodeName || "HTML");
    }, contains: function(s, a) {
      var u = a && a.parentNode;
      return s === u || !!(u && u.nodeType === 1 && (s.contains ? s.contains(u) : s.compareDocumentPosition && s.compareDocumentPosition(u) & 16));
    }, merge: function(s, a) {
      for (var u = +a.length, g = 0, T = s.length; g < u; g++) s[T++] = a[g];
      return s.length = T, s;
    }, grep: function(s, a, u) {
      for (var g, T = [], x = 0, A = s.length, M = !u; x < A; x++) g = !a(s[x], x), g !== M && T.push(s[x]);
      return T;
    }, map: function(s, a, u) {
      var g, T, x = 0, A = [];
      if (S(s)) for (g = s.length; x < g; x++) T = a(s[x], x, u), T != null && A.push(T);
      else for (x in s) T = a(s[x], x, u), T != null && A.push(T);
      return o(A);
    }, guid: 1, support: p }), typeof Symbol == "function" && (f.fn[Symbol.iterator] = i[Symbol.iterator]), f.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(s, a) {
      d["[object " + a + "]"] = a.toLowerCase();
    });
    function P(s, a) {
      return s.nodeName && s.nodeName.toLowerCase() === a.toLowerCase();
    }
    var D = i.pop, H = "[\\x20\\t\\r\\n\\f]", k = h.documentMode, z = k && new RegExp(":enabled|:disabled|\\[" + H + "*name" + H + "*=" + H + `*(?:''|"")`), B = new RegExp("^" + H + "+|((?:^|[^\\\\])(?:\\\\.)*)" + H + "+$", "g"), V = "(?:\\\\[\\da-fA-F]{1,6}" + H + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", X = new RegExp("^" + H + "*([>+~]|" + H + ")" + H + "*"), Z = new RegExp(H + "|>"), F = /[+~]/, W = h.documentElement, Y = W.matches || W.msMatchesSelector;
    function J() {
      var s = [];
      function a(u, g) {
        return s.push(u + " ") > f.expr.cacheLength && delete a[s.shift()], a[u + " "] = g;
      }
      return a;
    }
    function re(s) {
      return s && typeof s.getElementsByTagName != "undefined" && s;
    }
    var fe = "\\[" + H + "*(" + V + ")(?:" + H + "*([*^$|!~]?=)" + H + `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + V + "))|)" + H + "*\\]", _e = ":(" + V + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + fe + ")*)|.*)\\)|)", be = { ID: new RegExp("^#(" + V + ")"), CLASS: new RegExp("^\\.(" + V + ")"), TAG: new RegExp("^(" + V + "|[*])"), ATTR: new RegExp("^" + fe), PSEUDO: new RegExp("^" + _e), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + H + "*(even|odd|(([+-]|)(\\d*)n|)" + H + "*(?:([+-]|)" + H + "*(\\d+)|))" + H + "*\\)|)", "i") }, U = new RegExp(_e), Q = new RegExp("\\\\[\\da-fA-F]{1,6}" + H + "?|\\\\([^\\r\\n\\f])", "g"), ee = function(s, a) {
      var u = "0x" + s.slice(1) - 65536;
      return a || (u < 0 ? String.fromCharCode(u + 65536) : String.fromCharCode(u >> 10 | 55296, u & 1023 | 56320));
    };
    function K(s) {
      return s.replace(Q, ee);
    }
    function ne(s) {
      f.error("Syntax error, unrecognized expression: " + s);
    }
    var Ee = new RegExp("^" + H + "*," + H + "*"), Fe = J();
    function xe(s, a) {
      var u, g, T, x, A, M, w, $ = Fe[s + " "];
      if ($) return a ? 0 : $.slice(0);
      for (A = s, M = [], w = f.expr.preFilter; A; ) {
        (!u || (g = Ee.exec(A))) && (g && (A = A.slice(g[0].length) || A), M.push(T = [])), u = false, (g = X.exec(A)) && (u = g.shift(), T.push({ value: u, type: g[0].replace(B, " ") }), A = A.slice(u.length));
        for (x in be) (g = f.expr.match[x].exec(A)) && (!w[x] || (g = w[x](g))) && (u = g.shift(), T.push({ value: u, type: x, matches: g }), A = A.slice(u.length));
        if (!u) break;
      }
      return a ? A.length : A ? ne(s) : Fe(s, M).slice(0);
    }
    var Ke = { ATTR: function(s) {
      return s[1] = K(s[1]), s[3] = K(s[3] || s[4] || s[5] || ""), s[2] === "~=" && (s[3] = " " + s[3] + " "), s.slice(0, 4);
    }, CHILD: function(s) {
      return s[1] = s[1].toLowerCase(), s[1].slice(0, 3) === "nth" ? (s[3] || ne(s[0]), s[4] = +(s[4] ? s[5] + (s[6] || 1) : 2 * (s[3] === "even" || s[3] === "odd")), s[5] = +(s[7] + s[8] || s[3] === "odd")) : s[3] && ne(s[0]), s;
    }, PSEUDO: function(s) {
      var a, u = !s[6] && s[2];
      return be.CHILD.test(s[0]) ? null : (s[3] ? s[2] = s[4] || s[5] || "" : u && U.test(u) && (a = xe(u, true)) && (a = u.indexOf(")", u.length - a) - u.length) && (s[0] = s[0].slice(0, a), s[2] = u.slice(0, a)), s.slice(0, 3));
    } };
    function ge(s) {
      for (var a = 0, u = s.length, g = ""; a < u; a++) g += s[a].value;
      return g;
    }
    function ye(s, a, u, g, T, x, A) {
      var M = 0, w = s.length, $ = u == null;
      if (m(u) === "object") {
        T = true;
        for (M in u) ye(s, a, M, u[M], true, x, A);
      } else if (g !== void 0 && (T = true, typeof g != "function" && (A = true), $ && (A ? (a.call(s, g), a = null) : ($ = a, a = function(R, j, N) {
        return $.call(f(R), N);
      })), a)) for (; M < w; M++) a(s[M], u, A ? g : g.call(s[M], M, a(s[M], u)));
      return T ? s : $ ? a.call(s) : w ? a(s[0], u) : x;
    }
    var Ae = /[^\x20\t\r\n\f]+/g;
    f.fn.extend({ attr: function(s, a) {
      return ye(this, f.attr, s, a, arguments.length > 1);
    }, removeAttr: function(s) {
      return this.each(function() {
        f.removeAttr(this, s);
      });
    } }), f.extend({ attr: function(s, a, u) {
      var g, T, x = s.nodeType;
      if (!(x === 3 || x === 8 || x === 2)) {
        if (typeof s.getAttribute == "undefined") return f.prop(s, a, u);
        if ((x !== 1 || !f.isXMLDoc(s)) && (T = f.attrHooks[a.toLowerCase()]), u !== void 0) {
          if (u === null || u === false && a.toLowerCase().indexOf("aria-") !== 0) {
            f.removeAttr(s, a);
            return;
          }
          return T && "set" in T && (g = T.set(s, u, a)) !== void 0 ? g : (s.setAttribute(a, u), u);
        }
        return T && "get" in T && (g = T.get(s, a)) !== null ? g : (g = s.getAttribute(a), g == null ? void 0 : g);
      }
    }, attrHooks: {}, removeAttr: function(s, a) {
      var u, g = 0, T = a && a.match(Ae);
      if (T && s.nodeType === 1) for (; u = T[g++]; ) s.removeAttribute(u);
    } }), k && (f.attrHooks.type = { set: function(s, a) {
      if (a === "radio" && P(s, "input")) {
        var u = s.value;
        return s.setAttribute("type", a), u && (s.value = u), a;
      }
    } });
    var bt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function nt(s, a) {
      return a ? s === "\0" ? "�" : s.slice(0, -1) + "\\" + s.charCodeAt(s.length - 1).toString(16) + " " : "\\" + s;
    }
    f.escapeSelector = function(s) {
      return (s + "").replace(bt, nt);
    };
    var ct = i.sort, Mt = i.splice, Le;
    function dt(s, a) {
      if (s === a) return Le = true, 0;
      var u = !s.compareDocumentPosition - !a.compareDocumentPosition;
      return u || (u = (s.ownerDocument || s) == (a.ownerDocument || a) ? s.compareDocumentPosition(a) : 1, u & 1 ? s == h || s.ownerDocument == h && f.contains(h, s) ? -1 : a == h || a.ownerDocument == h && f.contains(h, a) ? 1 : 0 : u & 4 ? -1 : 1);
    }
    f.uniqueSort = function(s) {
      var a, u = [], g = 0, T = 0;
      if (Le = false, ct.call(s, dt), Le) {
        for (; a = s[T++]; ) a === s[T] && (g = u.push(T));
        for (; g--; ) Mt.call(s, u[g], 1);
      }
      return s;
    }, f.fn.uniqueSort = function() {
      return this.pushStack(f.uniqueSort(r.apply(this)));
    };
    var Ge, st, Te, Et, Ce, $e = 0, ft = 0, Or = J(), Mr = J(), rn = J(), Gl = new RegExp(H + "+", "g"), jl = new RegExp("^" + V + "$"), Lr = f.extend({ needsContext: new RegExp("^" + H + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + H + "*((?:-\\d)?\\d*)" + H + "*\\)|)(?=[^-]|$)", "i") }, be), Yl = /^(?:input|select|textarea|button)$/i, Xl = /^h\d$/i, ql = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, Ul = function() {
      oi();
    }, Kl = on(function(s) {
      return s.disabled === true && P(s, "fieldset");
    }, { dir: "parentNode", next: "legend" });
    function rt(s, a, u, g) {
      var T, x, A, M, w, $, R, j = a && a.ownerDocument, N = a ? a.nodeType : 9;
      if (u = u || [], typeof s != "string" || !s || N !== 1 && N !== 9 && N !== 11) return u;
      if (!g && (oi(a), a = a || Te, Ce)) {
        if (N !== 11 && (w = ql.exec(s))) if (T = w[1]) {
          if (N === 9) return (A = a.getElementById(T)) && l.call(u, A), u;
          if (j && (A = j.getElementById(T)) && f.contains(a, A)) return l.call(u, A), u;
        } else {
          if (w[2]) return l.apply(u, a.getElementsByTagName(s)), u;
          if ((T = w[3]) && a.getElementsByClassName) return l.apply(u, a.getElementsByClassName(T)), u;
        }
        if (!rn[s + " "] && (!z || !z.test(s))) {
          if (R = s, j = a, N === 1 && (Z.test(s) || X.test(s))) {
            for (j = F.test(s) && re(a.parentNode) || a, (j != a || k) && ((M = a.getAttribute("id")) ? M = f.escapeSelector(M) : a.setAttribute("id", M = f.expando)), $ = xe(s), x = $.length; x--; ) $[x] = (M ? "#" + M : ":scope") + " " + ge($[x]);
            R = $.join(",");
          }
          try {
            return l.apply(u, j.querySelectorAll(R)), u;
          } catch (G) {
            rn(s, true);
          } finally {
            M === f.expando && a.removeAttribute("id");
          }
        }
      }
      return $r(s.replace(B, "$1"), a, u, g);
    }
    function ht(s) {
      return s[f.expando] = true, s;
    }
    function Zl(s) {
      return function(a) {
        return P(a, "input") && a.type === s;
      };
    }
    function Ql(s) {
      return function(a) {
        return (P(a, "input") || P(a, "button")) && a.type === s;
      };
    }
    function Pr(s) {
      return function(a) {
        return "form" in a ? a.parentNode && a.disabled === false ? "label" in a ? "label" in a.parentNode ? a.parentNode.disabled === s : a.disabled === s : a.isDisabled === s || a.isDisabled !== !s && Kl(a) === s : a.disabled === s : "label" in a ? a.disabled === s : false;
      };
    }
    function Ft(s) {
      return ht(function(a) {
        return a = +a, ht(function(u, g) {
          for (var T, x = s([], u.length, a), A = x.length; A--; ) u[T = x[A]] && (u[T] = !(g[T] = u[T]));
        });
      });
    }
    function oi(s) {
      var a, u = s ? s.ownerDocument || s : h;
      u == Te || u.nodeType !== 9 || (Te = u, Et = Te.documentElement, Ce = !f.isXMLDoc(Te), k && h != Te && (a = Te.defaultView) && a.top !== a && a.addEventListener("unload", Ul));
    }
    rt.matches = function(s, a) {
      return rt(s, null, null, a);
    }, rt.matchesSelector = function(s, a) {
      if (oi(s), Ce && !rn[a + " "] && (!z || !z.test(a))) try {
        return Y.call(s, a);
      } catch (u) {
        rn(a, true);
      }
      return rt(a, Te, null, [s]).length > 0;
    }, f.expr = { cacheLength: 50, createPseudo: ht, match: Lr, find: { ID: function(s, a) {
      if (typeof a.getElementById != "undefined" && Ce) {
        var u = a.getElementById(s);
        return u ? [u] : [];
      }
    }, TAG: function(s, a) {
      return typeof a.getElementsByTagName != "undefined" ? a.getElementsByTagName(s) : a.querySelectorAll(s);
    }, CLASS: function(s, a) {
      if (typeof a.getElementsByClassName != "undefined" && Ce) return a.getElementsByClassName(s);
    } }, relative: { ">": { dir: "parentNode", first: true }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: true }, "~": { dir: "previousSibling" } }, preFilter: Ke, filter: { ID: function(s) {
      var a = K(s);
      return function(u) {
        return u.getAttribute("id") === a;
      };
    }, TAG: function(s) {
      var a = K(s).toLowerCase();
      return s === "*" ? function() {
        return true;
      } : function(u) {
        return P(u, a);
      };
    }, CLASS: function(s) {
      var a = Or[s + " "];
      return a || (a = new RegExp("(^|" + H + ")" + s + "(" + H + "|$)")) && Or(s, function(u) {
        return a.test(typeof u.className == "string" && u.className || typeof u.getAttribute != "undefined" && u.getAttribute("class") || "");
      });
    }, ATTR: function(s, a, u) {
      return function(g) {
        var T = f.attr(g, s);
        return T == null ? a === "!=" : a ? (T += "", a === "=" ? T === u : a === "!=" ? T !== u : a === "^=" ? u && T.indexOf(u) === 0 : a === "*=" ? u && T.indexOf(u) > -1 : a === "$=" ? u && T.slice(-u.length) === u : a === "~=" ? (" " + T.replace(Gl, " ") + " ").indexOf(u) > -1 : a === "|=" ? T === u || T.slice(0, u.length + 1) === u + "-" : false) : true;
      };
    }, CHILD: function(s, a, u, g, T) {
      var x = s.slice(0, 3) !== "nth", A = s.slice(-4) !== "last", M = a === "of-type";
      return g === 1 && T === 0 ? function(w) {
        return !!w.parentNode;
      } : function(w, $, R) {
        var j, N, G, te, ae, oe = x !== A ? "nextSibling" : "previousSibling", me = w.parentNode, he = M && w.nodeName.toLowerCase(), He = !R && !M, Pe = false;
        if (me) {
          if (x) {
            for (; oe; ) {
              for (G = w; G = G[oe]; ) if (M ? P(G, he) : G.nodeType === 1) return false;
              ae = oe = s === "only" && !ae && "nextSibling";
            }
            return true;
          }
          if (ae = [A ? me.firstChild : me.lastChild], A && He) {
            for (N = me[f.expando] || (me[f.expando] = {}), j = N[s] || [], te = j[0] === $e && j[1], Pe = te && j[2], G = te && me.childNodes[te]; G = ++te && G && G[oe] || (Pe = te = 0) || ae.pop(); ) if (G.nodeType === 1 && ++Pe && G === w) {
              N[s] = [$e, te, Pe];
              break;
            }
          } else if (He && (N = w[f.expando] || (w[f.expando] = {}), j = N[s] || [], te = j[0] === $e && j[1], Pe = te), Pe === false) for (; (G = ++te && G && G[oe] || (Pe = te = 0) || ae.pop()) && !((M ? P(G, he) : G.nodeType === 1) && ++Pe && (He && (N = G[f.expando] || (G[f.expando] = {}), N[s] = [$e, Pe]), G === w)); ) ;
          return Pe -= T, Pe === g || Pe % g === 0 && Pe / g >= 0;
        }
      };
    }, PSEUDO: function(s, a) {
      var u = f.expr.pseudos[s] || f.expr.setFilters[s.toLowerCase()] || ne("unsupported pseudo: " + s);
      return u[f.expando] ? u(a) : u;
    } }, pseudos: { not: ht(function(s) {
      var a = [], u = [], g = is(s.replace(B, "$1"));
      return g[f.expando] ? ht(function(T, x, A, M) {
        for (var w, $ = g(T, null, M, []), R = T.length; R--; ) (w = $[R]) && (T[R] = !(x[R] = w));
      }) : function(T, x, A) {
        return a[0] = T, g(a, null, A, u), a[0] = null, !u.pop();
      };
    }), has: ht(function(s) {
      return function(a) {
        return rt(s, a).length > 0;
      };
    }), contains: ht(function(s) {
      return s = K(s), function(a) {
        return (a.textContent || f.text(a)).indexOf(s) > -1;
      };
    }), lang: ht(function(s) {
      return jl.test(s || "") || ne("unsupported lang: " + s), s = K(s).toLowerCase(), function(a) {
        var u;
        do
          if (u = Ce ? a.lang : a.getAttribute("xml:lang") || a.getAttribute("lang")) return u = u.toLowerCase(), u === s || u.indexOf(s + "-") === 0;
        while ((a = a.parentNode) && a.nodeType === 1);
        return false;
      };
    }), target: function(s) {
      var a = t.location && t.location.hash;
      return a && a.slice(1) === s.id;
    }, root: function(s) {
      return s === Et;
    }, focus: function(s) {
      return s === Te.activeElement && Te.hasFocus() && !!(s.type || s.href || ~s.tabIndex);
    }, enabled: Pr(false), disabled: Pr(true), checked: function(s) {
      return P(s, "input") && !!s.checked || P(s, "option") && !!s.selected;
    }, selected: function(s) {
      return k && s.parentNode && s.parentNode.selectedIndex, s.selected === true;
    }, empty: function(s) {
      for (s = s.firstChild; s; s = s.nextSibling) if (s.nodeType < 6) return false;
      return true;
    }, parent: function(s) {
      return !f.expr.pseudos.empty(s);
    }, header: function(s) {
      return Xl.test(s.nodeName);
    }, input: function(s) {
      return Yl.test(s.nodeName);
    }, button: function(s) {
      return P(s, "input") && s.type === "button" || P(s, "button");
    }, text: function(s) {
      return P(s, "input") && s.type === "text";
    }, first: Ft(function() {
      return [0];
    }), last: Ft(function(s, a) {
      return [a - 1];
    }), eq: Ft(function(s, a, u) {
      return [u < 0 ? u + a : u];
    }), even: Ft(function(s, a) {
      for (var u = 0; u < a; u += 2) s.push(u);
      return s;
    }), odd: Ft(function(s, a) {
      for (var u = 1; u < a; u += 2) s.push(u);
      return s;
    }), lt: Ft(function(s, a, u) {
      var g;
      for (u < 0 ? g = u + a : u > a ? g = a : g = u; --g >= 0; ) s.push(g);
      return s;
    }), gt: Ft(function(s, a, u) {
      for (var g = u < 0 ? u + a : u; ++g < a; ) s.push(g);
      return s;
    }) } }, f.expr.pseudos.nth = f.expr.pseudos.eq;
    for (Ge in { radio: true, checkbox: true, file: true, password: true, image: true }) f.expr.pseudos[Ge] = Zl(Ge);
    for (Ge in { submit: true, reset: true }) f.expr.pseudos[Ge] = Ql(Ge);
    function Dr() {
    }
    Dr.prototype = f.expr.pseudos, f.expr.setFilters = new Dr();
    function on(s, a, u) {
      var g = a.dir, T = a.next, x = T || g, A = u && x === "parentNode", M = ft++;
      return a.first ? function(w, $, R) {
        for (; w = w[g]; ) if (w.nodeType === 1 || A) return s(w, $, R);
        return false;
      } : function(w, $, R) {
        var j, N, G = [$e, M];
        if (R) {
          for (; w = w[g]; ) if ((w.nodeType === 1 || A) && s(w, $, R)) return true;
        } else for (; w = w[g]; ) if (w.nodeType === 1 || A) if (N = w[f.expando] || (w[f.expando] = {}), T && P(w, T)) w = w[g] || w;
        else {
          if ((j = N[x]) && j[0] === $e && j[1] === M) return G[2] = j[2];
          if (N[x] = G, G[2] = s(w, $, R)) return true;
        }
        return false;
      };
    }
    function Jn(s) {
      return s.length > 1 ? function(a, u, g) {
        for (var T = s.length; T--; ) if (!s[T](a, u, g)) return false;
        return true;
      } : s[0];
    }
    function Jl(s, a, u) {
      for (var g = 0, T = a.length; g < T; g++) rt(s, a[g], u);
      return u;
    }
    function an(s, a, u, g, T) {
      for (var x, A = [], M = 0, w = s.length, $ = a != null; M < w; M++) (x = s[M]) && (!u || u(x, g, T)) && (A.push(x), $ && a.push(M));
      return A;
    }
    function es(s, a, u, g, T, x) {
      return g && !g[f.expando] && (g = es(g)), T && !T[f.expando] && (T = es(T, x)), ht(function(A, M, w, $) {
        var R, j, N, G, te = [], ae = [], oe = M.length, me = A || Jl(a || "*", w.nodeType ? [w] : w, []), he = s && (A || !a) ? an(me, te, s, w, $) : me;
        if (u ? (G = T || (A ? s : oe || g) ? [] : M, u(he, G, w, $)) : G = he, g) for (R = an(G, ae), g(R, [], w, $), j = R.length; j--; ) (N = R[j]) && (G[ae[j]] = !(he[ae[j]] = N));
        if (A) {
          if (T || s) {
            if (T) {
              for (R = [], j = G.length; j--; ) (N = G[j]) && R.push(he[j] = N);
              T(null, G = [], R, $);
            }
            for (j = G.length; j--; ) (N = G[j]) && (R = T ? c.call(A, N) : te[j]) > -1 && (A[R] = !(M[R] = N));
          }
        } else G = an(G === M ? G.splice(oe, G.length) : G), T ? T(null, M, G, $) : l.apply(M, G);
      });
    }
    function ts(s) {
      for (var a, u, g, T = s.length, x = f.expr.relative[s[0].type], A = x || f.expr.relative[" "], M = x ? 1 : 0, w = on(function(j) {
        return j === a;
      }, A, true), $ = on(function(j) {
        return c.call(a, j) > -1;
      }, A, true), R = [function(j, N, G) {
        var te = !x && (G || N != st) || ((a = N).nodeType ? w(j, N, G) : $(j, N, G));
        return a = null, te;
      }]; M < T; M++) if (u = f.expr.relative[s[M].type]) R = [on(Jn(R), u)];
      else {
        if (u = f.expr.filter[s[M].type].apply(null, s[M].matches), u[f.expando]) {
          for (g = ++M; g < T && !f.expr.relative[s[g].type]; g++) ;
          return es(M > 1 && Jn(R), M > 1 && ge(s.slice(0, M - 1).concat({ value: s[M - 2].type === " " ? "*" : "" })).replace(B, "$1"), u, M < g && ts(s.slice(M, g)), g < T && ts(s = s.slice(g)), g < T && ge(s));
        }
        R.push(u);
      }
      return Jn(R);
    }
    function eu(s, a) {
      var u = a.length > 0, g = s.length > 0, T = function(x, A, M, w, $) {
        var R, j, N, G = 0, te = "0", ae = x && [], oe = [], me = st, he = x || g && f.expr.find.TAG("*", $), He = $e += me == null ? 1 : Math.random() || 0.1;
        for ($ && (st = A == Te || A || $); (R = he[te]) != null; te++) {
          if (g && R) {
            for (j = 0, !A && R.ownerDocument != Te && (oi(R), M = !Ce); N = s[j++]; ) if (N(R, A || Te, M)) {
              l.call(w, R);
              break;
            }
            $ && ($e = He);
          }
          u && ((R = !N && R) && G--, x && ae.push(R));
        }
        if (G += te, u && te !== G) {
          for (j = 0; N = a[j++]; ) N(ae, oe, A, M);
          if (x) {
            if (G > 0) for (; te--; ) ae[te] || oe[te] || (oe[te] = D.call(w));
            oe = an(oe);
          }
          l.apply(w, oe), $ && !x && oe.length > 0 && G + a.length > 1 && f.uniqueSort(w);
        }
        return $ && ($e = He, st = me), ae;
      };
      return u ? ht(T) : T;
    }
    function is(s, a) {
      var u, g = [], T = [], x = Mr[s + " "];
      if (!x) {
        for (a || (a = xe(s)), u = a.length; u--; ) x = ts(a[u]), x[f.expando] ? g.push(x) : T.push(x);
        x = Mr(s, eu(T, g)), x.selector = s;
      }
      return x;
    }
    function $r(s, a, u, g) {
      var T, x, A, M, w, $ = typeof s == "function" && s, R = !g && xe(s = $.selector || s);
      if (u = u || [], R.length === 1) {
        if (x = R[0] = R[0].slice(0), x.length > 2 && (A = x[0]).type === "ID" && a.nodeType === 9 && Ce && f.expr.relative[x[1].type]) {
          if (a = (f.expr.find.ID(K(A.matches[0]), a) || [])[0], a) $ && (a = a.parentNode);
          else return u;
          s = s.slice(x.shift().value.length);
        }
        for (T = Lr.needsContext.test(s) ? 0 : x.length; T-- && (A = x[T], !f.expr.relative[M = A.type]); ) if ((w = f.expr.find[M]) && (g = w(K(A.matches[0]), F.test(x[0].type) && re(a.parentNode) || a))) {
          if (x.splice(T, 1), s = g.length && ge(x), !s) return l.apply(u, g), u;
          break;
        }
      }
      return ($ || is(s, R))(g, a, !Ce, u, !a || F.test(s) && re(a.parentNode) || a), u;
    }
    oi(), f.find = rt, rt.compile = is, rt.select = $r, rt.setDocument = oi, rt.tokenize = xe;
    function ai(s, a, u) {
      for (var g = [], T = u !== void 0; (s = s[a]) && s.nodeType !== 9; ) if (s.nodeType === 1) {
        if (T && f(s).is(u)) break;
        g.push(s);
      }
      return g;
    }
    function zr(s, a) {
      for (var u = []; s; s = s.nextSibling) s.nodeType === 1 && s !== a && u.push(s);
      return u;
    }
    var kr = f.expr.match.needsContext, Nr = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function Rr(s) {
      return s[0] === "<" && s[s.length - 1] === ">" && s.length >= 3;
    }
    function ns(s, a, u) {
      return typeof a == "function" ? f.grep(s, function(g, T) {
        return !!a.call(g, T, g) !== u;
      }) : a.nodeType ? f.grep(s, function(g) {
        return g === a !== u;
      }) : typeof a != "string" ? f.grep(s, function(g) {
        return c.call(a, g) > -1 !== u;
      }) : f.filter(a, s, u);
    }
    f.filter = function(s, a, u) {
      var g = a[0];
      return u && (s = ":not(" + s + ")"), a.length === 1 && g.nodeType === 1 ? f.find.matchesSelector(g, s) ? [g] : [] : f.find.matches(s, f.grep(a, function(T) {
        return T.nodeType === 1;
      }));
    }, f.fn.extend({ find: function(s) {
      var a, u, g = this.length, T = this;
      if (typeof s != "string") return this.pushStack(f(s).filter(function() {
        for (a = 0; a < g; a++) if (f.contains(T[a], this)) return true;
      }));
      for (u = this.pushStack([]), a = 0; a < g; a++) f.find(s, T[a], u);
      return g > 1 ? f.uniqueSort(u) : u;
    }, filter: function(s) {
      return this.pushStack(ns(this, s || [], false));
    }, not: function(s) {
      return this.pushStack(ns(this, s || [], true));
    }, is: function(s) {
      return !!ns(this, typeof s == "string" && kr.test(s) ? f(s) : s || [], false).length;
    } });
    var ln, tu = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, iu = f.fn.init = function(s, a) {
      var u, g;
      if (!s) return this;
      if (s.nodeType) return this[0] = s, this.length = 1, this;
      if (typeof s == "function") return ln.ready !== void 0 ? ln.ready(s) : s(f);
      if (u = s + "", Rr(u)) u = [null, s, null];
      else if (typeof s == "string") u = tu.exec(s);
      else return f.makeArray(s, this);
      if (u && (u[1] || !a)) if (u[1]) {
        if (a = a instanceof f ? a[0] : a, f.merge(this, f.parseHTML(u[1], a && a.nodeType ? a.ownerDocument || a : h, true)), Nr.test(u[1]) && f.isPlainObject(a)) for (u in a) typeof this[u] == "function" ? this[u](a[u]) : this.attr(u, a[u]);
        return this;
      } else return g = h.getElementById(u[2]), g && (this[0] = g, this.length = 1), this;
      else return !a || a.jquery ? (a || ln).find(s) : this.constructor(a).find(s);
    };
    iu.prototype = f.fn, ln = f(h);
    var nu = /^(?:parents|prev(?:Until|All))/, su = { children: true, contents: true, next: true, prev: true };
    f.fn.extend({ has: function(s) {
      var a = f(s, this), u = a.length;
      return this.filter(function() {
        for (var g = 0; g < u; g++) if (f.contains(this, a[g])) return true;
      });
    }, closest: function(s, a) {
      var u, g = 0, T = this.length, x = [], A = typeof s != "string" && f(s);
      if (!kr.test(s)) {
        for (; g < T; g++) for (u = this[g]; u && u !== a; u = u.parentNode) if (u.nodeType < 11 && (A ? A.index(u) > -1 : u.nodeType === 1 && f.find.matchesSelector(u, s))) {
          x.push(u);
          break;
        }
      }
      return this.pushStack(x.length > 1 ? f.uniqueSort(x) : x);
    }, index: function(s) {
      return s ? typeof s == "string" ? c.call(f(s), this[0]) : c.call(this, s.jquery ? s[0] : s) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    }, add: function(s, a) {
      return this.pushStack(f.uniqueSort(f.merge(this.get(), f(s, a))));
    }, addBack: function(s) {
      return this.add(s == null ? this.prevObject : this.prevObject.filter(s));
    } });
    function Hr(s, a) {
      for (; (s = s[a]) && s.nodeType !== 1; ) ;
      return s;
    }
    f.each({ parent: function(s) {
      var a = s.parentNode;
      return a && a.nodeType !== 11 ? a : null;
    }, parents: function(s) {
      return ai(s, "parentNode");
    }, parentsUntil: function(s, a, u) {
      return ai(s, "parentNode", u);
    }, next: function(s) {
      return Hr(s, "nextSibling");
    }, prev: function(s) {
      return Hr(s, "previousSibling");
    }, nextAll: function(s) {
      return ai(s, "nextSibling");
    }, prevAll: function(s) {
      return ai(s, "previousSibling");
    }, nextUntil: function(s, a, u) {
      return ai(s, "nextSibling", u);
    }, prevUntil: function(s, a, u) {
      return ai(s, "previousSibling", u);
    }, siblings: function(s) {
      return zr((s.parentNode || {}).firstChild, s);
    }, children: function(s) {
      return zr(s.firstChild);
    }, contents: function(s) {
      return s.contentDocument != null && n(s.contentDocument) ? s.contentDocument : (P(s, "template") && (s = s.content || s), f.merge([], s.childNodes));
    } }, function(s, a) {
      f.fn[s] = function(u, g) {
        var T = f.map(this, a, u);
        return s.slice(-5) !== "Until" && (g = u), g && typeof g == "string" && (T = f.filter(g, T)), this.length > 1 && (su[s] || f.uniqueSort(T), nu.test(s) && T.reverse()), this.pushStack(T);
      };
    });
    function ru(s) {
      var a = {};
      return f.each(s.match(Ae) || [], function(u, g) {
        a[g] = true;
      }), a;
    }
    f.Callbacks = function(s) {
      s = typeof s == "string" ? ru(s) : f.extend({}, s);
      var a, u, g, T, x = [], A = [], M = -1, w = function() {
        for (T = T || s.once, g = a = true; A.length; M = -1) for (u = A.shift(); ++M < x.length; ) x[M].apply(u[0], u[1]) === false && s.stopOnFalse && (M = x.length, u = false);
        s.memory || (u = false), a = false, T && (u ? x = [] : x = "");
      }, $ = { add: function() {
        return x && (u && !a && (M = x.length - 1, A.push(u)), (function R(j) {
          f.each(j, function(N, G) {
            typeof G == "function" ? (!s.unique || !$.has(G)) && x.push(G) : G && G.length && m(G) !== "string" && R(G);
          });
        })(arguments), u && !a && w()), this;
      }, remove: function() {
        return f.each(arguments, function(R, j) {
          for (var N; (N = f.inArray(j, x, N)) > -1; ) x.splice(N, 1), N <= M && M--;
        }), this;
      }, has: function(R) {
        return R ? f.inArray(R, x) > -1 : x.length > 0;
      }, empty: function() {
        return x && (x = []), this;
      }, disable: function() {
        return T = A = [], x = u = "", this;
      }, disabled: function() {
        return !x;
      }, lock: function() {
        return T = A = [], !u && !a && (x = u = ""), this;
      }, locked: function() {
        return !!T;
      }, fireWith: function(R, j) {
        return T || (j = j || [], j = [R, j.slice ? j.slice() : j], A.push(j), a || w()), this;
      }, fire: function() {
        return $.fireWith(this, arguments), this;
      }, fired: function() {
        return !!g;
      } };
      return $;
    };
    function li(s) {
      return s;
    }
    function un(s) {
      throw s;
    }
    function Br(s, a, u, g) {
      var T;
      try {
        s && typeof (T = s.promise) == "function" ? T.call(s).done(a).fail(u) : s && typeof (T = s.then) == "function" ? T.call(s, a, u) : a.apply(void 0, [s].slice(g));
      } catch (x) {
        u(x);
      }
    }
    f.extend({ Deferred: function(s) {
      var a = [["notify", "progress", f.Callbacks("memory"), f.Callbacks("memory"), 2], ["resolve", "done", f.Callbacks("once memory"), f.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", f.Callbacks("once memory"), f.Callbacks("once memory"), 1, "rejected"]], u = "pending", g = { state: function() {
        return u;
      }, always: function() {
        return T.done(arguments).fail(arguments), this;
      }, catch: function(x) {
        return g.then(null, x);
      }, pipe: function() {
        var x = arguments;
        return f.Deferred(function(A) {
          f.each(a, function(M, w) {
            var $ = typeof x[w[4]] == "function" && x[w[4]];
            T[w[1]](function() {
              var R = $ && $.apply(this, arguments);
              R && typeof R.promise == "function" ? R.promise().progress(A.notify).done(A.resolve).fail(A.reject) : A[w[0] + "With"](this, $ ? [R] : arguments);
            });
          }), x = null;
        }).promise();
      }, then: function(x, A, M) {
        var w = 0;
        function $(R, j, N, G) {
          return function() {
            var te = this, ae = arguments, oe = function() {
              var he, He;
              if (!(R < w)) {
                if (he = N.apply(te, ae), he === j.promise()) throw new TypeError("Thenable self-resolution");
                He = he && (typeof he == "object" || typeof he == "function") && he.then, typeof He == "function" ? G ? He.call(he, $(w, j, li, G), $(w, j, un, G)) : (w++, He.call(he, $(w, j, li, G), $(w, j, un, G), $(w, j, li, j.notifyWith))) : (N !== li && (te = void 0, ae = [he]), (G || j.resolveWith)(te, ae));
              }
            }, me = G ? oe : function() {
              try {
                oe();
              } catch (he) {
                f.Deferred.exceptionHook && f.Deferred.exceptionHook(he, me.error), R + 1 >= w && (N !== un && (te = void 0, ae = [he]), j.rejectWith(te, ae));
              }
            };
            R ? me() : (f.Deferred.getErrorHook && (me.error = f.Deferred.getErrorHook()), t.setTimeout(me));
          };
        }
        return f.Deferred(function(R) {
          a[0][3].add($(0, R, typeof M == "function" ? M : li, R.notifyWith)), a[1][3].add($(0, R, typeof x == "function" ? x : li)), a[2][3].add($(0, R, typeof A == "function" ? A : un));
        }).promise();
      }, promise: function(x) {
        return x != null ? f.extend(x, g) : g;
      } }, T = {};
      return f.each(a, function(x, A) {
        var M = A[2], w = A[5];
        g[A[1]] = M.add, w && M.add(function() {
          u = w;
        }, a[3 - x][2].disable, a[3 - x][3].disable, a[0][2].lock, a[0][3].lock), M.add(A[3].fire), T[A[0]] = function() {
          return T[A[0] + "With"](this === T ? void 0 : this, arguments), this;
        }, T[A[0] + "With"] = M.fireWith;
      }), g.promise(T), s && s.call(T, T), T;
    }, when: function(s) {
      var a = arguments.length, u = a, g = Array(u), T = r.call(arguments), x = f.Deferred(), A = function(M) {
        return function(w) {
          g[M] = this, T[M] = arguments.length > 1 ? r.call(arguments) : w, --a || x.resolveWith(g, T);
        };
      };
      if (a <= 1 && (Br(s, x.done(A(u)).resolve, x.reject, !a), x.state() === "pending" || typeof (T[u] && T[u].then) == "function")) return x.then();
      for (; u--; ) Br(T[u], A(u), x.reject);
      return x.promise();
    } });
    var ou = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    f.Deferred.exceptionHook = function(s, a) {
      s && ou.test(s.name) && t.console.warn("jQuery.Deferred exception", s, a);
    }, f.readyException = function(s) {
      t.setTimeout(function() {
        throw s;
      });
    };
    var ss = f.Deferred();
    f.fn.ready = function(s) {
      return ss.then(s).catch(function(a) {
        f.readyException(a);
      }), this;
    }, f.extend({ isReady: false, readyWait: 1, ready: function(s) {
      (s === true ? --f.readyWait : f.isReady) || (f.isReady = true, !(s !== true && --f.readyWait > 0) && ss.resolveWith(h, [f]));
    } }), f.ready.then = ss.then;
    function cn() {
      h.removeEventListener("DOMContentLoaded", cn), t.removeEventListener("load", cn), f.ready();
    }
    h.readyState !== "loading" ? t.setTimeout(f.ready) : (h.addEventListener("DOMContentLoaded", cn), t.addEventListener("load", cn));
    var au = /-([a-z])/g;
    function lu(s, a) {
      return a.toUpperCase();
    }
    function Gt(s) {
      return s.replace(au, lu);
    }
    function ki(s) {
      return s.nodeType === 1 || s.nodeType === 9 || !+s.nodeType;
    }
    function Ni() {
      this.expando = f.expando + Ni.uid++;
    }
    Ni.uid = 1, Ni.prototype = { cache: function(s) {
      var a = s[this.expando];
      return a || (a = /* @__PURE__ */ Object.create(null), ki(s) && (s.nodeType ? s[this.expando] = a : Object.defineProperty(s, this.expando, { value: a, configurable: true }))), a;
    }, set: function(s, a, u) {
      var g, T = this.cache(s);
      if (typeof a == "string") T[Gt(a)] = u;
      else for (g in a) T[Gt(g)] = a[g];
      return u;
    }, get: function(s, a) {
      return a === void 0 ? this.cache(s) : s[this.expando] && s[this.expando][Gt(a)];
    }, access: function(s, a, u) {
      return a === void 0 || a && typeof a == "string" && u === void 0 ? this.get(s, a) : (this.set(s, a, u), u !== void 0 ? u : a);
    }, remove: function(s, a) {
      var u, g = s[this.expando];
      if (g !== void 0) {
        if (a !== void 0) for (Array.isArray(a) ? a = a.map(Gt) : (a = Gt(a), a = a in g ? [a] : a.match(Ae) || []), u = a.length; u--; ) delete g[a[u]];
        (a === void 0 || f.isEmptyObject(g)) && (s.nodeType ? s[this.expando] = void 0 : delete s[this.expando]);
      }
    }, hasData: function(s) {
      var a = s[this.expando];
      return a !== void 0 && !f.isEmptyObject(a);
    } };
    var le = new Ni(), Ne = new Ni(), uu = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, cu = /[A-Z]/g;
    function du(s) {
      return s === "true" ? true : s === "false" ? false : s === "null" ? null : s === +s + "" ? +s : uu.test(s) ? JSON.parse(s) : s;
    }
    function Vr(s, a, u) {
      var g;
      if (u === void 0 && s.nodeType === 1) if (g = "data-" + a.replace(cu, "-$&").toLowerCase(), u = s.getAttribute(g), typeof u == "string") {
        try {
          u = du(u);
        } catch (T) {
        }
        Ne.set(s, a, u);
      } else u = void 0;
      return u;
    }
    f.extend({ hasData: function(s) {
      return Ne.hasData(s) || le.hasData(s);
    }, data: function(s, a, u) {
      return Ne.access(s, a, u);
    }, removeData: function(s, a) {
      Ne.remove(s, a);
    }, _data: function(s, a, u) {
      return le.access(s, a, u);
    }, _removeData: function(s, a) {
      le.remove(s, a);
    } }), f.fn.extend({ data: function(s, a) {
      var u, g, T, x = this[0], A = x && x.attributes;
      if (s === void 0) {
        if (this.length && (T = Ne.get(x), x.nodeType === 1 && !le.get(x, "hasDataAttrs"))) {
          for (u = A.length; u--; ) A[u] && (g = A[u].name, g.indexOf("data-") === 0 && (g = Gt(g.slice(5)), Vr(x, g, T[g])));
          le.set(x, "hasDataAttrs", true);
        }
        return T;
      }
      return typeof s == "object" ? this.each(function() {
        Ne.set(this, s);
      }) : ye(this, function(M) {
        var w;
        if (x && M === void 0) return w = Ne.get(x, s), w !== void 0 || (w = Vr(x, s), w !== void 0) ? w : void 0;
        this.each(function() {
          Ne.set(this, s, M);
        });
      }, null, a, arguments.length > 1, null, true);
    }, removeData: function(s) {
      return this.each(function() {
        Ne.remove(this, s);
      });
    } }), f.extend({ queue: function(s, a, u) {
      var g;
      if (s) return a = (a || "fx") + "queue", g = le.get(s, a), u && (!g || Array.isArray(u) ? g = le.set(s, a, f.makeArray(u)) : g.push(u)), g || [];
    }, dequeue: function(s, a) {
      a = a || "fx";
      var u = f.queue(s, a), g = u.length, T = u.shift(), x = f._queueHooks(s, a), A = function() {
        f.dequeue(s, a);
      };
      T === "inprogress" && (T = u.shift(), g--), T && (a === "fx" && u.unshift("inprogress"), delete x.stop, T.call(s, A, x)), !g && x && x.empty.fire();
    }, _queueHooks: function(s, a) {
      var u = a + "queueHooks";
      return le.get(s, u) || le.set(s, u, { empty: f.Callbacks("once memory").add(function() {
        le.remove(s, [a + "queue", u]);
      }) });
    } }), f.fn.extend({ queue: function(s, a) {
      var u = 2;
      return typeof s != "string" && (a = s, s = "fx", u--), arguments.length < u ? f.queue(this[0], s) : a === void 0 ? this : this.each(function() {
        var g = f.queue(this, s, a);
        f._queueHooks(this, s), s === "fx" && g[0] !== "inprogress" && f.dequeue(this, s);
      });
    }, dequeue: function(s) {
      return this.each(function() {
        f.dequeue(this, s);
      });
    }, clearQueue: function(s) {
      return this.queue(s || "fx", []);
    }, promise: function(s, a) {
      var u, g = 1, T = f.Deferred(), x = this, A = this.length, M = function() {
        --g || T.resolveWith(x, [x]);
      };
      for (typeof s != "string" && (a = s, s = void 0), s = s || "fx"; A--; ) u = le.get(x[A], s + "queueHooks"), u && u.empty && (g++, u.empty.add(M));
      return M(), T.promise(a);
    } });
    var Wr = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, Ri = new RegExp("^(?:([+-])=|)(" + Wr + ")([a-z%]*)$", "i"), Lt = ["Top", "Right", "Bottom", "Left"];
    function dn(s, a) {
      return s = a || s, s.style.display === "none" || s.style.display === "" && f.css(s, "display") === "none";
    }
    var fu = /^[a-z]/, hu = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;
    function fn(s) {
      return fu.test(s) && hu.test(s[0].toUpperCase() + s.slice(1));
    }
    function Fr(s, a, u, g) {
      var T, x, A = 20, M = g ? function() {
        return g.cur();
      } : function() {
        return f.css(s, a, "");
      }, w = M(), $ = u && u[3] || (fn(a) ? "px" : ""), R = s.nodeType && (!fn(a) || $ !== "px" && +w) && Ri.exec(f.css(s, a));
      if (R && R[3] !== $) {
        for (w = w / 2, $ = $ || R[3], R = +w || 1; A--; ) f.style(s, a, R + $), (1 - x) * (1 - (x = M() / w || 0.5)) <= 0 && (A = 0), R = R / x;
        R = R * 2, f.style(s, a, R + $), u = u || [];
      }
      return u && (R = +R || +w || 0, T = u[1] ? R + (u[1] + 1) * u[2] : +u[2], g && (g.unit = $, g.start = R, g.end = T)), T;
    }
    var pu = /^-ms-/;
    function rs(s) {
      return Gt(s.replace(pu, "ms-"));
    }
    var Gr = {};
    function gu(s) {
      var a, u = s.ownerDocument, g = s.nodeName, T = Gr[g];
      return T || (a = u.body.appendChild(u.createElement(g)), T = f.css(a, "display"), a.parentNode.removeChild(a), T === "none" && (T = "block"), Gr[g] = T, T);
    }
    function ui(s, a) {
      for (var u, g, T = [], x = 0, A = s.length; x < A; x++) g = s[x], g.style && (u = g.style.display, a ? (u === "none" && (T[x] = le.get(g, "display") || null, T[x] || (g.style.display = "")), g.style.display === "" && dn(g) && (T[x] = gu(g))) : u !== "none" && (T[x] = "none", le.set(g, "display", u)));
      for (x = 0; x < A; x++) T[x] != null && (s[x].style.display = T[x]);
      return s;
    }
    f.fn.extend({ show: function() {
      return ui(this, true);
    }, hide: function() {
      return ui(this);
    }, toggle: function(s) {
      return typeof s == "boolean" ? s ? this.show() : this.hide() : this.each(function() {
        dn(this) ? f(this).show() : f(this).hide();
      });
    } });
    var Hi = function(s) {
      return f.contains(s.ownerDocument, s) || s.getRootNode(mu) === s.ownerDocument;
    }, mu = { composed: true };
    W.getRootNode || (Hi = function(s) {
      return f.contains(s.ownerDocument, s);
    });
    var jr = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, Tt = { thead: ["table"], col: ["colgroup", "table"], tr: ["tbody", "table"], td: ["tr", "tbody", "table"] };
    Tt.tbody = Tt.tfoot = Tt.colgroup = Tt.caption = Tt.thead, Tt.th = Tt.td;
    function Re(s, a) {
      var u;
      return typeof s.getElementsByTagName != "undefined" ? u = i.slice.call(s.getElementsByTagName(a || "*")) : typeof s.querySelectorAll != "undefined" ? u = s.querySelectorAll(a || "*") : u = [], a === void 0 || a && P(s, a) ? f.merge([s], u) : u;
    }
    var Yr = /^$|^module$|\/(?:java|ecma)script/i;
    function os(s, a) {
      for (var u = 0, g = s.length; u < g; u++) le.set(s[u], "globalEval", !a || le.get(a[u], "globalEval"));
    }
    var vu = /<|&#?\w+;/;
    function Xr(s, a, u, g, T) {
      for (var x, A, M, w, $, R, j = a.createDocumentFragment(), N = [], G = 0, te = s.length; G < te; G++) if (x = s[G], x || x === 0) if (m(x) === "object" && (x.nodeType || S(x))) f.merge(N, x.nodeType ? [x] : x);
      else if (!vu.test(x)) N.push(a.createTextNode(x));
      else {
        for (A = A || j.appendChild(a.createElement("div")), M = (jr.exec(x) || ["", ""])[1].toLowerCase(), w = Tt[M] || i, R = w.length; --R > -1; ) A = A.appendChild(a.createElement(w[R]));
        A.innerHTML = f.htmlPrefilter(x), f.merge(N, A.childNodes), A = j.firstChild, A.textContent = "";
      }
      for (j.textContent = "", G = 0; x = N[G++]; ) {
        if (g && f.inArray(x, g) > -1) {
          T && T.push(x);
          continue;
        }
        if ($ = Hi(x), A = Re(j.appendChild(x), "script"), $ && os(A), u) for (R = 0; x = A[R++]; ) Yr.test(x.type || "") && u.push(x);
      }
      return j;
    }
    function yu(s) {
      return s.type = (s.getAttribute("type") !== null) + "/" + s.type, s;
    }
    function bu(s) {
      return (s.type || "").slice(0, 5) === "true/" ? s.type = s.type.slice(5) : s.removeAttribute("type"), s;
    }
    function ci(s, a, u, g) {
      a = o(a);
      var T, x, A, M, w, $, R = 0, j = s.length, N = j - 1, G = a[0], te = typeof G == "function";
      if (te) return s.each(function(ae) {
        var oe = s.eq(ae);
        a[0] = G.call(this, ae, oe.html()), ci(oe, a, u, g);
      });
      if (j && (T = Xr(a, s[0].ownerDocument, false, s, g), x = T.firstChild, T.childNodes.length === 1 && (T = x), x || g)) {
        for (A = f.map(Re(T, "script"), yu), M = A.length; R < j; R++) w = T, R !== N && (w = f.clone(w, true, true), M && f.merge(A, Re(w, "script"))), u.call(s[R], w, R);
        if (M) for ($ = A[A.length - 1].ownerDocument, f.map(A, bu), R = 0; R < M; R++) w = A[R], Yr.test(w.type || "") && !le.get(w, "globalEval") && f.contains($, w) && (w.src && (w.type || "").toLowerCase() !== "module" ? f._evalUrl && !w.noModule && f._evalUrl(w.src, { nonce: w.nonce, crossOrigin: w.crossOrigin }, $) : I(w.textContent, w, $));
      }
      return s;
    }
    var hn = /^(?:checkbox|radio)$/i, qr = /^([^.]*)(?:\.(.+)|)/;
    function di() {
      return true;
    }
    function fi() {
      return false;
    }
    function as(s, a, u, g, T, x) {
      var A, M;
      if (typeof a == "object") {
        typeof u != "string" && (g = g || u, u = void 0);
        for (M in a) as(s, M, u, g, a[M], x);
        return s;
      }
      if (g == null && T == null ? (T = u, g = u = void 0) : T == null && (typeof u == "string" ? (T = g, g = void 0) : (T = g, g = u, u = void 0)), T === false) T = fi;
      else if (!T) return s;
      return x === 1 && (A = T, T = function(w) {
        return f().off(w), A.apply(this, arguments);
      }, T.guid = A.guid || (A.guid = f.guid++)), s.each(function() {
        f.event.add(this, a, T, g, u);
      });
    }
    f.event = { add: function(s, a, u, g, T) {
      var x, A, M, w, $, R, j, N, G, te, ae, oe = le.get(s);
      if (ki(s)) for (u.handler && (x = u, u = x.handler, T = x.selector), T && f.find.matchesSelector(W, T), u.guid || (u.guid = f.guid++), (w = oe.events) || (w = oe.events = /* @__PURE__ */ Object.create(null)), (A = oe.handle) || (A = oe.handle = function(me) {
        return typeof f != "undefined" && f.event.triggered !== me.type ? f.event.dispatch.apply(s, arguments) : void 0;
      }), a = (a || "").match(Ae) || [""], $ = a.length; $--; ) M = qr.exec(a[$]) || [], G = ae = M[1], te = (M[2] || "").split(".").sort(), G && (j = f.event.special[G] || {}, G = (T ? j.delegateType : j.bindType) || G, j = f.event.special[G] || {}, R = f.extend({ type: G, origType: ae, data: g, handler: u, guid: u.guid, selector: T, needsContext: T && f.expr.match.needsContext.test(T), namespace: te.join(".") }, x), (N = w[G]) || (N = w[G] = [], N.delegateCount = 0, (!j.setup || j.setup.call(s, g, te, A) === false) && s.addEventListener && s.addEventListener(G, A)), j.add && (j.add.call(s, R), R.handler.guid || (R.handler.guid = u.guid)), T ? N.splice(N.delegateCount++, 0, R) : N.push(R));
    }, remove: function(s, a, u, g, T) {
      var x, A, M, w, $, R, j, N, G, te, ae, oe = le.hasData(s) && le.get(s);
      if (!(!oe || !(w = oe.events))) {
        for (a = (a || "").match(Ae) || [""], $ = a.length; $--; ) {
          if (M = qr.exec(a[$]) || [], G = ae = M[1], te = (M[2] || "").split(".").sort(), !G) {
            for (G in w) f.event.remove(s, G + a[$], u, g, true);
            continue;
          }
          for (j = f.event.special[G] || {}, G = (g ? j.delegateType : j.bindType) || G, N = w[G] || [], M = M[2] && new RegExp("(^|\\.)" + te.join("\\.(?:.*\\.|)") + "(\\.|$)"), A = x = N.length; x--; ) R = N[x], (T || ae === R.origType) && (!u || u.guid === R.guid) && (!M || M.test(R.namespace)) && (!g || g === R.selector || g === "**" && R.selector) && (N.splice(x, 1), R.selector && N.delegateCount--, j.remove && j.remove.call(s, R));
          A && !N.length && ((!j.teardown || j.teardown.call(s, te, oe.handle) === false) && f.removeEvent(s, G, oe.handle), delete w[G]);
        }
        f.isEmptyObject(w) && le.remove(s, "handle events");
      }
    }, dispatch: function(s) {
      var a, u, g, T, x, A, M = new Array(arguments.length), w = f.event.fix(s), $ = (le.get(this, "events") || /* @__PURE__ */ Object.create(null))[w.type] || [], R = f.event.special[w.type] || {};
      for (M[0] = w, a = 1; a < arguments.length; a++) M[a] = arguments[a];
      if (w.delegateTarget = this, !(R.preDispatch && R.preDispatch.call(this, w) === false)) {
        for (A = f.event.handlers.call(this, w, $), a = 0; (T = A[a++]) && !w.isPropagationStopped(); ) for (w.currentTarget = T.elem, u = 0; (x = T.handlers[u++]) && !w.isImmediatePropagationStopped(); ) (!w.rnamespace || x.namespace === false || w.rnamespace.test(x.namespace)) && (w.handleObj = x, w.data = x.data, g = ((f.event.special[x.origType] || {}).handle || x.handler).apply(T.elem, M), g !== void 0 && (w.result = g) === false && (w.preventDefault(), w.stopPropagation()));
        return R.postDispatch && R.postDispatch.call(this, w), w.result;
      }
    }, handlers: function(s, a) {
      var u, g, T, x, A, M = [], w = a.delegateCount, $ = s.target;
      if (w && !(s.type === "click" && s.button >= 1)) {
        for (; $ !== this; $ = $.parentNode || this) if ($.nodeType === 1 && !(s.type === "click" && $.disabled === true)) {
          for (x = [], A = {}, u = 0; u < w; u++) g = a[u], T = g.selector + " ", A[T] === void 0 && (A[T] = g.needsContext ? f(T, this).index($) > -1 : f.find(T, this, null, [$]).length), A[T] && x.push(g);
          x.length && M.push({ elem: $, handlers: x });
        }
      }
      return $ = this, w < a.length && M.push({ elem: $, handlers: a.slice(w) }), M;
    }, addProp: function(s, a) {
      Object.defineProperty(f.Event.prototype, s, { enumerable: true, configurable: true, get: typeof a == "function" ? function() {
        if (this.originalEvent) return a(this.originalEvent);
      } : function() {
        if (this.originalEvent) return this.originalEvent[s];
      }, set: function(u) {
        Object.defineProperty(this, s, { enumerable: true, configurable: true, writable: true, value: u });
      } });
    }, fix: function(s) {
      return s[f.expando] ? s : new f.Event(s);
    }, special: f.extend(/* @__PURE__ */ Object.create(null), { load: { noBubble: true }, click: { setup: function(s) {
      var a = this || s;
      return hn.test(a.type) && a.click && P(a, "input") && pn(a, "click", true), false;
    }, trigger: function(s) {
      var a = this || s;
      return hn.test(a.type) && a.click && P(a, "input") && pn(a, "click"), true;
    }, _default: function(s) {
      var a = s.target;
      return hn.test(a.type) && a.click && P(a, "input") && le.get(a, "click") || P(a, "a");
    } }, beforeunload: { postDispatch: function(s) {
      s.result !== void 0 && s.preventDefault();
    } } }) };
    function pn(s, a, u) {
      if (!u) {
        le.get(s, a) === void 0 && f.event.add(s, a, di);
        return;
      }
      le.set(s, a, false), f.event.add(s, a, { namespace: false, handler: function(g) {
        var T, x = le.get(this, a);
        if (g.isTrigger & 1 && this[a]) {
          if (x.length) (f.event.special[a] || {}).delegateType && g.stopPropagation();
          else if (x = r.call(arguments), le.set(this, a, x), this[a](), T = le.get(this, a), le.set(this, a, false), x !== T) return g.stopImmediatePropagation(), g.preventDefault(), T && T.value;
        } else x.length && (le.set(this, a, { value: f.event.trigger(x[0], x.slice(1), this) }), g.stopPropagation(), g.isImmediatePropagationStopped = di);
      } });
    }
    f.removeEvent = function(s, a, u) {
      s.removeEventListener && s.removeEventListener(a, u);
    }, f.Event = function(s, a) {
      if (!(this instanceof f.Event)) return new f.Event(s, a);
      s && s.type ? (this.originalEvent = s, this.type = s.type, this.isDefaultPrevented = s.defaultPrevented ? di : fi, this.target = s.target, this.currentTarget = s.currentTarget, this.relatedTarget = s.relatedTarget) : this.type = s, a && f.extend(this, a), this.timeStamp = s && s.timeStamp || Date.now(), this[f.expando] = true;
    }, f.Event.prototype = { constructor: f.Event, isDefaultPrevented: fi, isPropagationStopped: fi, isImmediatePropagationStopped: fi, isSimulated: false, preventDefault: function() {
      var s = this.originalEvent;
      this.isDefaultPrevented = di, s && !this.isSimulated && s.preventDefault();
    }, stopPropagation: function() {
      var s = this.originalEvent;
      this.isPropagationStopped = di, s && !this.isSimulated && s.stopPropagation();
    }, stopImmediatePropagation: function() {
      var s = this.originalEvent;
      this.isImmediatePropagationStopped = di, s && !this.isSimulated && s.stopImmediatePropagation(), this.stopPropagation();
    } }, f.each({ altKey: true, bubbles: true, cancelable: true, changedTouches: true, ctrlKey: true, detail: true, eventPhase: true, metaKey: true, pageX: true, pageY: true, shiftKey: true, view: true, char: true, code: true, charCode: true, key: true, keyCode: true, button: true, buttons: true, clientX: true, clientY: true, offsetX: true, offsetY: true, pointerId: true, pointerType: true, screenX: true, screenY: true, targetTouches: true, toElement: true, touches: true, which: true }, f.event.addProp), f.each({ focus: "focusin", blur: "focusout" }, function(s, a) {
      function u(g) {
        var T = f.event.fix(g);
        T.type = g.type === "focusin" ? "focus" : "blur", T.isSimulated = true, T.target === T.currentTarget && le.get(this, "handle")(T);
      }
      f.event.special[s] = { setup: function() {
        if (pn(this, s, true), k) this.addEventListener(a, u);
        else return false;
      }, trigger: function() {
        return pn(this, s), true;
      }, teardown: function() {
        if (k) this.removeEventListener(a, u);
        else return false;
      }, _default: function(g) {
        return le.get(g.target, s);
      }, delegateType: a };
    }), f.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function(s, a) {
      f.event.special[s] = { delegateType: a, bindType: a, handle: function(u) {
        var g, T = this, x = u.relatedTarget, A = u.handleObj;
        return (!x || x !== T && !f.contains(T, x)) && (u.type = A.origType, g = A.handler.apply(this, arguments), u.type = a), g;
      } };
    }), f.fn.extend({ on: function(s, a, u, g) {
      return as(this, s, a, u, g);
    }, one: function(s, a, u, g) {
      return as(this, s, a, u, g, 1);
    }, off: function(s, a, u) {
      var g, T;
      if (s && s.preventDefault && s.handleObj) return g = s.handleObj, f(s.delegateTarget).off(g.namespace ? g.origType + "." + g.namespace : g.origType, g.selector, g.handler), this;
      if (typeof s == "object") {
        for (T in s) this.off(T, a, s[T]);
        return this;
      }
      return (a === false || typeof a == "function") && (u = a, a = void 0), u === false && (u = fi), this.each(function() {
        f.event.remove(this, s, u, a);
      });
    } });
    var Eu = /<script|<style|<link/i;
    function Ur(s, a) {
      return P(s, "table") && P(a.nodeType !== 11 ? a : a.firstChild, "tr") && f(s).children("tbody")[0] || s;
    }
    function Kr(s, a) {
      var u, g, T, x = le.get(s, "events");
      if (a.nodeType === 1) {
        if (x) {
          le.remove(a, "handle events");
          for (u in x) for (g = 0, T = x[u].length; g < T; g++) f.event.add(a, u, x[u][g]);
        }
        Ne.hasData(s) && Ne.set(a, f.extend({}, Ne.get(s)));
      }
    }
    function Zr(s, a, u) {
      for (var g, T = a ? f.filter(a, s) : s, x = 0; (g = T[x]) != null; x++) !u && g.nodeType === 1 && f.cleanData(Re(g)), g.parentNode && (u && Hi(g) && os(Re(g, "script")), g.parentNode.removeChild(g));
      return s;
    }
    f.extend({ htmlPrefilter: function(s) {
      return s;
    }, clone: function(s, a, u) {
      var g, T, x, A, M = s.cloneNode(true), w = Hi(s);
      if (k && (s.nodeType === 1 || s.nodeType === 11) && !f.isXMLDoc(s)) for (A = Re(M), x = Re(s), g = 0, T = x.length; g < T; g++) P(A[g], "textarea") && (A[g].defaultValue = x[g].defaultValue);
      if (a) if (u) for (x = x || Re(s), A = A || Re(M), g = 0, T = x.length; g < T; g++) Kr(x[g], A[g]);
      else Kr(s, M);
      return A = Re(M, "script"), A.length > 0 && os(A, !w && Re(s, "script")), M;
    }, cleanData: function(s) {
      for (var a, u, g, T = f.event.special, x = 0; (u = s[x]) !== void 0; x++) if (ki(u)) {
        if (a = u[le.expando]) {
          if (a.events) for (g in a.events) T[g] ? f.event.remove(u, g) : f.removeEvent(u, g, a.handle);
          u[le.expando] = void 0;
        }
        u[Ne.expando] && (u[Ne.expando] = void 0);
      }
    } }), f.fn.extend({ detach: function(s) {
      return Zr(this, s, true);
    }, remove: function(s) {
      return Zr(this, s);
    }, text: function(s) {
      return ye(this, function(a) {
        return a === void 0 ? f.text(this) : this.empty().each(function() {
          (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) && (this.textContent = a);
        });
      }, null, s, arguments.length);
    }, append: function() {
      return ci(this, arguments, function(s) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var a = Ur(this, s);
          a.appendChild(s);
        }
      });
    }, prepend: function() {
      return ci(this, arguments, function(s) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var a = Ur(this, s);
          a.insertBefore(s, a.firstChild);
        }
      });
    }, before: function() {
      return ci(this, arguments, function(s) {
        this.parentNode && this.parentNode.insertBefore(s, this);
      });
    }, after: function() {
      return ci(this, arguments, function(s) {
        this.parentNode && this.parentNode.insertBefore(s, this.nextSibling);
      });
    }, empty: function() {
      for (var s, a = 0; (s = this[a]) != null; a++) s.nodeType === 1 && (f.cleanData(Re(s, false)), s.textContent = "");
      return this;
    }, clone: function(s, a) {
      return s = s == null ? false : s, a = a == null ? s : a, this.map(function() {
        return f.clone(this, s, a);
      });
    }, html: function(s) {
      return ye(this, function(a) {
        var u = this[0] || {}, g = 0, T = this.length;
        if (a === void 0 && u.nodeType === 1) return u.innerHTML;
        if (typeof a == "string" && !Eu.test(a) && !Tt[(jr.exec(a) || ["", ""])[1].toLowerCase()]) {
          a = f.htmlPrefilter(a);
          try {
            for (; g < T; g++) u = this[g] || {}, u.nodeType === 1 && (f.cleanData(Re(u, false)), u.innerHTML = a);
            u = 0;
          } catch (x) {
          }
        }
        u && this.empty().append(a);
      }, null, s, arguments.length);
    }, replaceWith: function() {
      var s = [];
      return ci(this, arguments, function(a) {
        var u = this.parentNode;
        f.inArray(this, s) < 0 && (f.cleanData(Re(this)), u && u.replaceChild(a, this));
      }, s);
    } }), f.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function(s, a) {
      f.fn[s] = function(u) {
        for (var g, T = [], x = f(u), A = x.length - 1, M = 0; M <= A; M++) g = M === A ? this : this.clone(true), f(x[M])[a](g), l.apply(T, g);
        return this.pushStack(T);
      };
    });
    var Tu = new RegExp("^(" + Wr + ")(?!px)[a-z%]+$", "i"), ls = /^--/;
    function gn(s) {
      var a = s.ownerDocument.defaultView;
      return a || (a = t), a.getComputedStyle(s);
    }
    function _u(s, a, u) {
      var g, T, x = {};
      for (T in a) x[T] = s.style[T], s.style[T] = a[T];
      g = u.call(s);
      for (T in a) s.style[T] = x[T];
      return g;
    }
    function Qr(s, a, u) {
      var g, T = ls.test(a);
      return u = u || gn(s), u && (g = u.getPropertyValue(a) || u[a], T && g && (g = g.replace(B, "$1") || void 0), g === "" && !Hi(s) && (g = f.style(s, a))), g !== void 0 ? g + "" : g;
    }
    var Jr = ["Webkit", "Moz", "ms"], eo = h.createElement("div").style;
    function Su(s) {
      for (var a = s[0].toUpperCase() + s.slice(1), u = Jr.length; u--; ) if (s = Jr[u] + a, s in eo) return s;
    }
    function us(s) {
      return s in eo ? s : Su(s) || s;
    }
    var to, io, Pt = h.createElement("table");
    function no() {
      if (!(!Pt || !Pt.style)) {
        var s, a = h.createElement("col"), u = h.createElement("tr"), g = h.createElement("td");
        if (Pt.style.cssText = "position:absolute;left:-11111px;border-collapse:separate;border-spacing:0", u.style.cssText = "box-sizing:content-box;border:1px solid;height:1px", g.style.cssText = "height:9px;width:9px;padding:0", a.span = 2, W.appendChild(Pt).appendChild(a).parentNode.appendChild(u).appendChild(g).parentNode.appendChild(g.cloneNode(true)), Pt.offsetWidth === 0) {
          W.removeChild(Pt);
          return;
        }
        s = t.getComputedStyle(u), io = k || Math.round(parseFloat(t.getComputedStyle(a).width)) === 18, to = Math.round(parseFloat(s.height) + parseFloat(s.borderTopWidth) + parseFloat(s.borderBottomWidth)) === u.offsetHeight, W.removeChild(Pt), Pt = null;
      }
    }
    f.extend(p, { reliableTrDimensions: function() {
      return no(), to;
    }, reliableColDimensions: function() {
      return no(), io;
    } });
    var xu = { position: "absolute", visibility: "hidden", display: "block" }, so = { letterSpacing: "0", fontWeight: "400" };
    function ro(s, a, u) {
      var g = Ri.exec(a);
      return g ? Math.max(0, g[2] - (u || 0)) + (g[3] || "px") : a;
    }
    function oo(s, a, u, g, T, x) {
      var A = a === "width" ? 1 : 0, M = 0, w = 0, $ = 0;
      if (u === (g ? "border" : "content")) return 0;
      for (; A < 4; A += 2) u === "margin" && ($ += f.css(s, u + Lt[A], true, T)), g ? (u === "content" && (w -= f.css(s, "padding" + Lt[A], true, T)), u !== "margin" && (w -= f.css(s, "border" + Lt[A] + "Width", true, T))) : (w += f.css(s, "padding" + Lt[A], true, T), u !== "padding" ? w += f.css(s, "border" + Lt[A] + "Width", true, T) : M += f.css(s, "border" + Lt[A] + "Width", true, T));
      return !g && x >= 0 && (w += Math.max(0, Math.ceil(s["offset" + a[0].toUpperCase() + a.slice(1)] - x - w - M - 0.5)) || 0), w + $;
    }
    function ao(s, a, u) {
      var g = gn(s), T = k || u, x = T && f.css(s, "boxSizing", false, g) === "border-box", A = x, M = Qr(s, a, g), w = "offset" + a[0].toUpperCase() + a.slice(1);
      if (Tu.test(M)) {
        if (!u) return M;
        M = "auto";
      }
      return (M === "auto" || k && x || !p.reliableColDimensions() && P(s, "col") || !p.reliableTrDimensions() && P(s, "tr")) && s.getClientRects().length && (x = f.css(s, "boxSizing", false, g) === "border-box", A = w in s, A && (M = s[w])), M = parseFloat(M) || 0, M + oo(s, a, u || (x ? "border" : "content"), A, g, M) + "px";
    }
    f.extend({ cssHooks: {}, style: function(s, a, u, g) {
      if (!(!s || s.nodeType === 3 || s.nodeType === 8 || !s.style)) {
        var T, x, A, M = rs(a), w = ls.test(a), $ = s.style;
        if (w || (a = us(M)), A = f.cssHooks[a] || f.cssHooks[M], u !== void 0) {
          if (x = typeof u, x === "string" && (T = Ri.exec(u)) && T[1] && (u = Fr(s, a, T), x = "number"), u == null || u !== u) return;
          x === "number" && (u += T && T[3] || (fn(M) ? "px" : "")), k && u === "" && a.indexOf("background") === 0 && ($[a] = "inherit"), (!A || !("set" in A) || (u = A.set(s, u, g)) !== void 0) && (w ? $.setProperty(a, u) : $[a] = u);
        } else return A && "get" in A && (T = A.get(s, false, g)) !== void 0 ? T : $[a];
      }
    }, css: function(s, a, u, g) {
      var T, x, A, M = rs(a), w = ls.test(a);
      return w || (a = us(M)), A = f.cssHooks[a] || f.cssHooks[M], A && "get" in A && (T = A.get(s, true, u)), T === void 0 && (T = Qr(s, a, g)), T === "normal" && a in so && (T = so[a]), u === "" || u ? (x = parseFloat(T), u === true || isFinite(x) ? x || 0 : T) : T;
    } }), f.each(["height", "width"], function(s, a) {
      f.cssHooks[a] = { get: function(u, g, T) {
        if (g) return f.css(u, "display") === "none" ? _u(u, xu, function() {
          return ao(u, a, T);
        }) : ao(u, a, T);
      }, set: function(u, g, T) {
        var x, A = gn(u), M = T && f.css(u, "boxSizing", false, A) === "border-box", w = T ? oo(u, a, T, M, A) : 0;
        return w && (x = Ri.exec(g)) && (x[3] || "px") !== "px" && (u.style[a] = g, g = f.css(u, a)), ro(u, g, w);
      } };
    }), f.each({ margin: "", padding: "", border: "Width" }, function(s, a) {
      f.cssHooks[s + a] = { expand: function(u) {
        for (var g = 0, T = {}, x = typeof u == "string" ? u.split(" ") : [u]; g < 4; g++) T[s + Lt[g] + a] = x[g] || x[g - 2] || x[0];
        return T;
      } }, s !== "margin" && (f.cssHooks[s + a].set = ro);
    }), f.fn.extend({ css: function(s, a) {
      return ye(this, function(u, g, T) {
        var x, A, M = {}, w = 0;
        if (Array.isArray(g)) {
          for (x = gn(u), A = g.length; w < A; w++) M[g[w]] = f.css(u, g[w], false, x);
          return M;
        }
        return T !== void 0 ? f.style(u, g, T) : f.css(u, g);
      }, s, a, arguments.length > 1);
    } });
    function Ze(s, a, u, g, T) {
      return new Ze.prototype.init(s, a, u, g, T);
    }
    f.Tween = Ze, Ze.prototype = { constructor: Ze, init: function(s, a, u, g, T, x) {
      this.elem = s, this.prop = u, this.easing = T || f.easing._default, this.options = a, this.start = this.now = this.cur(), this.end = g, this.unit = x || (fn(u) ? "px" : "");
    }, cur: function() {
      var s = Ze.propHooks[this.prop];
      return s && s.get ? s.get(this) : Ze.propHooks._default.get(this);
    }, run: function(s) {
      var a, u = Ze.propHooks[this.prop];
      return this.options.duration ? this.pos = a = f.easing[this.easing](s, this.options.duration * s, 0, 1, this.options.duration) : this.pos = a = s, this.now = (this.end - this.start) * a + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), u && u.set ? u.set(this) : Ze.propHooks._default.set(this), this;
    } }, Ze.prototype.init.prototype = Ze.prototype, Ze.propHooks = { _default: { get: function(s) {
      var a;
      return s.elem.nodeType !== 1 || s.elem[s.prop] != null && s.elem.style[s.prop] == null ? s.elem[s.prop] : (a = f.css(s.elem, s.prop, ""), !a || a === "auto" ? 0 : a);
    }, set: function(s) {
      f.fx.step[s.prop] ? f.fx.step[s.prop](s) : s.elem.nodeType === 1 && (f.cssHooks[s.prop] || s.elem.style[us(s.prop)] != null) ? f.style(s.elem, s.prop, s.now + s.unit) : s.elem[s.prop] = s.now;
    } } }, f.easing = { linear: function(s) {
      return s;
    }, swing: function(s) {
      return 0.5 - Math.cos(s * Math.PI) / 2;
    }, _default: "swing" }, f.fx = Ze.prototype.init, f.fx.step = {};
    var hi, mn, Cu = /^(?:toggle|show|hide)$/, Iu = /queueHooks$/;
    function cs() {
      mn && (h.hidden === false && t.requestAnimationFrame ? t.requestAnimationFrame(cs) : t.setTimeout(cs, 13), f.fx.tick());
    }
    function lo() {
      return t.setTimeout(function() {
        hi = void 0;
      }), hi = Date.now();
    }
    function vn(s, a) {
      var u, g = 0, T = { height: s };
      for (a = a ? 1 : 0; g < 4; g += 2 - a) u = Lt[g], T["margin" + u] = T["padding" + u] = s;
      return a && (T.opacity = T.width = s), T;
    }
    function uo(s, a, u) {
      for (var g, T = (ot.tweeners[a] || []).concat(ot.tweeners["*"]), x = 0, A = T.length; x < A; x++) if (g = T[x].call(u, a, s)) return g;
    }
    function Au(s, a, u) {
      var g, T, x, A, M, w, $, R, j = "width" in a || "height" in a, N = this, G = {}, te = s.style, ae = s.nodeType && dn(s), oe = le.get(s, "fxshow");
      u.queue || (A = f._queueHooks(s, "fx"), A.unqueued == null && (A.unqueued = 0, M = A.empty.fire, A.empty.fire = function() {
        A.unqueued || M();
      }), A.unqueued++, N.always(function() {
        N.always(function() {
          A.unqueued--, f.queue(s, "fx").length || A.empty.fire();
        });
      }));
      for (g in a) if (T = a[g], Cu.test(T)) {
        if (delete a[g], x = x || T === "toggle", T === (ae ? "hide" : "show")) if (T === "show" && oe && oe[g] !== void 0) ae = true;
        else continue;
        G[g] = oe && oe[g] || f.style(s, g);
      }
      if (w = !f.isEmptyObject(a), !(!w && f.isEmptyObject(G))) {
        j && s.nodeType === 1 && (u.overflow = [te.overflow, te.overflowX, te.overflowY], $ = oe && oe.display, $ == null && ($ = le.get(s, "display")), R = f.css(s, "display"), R === "none" && ($ ? R = $ : (ui([s], true), $ = s.style.display || $, R = f.css(s, "display"), ui([s]))), (R === "inline" || R === "inline-block" && $ != null) && f.css(s, "float") === "none" && (w || (N.done(function() {
          te.display = $;
        }), $ == null && (R = te.display, $ = R === "none" ? "" : R)), te.display = "inline-block")), u.overflow && (te.overflow = "hidden", N.always(function() {
          te.overflow = u.overflow[0], te.overflowX = u.overflow[1], te.overflowY = u.overflow[2];
        })), w = false;
        for (g in G) w || (oe ? "hidden" in oe && (ae = oe.hidden) : oe = le.set(s, "fxshow", { display: $ }), x && (oe.hidden = !ae), ae && ui([s], true), N.done(function() {
          ae || ui([s]), le.remove(s, "fxshow");
          for (g in G) f.style(s, g, G[g]);
        })), w = uo(ae ? oe[g] : 0, g, N), g in oe || (oe[g] = w.start, ae && (w.end = w.start, w.start = 0));
      }
    }
    function wu(s, a) {
      var u, g, T, x, A;
      for (u in s) if (g = rs(u), T = a[g], x = s[u], Array.isArray(x) && (T = x[1], x = s[u] = x[0]), u !== g && (s[g] = x, delete s[u]), A = f.cssHooks[g], A && "expand" in A) {
        x = A.expand(x), delete s[g];
        for (u in x) u in s || (s[u] = x[u], a[u] = T);
      } else a[g] = T;
    }
    function ot(s, a, u) {
      var g, T, x = 0, A = ot.prefilters.length, M = f.Deferred().always(function() {
        delete w.elem;
      }), w = function() {
        if (T) return false;
        for (var j = hi || lo(), N = Math.max(0, $.startTime + $.duration - j), G = 1 - (N / $.duration || 0), te = 0, ae = $.tweens.length; te < ae; te++) $.tweens[te].run(G);
        return M.notifyWith(s, [$, G, N]), G < 1 && ae ? N : (ae || M.notifyWith(s, [$, 1, 0]), M.resolveWith(s, [$]), false);
      }, $ = M.promise({ elem: s, props: f.extend({}, a), opts: f.extend(true, { specialEasing: {}, easing: f.easing._default }, u), originalProperties: a, originalOptions: u, startTime: hi || lo(), duration: u.duration, tweens: [], createTween: function(j, N) {
        var G = f.Tween(s, $.opts, j, N, $.opts.specialEasing[j] || $.opts.easing);
        return $.tweens.push(G), G;
      }, stop: function(j) {
        var N = 0, G = j ? $.tweens.length : 0;
        if (T) return this;
        for (T = true; N < G; N++) $.tweens[N].run(1);
        return j ? (M.notifyWith(s, [$, 1, 0]), M.resolveWith(s, [$, j])) : M.rejectWith(s, [$, j]), this;
      } }), R = $.props;
      for (wu(R, $.opts.specialEasing); x < A; x++) if (g = ot.prefilters[x].call($, s, R, $.opts), g) return typeof g.stop == "function" && (f._queueHooks($.elem, $.opts.queue).stop = g.stop.bind(g)), g;
      return f.map(R, uo, $), typeof $.opts.start == "function" && $.opts.start.call(s, $), $.progress($.opts.progress).done($.opts.done, $.opts.complete).fail($.opts.fail).always($.opts.always), f.fx.timer(f.extend(w, { elem: s, anim: $, queue: $.opts.queue })), $;
    }
    f.Animation = f.extend(ot, { tweeners: { "*": [function(s, a) {
      var u = this.createTween(s, a);
      return Fr(u.elem, s, Ri.exec(a), u), u;
    }] }, tweener: function(s, a) {
      typeof s == "function" ? (a = s, s = ["*"]) : s = s.match(Ae);
      for (var u, g = 0, T = s.length; g < T; g++) u = s[g], ot.tweeners[u] = ot.tweeners[u] || [], ot.tweeners[u].unshift(a);
    }, prefilters: [Au], prefilter: function(s, a) {
      a ? ot.prefilters.unshift(s) : ot.prefilters.push(s);
    } }), f.speed = function(s, a, u) {
      var g = s && typeof s == "object" ? f.extend({}, s) : { complete: u || a || typeof s == "function" && s, duration: s, easing: u && a || a && typeof a != "function" && a };
      return f.fx.off ? g.duration = 0 : typeof g.duration != "number" && (g.duration in f.fx.speeds ? g.duration = f.fx.speeds[g.duration] : g.duration = f.fx.speeds._default), (g.queue == null || g.queue === true) && (g.queue = "fx"), g.old = g.complete, g.complete = function() {
        typeof g.old == "function" && g.old.call(this), g.queue && f.dequeue(this, g.queue);
      }, g;
    }, f.fn.extend({ fadeTo: function(s, a, u, g) {
      return this.filter(dn).css("opacity", 0).show().end().animate({ opacity: a }, s, u, g);
    }, animate: function(s, a, u, g) {
      var T = f.isEmptyObject(s), x = f.speed(a, u, g), A = function() {
        var M = ot(this, f.extend({}, s), x);
        (T || le.get(this, "finish")) && M.stop(true);
      };
      return A.finish = A, T || x.queue === false ? this.each(A) : this.queue(x.queue, A);
    }, stop: function(s, a, u) {
      var g = function(T) {
        var x = T.stop;
        delete T.stop, x(u);
      };
      return typeof s != "string" && (u = a, a = s, s = void 0), a && this.queue(s || "fx", []), this.each(function() {
        var T = true, x = s != null && s + "queueHooks", A = f.timers, M = le.get(this);
        if (x) M[x] && M[x].stop && g(M[x]);
        else for (x in M) M[x] && M[x].stop && Iu.test(x) && g(M[x]);
        for (x = A.length; x--; ) A[x].elem === this && (s == null || A[x].queue === s) && (A[x].anim.stop(u), T = false, A.splice(x, 1));
        (T || !u) && f.dequeue(this, s);
      });
    }, finish: function(s) {
      return s !== false && (s = s || "fx"), this.each(function() {
        var a, u = le.get(this), g = u[s + "queue"], T = u[s + "queueHooks"], x = f.timers, A = g ? g.length : 0;
        for (u.finish = true, f.queue(this, s, []), T && T.stop && T.stop.call(this, true), a = x.length; a--; ) x[a].elem === this && x[a].queue === s && (x[a].anim.stop(true), x.splice(a, 1));
        for (a = 0; a < A; a++) g[a] && g[a].finish && g[a].finish.call(this);
        delete u.finish;
      });
    } }), f.each(["toggle", "show", "hide"], function(s, a) {
      var u = f.fn[a];
      f.fn[a] = function(g, T, x) {
        return g == null || typeof g == "boolean" ? u.apply(this, arguments) : this.animate(vn(a, true), g, T, x);
      };
    }), f.each({ slideDown: vn("show"), slideUp: vn("hide"), slideToggle: vn("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function(s, a) {
      f.fn[s] = function(u, g, T) {
        return this.animate(a, u, g, T);
      };
    }), f.timers = [], f.fx.tick = function() {
      var s, a = 0, u = f.timers;
      for (hi = Date.now(); a < u.length; a++) s = u[a], !s() && u[a] === s && u.splice(a--, 1);
      u.length || f.fx.stop(), hi = void 0;
    }, f.fx.timer = function(s) {
      f.timers.push(s), f.fx.start();
    }, f.fx.start = function() {
      mn || (mn = true, cs());
    }, f.fx.stop = function() {
      mn = null;
    }, f.fx.speeds = { slow: 600, fast: 200, _default: 400 }, f.fn.delay = function(s, a) {
      return s = f.fx && f.fx.speeds[s] || s, a = a || "fx", this.queue(a, function(u, g) {
        var T = t.setTimeout(u, s);
        g.stop = function() {
          t.clearTimeout(T);
        };
      });
    };
    var Ou = /^(?:input|select|textarea|button)$/i, Mu = /^(?:a|area)$/i;
    f.fn.extend({ prop: function(s, a) {
      return ye(this, f.prop, s, a, arguments.length > 1);
    }, removeProp: function(s) {
      return this.each(function() {
        delete this[f.propFix[s] || s];
      });
    } }), f.extend({ prop: function(s, a, u) {
      var g, T, x = s.nodeType;
      if (!(x === 3 || x === 8 || x === 2)) return (x !== 1 || !f.isXMLDoc(s)) && (a = f.propFix[a] || a, T = f.propHooks[a]), u !== void 0 ? T && "set" in T && (g = T.set(s, u, a)) !== void 0 ? g : s[a] = u : T && "get" in T && (g = T.get(s, a)) !== null ? g : s[a];
    }, propHooks: { tabIndex: { get: function(s) {
      var a = s.getAttribute("tabindex");
      return a ? parseInt(a, 10) : Ou.test(s.nodeName) || Mu.test(s.nodeName) && s.href ? 0 : -1;
    } } }, propFix: { for: "htmlFor", class: "className" } }), k && (f.propHooks.selected = { get: function(s) {
      var a = s.parentNode;
      return a && a.parentNode && a.parentNode.selectedIndex, null;
    }, set: function(s) {
      var a = s.parentNode;
      a && (a.selectedIndex, a.parentNode && a.parentNode.selectedIndex);
    } }), f.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
      f.propFix[this.toLowerCase()] = this;
    });
    function jt(s) {
      var a = s.match(Ae) || [];
      return a.join(" ");
    }
    function pi(s) {
      return s.getAttribute && s.getAttribute("class") || "";
    }
    function ds(s) {
      return Array.isArray(s) ? s : typeof s == "string" ? s.match(Ae) || [] : [];
    }
    f.fn.extend({ addClass: function(s) {
      var a, u, g, T, x, A;
      return typeof s == "function" ? this.each(function(M) {
        f(this).addClass(s.call(this, M, pi(this)));
      }) : (a = ds(s), a.length ? this.each(function() {
        if (g = pi(this), u = this.nodeType === 1 && " " + jt(g) + " ", u) {
          for (x = 0; x < a.length; x++) T = a[x], u.indexOf(" " + T + " ") < 0 && (u += T + " ");
          A = jt(u), g !== A && this.setAttribute("class", A);
        }
      }) : this);
    }, removeClass: function(s) {
      var a, u, g, T, x, A;
      return typeof s == "function" ? this.each(function(M) {
        f(this).removeClass(s.call(this, M, pi(this)));
      }) : arguments.length ? (a = ds(s), a.length ? this.each(function() {
        if (g = pi(this), u = this.nodeType === 1 && " " + jt(g) + " ", u) {
          for (x = 0; x < a.length; x++) for (T = a[x]; u.indexOf(" " + T + " ") > -1; ) u = u.replace(" " + T + " ", " ");
          A = jt(u), g !== A && this.setAttribute("class", A);
        }
      }) : this) : this.attr("class", "");
    }, toggleClass: function(s, a) {
      var u, g, T, x;
      return typeof s == "function" ? this.each(function(A) {
        f(this).toggleClass(s.call(this, A, pi(this), a), a);
      }) : typeof a == "boolean" ? a ? this.addClass(s) : this.removeClass(s) : (u = ds(s), u.length ? this.each(function() {
        for (x = f(this), T = 0; T < u.length; T++) g = u[T], x.hasClass(g) ? x.removeClass(g) : x.addClass(g);
      }) : this);
    }, hasClass: function(s) {
      var a, u, g = 0;
      for (a = " " + s + " "; u = this[g++]; ) if (u.nodeType === 1 && (" " + jt(pi(u)) + " ").indexOf(a) > -1) return true;
      return false;
    } }), f.fn.extend({ val: function(s) {
      var a, u, g, T = this[0];
      return arguments.length ? (g = typeof s == "function", this.each(function(x) {
        var A;
        this.nodeType === 1 && (g ? A = s.call(this, x, f(this).val()) : A = s, A == null ? A = "" : typeof A == "number" ? A += "" : Array.isArray(A) && (A = f.map(A, function(M) {
          return M == null ? "" : M + "";
        })), a = f.valHooks[this.type] || f.valHooks[this.nodeName.toLowerCase()], (!a || !("set" in a) || a.set(this, A, "value") === void 0) && (this.value = A));
      })) : T ? (a = f.valHooks[T.type] || f.valHooks[T.nodeName.toLowerCase()], a && "get" in a && (u = a.get(T, "value")) !== void 0 ? u : (u = T.value, u == null ? "" : u)) : void 0;
    } }), f.extend({ valHooks: { select: { get: function(s) {
      var a, u, g, T = s.options, x = s.selectedIndex, A = s.type === "select-one", M = A ? null : [], w = A ? x + 1 : T.length;
      for (x < 0 ? g = w : g = A ? x : 0; g < w; g++) if (u = T[g], u.selected && !u.disabled && (!u.parentNode.disabled || !P(u.parentNode, "optgroup"))) {
        if (a = f(u).val(), A) return a;
        M.push(a);
      }
      return M;
    }, set: function(s, a) {
      for (var u, g, T = s.options, x = f.makeArray(a), A = T.length; A--; ) g = T[A], (g.selected = f.inArray(f(g).val(), x) > -1) && (u = true);
      return u || (s.selectedIndex = -1), x;
    } } } }), k && (f.valHooks.option = { get: function(s) {
      var a = s.getAttribute("value");
      return a != null ? a : jt(f.text(s));
    } }), f.each(["radio", "checkbox"], function() {
      f.valHooks[this] = { set: function(s, a) {
        if (Array.isArray(a)) return s.checked = f.inArray(f(s).val(), a) > -1;
      } };
    });
    var co = /^(?:focusinfocus|focusoutblur)$/, fo = function(s) {
      s.stopPropagation();
    };
    f.extend(f.event, { trigger: function(s, a, u, g) {
      var T, x, A, M, w, $, R, j, N = [u || h], G = b.call(s, "type") ? s.type : s, te = b.call(s, "namespace") ? s.namespace.split(".") : [];
      if (x = j = A = u = u || h, !(u.nodeType === 3 || u.nodeType === 8) && !co.test(G + f.event.triggered) && (G.indexOf(".") > -1 && (te = G.split("."), G = te.shift(), te.sort()), w = G.indexOf(":") < 0 && "on" + G, s = s[f.expando] ? s : new f.Event(G, typeof s == "object" && s), s.isTrigger = g ? 2 : 3, s.namespace = te.join("."), s.rnamespace = s.namespace ? new RegExp("(^|\\.)" + te.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, s.result = void 0, s.target || (s.target = u), a = a == null ? [s] : f.makeArray(a, [s]), R = f.event.special[G] || {}, !(!g && R.trigger && R.trigger.apply(u, a) === false))) {
        if (!g && !R.noBubble && !C(u)) {
          for (M = R.delegateType || G, co.test(M + G) || (x = x.parentNode); x; x = x.parentNode) N.push(x), A = x;
          A === (u.ownerDocument || h) && N.push(A.defaultView || A.parentWindow || t);
        }
        for (T = 0; (x = N[T++]) && !s.isPropagationStopped(); ) j = x, s.type = T > 1 ? M : R.bindType || G, $ = (le.get(x, "events") || /* @__PURE__ */ Object.create(null))[s.type] && le.get(x, "handle"), $ && $.apply(x, a), $ = w && x[w], $ && $.apply && ki(x) && (s.result = $.apply(x, a), s.result === false && s.preventDefault());
        return s.type = G, !g && !s.isDefaultPrevented() && (!R._default || R._default.apply(N.pop(), a) === false) && ki(u) && w && typeof u[G] == "function" && !C(u) && (A = u[w], A && (u[w] = null), f.event.triggered = G, s.isPropagationStopped() && j.addEventListener(G, fo), u[G](), s.isPropagationStopped() && j.removeEventListener(G, fo), f.event.triggered = void 0, A && (u[w] = A)), s.result;
      }
    }, simulate: function(s, a, u) {
      var g = f.extend(new f.Event(), u, { type: s, isSimulated: true });
      f.event.trigger(g, null, a);
    } }), f.fn.extend({ trigger: function(s, a) {
      return this.each(function() {
        f.event.trigger(s, a, this);
      });
    }, triggerHandler: function(s, a) {
      var u = this[0];
      if (u) return f.event.trigger(s, a, u, true);
    } });
    var Bi = t.location, ho = { guid: Date.now() }, fs = /\?/;
    f.parseXML = function(s) {
      var a, u;
      if (!s || typeof s != "string") return null;
      try {
        a = new t.DOMParser().parseFromString(s, "text/xml");
      } catch (g) {
      }
      return u = a && a.getElementsByTagName("parsererror")[0], (!a || u) && f.error("Invalid XML: " + (u ? f.map(u.childNodes, function(g) {
        return g.textContent;
      }).join(`
`) : s)), a;
    };
    var Lu = /\[\]$/, po = /\r?\n/g, Pu = /^(?:submit|button|image|reset|file)$/i, Du = /^(?:input|select|textarea|keygen)/i;
    function hs(s, a, u, g) {
      var T;
      if (Array.isArray(a)) f.each(a, function(x, A) {
        u || Lu.test(s) ? g(s, A) : hs(s + "[" + (typeof A == "object" && A != null ? x : "") + "]", A, u, g);
      });
      else if (!u && m(a) === "object") for (T in a) hs(s + "[" + T + "]", a[T], u, g);
      else g(s, a);
    }
    f.param = function(s, a) {
      var u, g = [], T = function(x, A) {
        var M = typeof A == "function" ? A() : A;
        g[g.length] = encodeURIComponent(x) + "=" + encodeURIComponent(M == null ? "" : M);
      };
      if (s == null) return "";
      if (Array.isArray(s) || s.jquery && !f.isPlainObject(s)) f.each(s, function() {
        T(this.name, this.value);
      });
      else for (u in s) hs(u, s[u], a, T);
      return g.join("&");
    }, f.fn.extend({ serialize: function() {
      return f.param(this.serializeArray());
    }, serializeArray: function() {
      return this.map(function() {
        var s = f.prop(this, "elements");
        return s ? f.makeArray(s) : this;
      }).filter(function() {
        var s = this.type;
        return this.name && !f(this).is(":disabled") && Du.test(this.nodeName) && !Pu.test(s) && (this.checked || !hn.test(s));
      }).map(function(s, a) {
        var u = f(this).val();
        return u == null ? null : Array.isArray(u) ? f.map(u, function(g) {
          return { name: a.name, value: g.replace(po, `\r
`) };
        }) : { name: a.name, value: u.replace(po, `\r
`) };
      }).get();
    } });
    var $u = /%20/g, zu = /#.*$/, ku = /([?&])_=[^&]*/, Nu = /^(.*?):[ \t]*([^\r\n]*)$/mg, Ru = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, Hu = /^(?:GET|HEAD)$/, Bu = /^\/\//, go = {}, ps = {}, mo = "*/".concat("*"), gs = h.createElement("a");
    gs.href = Bi.href;
    function vo(s) {
      return function(a, u) {
        typeof a != "string" && (u = a, a = "*");
        var g, T = 0, x = a.toLowerCase().match(Ae) || [];
        if (typeof u == "function") for (; g = x[T++]; ) g[0] === "+" ? (g = g.slice(1) || "*", (s[g] = s[g] || []).unshift(u)) : (s[g] = s[g] || []).push(u);
      };
    }
    function yo(s, a, u, g) {
      var T = {}, x = s === ps;
      function A(M) {
        var w;
        return T[M] = true, f.each(s[M] || [], function($, R) {
          var j = R(a, u, g);
          if (typeof j == "string" && !x && !T[j]) return a.dataTypes.unshift(j), A(j), false;
          if (x) return !(w = j);
        }), w;
      }
      return A(a.dataTypes[0]) || !T["*"] && A("*");
    }
    function ms(s, a) {
      var u, g, T = f.ajaxSettings.flatOptions || {};
      for (u in a) a[u] !== void 0 && ((T[u] ? s : g || (g = {}))[u] = a[u]);
      return g && f.extend(true, s, g), s;
    }
    function Vu(s, a, u) {
      for (var g, T, x, A, M = s.contents, w = s.dataTypes; w[0] === "*"; ) w.shift(), g === void 0 && (g = s.mimeType || a.getResponseHeader("Content-Type"));
      if (g) {
        for (T in M) if (M[T] && M[T].test(g)) {
          w.unshift(T);
          break;
        }
      }
      if (w[0] in u) x = w[0];
      else {
        for (T in u) {
          if (!w[0] || s.converters[T + " " + w[0]]) {
            x = T;
            break;
          }
          A || (A = T);
        }
        x = x || A;
      }
      if (x) return x !== w[0] && w.unshift(x), u[x];
    }
    function Wu(s, a, u, g) {
      var T, x, A, M, w, $ = {}, R = s.dataTypes.slice();
      if (R[1]) for (A in s.converters) $[A.toLowerCase()] = s.converters[A];
      for (x = R.shift(); x; ) if (s.responseFields[x] && (u[s.responseFields[x]] = a), !w && g && s.dataFilter && (a = s.dataFilter(a, s.dataType)), w = x, x = R.shift(), x) {
        if (x === "*") x = w;
        else if (w !== "*" && w !== x) {
          if (A = $[w + " " + x] || $["* " + x], !A) {
            for (T in $) if (M = T.split(" "), M[1] === x && (A = $[w + " " + M[0]] || $["* " + M[0]], A)) {
              A === true ? A = $[T] : $[T] !== true && (x = M[0], R.unshift(M[1]));
              break;
            }
          }
          if (A !== true) if (A && s.throws) a = A(a);
          else try {
            a = A(a);
          } catch (j) {
            return { state: "parsererror", error: A ? j : "No conversion from " + w + " to " + x };
          }
        }
      }
      return { state: "success", data: a };
    }
    f.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: Bi.href, type: "GET", isLocal: Ru.test(Bi.protocol), global: true, processData: true, async: true, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": mo, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": true, "text json": JSON.parse, "text xml": f.parseXML }, flatOptions: { url: true, context: true } }, ajaxSetup: function(s, a) {
      return a ? ms(ms(s, f.ajaxSettings), a) : ms(f.ajaxSettings, s);
    }, ajaxPrefilter: vo(go), ajaxTransport: vo(ps), ajax: function(s, a) {
      typeof s == "object" && (a = s, s = void 0), a = a || {};
      var u, g, T, x, A, M, w, $, R, j, N = f.ajaxSetup({}, a), G = N.context || N, te = N.context && (G.nodeType || G.jquery) ? f(G) : f.event, ae = f.Deferred(), oe = f.Callbacks("once memory"), me = N.statusCode || {}, he = {}, He = {}, Pe = "canceled", ce = { readyState: 0, getResponseHeader: function(de) {
        var Se;
        if (w) {
          if (!x) for (x = {}; Se = Nu.exec(T); ) x[Se[1].toLowerCase() + " "] = (x[Se[1].toLowerCase() + " "] || []).concat(Se[2]);
          Se = x[de.toLowerCase() + " "];
        }
        return Se == null ? null : Se.join(", ");
      }, getAllResponseHeaders: function() {
        return w ? T : null;
      }, setRequestHeader: function(de, Se) {
        return w == null && (de = He[de.toLowerCase()] = He[de.toLowerCase()] || de, he[de] = Se), this;
      }, overrideMimeType: function(de) {
        return w == null && (N.mimeType = de), this;
      }, statusCode: function(de) {
        var Se;
        if (de) if (w) ce.always(de[ce.status]);
        else for (Se in de) me[Se] = [me[Se], de[Se]];
        return this;
      }, abort: function(de) {
        var Se = de || Pe;
        return u && u.abort(Se), yn(0, Se), this;
      } };
      if (ae.promise(ce), N.url = ((s || N.url || Bi.href) + "").replace(Bu, Bi.protocol + "//"), N.type = a.method || a.type || N.method || N.type, N.dataTypes = (N.dataType || "*").toLowerCase().match(Ae) || [""], N.crossDomain == null) {
        M = h.createElement("a");
        try {
          M.href = N.url, M.href = M.href, N.crossDomain = gs.protocol + "//" + gs.host != M.protocol + "//" + M.host;
        } catch (de) {
          N.crossDomain = true;
        }
      }
      if (yo(go, N, a, ce), N.data && N.processData && typeof N.data != "string" && (N.data = f.param(N.data, N.traditional)), w) return ce;
      $ = f.event && N.global, $ && f.active++ === 0 && f.event.trigger("ajaxStart"), N.type = N.type.toUpperCase(), N.hasContent = !Hu.test(N.type), g = N.url.replace(zu, ""), N.hasContent ? N.data && N.processData && (N.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (N.data = N.data.replace($u, "+")) : (j = N.url.slice(g.length), N.data && (N.processData || typeof N.data == "string") && (g += (fs.test(g) ? "&" : "?") + N.data, delete N.data), N.cache === false && (g = g.replace(ku, "$1"), j = (fs.test(g) ? "&" : "?") + "_=" + ho.guid++ + j), N.url = g + j), N.ifModified && (f.lastModified[g] && ce.setRequestHeader("If-Modified-Since", f.lastModified[g]), f.etag[g] && ce.setRequestHeader("If-None-Match", f.etag[g])), (N.data && N.hasContent && N.contentType !== false || a.contentType) && ce.setRequestHeader("Content-Type", N.contentType), ce.setRequestHeader("Accept", N.dataTypes[0] && N.accepts[N.dataTypes[0]] ? N.accepts[N.dataTypes[0]] + (N.dataTypes[0] !== "*" ? ", " + mo + "; q=0.01" : "") : N.accepts["*"]);
      for (R in N.headers) ce.setRequestHeader(R, N.headers[R]);
      if (N.beforeSend && (N.beforeSend.call(G, ce, N) === false || w)) return ce.abort();
      if (Pe = "abort", oe.add(N.complete), ce.done(N.success), ce.fail(N.error), u = yo(ps, N, a, ce), !u) yn(-1, "No Transport");
      else {
        if (ce.readyState = 1, $ && te.trigger("ajaxSend", [ce, N]), w) return ce;
        N.async && N.timeout > 0 && (A = t.setTimeout(function() {
          ce.abort("timeout");
        }, N.timeout));
        try {
          w = false, u.send(he, yn);
        } catch (de) {
          if (w) throw de;
          yn(-1, de);
        }
      }
      function yn(de, Se, To, Yu) {
        var Dt, ys, Vi, gi, mi, pt = Se;
        w || (w = true, A && t.clearTimeout(A), u = void 0, T = Yu || "", ce.readyState = de > 0 ? 4 : 0, Dt = de >= 200 && de < 300 || de === 304, To && (gi = Vu(N, ce, To)), !Dt && f.inArray("script", N.dataTypes) > -1 && f.inArray("json", N.dataTypes) < 0 && (N.converters["text script"] = function() {
        }), gi = Wu(N, gi, ce, Dt), Dt ? (N.ifModified && (mi = ce.getResponseHeader("Last-Modified"), mi && (f.lastModified[g] = mi), mi = ce.getResponseHeader("etag"), mi && (f.etag[g] = mi)), de === 204 || N.type === "HEAD" ? pt = "nocontent" : de === 304 ? pt = "notmodified" : (pt = gi.state, ys = gi.data, Vi = gi.error, Dt = !Vi)) : (Vi = pt, (de || !pt) && (pt = "error", de < 0 && (de = 0))), ce.status = de, ce.statusText = (Se || pt) + "", Dt ? ae.resolveWith(G, [ys, pt, ce]) : ae.rejectWith(G, [ce, pt, Vi]), ce.statusCode(me), me = void 0, $ && te.trigger(Dt ? "ajaxSuccess" : "ajaxError", [ce, N, Dt ? ys : Vi]), oe.fireWith(G, [ce, pt]), $ && (te.trigger("ajaxComplete", [ce, N]), --f.active || f.event.trigger("ajaxStop")));
      }
      return ce;
    }, getJSON: function(s, a, u) {
      return f.get(s, a, u, "json");
    }, getScript: function(s, a) {
      return f.get(s, void 0, a, "script");
    } }), f.each(["get", "post"], function(s, a) {
      f[a] = function(u, g, T, x) {
        return (typeof g == "function" || g === null) && (x = x || T, T = g, g = void 0), f.ajax(f.extend({ url: u, type: a, dataType: x, data: g, success: T }, f.isPlainObject(u) && u));
      };
    }), f.ajaxPrefilter(function(s) {
      var a;
      for (a in s.headers) a.toLowerCase() === "content-type" && (s.contentType = s.headers[a] || "");
    }), f._evalUrl = function(s, a, u) {
      return f.ajax({ url: s, type: "GET", dataType: "script", cache: true, async: false, global: false, scriptAttrs: a.crossOrigin ? { crossOrigin: a.crossOrigin } : void 0, converters: { "text script": function() {
      } }, dataFilter: function(g) {
        f.globalEval(g, a, u);
      } });
    }, f.fn.extend({ wrapAll: function(s) {
      var a;
      return this[0] && (typeof s == "function" && (s = s.call(this[0])), a = f(s, this[0].ownerDocument).eq(0).clone(true), this[0].parentNode && a.insertBefore(this[0]), a.map(function() {
        for (var u = this; u.firstElementChild; ) u = u.firstElementChild;
        return u;
      }).append(this)), this;
    }, wrapInner: function(s) {
      return typeof s == "function" ? this.each(function(a) {
        f(this).wrapInner(s.call(this, a));
      }) : this.each(function() {
        var a = f(this), u = a.contents();
        u.length ? u.wrapAll(s) : a.append(s);
      });
    }, wrap: function(s) {
      var a = typeof s == "function";
      return this.each(function(u) {
        f(this).wrapAll(a ? s.call(this, u) : s);
      });
    }, unwrap: function(s) {
      return this.parent(s).not("body").each(function() {
        f(this).replaceWith(this.childNodes);
      }), this;
    } }), f.expr.pseudos.hidden = function(s) {
      return !f.expr.pseudos.visible(s);
    }, f.expr.pseudos.visible = function(s) {
      return !!(s.offsetWidth || s.offsetHeight || s.getClientRects().length);
    }, f.ajaxSettings.xhr = function() {
      return new t.XMLHttpRequest();
    };
    var Fu = { 0: 200 };
    f.ajaxTransport(function(s) {
      var a;
      return { send: function(u, g) {
        var T, x = s.xhr();
        if (x.open(s.type, s.url, s.async, s.username, s.password), s.xhrFields) for (T in s.xhrFields) x[T] = s.xhrFields[T];
        s.mimeType && x.overrideMimeType && x.overrideMimeType(s.mimeType), !s.crossDomain && !u["X-Requested-With"] && (u["X-Requested-With"] = "XMLHttpRequest");
        for (T in u) x.setRequestHeader(T, u[T]);
        a = function(A) {
          return function() {
            a && (a = x.onload = x.onerror = x.onabort = x.ontimeout = null, A === "abort" ? x.abort() : A === "error" ? g(x.status, x.statusText) : g(Fu[x.status] || x.status, x.statusText, (x.responseType || "text") === "text" ? { text: x.responseText } : { binary: x.response }, x.getAllResponseHeaders()));
          };
        }, x.onload = a(), x.onabort = x.onerror = x.ontimeout = a("error"), a = a("abort");
        try {
          x.send(s.hasContent && s.data || null);
        } catch (A) {
          if (a) throw A;
        }
      }, abort: function() {
        a && a();
      } };
    });
    function bo(s) {
      return s.scriptAttrs || !s.headers && (s.crossDomain || s.async && f.inArray("json", s.dataTypes) < 0);
    }
    f.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, converters: { "text script": function(s) {
      return f.globalEval(s), s;
    } } }), f.ajaxPrefilter("script", function(s) {
      s.cache === void 0 && (s.cache = false), bo(s) && (s.type = "GET");
    }), f.ajaxTransport("script", function(s) {
      if (bo(s)) {
        var a, u;
        return { send: function(g, T) {
          a = f("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", u = function(x) {
            a.remove(), u = null, x && T(x.type === "error" ? 404 : 200, x.type);
          }), h.head.appendChild(a[0]);
        }, abort: function() {
          u && u();
        } };
      }
    });
    var Eo = [], vs = /(=)\?(?=&|$)|\?\?/;
    f.ajaxSetup({ jsonp: "callback", jsonpCallback: function() {
      var s = Eo.pop() || f.expando + "_" + ho.guid++;
      return this[s] = true, s;
    } }), f.ajaxPrefilter("jsonp", function(s, a, u) {
      var g, T, x, A = s.jsonp !== false && (vs.test(s.url) ? "url" : typeof s.data == "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && vs.test(s.data) && "data");
      return g = s.jsonpCallback = typeof s.jsonpCallback == "function" ? s.jsonpCallback() : s.jsonpCallback, A ? s[A] = s[A].replace(vs, "$1" + g) : s.jsonp !== false && (s.url += (fs.test(s.url) ? "&" : "?") + s.jsonp + "=" + g), s.converters["script json"] = function() {
        return x || f.error(g + " was not called"), x[0];
      }, s.dataTypes[0] = "json", T = t[g], t[g] = function() {
        x = arguments;
      }, u.always(function() {
        T === void 0 ? f(t).removeProp(g) : t[g] = T, s[g] && (s.jsonpCallback = a.jsonpCallback, Eo.push(g)), x && typeof T == "function" && T(x[0]), x = T = void 0;
      }), "script";
    }), f.ajaxPrefilter(function(s, a) {
      typeof s.data != "string" && !f.isPlainObject(s.data) && !Array.isArray(s.data) && !("processData" in a) && (s.processData = false), s.data instanceof t.FormData && (s.contentType = false);
    }), f.parseHTML = function(s, a, u) {
      if (typeof s != "string" && !Rr(s + "")) return [];
      typeof a == "boolean" && (u = a, a = false);
      var g, T;
      return a || (a = new t.DOMParser().parseFromString("", "text/html")), g = Nr.exec(s), T = !u && [], g ? [a.createElement(g[1])] : (g = Xr([s], a, T), T && T.length && f(T).remove(), f.merge([], g.childNodes));
    }, f.fn.load = function(s, a, u) {
      var g, T, x, A = this, M = s.indexOf(" ");
      return M > -1 && (g = jt(s.slice(M)), s = s.slice(0, M)), typeof a == "function" ? (u = a, a = void 0) : a && typeof a == "object" && (T = "POST"), A.length > 0 && f.ajax({ url: s, type: T || "GET", dataType: "html", data: a }).done(function(w) {
        x = arguments, A.html(g ? f("<div>").append(f.parseHTML(w)).find(g) : w);
      }).always(u && function(w, $) {
        A.each(function() {
          u.apply(this, x || [w.responseText, $, w]);
        });
      }), this;
    }, f.expr.pseudos.animated = function(s) {
      return f.grep(f.timers, function(a) {
        return s === a.elem;
      }).length;
    }, f.offset = { setOffset: function(s, a, u) {
      var g, T, x, A, M, w, $, R = f.css(s, "position"), j = f(s), N = {};
      R === "static" && (s.style.position = "relative"), M = j.offset(), x = f.css(s, "top"), w = f.css(s, "left"), $ = (R === "absolute" || R === "fixed") && (x + w).indexOf("auto") > -1, $ ? (g = j.position(), A = g.top, T = g.left) : (A = parseFloat(x) || 0, T = parseFloat(w) || 0), typeof a == "function" && (a = a.call(s, u, f.extend({}, M))), a.top != null && (N.top = a.top - M.top + A), a.left != null && (N.left = a.left - M.left + T), "using" in a ? a.using.call(s, N) : j.css(N);
    } }, f.fn.extend({ offset: function(s) {
      if (arguments.length) return s === void 0 ? this : this.each(function(T) {
        f.offset.setOffset(this, s, T);
      });
      var a, u, g = this[0];
      if (g) return g.getClientRects().length ? (a = g.getBoundingClientRect(), u = g.ownerDocument.defaultView, { top: a.top + u.pageYOffset, left: a.left + u.pageXOffset }) : { top: 0, left: 0 };
    }, position: function() {
      if (this[0]) {
        var s, a, u, g = this[0], T = { top: 0, left: 0 };
        if (f.css(g, "position") === "fixed") a = g.getBoundingClientRect();
        else {
          for (a = this.offset(), u = g.ownerDocument, s = g.offsetParent || u.documentElement; s && s !== u.documentElement && f.css(s, "position") === "static"; ) s = s.offsetParent || u.documentElement;
          s && s !== g && s.nodeType === 1 && f.css(s, "position") !== "static" && (T = f(s).offset(), T.top += f.css(s, "borderTopWidth", true), T.left += f.css(s, "borderLeftWidth", true));
        }
        return { top: a.top - T.top - f.css(g, "marginTop", true), left: a.left - T.left - f.css(g, "marginLeft", true) };
      }
    }, offsetParent: function() {
      return this.map(function() {
        for (var s = this.offsetParent; s && f.css(s, "position") === "static"; ) s = s.offsetParent;
        return s || W;
      });
    } }), f.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(s, a) {
      var u = a === "pageYOffset";
      f.fn[s] = function(g) {
        return ye(this, function(T, x, A) {
          var M;
          if (C(T) ? M = T : T.nodeType === 9 && (M = T.defaultView), A === void 0) return M ? M[a] : T[x];
          M ? M.scrollTo(u ? M.pageXOffset : A, u ? A : M.pageYOffset) : T[x] = A;
        }, s, g, arguments.length);
      };
    }), f.each({ Height: "height", Width: "width" }, function(s, a) {
      f.each({ padding: "inner" + s, content: a, "": "outer" + s }, function(u, g) {
        f.fn[g] = function(T, x) {
          var A = arguments.length && (u || typeof T != "boolean"), M = u || (T === true || x === true ? "margin" : "border");
          return ye(this, function(w, $, R) {
            var j;
            return C(w) ? g.indexOf("outer") === 0 ? w["inner" + s] : w.document.documentElement["client" + s] : w.nodeType === 9 ? (j = w.documentElement, Math.max(w.body["scroll" + s], j["scroll" + s], w.body["offset" + s], j["offset" + s], j["client" + s])) : R === void 0 ? f.css(w, $, M) : f.style(w, $, R, M);
          }, a, A ? T : void 0, A);
        };
      });
    }), f.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(s, a) {
      f.fn[a] = function(u) {
        return this.on(a, u);
      };
    }), f.fn.extend({ bind: function(s, a, u) {
      return this.on(s, null, a, u);
    }, unbind: function(s, a) {
      return this.off(s, null, a);
    }, delegate: function(s, a, u, g) {
      return this.on(a, s, u, g);
    }, undelegate: function(s, a, u) {
      return arguments.length === 1 ? this.off(s, "**") : this.off(a, s || "**", u);
    }, hover: function(s, a) {
      return this.on("mouseenter", s).on("mouseleave", a || s);
    } }), f.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(s, a) {
      f.fn[a] = function(u, g) {
        return arguments.length > 0 ? this.on(a, null, u, g) : this.trigger(a);
      };
    }), f.proxy = function(s, a) {
      var u, g, T;
      if (typeof a == "string" && (u = s[a], a = s, s = u), typeof s == "function") return g = r.call(arguments, 2), T = function() {
        return s.apply(a || this, g.concat(r.call(arguments)));
      }, T.guid = s.guid = s.guid || f.guid++, T;
    }, f.holdReady = function(s) {
      s ? f.readyWait++ : f.ready(true);
    }, f.expr[":"] = f.expr.filters = f.expr.pseudos, typeof define == "function" && define.amd && define("jquery", [], function() {
      return f;
    });
    var Gu = t.jQuery, ju = t.$;
    return f.noConflict = function(s) {
      return t.$ === f && (t.$ = ju), s && t.jQuery === f && (t.jQuery = Gu), f;
    }, f;
  }
  var Ju = Qu(window);
  window.jQuery = window.$ = Ju;
  var ze = "top", Xe = "bottom", qe = "right", ke = "left", Wn = "auto", Pi = [ze, Xe, qe, ke], Qt = "start", xi = "end", Aa = "clippingParents", fr = "viewport", Ei = "popper", wa = "reference", ir = Pi.reduce(function(t, e) {
    return t.concat([e + "-" + Qt, e + "-" + xi]);
  }, []), hr = [].concat(Pi, [Wn]).reduce(function(t, e) {
    return t.concat([e, e + "-" + Qt, e + "-" + xi]);
  }, []), Oa = "beforeRead", Ma = "read", La = "afterRead", Pa = "beforeMain", Da = "main", $a = "afterMain", za = "beforeWrite", ka = "write", Na = "afterWrite", Ra = [Oa, Ma, La, Pa, Da, $a, za, ka, Na];
  function vt(t) {
    return t ? (t.nodeName || "").toLowerCase() : null;
  }
  function Ue(t) {
    if (t == null) return window;
    if (t.toString() !== "[object Window]") {
      var e = t.ownerDocument;
      return e && e.defaultView || window;
    }
    return t;
  }
  function Jt(t) {
    var e = Ue(t).Element;
    return t instanceof e || t instanceof Element;
  }
  function Je(t) {
    var e = Ue(t).HTMLElement;
    return t instanceof e || t instanceof HTMLElement;
  }
  function pr(t) {
    if (typeof ShadowRoot == "undefined") return false;
    var e = Ue(t).ShadowRoot;
    return t instanceof e || t instanceof ShadowRoot;
  }
  function ec(t) {
    var e = t.state;
    Object.keys(e.elements).forEach(function(i) {
      var n = e.styles[i] || {}, r = e.attributes[i] || {}, o = e.elements[i];
      !Je(o) || !vt(o) || (Object.assign(o.style, n), Object.keys(r).forEach(function(l) {
        var c = r[l];
        c === false ? o.removeAttribute(l) : o.setAttribute(l, c === true ? "" : c);
      }));
    });
  }
  function tc(t) {
    var e = t.state, i = { popper: { position: e.options.strategy, left: "0", top: "0", margin: "0" }, arrow: { position: "absolute" }, reference: {} };
    return Object.assign(e.elements.popper.style, i.popper), e.styles = i, e.elements.arrow && Object.assign(e.elements.arrow.style, i.arrow), function() {
      Object.keys(e.elements).forEach(function(n) {
        var r = e.elements[n], o = e.attributes[n] || {}, l = Object.keys(e.styles.hasOwnProperty(n) ? e.styles[n] : i[n]), c = l.reduce(function(d, v) {
          return d[v] = "", d;
        }, {});
        !Je(r) || !vt(r) || (Object.assign(r.style, c), Object.keys(o).forEach(function(d) {
          r.removeAttribute(d);
        }));
      });
    };
  }
  const Ha = { name: "applyStyles", enabled: true, phase: "write", fn: ec, effect: tc, requires: ["computeStyles"] };
  function mt(t) {
    return t.split("-")[0];
  }
  var Ut = Math.max, Ln = Math.min, Ci = Math.round;
  function nr() {
    var t = navigator.userAgentData;
    return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
      return e.brand + "/" + e.version;
    }).join(" ") : navigator.userAgent;
  }
  function Ba() {
    return !/^((?!chrome|android).)*safari/i.test(nr());
  }
  function Ii(t, e, i) {
    e === void 0 && (e = false), i === void 0 && (i = false);
    var n = t.getBoundingClientRect(), r = 1, o = 1;
    e && Je(t) && (r = t.offsetWidth > 0 && Ci(n.width) / t.offsetWidth || 1, o = t.offsetHeight > 0 && Ci(n.height) / t.offsetHeight || 1);
    var l = Jt(t) ? Ue(t) : window, c = l.visualViewport, d = !Ba() && i, v = (n.left + (d && c ? c.offsetLeft : 0)) / r, b = (n.top + (d && c ? c.offsetTop : 0)) / o, y = n.width / r, _ = n.height / o;
    return { width: y, height: _, top: b, right: v + y, bottom: b + _, left: v, x: v, y: b };
  }
  function gr(t) {
    var e = Ii(t), i = t.offsetWidth, n = t.offsetHeight;
    return Math.abs(e.width - i) <= 1 && (i = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), { x: t.offsetLeft, y: t.offsetTop, width: i, height: n };
  }
  function Va(t, e) {
    var i = e.getRootNode && e.getRootNode();
    if (t.contains(e)) return true;
    if (i && pr(i)) {
      var n = e;
      do {
        if (n && t.isSameNode(n)) return true;
        n = n.parentNode || n.host;
      } while (n);
    }
    return false;
  }
  function At(t) {
    return Ue(t).getComputedStyle(t);
  }
  function ic(t) {
    return ["table", "td", "th"].indexOf(vt(t)) >= 0;
  }
  function Bt(t) {
    return ((Jt(t) ? t.ownerDocument : t.document) || window.document).documentElement;
  }
  function Fn(t) {
    return vt(t) === "html" ? t : t.assignedSlot || t.parentNode || (pr(t) ? t.host : null) || Bt(t);
  }
  function xo(t) {
    return !Je(t) || At(t).position === "fixed" ? null : t.offsetParent;
  }
  function nc(t) {
    var e = /firefox/i.test(nr()), i = /Trident/i.test(nr());
    if (i && Je(t)) {
      var n = At(t);
      if (n.position === "fixed") return null;
    }
    var r = Fn(t);
    for (pr(r) && (r = r.host); Je(r) && ["html", "body"].indexOf(vt(r)) < 0; ) {
      var o = At(r);
      if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || e && o.willChange === "filter" || e && o.filter && o.filter !== "none") return r;
      r = r.parentNode;
    }
    return null;
  }
  function Zi(t) {
    for (var e = Ue(t), i = xo(t); i && ic(i) && At(i).position === "static"; ) i = xo(i);
    return i && (vt(i) === "html" || vt(i) === "body" && At(i).position === "static") ? e : i || nc(t) || e;
  }
  function mr(t) {
    return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
  }
  function Xi(t, e, i) {
    return Ut(t, Ln(e, i));
  }
  function sc(t, e, i) {
    var n = Xi(t, e, i);
    return n > i ? i : n;
  }
  function Wa() {
    return { top: 0, right: 0, bottom: 0, left: 0 };
  }
  function Fa(t) {
    return Object.assign({}, Wa(), t);
  }
  function Ga(t, e) {
    return e.reduce(function(i, n) {
      return i[n] = t, i;
    }, {});
  }
  var rc = function(e, i) {
    return e = typeof e == "function" ? e(Object.assign({}, i.rects, { placement: i.placement })) : e, Fa(typeof e != "number" ? e : Ga(e, Pi));
  };
  function oc(t) {
    var e, i = t.state, n = t.name, r = t.options, o = i.elements.arrow, l = i.modifiersData.popperOffsets, c = mt(i.placement), d = mr(c), v = [ke, qe].indexOf(c) >= 0, b = v ? "height" : "width";
    if (!(!o || !l)) {
      var y = rc(r.padding, i), _ = gr(o), p = d === "y" ? ze : ke, m = d === "y" ? Xe : qe, C = i.rects.reference[b] + i.rects.reference[d] - l[d] - i.rects.popper[b], S = l[d] - i.rects.reference[d], h = Zi(o), E = h ? d === "y" ? h.clientHeight || 0 : h.clientWidth || 0 : 0, I = C / 2 - S / 2, O = y[p], L = E - _[b] - y[m], f = E / 2 - _[b] / 2 + I, P = Xi(O, f, L), D = d;
      i.modifiersData[n] = (e = {}, e[D] = P, e.centerOffset = P - f, e);
    }
  }
  function ac(t) {
    var e = t.state, i = t.options, n = i.element, r = n === void 0 ? "[data-popper-arrow]" : n;
    r != null && (typeof r == "string" && (r = e.elements.popper.querySelector(r), !r) || Va(e.elements.popper, r) && (e.elements.arrow = r));
  }
  const ja = { name: "arrow", enabled: true, phase: "main", fn: oc, effect: ac, requires: ["popperOffsets"], requiresIfExists: ["preventOverflow"] };
  function Ai(t) {
    return t.split("-")[1];
  }
  var lc = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
  function uc(t, e) {
    var i = t.x, n = t.y, r = e.devicePixelRatio || 1;
    return { x: Ci(i * r) / r || 0, y: Ci(n * r) / r || 0 };
  }
  function Co(t) {
    var e, i = t.popper, n = t.popperRect, r = t.placement, o = t.variation, l = t.offsets, c = t.position, d = t.gpuAcceleration, v = t.adaptive, b = t.roundOffsets, y = t.isFixed, _ = l.x, p = _ === void 0 ? 0 : _, m = l.y, C = m === void 0 ? 0 : m, S = typeof b == "function" ? b({ x: p, y: C }) : { x: p, y: C };
    p = S.x, C = S.y;
    var h = l.hasOwnProperty("x"), E = l.hasOwnProperty("y"), I = ke, O = ze, L = window;
    if (v) {
      var f = Zi(i), P = "clientHeight", D = "clientWidth";
      if (f === Ue(i) && (f = Bt(i), At(f).position !== "static" && c === "absolute" && (P = "scrollHeight", D = "scrollWidth")), f = f, r === ze || (r === ke || r === qe) && o === xi) {
        O = Xe;
        var H = y && f === L && L.visualViewport ? L.visualViewport.height : f[P];
        C -= H - n.height, C *= d ? 1 : -1;
      }
      if (r === ke || (r === ze || r === Xe) && o === xi) {
        I = qe;
        var k = y && f === L && L.visualViewport ? L.visualViewport.width : f[D];
        p -= k - n.width, p *= d ? 1 : -1;
      }
    }
    var z = Object.assign({ position: c }, v && lc), B = b === true ? uc({ x: p, y: C }, Ue(i)) : { x: p, y: C };
    if (p = B.x, C = B.y, d) {
      var V;
      return Object.assign({}, z, (V = {}, V[O] = E ? "0" : "", V[I] = h ? "0" : "", V.transform = (L.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + C + "px)" : "translate3d(" + p + "px, " + C + "px, 0)", V));
    }
    return Object.assign({}, z, (e = {}, e[O] = E ? C + "px" : "", e[I] = h ? p + "px" : "", e.transform = "", e));
  }
  function cc(t) {
    var e = t.state, i = t.options, n = i.gpuAcceleration, r = n === void 0 ? true : n, o = i.adaptive, l = o === void 0 ? true : o, c = i.roundOffsets, d = c === void 0 ? true : c, v = { placement: mt(e.placement), variation: Ai(e.placement), popper: e.elements.popper, popperRect: e.rects.popper, gpuAcceleration: r, isFixed: e.options.strategy === "fixed" };
    e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Co(Object.assign({}, v, { offsets: e.modifiersData.popperOffsets, position: e.options.strategy, adaptive: l, roundOffsets: d })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Co(Object.assign({}, v, { offsets: e.modifiersData.arrow, position: "absolute", adaptive: false, roundOffsets: d })))), e.attributes.popper = Object.assign({}, e.attributes.popper, { "data-popper-placement": e.placement });
  }
  const Ya = { name: "computeStyles", enabled: true, phase: "beforeWrite", fn: cc, data: {} };
  var bn = { passive: true };
  function dc(t) {
    var e = t.state, i = t.instance, n = t.options, r = n.scroll, o = r === void 0 ? true : r, l = n.resize, c = l === void 0 ? true : l, d = Ue(e.elements.popper), v = [].concat(e.scrollParents.reference, e.scrollParents.popper);
    return o && v.forEach(function(b) {
      b.addEventListener("scroll", i.update, bn);
    }), c && d.addEventListener("resize", i.update, bn), function() {
      o && v.forEach(function(b) {
        b.removeEventListener("scroll", i.update, bn);
      }), c && d.removeEventListener("resize", i.update, bn);
    };
  }
  const Xa = { name: "eventListeners", enabled: true, phase: "write", fn: function() {
  }, effect: dc, data: {} };
  var fc = { left: "right", right: "left", bottom: "top", top: "bottom" };
  function In(t) {
    return t.replace(/left|right|bottom|top/g, function(e) {
      return fc[e];
    });
  }
  var hc = { start: "end", end: "start" };
  function Io(t) {
    return t.replace(/start|end/g, function(e) {
      return hc[e];
    });
  }
  function vr(t) {
    var e = Ue(t), i = e.pageXOffset, n = e.pageYOffset;
    return { scrollLeft: i, scrollTop: n };
  }
  function yr(t) {
    return Ii(Bt(t)).left + vr(t).scrollLeft;
  }
  function pc(t, e) {
    var i = Ue(t), n = Bt(t), r = i.visualViewport, o = n.clientWidth, l = n.clientHeight, c = 0, d = 0;
    if (r) {
      o = r.width, l = r.height;
      var v = Ba();
      (v || !v && e === "fixed") && (c = r.offsetLeft, d = r.offsetTop);
    }
    return { width: o, height: l, x: c + yr(t), y: d };
  }
  function gc(t) {
    var e, i = Bt(t), n = vr(t), r = (e = t.ownerDocument) == null ? void 0 : e.body, o = Ut(i.scrollWidth, i.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), l = Ut(i.scrollHeight, i.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), c = -n.scrollLeft + yr(t), d = -n.scrollTop;
    return At(r || i).direction === "rtl" && (c += Ut(i.clientWidth, r ? r.clientWidth : 0) - o), { width: o, height: l, x: c, y: d };
  }
  function br(t) {
    var e = At(t), i = e.overflow, n = e.overflowX, r = e.overflowY;
    return /auto|scroll|overlay|hidden/.test(i + r + n);
  }
  function qa(t) {
    return ["html", "body", "#document"].indexOf(vt(t)) >= 0 ? t.ownerDocument.body : Je(t) && br(t) ? t : qa(Fn(t));
  }
  function qi(t, e) {
    var i;
    e === void 0 && (e = []);
    var n = qa(t), r = n === ((i = t.ownerDocument) == null ? void 0 : i.body), o = Ue(n), l = r ? [o].concat(o.visualViewport || [], br(n) ? n : []) : n, c = e.concat(l);
    return r ? c : c.concat(qi(Fn(l)));
  }
  function sr(t) {
    return Object.assign({}, t, { left: t.x, top: t.y, right: t.x + t.width, bottom: t.y + t.height });
  }
  function mc(t, e) {
    var i = Ii(t, false, e === "fixed");
    return i.top = i.top + t.clientTop, i.left = i.left + t.clientLeft, i.bottom = i.top + t.clientHeight, i.right = i.left + t.clientWidth, i.width = t.clientWidth, i.height = t.clientHeight, i.x = i.left, i.y = i.top, i;
  }
  function Ao(t, e, i) {
    return e === fr ? sr(pc(t, i)) : Jt(e) ? mc(e, i) : sr(gc(Bt(t)));
  }
  function vc(t) {
    var e = qi(Fn(t)), i = ["absolute", "fixed"].indexOf(At(t).position) >= 0, n = i && Je(t) ? Zi(t) : t;
    return Jt(n) ? e.filter(function(r) {
      return Jt(r) && Va(r, n) && vt(r) !== "body";
    }) : [];
  }
  function yc(t, e, i, n) {
    var r = e === "clippingParents" ? vc(t) : [].concat(e), o = [].concat(r, [i]), l = o[0], c = o.reduce(function(d, v) {
      var b = Ao(t, v, n);
      return d.top = Ut(b.top, d.top), d.right = Ln(b.right, d.right), d.bottom = Ln(b.bottom, d.bottom), d.left = Ut(b.left, d.left), d;
    }, Ao(t, l, n));
    return c.width = c.right - c.left, c.height = c.bottom - c.top, c.x = c.left, c.y = c.top, c;
  }
  function Ua(t) {
    var e = t.reference, i = t.element, n = t.placement, r = n ? mt(n) : null, o = n ? Ai(n) : null, l = e.x + e.width / 2 - i.width / 2, c = e.y + e.height / 2 - i.height / 2, d;
    switch (r) {
      case ze:
        d = { x: l, y: e.y - i.height };
        break;
      case Xe:
        d = { x: l, y: e.y + e.height };
        break;
      case qe:
        d = { x: e.x + e.width, y: c };
        break;
      case ke:
        d = { x: e.x - i.width, y: c };
        break;
      default:
        d = { x: e.x, y: e.y };
    }
    var v = r ? mr(r) : null;
    if (v != null) {
      var b = v === "y" ? "height" : "width";
      switch (o) {
        case Qt:
          d[v] = d[v] - (e[b] / 2 - i[b] / 2);
          break;
        case xi:
          d[v] = d[v] + (e[b] / 2 - i[b] / 2);
          break;
      }
    }
    return d;
  }
  function wi(t, e) {
    e === void 0 && (e = {});
    var i = e, n = i.placement, r = n === void 0 ? t.placement : n, o = i.strategy, l = o === void 0 ? t.strategy : o, c = i.boundary, d = c === void 0 ? Aa : c, v = i.rootBoundary, b = v === void 0 ? fr : v, y = i.elementContext, _ = y === void 0 ? Ei : y, p = i.altBoundary, m = p === void 0 ? false : p, C = i.padding, S = C === void 0 ? 0 : C, h = Fa(typeof S != "number" ? S : Ga(S, Pi)), E = _ === Ei ? wa : Ei, I = t.rects.popper, O = t.elements[m ? E : _], L = yc(Jt(O) ? O : O.contextElement || Bt(t.elements.popper), d, b, l), f = Ii(t.elements.reference), P = Ua({ reference: f, element: I, placement: r }), D = sr(Object.assign({}, I, P)), H = _ === Ei ? D : f, k = { top: L.top - H.top + h.top, bottom: H.bottom - L.bottom + h.bottom, left: L.left - H.left + h.left, right: H.right - L.right + h.right }, z = t.modifiersData.offset;
    if (_ === Ei && z) {
      var B = z[r];
      Object.keys(k).forEach(function(V) {
        var X = [qe, Xe].indexOf(V) >= 0 ? 1 : -1, Z = [ze, Xe].indexOf(V) >= 0 ? "y" : "x";
        k[V] += B[Z] * X;
      });
    }
    return k;
  }
  function bc(t, e) {
    e === void 0 && (e = {});
    var i = e, n = i.placement, r = i.boundary, o = i.rootBoundary, l = i.padding, c = i.flipVariations, d = i.allowedAutoPlacements, v = d === void 0 ? hr : d, b = Ai(n), y = b ? c ? ir : ir.filter(function(m) {
      return Ai(m) === b;
    }) : Pi, _ = y.filter(function(m) {
      return v.indexOf(m) >= 0;
    });
    _.length === 0 && (_ = y);
    var p = _.reduce(function(m, C) {
      return m[C] = wi(t, { placement: C, boundary: r, rootBoundary: o, padding: l })[mt(C)], m;
    }, {});
    return Object.keys(p).sort(function(m, C) {
      return p[m] - p[C];
    });
  }
  function Ec(t) {
    if (mt(t) === Wn) return [];
    var e = In(t);
    return [Io(t), e, Io(e)];
  }
  function Tc(t) {
    var e = t.state, i = t.options, n = t.name;
    if (!e.modifiersData[n]._skip) {
      for (var r = i.mainAxis, o = r === void 0 ? true : r, l = i.altAxis, c = l === void 0 ? true : l, d = i.fallbackPlacements, v = i.padding, b = i.boundary, y = i.rootBoundary, _ = i.altBoundary, p = i.flipVariations, m = p === void 0 ? true : p, C = i.allowedAutoPlacements, S = e.options.placement, h = mt(S), E = h === S, I = d || (E || !m ? [In(S)] : Ec(S)), O = [S].concat(I).reduce(function(U, Q) {
        return U.concat(mt(Q) === Wn ? bc(e, { placement: Q, boundary: b, rootBoundary: y, padding: v, flipVariations: m, allowedAutoPlacements: C }) : Q);
      }, []), L = e.rects.reference, f = e.rects.popper, P = /* @__PURE__ */ new Map(), D = true, H = O[0], k = 0; k < O.length; k++) {
        var z = O[k], B = mt(z), V = Ai(z) === Qt, X = [ze, Xe].indexOf(B) >= 0, Z = X ? "width" : "height", F = wi(e, { placement: z, boundary: b, rootBoundary: y, altBoundary: _, padding: v }), W = X ? V ? qe : ke : V ? Xe : ze;
        L[Z] > f[Z] && (W = In(W));
        var Y = In(W), J = [];
        if (o && J.push(F[B] <= 0), c && J.push(F[W] <= 0, F[Y] <= 0), J.every(function(U) {
          return U;
        })) {
          H = z, D = false;
          break;
        }
        P.set(z, J);
      }
      if (D) for (var re = m ? 3 : 1, fe = function(Q) {
        var ee = O.find(function(K) {
          var ne = P.get(K);
          if (ne) return ne.slice(0, Q).every(function(Ee) {
            return Ee;
          });
        });
        if (ee) return H = ee, "break";
      }, _e = re; _e > 0; _e--) {
        var be = fe(_e);
        if (be === "break") break;
      }
      e.placement !== H && (e.modifiersData[n]._skip = true, e.placement = H, e.reset = true);
    }
  }
  const Ka = { name: "flip", enabled: true, phase: "main", fn: Tc, requiresIfExists: ["offset"], data: { _skip: false } };
  function wo(t, e, i) {
    return i === void 0 && (i = { x: 0, y: 0 }), { top: t.top - e.height - i.y, right: t.right - e.width + i.x, bottom: t.bottom - e.height + i.y, left: t.left - e.width - i.x };
  }
  function Oo(t) {
    return [ze, qe, Xe, ke].some(function(e) {
      return t[e] >= 0;
    });
  }
  function _c(t) {
    var e = t.state, i = t.name, n = e.rects.reference, r = e.rects.popper, o = e.modifiersData.preventOverflow, l = wi(e, { elementContext: "reference" }), c = wi(e, { altBoundary: true }), d = wo(l, n), v = wo(c, r, o), b = Oo(d), y = Oo(v);
    e.modifiersData[i] = { referenceClippingOffsets: d, popperEscapeOffsets: v, isReferenceHidden: b, hasPopperEscaped: y }, e.attributes.popper = Object.assign({}, e.attributes.popper, { "data-popper-reference-hidden": b, "data-popper-escaped": y });
  }
  const Za = { name: "hide", enabled: true, phase: "main", requiresIfExists: ["preventOverflow"], fn: _c };
  function Sc(t, e, i) {
    var n = mt(t), r = [ke, ze].indexOf(n) >= 0 ? -1 : 1, o = typeof i == "function" ? i(Object.assign({}, e, { placement: t })) : i, l = o[0], c = o[1];
    return l = l || 0, c = (c || 0) * r, [ke, qe].indexOf(n) >= 0 ? { x: c, y: l } : { x: l, y: c };
  }
  function xc(t) {
    var e = t.state, i = t.options, n = t.name, r = i.offset, o = r === void 0 ? [0, 0] : r, l = hr.reduce(function(b, y) {
      return b[y] = Sc(y, e.rects, o), b;
    }, {}), c = l[e.placement], d = c.x, v = c.y;
    e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += d, e.modifiersData.popperOffsets.y += v), e.modifiersData[n] = l;
  }
  const Qa = { name: "offset", enabled: true, phase: "main", requires: ["popperOffsets"], fn: xc };
  function Cc(t) {
    var e = t.state, i = t.name;
    e.modifiersData[i] = Ua({ reference: e.rects.reference, element: e.rects.popper, placement: e.placement });
  }
  const Ja = { name: "popperOffsets", enabled: true, phase: "read", fn: Cc, data: {} };
  function Ic(t) {
    return t === "x" ? "y" : "x";
  }
  function Ac(t) {
    var e = t.state, i = t.options, n = t.name, r = i.mainAxis, o = r === void 0 ? true : r, l = i.altAxis, c = l === void 0 ? false : l, d = i.boundary, v = i.rootBoundary, b = i.altBoundary, y = i.padding, _ = i.tether, p = _ === void 0 ? true : _, m = i.tetherOffset, C = m === void 0 ? 0 : m, S = wi(e, { boundary: d, rootBoundary: v, padding: y, altBoundary: b }), h = mt(e.placement), E = Ai(e.placement), I = !E, O = mr(h), L = Ic(O), f = e.modifiersData.popperOffsets, P = e.rects.reference, D = e.rects.popper, H = typeof C == "function" ? C(Object.assign({}, e.rects, { placement: e.placement })) : C, k = typeof H == "number" ? { mainAxis: H, altAxis: H } : Object.assign({ mainAxis: 0, altAxis: 0 }, H), z = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, B = { x: 0, y: 0 };
    if (f) {
      if (o) {
        var V, X = O === "y" ? ze : ke, Z = O === "y" ? Xe : qe, F = O === "y" ? "height" : "width", W = f[O], Y = W + S[X], J = W - S[Z], re = p ? -D[F] / 2 : 0, fe = E === Qt ? P[F] : D[F], _e = E === Qt ? -D[F] : -P[F], be = e.elements.arrow, U = p && be ? gr(be) : { width: 0, height: 0 }, Q = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Wa(), ee = Q[X], K = Q[Z], ne = Xi(0, P[F], U[F]), Ee = I ? P[F] / 2 - re - ne - ee - k.mainAxis : fe - ne - ee - k.mainAxis, Fe = I ? -P[F] / 2 + re + ne + K + k.mainAxis : _e + ne + K + k.mainAxis, xe = e.elements.arrow && Zi(e.elements.arrow), Ke = xe ? O === "y" ? xe.clientTop || 0 : xe.clientLeft || 0 : 0, ge = (V = z == null ? void 0 : z[O]) != null ? V : 0, ye = W + Ee - ge - Ke, Ae = W + Fe - ge, bt = Xi(p ? Ln(Y, ye) : Y, W, p ? Ut(J, Ae) : J);
        f[O] = bt, B[O] = bt - W;
      }
      if (c) {
        var nt, ct = O === "x" ? ze : ke, Mt = O === "x" ? Xe : qe, Le = f[L], dt = L === "y" ? "height" : "width", Ge = Le + S[ct], st = Le - S[Mt], Te = [ze, ke].indexOf(h) !== -1, Et = (nt = z == null ? void 0 : z[L]) != null ? nt : 0, Ce = Te ? Ge : Le - P[dt] - D[dt] - Et + k.altAxis, $e = Te ? Le + P[dt] + D[dt] - Et - k.altAxis : st, ft = p && Te ? sc(Ce, Le, $e) : Xi(p ? Ce : Ge, Le, p ? $e : st);
        f[L] = ft, B[L] = ft - Le;
      }
      e.modifiersData[n] = B;
    }
  }
  const el = { name: "preventOverflow", enabled: true, phase: "main", fn: Ac, requiresIfExists: ["offset"] };
  function wc(t) {
    return { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop };
  }
  function Oc(t) {
    return t === Ue(t) || !Je(t) ? vr(t) : wc(t);
  }
  function Mc(t) {
    var e = t.getBoundingClientRect(), i = Ci(e.width) / t.offsetWidth || 1, n = Ci(e.height) / t.offsetHeight || 1;
    return i !== 1 || n !== 1;
  }
  function Lc(t, e, i) {
    i === void 0 && (i = false);
    var n = Je(e), r = Je(e) && Mc(e), o = Bt(e), l = Ii(t, r, i), c = { scrollLeft: 0, scrollTop: 0 }, d = { x: 0, y: 0 };
    return (n || !n && !i) && ((vt(e) !== "body" || br(o)) && (c = Oc(e)), Je(e) ? (d = Ii(e, true), d.x += e.clientLeft, d.y += e.clientTop) : o && (d.x = yr(o))), { x: l.left + c.scrollLeft - d.x, y: l.top + c.scrollTop - d.y, width: l.width, height: l.height };
  }
  function Pc(t) {
    var e = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), n = [];
    t.forEach(function(o) {
      e.set(o.name, o);
    });
    function r(o) {
      i.add(o.name);
      var l = [].concat(o.requires || [], o.requiresIfExists || []);
      l.forEach(function(c) {
        if (!i.has(c)) {
          var d = e.get(c);
          d && r(d);
        }
      }), n.push(o);
    }
    return t.forEach(function(o) {
      i.has(o.name) || r(o);
    }), n;
  }
  function Dc(t) {
    var e = Pc(t);
    return Ra.reduce(function(i, n) {
      return i.concat(e.filter(function(r) {
        return r.phase === n;
      }));
    }, []);
  }
  function $c(t) {
    var e;
    return function() {
      return e || (e = new Promise(function(i) {
        Promise.resolve().then(function() {
          e = void 0, i(t());
        });
      })), e;
    };
  }
  function zc(t) {
    var e = t.reduce(function(i, n) {
      var r = i[n.name];
      return i[n.name] = r ? Object.assign({}, r, n, { options: Object.assign({}, r.options, n.options), data: Object.assign({}, r.data, n.data) }) : n, i;
    }, {});
    return Object.keys(e).map(function(i) {
      return e[i];
    });
  }
  var Mo = { placement: "bottom", modifiers: [], strategy: "absolute" };
  function Lo() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
    return !e.some(function(n) {
      return !(n && typeof n.getBoundingClientRect == "function");
    });
  }
  function tl(t) {
    t === void 0 && (t = {});
    var e = t, i = e.defaultModifiers, n = i === void 0 ? [] : i, r = e.defaultOptions, o = r === void 0 ? Mo : r;
    return function(c, d, v) {
      v === void 0 && (v = o);
      var b = { placement: "bottom", orderedModifiers: [], options: Object.assign({}, Mo, o), modifiersData: {}, elements: { reference: c, popper: d }, attributes: {}, styles: {} }, y = [], _ = false, p = { state: b, setOptions: function(h) {
        var E = typeof h == "function" ? h(b.options) : h;
        C(), b.options = Object.assign({}, o, b.options, E), b.scrollParents = { reference: Jt(c) ? qi(c) : c.contextElement ? qi(c.contextElement) : [], popper: qi(d) };
        var I = Dc(zc([].concat(n, b.options.modifiers)));
        return b.orderedModifiers = I.filter(function(O) {
          return O.enabled;
        }), m(), p.update();
      }, forceUpdate: function() {
        if (!_) {
          var h = b.elements, E = h.reference, I = h.popper;
          if (Lo(E, I)) {
            b.rects = { reference: Lc(E, Zi(I), b.options.strategy === "fixed"), popper: gr(I) }, b.reset = false, b.placement = b.options.placement, b.orderedModifiers.forEach(function(k) {
              return b.modifiersData[k.name] = Object.assign({}, k.data);
            });
            for (var O = 0; O < b.orderedModifiers.length; O++) {
              if (b.reset === true) {
                b.reset = false, O = -1;
                continue;
              }
              var L = b.orderedModifiers[O], f = L.fn, P = L.options, D = P === void 0 ? {} : P, H = L.name;
              typeof f == "function" && (b = f({ state: b, options: D, name: H, instance: p }) || b);
            }
          }
        }
      }, update: $c(function() {
        return new Promise(function(S) {
          p.forceUpdate(), S(b);
        });
      }), destroy: function() {
        C(), _ = true;
      } };
      if (!Lo(c, d)) return p;
      p.setOptions(v).then(function(S) {
        !_ && v.onFirstUpdate && v.onFirstUpdate(S);
      });
      function m() {
        b.orderedModifiers.forEach(function(S) {
          var h = S.name, E = S.options, I = E === void 0 ? {} : E, O = S.effect;
          if (typeof O == "function") {
            var L = O({ state: b, name: h, instance: p, options: I }), f = function() {
            };
            y.push(L || f);
          }
        });
      }
      function C() {
        y.forEach(function(S) {
          return S();
        }), y = [];
      }
      return p;
    };
  }
  var kc = [Xa, Ja, Ya, Ha, Qa, Ka, el, ja, Za], Er = tl({ defaultModifiers: kc });
  const il = Object.freeze(Object.defineProperty({ __proto__: null, afterMain: $a, afterRead: La, afterWrite: Na, applyStyles: Ha, arrow: ja, auto: Wn, basePlacements: Pi, beforeMain: Pa, beforeRead: Oa, beforeWrite: za, bottom: Xe, clippingParents: Aa, computeStyles: Ya, createPopper: Er, detectOverflow: wi, end: xi, eventListeners: Xa, flip: Ka, hide: Za, left: ke, main: Da, modifierPhases: Ra, offset: Qa, placements: hr, popper: Ei, popperGenerator: tl, popperOffsets: Ja, preventOverflow: el, read: Ma, reference: wa, right: qe, start: Qt, top: ze, variationPlacements: ir, viewport: fr, write: ka }, Symbol.toStringTag, { value: "Module" }));
  const $t = /* @__PURE__ */ new Map(), bs = { set(t, e, i) {
    $t.has(t) || $t.set(t, /* @__PURE__ */ new Map());
    const n = $t.get(t);
    if (!n.has(e) && n.size !== 0) {
      console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(n.keys())[0]}.`);
      return;
    }
    n.set(e, i);
  }, get(t, e) {
    return $t.has(t) && $t.get(t).get(e) || null;
  }, remove(t, e) {
    if (!$t.has(t)) return;
    const i = $t.get(t);
    i.delete(e), i.size === 0 && $t.delete(t);
  } }, Nc = 1e6, Rc = 1e3, rr = "transitionend", nl = (t) => (t && window.CSS && window.CSS.escape && (t = t.replace(/#([^\s"#']+)/g, (e, i) => `#${CSS.escape(i)}`)), t), Hc = (t) => t == null ? `${t}` : Object.prototype.toString.call(t).match(/\s([a-z]+)/i)[1].toLowerCase(), Bc = (t) => {
    do
      t += Math.floor(Math.random() * Nc);
    while (document.getElementById(t));
    return t;
  }, Vc = (t) => {
    if (!t) return 0;
    let { transitionDuration: e, transitionDelay: i } = window.getComputedStyle(t);
    const n = Number.parseFloat(e), r = Number.parseFloat(i);
    return !n && !r ? 0 : (e = e.split(",")[0], i = i.split(",")[0], (Number.parseFloat(e) + Number.parseFloat(i)) * Rc);
  }, sl = (t) => {
    t.dispatchEvent(new Event(rr));
  }, Ct = (t) => !t || typeof t != "object" ? false : (typeof t.jquery != "undefined" && (t = t[0]), typeof t.nodeType != "undefined"), Rt = (t) => Ct(t) ? t.jquery ? t[0] : t : typeof t == "string" && t.length > 0 ? document.querySelector(nl(t)) : null, Di = (t) => {
    if (!Ct(t) || t.getClientRects().length === 0) return false;
    const e = getComputedStyle(t).getPropertyValue("visibility") === "visible", i = t.closest("details:not([open])");
    if (!i) return e;
    if (i !== t) {
      const n = t.closest("summary");
      if (n && n.parentNode !== i || n === null) return false;
    }
    return e;
  }, Ht = (t) => !t || t.nodeType !== Node.ELEMENT_NODE || t.classList.contains("disabled") ? true : typeof t.disabled != "undefined" ? t.disabled : t.hasAttribute("disabled") && t.getAttribute("disabled") !== "false", rl = (t) => {
    if (!document.documentElement.attachShadow) return null;
    if (typeof t.getRootNode == "function") {
      const e = t.getRootNode();
      return e instanceof ShadowRoot ? e : null;
    }
    return t instanceof ShadowRoot ? t : t.parentNode ? rl(t.parentNode) : null;
  }, Pn = () => {
  }, Qi = (t) => {
    t.offsetHeight;
  }, ol = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, Es = [], Wc = (t) => {
    document.readyState === "loading" ? (Es.length || document.addEventListener("DOMContentLoaded", () => {
      for (const e of Es) e();
    }), Es.push(t)) : t();
  }, et = () => document.documentElement.dir === "rtl", it = (t) => {
    Wc(() => {
      const e = ol();
      if (e) {
        const i = t.NAME, n = e.fn[i];
        e.fn[i] = t.jQueryInterface, e.fn[i].Constructor = t, e.fn[i].noConflict = () => (e.fn[i] = n, t.jQueryInterface);
      }
    });
  }, We = (t, e = [], i = t) => typeof t == "function" ? t.call(...e) : i, al = (t, e, i = true) => {
    if (!i) {
      We(t);
      return;
    }
    const r = Vc(e) + 5;
    let o = false;
    const l = ({ target: c }) => {
      c === e && (o = true, e.removeEventListener(rr, l), We(t));
    };
    e.addEventListener(rr, l), setTimeout(() => {
      o || sl(e);
    }, r);
  }, Tr = (t, e, i, n) => {
    const r = t.length;
    let o = t.indexOf(e);
    return o === -1 ? !i && n ? t[r - 1] : t[0] : (o += i ? 1 : -1, n && (o = (o + r) % r), t[Math.max(0, Math.min(o, r - 1))]);
  }, Fc = /[^.]*(?=\..*)\.|.*/, Gc = /\..*/, jc = /::\d+$/, Ts = {};
  let Po = 1;
  const ll = { mouseenter: "mouseover", mouseleave: "mouseout" }, Yc = /* @__PURE__ */ new Set(["click", "dblclick", "mouseup", "mousedown", "contextmenu", "mousewheel", "DOMMouseScroll", "mouseover", "mouseout", "mousemove", "selectstart", "selectend", "keydown", "keypress", "keyup", "orientationchange", "touchstart", "touchmove", "touchend", "touchcancel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel", "gesturestart", "gesturechange", "gestureend", "focus", "blur", "change", "reset", "select", "submit", "focusin", "focusout", "load", "unload", "beforeunload", "resize", "move", "DOMContentLoaded", "readystatechange", "error", "abort", "scroll"]);
  function ul(t, e) {
    return e && `${e}::${Po++}` || t.uidEvent || Po++;
  }
  function cl(t) {
    const e = ul(t);
    return t.uidEvent = e, Ts[e] = Ts[e] || {}, Ts[e];
  }
  function Xc(t, e) {
    return function i(n) {
      return _r(n, { delegateTarget: t }), i.oneOff && q.off(t, n.type, e), e.apply(t, [n]);
    };
  }
  function qc(t, e, i) {
    return function n(r) {
      const o = t.querySelectorAll(e);
      for (let { target: l } = r; l && l !== this; l = l.parentNode) for (const c of o) if (c === l) return _r(r, { delegateTarget: l }), n.oneOff && q.off(t, r.type, e, i), i.apply(l, [r]);
    };
  }
  function dl(t, e, i = null) {
    return Object.values(t).find((n) => n.callable === e && n.delegationSelector === i);
  }
  function fl(t, e, i) {
    const n = typeof e == "string", r = n ? i : e || i;
    let o = hl(t);
    return Yc.has(o) || (o = t), [n, r, o];
  }
  function Do(t, e, i, n, r) {
    if (typeof e != "string" || !t) return;
    let [o, l, c] = fl(e, i, n);
    e in ll && (l = /* @__PURE__ */ ((m) => function(C) {
      if (!C.relatedTarget || C.relatedTarget !== C.delegateTarget && !C.delegateTarget.contains(C.relatedTarget)) return m.call(this, C);
    })(l));
    const d = cl(t), v = d[c] || (d[c] = {}), b = dl(v, l, o ? i : null);
    if (b) {
      b.oneOff = b.oneOff && r;
      return;
    }
    const y = ul(l, e.replace(Fc, "")), _ = o ? qc(t, i, l) : Xc(t, l);
    _.delegationSelector = o ? i : null, _.callable = l, _.oneOff = r, _.uidEvent = y, v[y] = _, t.addEventListener(c, _, o);
  }
  function or(t, e, i, n, r) {
    const o = dl(e[i], n, r);
    o && (t.removeEventListener(i, o, !!r), delete e[i][o.uidEvent]);
  }
  function Uc(t, e, i, n) {
    const r = e[i] || {};
    for (const [o, l] of Object.entries(r)) o.includes(n) && or(t, e, i, l.callable, l.delegationSelector);
  }
  function hl(t) {
    return t = t.replace(Gc, ""), ll[t] || t;
  }
  const q = { on(t, e, i, n) {
    Do(t, e, i, n, false);
  }, one(t, e, i, n) {
    Do(t, e, i, n, true);
  }, off(t, e, i, n) {
    if (typeof e != "string" || !t) return;
    const [r, o, l] = fl(e, i, n), c = l !== e, d = cl(t), v = d[l] || {}, b = e.startsWith(".");
    if (typeof o != "undefined") {
      if (!Object.keys(v).length) return;
      or(t, d, l, o, r ? i : null);
      return;
    }
    if (b) for (const y of Object.keys(d)) Uc(t, d, y, e.slice(1));
    for (const [y, _] of Object.entries(v)) {
      const p = y.replace(jc, "");
      (!c || e.includes(p)) && or(t, d, l, _.callable, _.delegationSelector);
    }
  }, trigger(t, e, i) {
    if (typeof e != "string" || !t) return null;
    const n = ol(), r = hl(e), o = e !== r;
    let l = null, c = true, d = true, v = false;
    o && n && (l = n.Event(e, i), n(t).trigger(l), c = !l.isPropagationStopped(), d = !l.isImmediatePropagationStopped(), v = l.isDefaultPrevented());
    const b = _r(new Event(e, { bubbles: c, cancelable: true }), i);
    return v && b.preventDefault(), d && t.dispatchEvent(b), b.defaultPrevented && l && l.preventDefault(), b;
  } };
  function _r(t, e = {}) {
    for (const [i, n] of Object.entries(e)) try {
      t[i] = n;
    } catch (r) {
      Object.defineProperty(t, i, { configurable: true, get() {
        return n;
      } });
    }
    return t;
  }
  function $o(t) {
    if (t === "true") return true;
    if (t === "false") return false;
    if (t === Number(t).toString()) return Number(t);
    if (t === "" || t === "null") return null;
    if (typeof t != "string") return t;
    try {
      return JSON.parse(decodeURIComponent(t));
    } catch (e) {
      return t;
    }
  }
  function _s(t) {
    return t.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
  }
  const It = { setDataAttribute(t, e, i) {
    t.setAttribute(`data-bs-${_s(e)}`, i);
  }, removeDataAttribute(t, e) {
    t.removeAttribute(`data-bs-${_s(e)}`);
  }, getDataAttributes(t) {
    if (!t) return {};
    const e = {}, i = Object.keys(t.dataset).filter((n) => n.startsWith("bs") && !n.startsWith("bsConfig"));
    for (const n of i) {
      let r = n.replace(/^bs/, "");
      r = r.charAt(0).toLowerCase() + r.slice(1), e[r] = $o(t.dataset[n]);
    }
    return e;
  }, getDataAttribute(t, e) {
    return $o(t.getAttribute(`data-bs-${_s(e)}`));
  } };
  class Ji {
    static get Default() {
      return {};
    }
    static get DefaultType() {
      return {};
    }
    static get NAME() {
      throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(e) {
      return e = this._mergeConfigObj(e), e = this._configAfterMerge(e), this._typeCheckConfig(e), e;
    }
    _configAfterMerge(e) {
      return e;
    }
    _mergeConfigObj(e, i) {
      const n = Ct(i) ? It.getDataAttribute(i, "config") : {};
      return we(we(we(we({}, this.constructor.Default), typeof n == "object" ? n : {}), Ct(i) ? It.getDataAttributes(i) : {}), typeof e == "object" ? e : {});
    }
    _typeCheckConfig(e, i = this.constructor.DefaultType) {
      for (const [n, r] of Object.entries(i)) {
        const o = e[n], l = Ct(o) ? "element" : Hc(o);
        if (!new RegExp(r).test(l)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${n}" provided type "${l}" but expected type "${r}".`);
      }
    }
  }
  const Kc = "5.3.8";
  class ut extends Ji {
    constructor(e, i) {
      super(), e = Rt(e), e && (this._element = e, this._config = this._getConfig(i), bs.set(this._element, this.constructor.DATA_KEY, this));
    }
    dispose() {
      bs.remove(this._element, this.constructor.DATA_KEY), q.off(this._element, this.constructor.EVENT_KEY);
      for (const e of Object.getOwnPropertyNames(this)) this[e] = null;
    }
    _queueCallback(e, i, n = true) {
      al(e, i, n);
    }
    _getConfig(e) {
      return e = this._mergeConfigObj(e, this._element), e = this._configAfterMerge(e), this._typeCheckConfig(e), e;
    }
    static getInstance(e) {
      return bs.get(Rt(e), this.DATA_KEY);
    }
    static getOrCreateInstance(e, i = {}) {
      return this.getInstance(e) || new this(e, typeof i == "object" ? i : null);
    }
    static get VERSION() {
      return Kc;
    }
    static get DATA_KEY() {
      return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
      return `.${this.DATA_KEY}`;
    }
    static eventName(e) {
      return `${e}${this.EVENT_KEY}`;
    }
  }
  const Ss = (t) => {
    let e = t.getAttribute("data-bs-target");
    if (!e || e === "#") {
      let i = t.getAttribute("href");
      if (!i || !i.includes("#") && !i.startsWith(".")) return null;
      i.includes("#") && !i.startsWith("#") && (i = `#${i.split("#")[1]}`), e = i && i !== "#" ? i.trim() : null;
    }
    return e ? e.split(",").map((i) => nl(i)).join(",") : null;
  }, ie = { find(t, e = document.documentElement) {
    return [].concat(...Element.prototype.querySelectorAll.call(e, t));
  }, findOne(t, e = document.documentElement) {
    return Element.prototype.querySelector.call(e, t);
  }, children(t, e) {
    return [].concat(...t.children).filter((i) => i.matches(e));
  }, parents(t, e) {
    const i = [];
    let n = t.parentNode.closest(e);
    for (; n; ) i.push(n), n = n.parentNode.closest(e);
    return i;
  }, prev(t, e) {
    let i = t.previousElementSibling;
    for (; i; ) {
      if (i.matches(e)) return [i];
      i = i.previousElementSibling;
    }
    return [];
  }, next(t, e) {
    let i = t.nextElementSibling;
    for (; i; ) {
      if (i.matches(e)) return [i];
      i = i.nextElementSibling;
    }
    return [];
  }, focusableChildren(t) {
    const e = ["a", "button", "input", "textarea", "select", "details", "[tabindex]", '[contenteditable="true"]'].map((i) => `${i}:not([tabindex^="-"])`).join(",");
    return this.find(e, t).filter((i) => !Ht(i) && Di(i));
  }, getSelectorFromElement(t) {
    const e = Ss(t);
    return e && ie.findOne(e) ? e : null;
  }, getElementFromSelector(t) {
    const e = Ss(t);
    return e ? ie.findOne(e) : null;
  }, getMultipleElementsFromSelector(t) {
    const e = Ss(t);
    return e ? ie.find(e) : [];
  } }, Gn = (t, e = "hide") => {
    const i = `click.dismiss${t.EVENT_KEY}`, n = t.NAME;
    q.on(document, i, `[data-bs-dismiss="${n}"]`, function(r) {
      if (["A", "AREA"].includes(this.tagName) && r.preventDefault(), Ht(this)) return;
      const o = ie.getElementFromSelector(this) || this.closest(`.${n}`);
      t.getOrCreateInstance(o)[e]();
    });
  }, Zc = "alert", Qc = "bs.alert", pl = `.${Qc}`, Jc = `close${pl}`, ed = `closed${pl}`, td = "fade", id = "show";
  class jn extends ut {
    static get NAME() {
      return Zc;
    }
    close() {
      if (q.trigger(this._element, Jc).defaultPrevented) return;
      this._element.classList.remove(id);
      const i = this._element.classList.contains(td);
      this._queueCallback(() => this._destroyElement(), this._element, i);
    }
    _destroyElement() {
      this._element.remove(), q.trigger(this._element, ed), this.dispose();
    }
    static jQueryInterface(e) {
      return this.each(function() {
        const i = jn.getOrCreateInstance(this);
        if (typeof e == "string") {
          if (i[e] === void 0 || e.startsWith("_") || e === "constructor") throw new TypeError(`No method named "${e}"`);
          i[e](this);
        }
      });
    }
  }
  Gn(jn, "close");
  it(jn);
  const nd = "button", sd = "bs.button", rd = `.${sd}`, od = ".data-api", ad = "active", zo = '[data-bs-toggle="button"]', ld = `click${rd}${od}`;
  class Yn extends ut {
    static get NAME() {
      return nd;
    }
    toggle() {
      this._element.setAttribute("aria-pressed", this._element.classList.toggle(ad));
    }
    static jQueryInterface(e) {
      return this.each(function() {
        const i = Yn.getOrCreateInstance(this);
        e === "toggle" && i[e]();
      });
    }
  }
  q.on(document, ld, zo, (t) => {
    t.preventDefault();
    const e = t.target.closest(zo);
    Yn.getOrCreateInstance(e).toggle();
  });
  it(Yn);
  const ud = "swipe", $i = ".bs.swipe", cd = `touchstart${$i}`, dd = `touchmove${$i}`, fd = `touchend${$i}`, hd = `pointerdown${$i}`, pd = `pointerup${$i}`, gd = "touch", md = "pen", vd = "pointer-event", yd = 40, bd = { endCallback: null, leftCallback: null, rightCallback: null }, Ed = { endCallback: "(function|null)", leftCallback: "(function|null)", rightCallback: "(function|null)" };
  class Dn extends Ji {
    constructor(e, i) {
      super(), this._element = e, !(!e || !Dn.isSupported()) && (this._config = this._getConfig(i), this._deltaX = 0, this._supportPointerEvents = !!window.PointerEvent, this._initEvents());
    }
    static get Default() {
      return bd;
    }
    static get DefaultType() {
      return Ed;
    }
    static get NAME() {
      return ud;
    }
    dispose() {
      q.off(this._element, $i);
    }
    _start(e) {
      if (!this._supportPointerEvents) {
        this._deltaX = e.touches[0].clientX;
        return;
      }
      this._eventIsPointerPenTouch(e) && (this._deltaX = e.clientX);
    }
    _end(e) {
      this._eventIsPointerPenTouch(e) && (this._deltaX = e.clientX - this._deltaX), this._handleSwipe(), We(this._config.endCallback);
    }
    _move(e) {
      this._deltaX = e.touches && e.touches.length > 1 ? 0 : e.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
      const e = Math.abs(this._deltaX);
      if (e <= yd) return;
      const i = e / this._deltaX;
      this._deltaX = 0, i && We(i > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
      this._supportPointerEvents ? (q.on(this._element, hd, (e) => this._start(e)), q.on(this._element, pd, (e) => this._end(e)), this._element.classList.add(vd)) : (q.on(this._element, cd, (e) => this._start(e)), q.on(this._element, dd, (e) => this._move(e)), q.on(this._element, fd, (e) => this._end(e)));
    }
    _eventIsPointerPenTouch(e) {
      return this._supportPointerEvents && (e.pointerType === md || e.pointerType === gd);
    }
    static isSupported() {
      return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
  }
  const Td = "carousel", _d = "bs.carousel", Vt = `.${_d}`, gl = ".data-api", Sd = "ArrowLeft", xd = "ArrowRight", Cd = 500, Wi = "next", yi = "prev", Ti = "left", An = "right", Id = `slide${Vt}`, xs = `slid${Vt}`, Ad = `keydown${Vt}`, wd = `mouseenter${Vt}`, Od = `mouseleave${Vt}`, Md = `dragstart${Vt}`, Ld = `load${Vt}${gl}`, Pd = `click${Vt}${gl}`, ml = "carousel", En = "active", Dd = "slide", $d = "carousel-item-end", zd = "carousel-item-start", kd = "carousel-item-next", Nd = "carousel-item-prev", vl = ".active", yl = ".carousel-item", Rd = vl + yl, Hd = ".carousel-item img", Bd = ".carousel-indicators", Vd = "[data-bs-slide], [data-bs-slide-to]", Wd = '[data-bs-ride="carousel"]', Fd = { [Sd]: An, [xd]: Ti }, Gd = { interval: 5e3, keyboard: true, pause: "hover", ride: false, touch: true, wrap: true }, jd = { interval: "(number|boolean)", keyboard: "boolean", pause: "(string|boolean)", ride: "(boolean|string)", touch: "boolean", wrap: "boolean" };
  class en extends ut {
    constructor(e, i) {
      super(e, i), this._interval = null, this._activeElement = null, this._isSliding = false, this.touchTimeout = null, this._swipeHelper = null, this._indicatorsElement = ie.findOne(Bd, this._element), this._addEventListeners(), this._config.ride === ml && this.cycle();
    }
    static get Default() {
      return Gd;
    }
    static get DefaultType() {
      return jd;
    }
    static get NAME() {
      return Td;
    }
    next() {
      this._slide(Wi);
    }
    nextWhenVisible() {
      !document.hidden && Di(this._element) && this.next();
    }
    prev() {
      this._slide(yi);
    }
    pause() {
      this._isSliding && sl(this._element), this._clearInterval();
    }
    cycle() {
      this._clearInterval(), this._updateInterval(), this._interval = setInterval(() => this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
      if (this._config.ride) {
        if (this._isSliding) {
          q.one(this._element, xs, () => this.cycle());
          return;
        }
        this.cycle();
      }
    }
    to(e) {
      const i = this._getItems();
      if (e > i.length - 1 || e < 0) return;
      if (this._isSliding) {
        q.one(this._element, xs, () => this.to(e));
        return;
      }
      const n = this._getItemIndex(this._getActive());
      if (n === e) return;
      const r = e > n ? Wi : yi;
      this._slide(r, i[e]);
    }
    dispose() {
      this._swipeHelper && this._swipeHelper.dispose(), super.dispose();
    }
    _configAfterMerge(e) {
      return e.defaultInterval = e.interval, e;
    }
    _addEventListeners() {
      this._config.keyboard && q.on(this._element, Ad, (e) => this._keydown(e)), this._config.pause === "hover" && (q.on(this._element, wd, () => this.pause()), q.on(this._element, Od, () => this._maybeEnableCycle())), this._config.touch && Dn.isSupported() && this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
      for (const n of ie.find(Hd, this._element)) q.on(n, Md, (r) => r.preventDefault());
      const i = { leftCallback: () => this._slide(this._directionToOrder(Ti)), rightCallback: () => this._slide(this._directionToOrder(An)), endCallback: () => {
        this._config.pause === "hover" && (this.pause(), this.touchTimeout && clearTimeout(this.touchTimeout), this.touchTimeout = setTimeout(() => this._maybeEnableCycle(), Cd + this._config.interval));
      } };
      this._swipeHelper = new Dn(this._element, i);
    }
    _keydown(e) {
      if (/input|textarea/i.test(e.target.tagName)) return;
      const i = Fd[e.key];
      i && (e.preventDefault(), this._slide(this._directionToOrder(i)));
    }
    _getItemIndex(e) {
      return this._getItems().indexOf(e);
    }
    _setActiveIndicatorElement(e) {
      if (!this._indicatorsElement) return;
      const i = ie.findOne(vl, this._indicatorsElement);
      i.classList.remove(En), i.removeAttribute("aria-current");
      const n = ie.findOne(`[data-bs-slide-to="${e}"]`, this._indicatorsElement);
      n && (n.classList.add(En), n.setAttribute("aria-current", "true"));
    }
    _updateInterval() {
      const e = this._activeElement || this._getActive();
      if (!e) return;
      const i = Number.parseInt(e.getAttribute("data-bs-interval"), 10);
      this._config.interval = i || this._config.defaultInterval;
    }
    _slide(e, i = null) {
      if (this._isSliding) return;
      const n = this._getActive(), r = e === Wi, o = i || Tr(this._getItems(), n, r, this._config.wrap);
      if (o === n) return;
      const l = this._getItemIndex(o), c = (p) => q.trigger(this._element, p, { relatedTarget: o, direction: this._orderToDirection(e), from: this._getItemIndex(n), to: l });
      if (c(Id).defaultPrevented || !n || !o) return;
      const v = !!this._interval;
      this.pause(), this._isSliding = true, this._setActiveIndicatorElement(l), this._activeElement = o;
      const b = r ? zd : $d, y = r ? kd : Nd;
      o.classList.add(y), Qi(o), n.classList.add(b), o.classList.add(b);
      const _ = () => {
        o.classList.remove(b, y), o.classList.add(En), n.classList.remove(En, y, b), this._isSliding = false, c(xs);
      };
      this._queueCallback(_, n, this._isAnimated()), v && this.cycle();
    }
    _isAnimated() {
      return this._element.classList.contains(Dd);
    }
    _getActive() {
      return ie.findOne(Rd, this._element);
    }
    _getItems() {
      return ie.find(yl, this._element);
    }
    _clearInterval() {
      this._interval && (clearInterval(this._interval), this._interval = null);
    }
    _directionToOrder(e) {
      return et() ? e === Ti ? yi : Wi : e === Ti ? Wi : yi;
    }
    _orderToDirection(e) {
      return et() ? e === yi ? Ti : An : e === yi ? An : Ti;
    }
    static jQueryInterface(e) {
      return this.each(function() {
        const i = en.getOrCreateInstance(this, e);
        if (typeof e == "number") {
          i.to(e);
          return;
        }
        if (typeof e == "string") {
          if (i[e] === void 0 || e.startsWith("_") || e === "constructor") throw new TypeError(`No method named "${e}"`);
          i[e]();
        }
      });
    }
  }
  q.on(document, Pd, Vd, function(t) {
    const e = ie.getElementFromSelector(this);
    if (!e || !e.classList.contains(ml)) return;
    t.preventDefault();
    const i = en.getOrCreateInstance(e), n = this.getAttribute("data-bs-slide-to");
    if (n) {
      i.to(n), i._maybeEnableCycle();
      return;
    }
    if (It.getDataAttribute(this, "slide") === "next") {
      i.next(), i._maybeEnableCycle();
      return;
    }
    i.prev(), i._maybeEnableCycle();
  });
  q.on(window, Ld, () => {
    const t = ie.find(Wd);
    for (const e of t) en.getOrCreateInstance(e);
  });
  it(en);
  const Yd = "collapse", Xd = "bs.collapse", tn = `.${Xd}`, qd = ".data-api", Ud = `show${tn}`, Kd = `shown${tn}`, Zd = `hide${tn}`, Qd = `hidden${tn}`, Jd = `click${tn}${qd}`, Cs = "show", Si = "collapse", Tn = "collapsing", ef = "collapsed", tf = `:scope .${Si} .${Si}`, nf = "collapse-horizontal", sf = "width", rf = "height", of = ".collapse.show, .collapse.collapsing", ar = '[data-bs-toggle="collapse"]', af = { parent: null, toggle: true }, lf = { parent: "(null|element)", toggle: "boolean" };
  class Oi extends ut {
    constructor(e, i) {
      super(e, i), this._isTransitioning = false, this._triggerArray = [];
      const n = ie.find(ar);
      for (const r of n) {
        const o = ie.getSelectorFromElement(r), l = ie.find(o).filter((c) => c === this._element);
        o !== null && l.length && this._triggerArray.push(r);
      }
      this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
    }
    static get Default() {
      return af;
    }
    static get DefaultType() {
      return lf;
    }
    static get NAME() {
      return Yd;
    }
    toggle() {
      this._isShown() ? this.hide() : this.show();
    }
    show() {
      if (this._isTransitioning || this._isShown()) return;
      let e = [];
      if (this._config.parent && (e = this._getFirstLevelChildren(of).filter((c) => c !== this._element).map((c) => Oi.getOrCreateInstance(c, { toggle: false }))), e.length && e[0]._isTransitioning || q.trigger(this._element, Ud).defaultPrevented) return;
      for (const c of e) c.hide();
      const n = this._getDimension();
      this._element.classList.remove(Si), this._element.classList.add(Tn), this._element.style[n] = 0, this._addAriaAndCollapsedClass(this._triggerArray, true), this._isTransitioning = true;
      const r = () => {
        this._isTransitioning = false, this._element.classList.remove(Tn), this._element.classList.add(Si, Cs), this._element.style[n] = "", q.trigger(this._element, Kd);
      }, l = `scroll${n[0].toUpperCase() + n.slice(1)}`;
      this._queueCallback(r, this._element, true), this._element.style[n] = `${this._element[l]}px`;
    }
    hide() {
      if (this._isTransitioning || !this._isShown() || q.trigger(this._element, Zd).defaultPrevented) return;
      const i = this._getDimension();
      this._element.style[i] = `${this._element.getBoundingClientRect()[i]}px`, Qi(this._element), this._element.classList.add(Tn), this._element.classList.remove(Si, Cs);
      for (const r of this._triggerArray) {
        const o = ie.getElementFromSelector(r);
        o && !this._isShown(o) && this._addAriaAndCollapsedClass([r], false);
      }
      this._isTransitioning = true;
      const n = () => {
        this._isTransitioning = false, this._element.classList.remove(Tn), this._element.classList.add(Si), q.trigger(this._element, Qd);
      };
      this._element.style[i] = "", this._queueCallback(n, this._element, true);
    }
    _isShown(e = this._element) {
      return e.classList.contains(Cs);
    }
    _configAfterMerge(e) {
      return e.toggle = !!e.toggle, e.parent = Rt(e.parent), e;
    }
    _getDimension() {
      return this._element.classList.contains(nf) ? sf : rf;
    }
    _initializeChildren() {
      if (!this._config.parent) return;
      const e = this._getFirstLevelChildren(ar);
      for (const i of e) {
        const n = ie.getElementFromSelector(i);
        n && this._addAriaAndCollapsedClass([i], this._isShown(n));
      }
    }
    _getFirstLevelChildren(e) {
      const i = ie.find(tf, this._config.parent);
      return ie.find(e, this._config.parent).filter((n) => !i.includes(n));
    }
    _addAriaAndCollapsedClass(e, i) {
      if (e.length) for (const n of e) n.classList.toggle(ef, !i), n.setAttribute("aria-expanded", i);
    }
    static jQueryInterface(e) {
      const i = {};
      return typeof e == "string" && /show|hide/.test(e) && (i.toggle = false), this.each(function() {
        const n = Oi.getOrCreateInstance(this, i);
        if (typeof e == "string") {
          if (typeof n[e] == "undefined") throw new TypeError(`No method named "${e}"`);
          n[e]();
        }
      });
    }
  }
  q.on(document, Jd, ar, function(t) {
    (t.target.tagName === "A" || t.delegateTarget && t.delegateTarget.tagName === "A") && t.preventDefault();
    for (const e of ie.getMultipleElementsFromSelector(this)) Oi.getOrCreateInstance(e, { toggle: false }).toggle();
  });
  it(Oi);
  const ko = "dropdown", uf = "bs.dropdown", ii = `.${uf}`, Sr = ".data-api", cf = "Escape", No = "Tab", df = "ArrowUp", Ro = "ArrowDown", ff = 2, hf = `hide${ii}`, pf = `hidden${ii}`, gf = `show${ii}`, mf = `shown${ii}`, bl = `click${ii}${Sr}`, El = `keydown${ii}${Sr}`, vf = `keyup${ii}${Sr}`, _i = "show", yf = "dropup", bf = "dropend", Ef = "dropstart", Tf = "dropup-center", _f = "dropdown-center", Xt = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)', Sf = `${Xt}.${_i}`, wn = ".dropdown-menu", xf = ".navbar", Cf = ".navbar-nav", If = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", Af = et() ? "top-end" : "top-start", wf = et() ? "top-start" : "top-end", Of = et() ? "bottom-end" : "bottom-start", Mf = et() ? "bottom-start" : "bottom-end", Lf = et() ? "left-start" : "right-start", Pf = et() ? "right-start" : "left-start", Df = "top", $f = "bottom", zf = { autoClose: true, boundary: "clippingParents", display: "dynamic", offset: [0, 2], popperConfig: null, reference: "toggle" }, kf = { autoClose: "(boolean|string)", boundary: "(string|element)", display: "string", offset: "(array|string|function)", popperConfig: "(null|object|function)", reference: "(string|element|object)" };
  class at extends ut {
    constructor(e, i) {
      super(e, i), this._popper = null, this._parent = this._element.parentNode, this._menu = ie.next(this._element, wn)[0] || ie.prev(this._element, wn)[0] || ie.findOne(wn, this._parent), this._inNavbar = this._detectNavbar();
    }
    static get Default() {
      return zf;
    }
    static get DefaultType() {
      return kf;
    }
    static get NAME() {
      return ko;
    }
    toggle() {
      return this._isShown() ? this.hide() : this.show();
    }
    show() {
      if (Ht(this._element) || this._isShown()) return;
      const e = { relatedTarget: this._element };
      if (!q.trigger(this._element, gf, e).defaultPrevented) {
        if (this._createPopper(), "ontouchstart" in document.documentElement && !this._parent.closest(Cf)) for (const n of [].concat(...document.body.children)) q.on(n, "mouseover", Pn);
        this._element.focus(), this._element.setAttribute("aria-expanded", true), this._menu.classList.add(_i), this._element.classList.add(_i), q.trigger(this._element, mf, e);
      }
    }
    hide() {
      if (Ht(this._element) || !this._isShown()) return;
      const e = { relatedTarget: this._element };
      this._completeHide(e);
    }
    dispose() {
      this._popper && this._popper.destroy(), super.dispose();
    }
    update() {
      this._inNavbar = this._detectNavbar(), this._popper && this._popper.update();
    }
    _completeHide(e) {
      if (!q.trigger(this._element, hf, e).defaultPrevented) {
        if ("ontouchstart" in document.documentElement) for (const n of [].concat(...document.body.children)) q.off(n, "mouseover", Pn);
        this._popper && this._popper.destroy(), this._menu.classList.remove(_i), this._element.classList.remove(_i), this._element.setAttribute("aria-expanded", "false"), It.removeDataAttribute(this._menu, "popper"), q.trigger(this._element, pf, e);
      }
    }
    _getConfig(e) {
      if (e = super._getConfig(e), typeof e.reference == "object" && !Ct(e.reference) && typeof e.reference.getBoundingClientRect != "function") throw new TypeError(`${ko.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
      return e;
    }
    _createPopper() {
      if (typeof il == "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org/docs/v2/)");
      let e = this._element;
      this._config.reference === "parent" ? e = this._parent : Ct(this._config.reference) ? e = Rt(this._config.reference) : typeof this._config.reference == "object" && (e = this._config.reference);
      const i = this._getPopperConfig();
      this._popper = Er(e, this._menu, i);
    }
    _isShown() {
      return this._menu.classList.contains(_i);
    }
    _getPlacement() {
      const e = this._parent;
      if (e.classList.contains(bf)) return Lf;
      if (e.classList.contains(Ef)) return Pf;
      if (e.classList.contains(Tf)) return Df;
      if (e.classList.contains(_f)) return $f;
      const i = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
      return e.classList.contains(yf) ? i ? wf : Af : i ? Mf : Of;
    }
    _detectNavbar() {
      return this._element.closest(xf) !== null;
    }
    _getOffset() {
      const { offset: e } = this._config;
      return typeof e == "string" ? e.split(",").map((i) => Number.parseInt(i, 10)) : typeof e == "function" ? (i) => e(i, this._element) : e;
    }
    _getPopperConfig() {
      const e = { placement: this._getPlacement(), modifiers: [{ name: "preventOverflow", options: { boundary: this._config.boundary } }, { name: "offset", options: { offset: this._getOffset() } }] };
      return (this._inNavbar || this._config.display === "static") && (It.setDataAttribute(this._menu, "popper", "static"), e.modifiers = [{ name: "applyStyles", enabled: false }]), we(we({}, e), We(this._config.popperConfig, [void 0, e]));
    }
    _selectMenuItem({ key: e, target: i }) {
      const n = ie.find(If, this._menu).filter((r) => Di(r));
      n.length && Tr(n, i, e === Ro, !n.includes(i)).focus();
    }
    static jQueryInterface(e) {
      return this.each(function() {
        const i = at.getOrCreateInstance(this, e);
        if (typeof e == "string") {
          if (typeof i[e] == "undefined") throw new TypeError(`No method named "${e}"`);
          i[e]();
        }
      });
    }
    static clearMenus(e) {
      if (e.button === ff || e.type === "keyup" && e.key !== No) return;
      const i = ie.find(Sf);
      for (const n of i) {
        const r = at.getInstance(n);
        if (!r || r._config.autoClose === false) continue;
        const o = e.composedPath(), l = o.includes(r._menu);
        if (o.includes(r._element) || r._config.autoClose === "inside" && !l || r._config.autoClose === "outside" && l || r._menu.contains(e.target) && (e.type === "keyup" && e.key === No || /input|select|option|textarea|form/i.test(e.target.tagName))) continue;
        const c = { relatedTarget: r._element };
        e.type === "click" && (c.clickEvent = e), r._completeHide(c);
      }
    }
    static dataApiKeydownHandler(e) {
      const i = /input|textarea/i.test(e.target.tagName), n = e.key === cf, r = [df, Ro].includes(e.key);
      if (!r && !n || i && !n) return;
      e.preventDefault();
      const o = this.matches(Xt) ? this : ie.prev(this, Xt)[0] || ie.next(this, Xt)[0] || ie.findOne(Xt, e.delegateTarget.parentNode), l = at.getOrCreateInstance(o);
      if (r) {
        e.stopPropagation(), l.show(), l._selectMenuItem(e);
        return;
      }
      l._isShown() && (e.stopPropagation(), l.hide(), o.focus());
    }
  }
  q.on(document, El, Xt, at.dataApiKeydownHandler);
  q.on(document, El, wn, at.dataApiKeydownHandler);
  q.on(document, bl, at.clearMenus);
  q.on(document, vf, at.clearMenus);
  q.on(document, bl, Xt, function(t) {
    t.preventDefault(), at.getOrCreateInstance(this).toggle();
  });
  it(at);
  const Tl = "backdrop", Nf = "fade", Ho = "show", Bo = `mousedown.bs.${Tl}`, Rf = { className: "modal-backdrop", clickCallback: null, isAnimated: false, isVisible: true, rootElement: "body" }, Hf = { className: "string", clickCallback: "(function|null)", isAnimated: "boolean", isVisible: "boolean", rootElement: "(element|string)" };
  class _l extends Ji {
    constructor(e) {
      super(), this._config = this._getConfig(e), this._isAppended = false, this._element = null;
    }
    static get Default() {
      return Rf;
    }
    static get DefaultType() {
      return Hf;
    }
    static get NAME() {
      return Tl;
    }
    show(e) {
      if (!this._config.isVisible) {
        We(e);
        return;
      }
      this._append();
      const i = this._getElement();
      this._config.isAnimated && Qi(i), i.classList.add(Ho), this._emulateAnimation(() => {
        We(e);
      });
    }
    hide(e) {
      if (!this._config.isVisible) {
        We(e);
        return;
      }
      this._getElement().classList.remove(Ho), this._emulateAnimation(() => {
        this.dispose(), We(e);
      });
    }
    dispose() {
      this._isAppended && (q.off(this._element, Bo), this._element.remove(), this._isAppended = false);
    }
    _getElement() {
      if (!this._element) {
        const e = document.createElement("div");
        e.className = this._config.className, this._config.isAnimated && e.classList.add(Nf), this._element = e;
      }
      return this._element;
    }
    _configAfterMerge(e) {
      return e.rootElement = Rt(e.rootElement), e;
    }
    _append() {
      if (this._isAppended) return;
      const e = this._getElement();
      this._config.rootElement.append(e), q.on(e, Bo, () => {
        We(this._config.clickCallback);
      }), this._isAppended = true;
    }
    _emulateAnimation(e) {
      al(e, this._getElement(), this._config.isAnimated);
    }
  }
  const Bf = "focustrap", Vf = "bs.focustrap", $n = `.${Vf}`, Wf = `focusin${$n}`, Ff = `keydown.tab${$n}`, Gf = "Tab", jf = "forward", Vo = "backward", Yf = { autofocus: true, trapElement: null }, Xf = { autofocus: "boolean", trapElement: "element" };
  class Sl extends Ji {
    constructor(e) {
      super(), this._config = this._getConfig(e), this._isActive = false, this._lastTabNavDirection = null;
    }
    static get Default() {
      return Yf;
    }
    static get DefaultType() {
      return Xf;
    }
    static get NAME() {
      return Bf;
    }
    activate() {
      this._isActive || (this._config.autofocus && this._config.trapElement.focus(), q.off(document, $n), q.on(document, Wf, (e) => this._handleFocusin(e)), q.on(document, Ff, (e) => this._handleKeydown(e)), this._isActive = true);
    }
    deactivate() {
      this._isActive && (this._isActive = false, q.off(document, $n));
    }
    _handleFocusin(e) {
      const { trapElement: i } = this._config;
      if (e.target === document || e.target === i || i.contains(e.target)) return;
      const n = ie.focusableChildren(i);
      n.length === 0 ? i.focus() : this._lastTabNavDirection === Vo ? n[n.length - 1].focus() : n[0].focus();
    }
    _handleKeydown(e) {
      e.key === Gf && (this._lastTabNavDirection = e.shiftKey ? Vo : jf);
    }
  }
  const Wo = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", Fo = ".sticky-top", _n = "padding-right", Go = "margin-right";
  class lr {
    constructor() {
      this._element = document.body;
    }
    getWidth() {
      const e = document.documentElement.clientWidth;
      return Math.abs(window.innerWidth - e);
    }
    hide() {
      const e = this.getWidth();
      this._disableOverFlow(), this._setElementAttributes(this._element, _n, (i) => i + e), this._setElementAttributes(Wo, _n, (i) => i + e), this._setElementAttributes(Fo, Go, (i) => i - e);
    }
    reset() {
      this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, _n), this._resetElementAttributes(Wo, _n), this._resetElementAttributes(Fo, Go);
    }
    isOverflowing() {
      return this.getWidth() > 0;
    }
    _disableOverFlow() {
      this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
    }
    _setElementAttributes(e, i, n) {
      const r = this.getWidth(), o = (l) => {
        if (l !== this._element && window.innerWidth > l.clientWidth + r) return;
        this._saveInitialAttribute(l, i);
        const c = window.getComputedStyle(l).getPropertyValue(i);
        l.style.setProperty(i, `${n(Number.parseFloat(c))}px`);
      };
      this._applyManipulationCallback(e, o);
    }
    _saveInitialAttribute(e, i) {
      const n = e.style.getPropertyValue(i);
      n && It.setDataAttribute(e, i, n);
    }
    _resetElementAttributes(e, i) {
      const n = (r) => {
        const o = It.getDataAttribute(r, i);
        if (o === null) {
          r.style.removeProperty(i);
          return;
        }
        It.removeDataAttribute(r, i), r.style.setProperty(i, o);
      };
      this._applyManipulationCallback(e, n);
    }
    _applyManipulationCallback(e, i) {
      if (Ct(e)) {
        i(e);
        return;
      }
      for (const n of ie.find(e, this._element)) i(n);
    }
  }
  const qf = "modal", Uf = "bs.modal", tt = `.${Uf}`, Kf = ".data-api", Zf = "Escape", Qf = `hide${tt}`, Jf = `hidePrevented${tt}`, xl = `hidden${tt}`, Cl = `show${tt}`, eh = `shown${tt}`, th = `resize${tt}`, ih = `click.dismiss${tt}`, nh = `mousedown.dismiss${tt}`, sh = `keydown.dismiss${tt}`, rh = `click${tt}${Kf}`, jo = "modal-open", oh = "fade", Yo = "show", Is = "modal-static", ah = ".modal.show", lh = ".modal-dialog", uh = ".modal-body", ch = '[data-bs-toggle="modal"]', dh = { backdrop: true, focus: true, keyboard: true }, fh = { backdrop: "(boolean|string)", focus: "boolean", keyboard: "boolean" };
  class ei extends ut {
    constructor(e, i) {
      super(e, i), this._dialog = ie.findOne(lh, this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = false, this._isTransitioning = false, this._scrollBar = new lr(), this._addEventListeners();
    }
    static get Default() {
      return dh;
    }
    static get DefaultType() {
      return fh;
    }
    static get NAME() {
      return qf;
    }
    toggle(e) {
      return this._isShown ? this.hide() : this.show(e);
    }
    show(e) {
      this._isShown || this._isTransitioning || q.trigger(this._element, Cl, { relatedTarget: e }).defaultPrevented || (this._isShown = true, this._isTransitioning = true, this._scrollBar.hide(), document.body.classList.add(jo), this._adjustDialog(), this._backdrop.show(() => this._showElement(e)));
    }
    hide() {
      !this._isShown || this._isTransitioning || q.trigger(this._element, Qf).defaultPrevented || (this._isShown = false, this._isTransitioning = true, this._focustrap.deactivate(), this._element.classList.remove(Yo), this._queueCallback(() => this._hideModal(), this._element, this._isAnimated()));
    }
    dispose() {
      q.off(window, tt), q.off(this._dialog, tt), this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
    }
    handleUpdate() {
      this._adjustDialog();
    }
    _initializeBackDrop() {
      return new _l({ isVisible: !!this._config.backdrop, isAnimated: this._isAnimated() });
    }
    _initializeFocusTrap() {
      return new Sl({ trapElement: this._element });
    }
    _showElement(e) {
      document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", true), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
      const i = ie.findOne(uh, this._dialog);
      i && (i.scrollTop = 0), Qi(this._element), this._element.classList.add(Yo);
      const n = () => {
        this._config.focus && this._focustrap.activate(), this._isTransitioning = false, q.trigger(this._element, eh, { relatedTarget: e });
      };
      this._queueCallback(n, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
      q.on(this._element, sh, (e) => {
        if (e.key === Zf) {
          if (this._config.keyboard) {
            this.hide();
            return;
          }
          this._triggerBackdropTransition();
        }
      }), q.on(window, th, () => {
        this._isShown && !this._isTransitioning && this._adjustDialog();
      }), q.on(this._element, nh, (e) => {
        q.one(this._element, ih, (i) => {
          if (!(this._element !== e.target || this._element !== i.target)) {
            if (this._config.backdrop === "static") {
              this._triggerBackdropTransition();
              return;
            }
            this._config.backdrop && this.hide();
          }
        });
      });
    }
    _hideModal() {
      this._element.style.display = "none", this._element.setAttribute("aria-hidden", true), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = false, this._backdrop.hide(() => {
        document.body.classList.remove(jo), this._resetAdjustments(), this._scrollBar.reset(), q.trigger(this._element, xl);
      });
    }
    _isAnimated() {
      return this._element.classList.contains(oh);
    }
    _triggerBackdropTransition() {
      if (q.trigger(this._element, Jf).defaultPrevented) return;
      const i = this._element.scrollHeight > document.documentElement.clientHeight, n = this._element.style.overflowY;
      n === "hidden" || this._element.classList.contains(Is) || (i || (this._element.style.overflowY = "hidden"), this._element.classList.add(Is), this._queueCallback(() => {
        this._element.classList.remove(Is), this._queueCallback(() => {
          this._element.style.overflowY = n;
        }, this._dialog);
      }, this._dialog), this._element.focus());
    }
    _adjustDialog() {
      const e = this._element.scrollHeight > document.documentElement.clientHeight, i = this._scrollBar.getWidth(), n = i > 0;
      if (n && !e) {
        const r = et() ? "paddingLeft" : "paddingRight";
        this._element.style[r] = `${i}px`;
      }
      if (!n && e) {
        const r = et() ? "paddingRight" : "paddingLeft";
        this._element.style[r] = `${i}px`;
      }
    }
    _resetAdjustments() {
      this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
    }
    static jQueryInterface(e, i) {
      return this.each(function() {
        const n = ei.getOrCreateInstance(this, e);
        if (typeof e == "string") {
          if (typeof n[e] == "undefined") throw new TypeError(`No method named "${e}"`);
          n[e](i);
        }
      });
    }
  }
  q.on(document, rh, ch, function(t) {
    const e = ie.getElementFromSelector(this);
    ["A", "AREA"].includes(this.tagName) && t.preventDefault(), q.one(e, Cl, (r) => {
      r.defaultPrevented || q.one(e, xl, () => {
        Di(this) && this.focus();
      });
    });
    const i = ie.findOne(ah);
    i && ei.getInstance(i).hide(), ei.getOrCreateInstance(e).toggle(this);
  });
  Gn(ei);
  it(ei);
  const hh = "offcanvas", ph = "bs.offcanvas", Ot = `.${ph}`, Il = ".data-api", gh = `load${Ot}${Il}`, mh = "Escape", Xo = "show", qo = "showing", Uo = "hiding", vh = "offcanvas-backdrop", Al = ".offcanvas.show", yh = `show${Ot}`, bh = `shown${Ot}`, Eh = `hide${Ot}`, Ko = `hidePrevented${Ot}`, wl = `hidden${Ot}`, Th = `resize${Ot}`, _h = `click${Ot}${Il}`, Sh = `keydown.dismiss${Ot}`, xh = '[data-bs-toggle="offcanvas"]', Ch = { backdrop: true, keyboard: true, scroll: false }, Ih = { backdrop: "(boolean|string)", keyboard: "boolean", scroll: "boolean" };
  class wt extends ut {
    constructor(e, i) {
      super(e, i), this._isShown = false, this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._addEventListeners();
    }
    static get Default() {
      return Ch;
    }
    static get DefaultType() {
      return Ih;
    }
    static get NAME() {
      return hh;
    }
    toggle(e) {
      return this._isShown ? this.hide() : this.show(e);
    }
    show(e) {
      if (this._isShown || q.trigger(this._element, yh, { relatedTarget: e }).defaultPrevented) return;
      this._isShown = true, this._backdrop.show(), this._config.scroll || new lr().hide(), this._element.setAttribute("aria-modal", true), this._element.setAttribute("role", "dialog"), this._element.classList.add(qo);
      const n = () => {
        (!this._config.scroll || this._config.backdrop) && this._focustrap.activate(), this._element.classList.add(Xo), this._element.classList.remove(qo), q.trigger(this._element, bh, { relatedTarget: e });
      };
      this._queueCallback(n, this._element, true);
    }
    hide() {
      if (!this._isShown || q.trigger(this._element, Eh).defaultPrevented) return;
      this._focustrap.deactivate(), this._element.blur(), this._isShown = false, this._element.classList.add(Uo), this._backdrop.hide();
      const i = () => {
        this._element.classList.remove(Xo, Uo), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._config.scroll || new lr().reset(), q.trigger(this._element, wl);
      };
      this._queueCallback(i, this._element, true);
    }
    dispose() {
      this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
    }
    _initializeBackDrop() {
      const e = () => {
        if (this._config.backdrop === "static") {
          q.trigger(this._element, Ko);
          return;
        }
        this.hide();
      }, i = !!this._config.backdrop;
      return new _l({ className: vh, isVisible: i, isAnimated: true, rootElement: this._element.parentNode, clickCallback: i ? e : null });
    }
    _initializeFocusTrap() {
      return new Sl({ trapElement: this._element });
    }
    _addEventListeners() {
      q.on(this._element, Sh, (e) => {
        if (e.key === mh) {
          if (this._config.keyboard) {
            this.hide();
            return;
          }
          q.trigger(this._element, Ko);
        }
      });
    }
    static jQueryInterface(e) {
      return this.each(function() {
        const i = wt.getOrCreateInstance(this, e);
        if (typeof e == "string") {
          if (i[e] === void 0 || e.startsWith("_") || e === "constructor") throw new TypeError(`No method named "${e}"`);
          i[e](this);
        }
      });
    }
  }
  q.on(document, _h, xh, function(t) {
    const e = ie.getElementFromSelector(this);
    if (["A", "AREA"].includes(this.tagName) && t.preventDefault(), Ht(this)) return;
    q.one(e, wl, () => {
      Di(this) && this.focus();
    });
    const i = ie.findOne(Al);
    i && i !== e && wt.getInstance(i).hide(), wt.getOrCreateInstance(e).toggle(this);
  });
  q.on(window, gh, () => {
    for (const t of ie.find(Al)) wt.getOrCreateInstance(t).show();
  });
  q.on(window, Th, () => {
    for (const t of ie.find("[aria-modal][class*=show][class*=offcanvas-]")) getComputedStyle(t).position !== "fixed" && wt.getOrCreateInstance(t).hide();
  });
  Gn(wt);
  it(wt);
  const Ah = /^aria-[\w-]*$/i, Ol = { "*": ["class", "dir", "id", "lang", "role", Ah], a: ["target", "href", "title", "rel"], area: [], b: [], br: [], col: [], code: [], dd: [], div: [], dl: [], dt: [], em: [], hr: [], h1: [], h2: [], h3: [], h4: [], h5: [], h6: [], i: [], img: ["src", "srcset", "alt", "title", "width", "height"], li: [], ol: [], p: [], pre: [], s: [], small: [], span: [], sub: [], sup: [], strong: [], u: [], ul: [] }, wh = /* @__PURE__ */ new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]), Oh = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, Mh = (t, e) => {
    const i = t.nodeName.toLowerCase();
    return e.includes(i) ? wh.has(i) ? !!Oh.test(t.nodeValue) : true : e.filter((n) => n instanceof RegExp).some((n) => n.test(i));
  };
  function Lh(t, e, i) {
    if (!t.length) return t;
    if (i && typeof i == "function") return i(t);
    const r = new window.DOMParser().parseFromString(t, "text/html"), o = [].concat(...r.body.querySelectorAll("*"));
    for (const l of o) {
      const c = l.nodeName.toLowerCase();
      if (!Object.keys(e).includes(c)) {
        l.remove();
        continue;
      }
      const d = [].concat(...l.attributes), v = [].concat(e["*"] || [], e[c] || []);
      for (const b of d) Mh(b, v) || l.removeAttribute(b.nodeName);
    }
    return r.body.innerHTML;
  }
  const Ph = "TemplateFactory", Dh = { allowList: Ol, content: {}, extraClass: "", html: false, sanitize: true, sanitizeFn: null, template: "<div></div>" }, $h = { allowList: "object", content: "object", extraClass: "(string|function)", html: "boolean", sanitize: "boolean", sanitizeFn: "(null|function)", template: "string" }, zh = { entry: "(string|element|function|null)", selector: "(string|element)" };
  class kh extends Ji {
    constructor(e) {
      super(), this._config = this._getConfig(e);
    }
    static get Default() {
      return Dh;
    }
    static get DefaultType() {
      return $h;
    }
    static get NAME() {
      return Ph;
    }
    getContent() {
      return Object.values(this._config.content).map((e) => this._resolvePossibleFunction(e)).filter(Boolean);
    }
    hasContent() {
      return this.getContent().length > 0;
    }
    changeContent(e) {
      return this._checkContent(e), this._config.content = we(we({}, this._config.content), e), this;
    }
    toHtml() {
      const e = document.createElement("div");
      e.innerHTML = this._maybeSanitize(this._config.template);
      for (const [r, o] of Object.entries(this._config.content)) this._setContent(e, o, r);
      const i = e.children[0], n = this._resolvePossibleFunction(this._config.extraClass);
      return n && i.classList.add(...n.split(" ")), i;
    }
    _typeCheckConfig(e) {
      super._typeCheckConfig(e), this._checkContent(e.content);
    }
    _checkContent(e) {
      for (const [i, n] of Object.entries(e)) super._typeCheckConfig({ selector: i, entry: n }, zh);
    }
    _setContent(e, i, n) {
      const r = ie.findOne(n, e);
      if (r) {
        if (i = this._resolvePossibleFunction(i), !i) {
          r.remove();
          return;
        }
        if (Ct(i)) {
          this._putElementInTemplate(Rt(i), r);
          return;
        }
        if (this._config.html) {
          r.innerHTML = this._maybeSanitize(i);
          return;
        }
        r.textContent = i;
      }
    }
    _maybeSanitize(e) {
      return this._config.sanitize ? Lh(e, this._config.allowList, this._config.sanitizeFn) : e;
    }
    _resolvePossibleFunction(e) {
      return We(e, [void 0, this]);
    }
    _putElementInTemplate(e, i) {
      if (this._config.html) {
        i.innerHTML = "", i.append(e);
        return;
      }
      i.textContent = e.textContent;
    }
  }
  const Nh = "tooltip", Rh = /* @__PURE__ */ new Set(["sanitize", "allowList", "sanitizeFn"]), As = "fade", Hh = "modal", Sn = "show", Bh = ".tooltip-inner", Zo = `.${Hh}`, Qo = "hide.bs.modal", Fi = "hover", ws = "focus", Os = "click", Vh = "manual", Wh = "hide", Fh = "hidden", Gh = "show", jh = "shown", Yh = "inserted", Xh = "click", qh = "focusin", Uh = "focusout", Kh = "mouseenter", Zh = "mouseleave", Qh = { AUTO: "auto", TOP: "top", RIGHT: et() ? "left" : "right", BOTTOM: "bottom", LEFT: et() ? "right" : "left" }, Jh = { allowList: Ol, animation: true, boundary: "clippingParents", container: false, customClass: "", delay: 0, fallbackPlacements: ["top", "right", "bottom", "left"], html: false, offset: [0, 6], placement: "top", popperConfig: null, sanitize: true, sanitizeFn: null, selector: false, template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>', title: "", trigger: "hover focus" }, ep = { allowList: "object", animation: "boolean", boundary: "(string|element)", container: "(string|element|boolean)", customClass: "(string|function)", delay: "(number|object)", fallbackPlacements: "array", html: "boolean", offset: "(array|string|function)", placement: "(string|function)", popperConfig: "(null|object|function)", sanitize: "boolean", sanitizeFn: "(null|function)", selector: "(string|boolean)", template: "string", title: "(string|element|function)", trigger: "string" };
  class ni extends ut {
    constructor(e, i) {
      if (typeof il == "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org/docs/v2/)");
      super(e, i), this._isEnabled = true, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
    }
    static get Default() {
      return Jh;
    }
    static get DefaultType() {
      return ep;
    }
    static get NAME() {
      return Nh;
    }
    enable() {
      this._isEnabled = true;
    }
    disable() {
      this._isEnabled = false;
    }
    toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    }
    toggle() {
      if (this._isEnabled) {
        if (this._isShown()) {
          this._leave();
          return;
        }
        this._enter();
      }
    }
    dispose() {
      clearTimeout(this._timeout), q.off(this._element.closest(Zo), Qo, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
    }
    show() {
      if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
      if (!(this._isWithContent() && this._isEnabled)) return;
      const e = q.trigger(this._element, this.constructor.eventName(Gh)), n = (rl(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
      if (e.defaultPrevented || !n) return;
      this._disposePopper();
      const r = this._getTipElement();
      this._element.setAttribute("aria-describedby", r.getAttribute("id"));
      const { container: o } = this._config;
      if (this._element.ownerDocument.documentElement.contains(this.tip) || (o.append(r), q.trigger(this._element, this.constructor.eventName(Yh))), this._popper = this._createPopper(r), r.classList.add(Sn), "ontouchstart" in document.documentElement) for (const c of [].concat(...document.body.children)) q.on(c, "mouseover", Pn);
      const l = () => {
        q.trigger(this._element, this.constructor.eventName(jh)), this._isHovered === false && this._leave(), this._isHovered = false;
      };
      this._queueCallback(l, this.tip, this._isAnimated());
    }
    hide() {
      if (!this._isShown() || q.trigger(this._element, this.constructor.eventName(Wh)).defaultPrevented) return;
      if (this._getTipElement().classList.remove(Sn), "ontouchstart" in document.documentElement) for (const r of [].concat(...document.body.children)) q.off(r, "mouseover", Pn);
      this._activeTrigger[Os] = false, this._activeTrigger[ws] = false, this._activeTrigger[Fi] = false, this._isHovered = null;
      const n = () => {
        this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), q.trigger(this._element, this.constructor.eventName(Fh)));
      };
      this._queueCallback(n, this.tip, this._isAnimated());
    }
    update() {
      this._popper && this._popper.update();
    }
    _isWithContent() {
      return !!this._getTitle();
    }
    _getTipElement() {
      return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
    }
    _createTipElement(e) {
      const i = this._getTemplateFactory(e).toHtml();
      if (!i) return null;
      i.classList.remove(As, Sn), i.classList.add(`bs-${this.constructor.NAME}-auto`);
      const n = Bc(this.constructor.NAME).toString();
      return i.setAttribute("id", n), this._isAnimated() && i.classList.add(As), i;
    }
    setContent(e) {
      this._newContent = e, this._isShown() && (this._disposePopper(), this.show());
    }
    _getTemplateFactory(e) {
      return this._templateFactory ? this._templateFactory.changeContent(e) : this._templateFactory = new kh(vi(we({}, this._config), { content: e, extraClass: this._resolvePossibleFunction(this._config.customClass) })), this._templateFactory;
    }
    _getContentForTemplate() {
      return { [Bh]: this._getTitle() };
    }
    _getTitle() {
      return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    _initializeOnDelegatedTarget(e) {
      return this.constructor.getOrCreateInstance(e.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
      return this._config.animation || this.tip && this.tip.classList.contains(As);
    }
    _isShown() {
      return this.tip && this.tip.classList.contains(Sn);
    }
    _createPopper(e) {
      const i = We(this._config.placement, [this, e, this._element]), n = Qh[i.toUpperCase()];
      return Er(this._element, e, this._getPopperConfig(n));
    }
    _getOffset() {
      const { offset: e } = this._config;
      return typeof e == "string" ? e.split(",").map((i) => Number.parseInt(i, 10)) : typeof e == "function" ? (i) => e(i, this._element) : e;
    }
    _resolvePossibleFunction(e) {
      return We(e, [this._element, this._element]);
    }
    _getPopperConfig(e) {
      const i = { placement: e, modifiers: [{ name: "flip", options: { fallbackPlacements: this._config.fallbackPlacements } }, { name: "offset", options: { offset: this._getOffset() } }, { name: "preventOverflow", options: { boundary: this._config.boundary } }, { name: "arrow", options: { element: `.${this.constructor.NAME}-arrow` } }, { name: "preSetPlacement", enabled: true, phase: "beforeMain", fn: (n) => {
        this._getTipElement().setAttribute("data-popper-placement", n.state.placement);
      } }] };
      return we(we({}, i), We(this._config.popperConfig, [void 0, i]));
    }
    _setListeners() {
      const e = this._config.trigger.split(" ");
      for (const i of e) if (i === "click") q.on(this._element, this.constructor.eventName(Xh), this._config.selector, (n) => {
        const r = this._initializeOnDelegatedTarget(n);
        r._activeTrigger[Os] = !(r._isShown() && r._activeTrigger[Os]), r.toggle();
      });
      else if (i !== Vh) {
        const n = i === Fi ? this.constructor.eventName(Kh) : this.constructor.eventName(qh), r = i === Fi ? this.constructor.eventName(Zh) : this.constructor.eventName(Uh);
        q.on(this._element, n, this._config.selector, (o) => {
          const l = this._initializeOnDelegatedTarget(o);
          l._activeTrigger[o.type === "focusin" ? ws : Fi] = true, l._enter();
        }), q.on(this._element, r, this._config.selector, (o) => {
          const l = this._initializeOnDelegatedTarget(o);
          l._activeTrigger[o.type === "focusout" ? ws : Fi] = l._element.contains(o.relatedTarget), l._leave();
        });
      }
      this._hideModalHandler = () => {
        this._element && this.hide();
      }, q.on(this._element.closest(Zo), Qo, this._hideModalHandler);
    }
    _fixTitle() {
      const e = this._element.getAttribute("title");
      e && (!this._element.getAttribute("aria-label") && !this._element.textContent.trim() && this._element.setAttribute("aria-label", e), this._element.setAttribute("data-bs-original-title", e), this._element.removeAttribute("title"));
    }
    _enter() {
      if (this._isShown() || this._isHovered) {
        this._isHovered = true;
        return;
      }
      this._isHovered = true, this._setTimeout(() => {
        this._isHovered && this.show();
      }, this._config.delay.show);
    }
    _leave() {
      this._isWithActiveTrigger() || (this._isHovered = false, this._setTimeout(() => {
        this._isHovered || this.hide();
      }, this._config.delay.hide));
    }
    _setTimeout(e, i) {
      clearTimeout(this._timeout), this._timeout = setTimeout(e, i);
    }
    _isWithActiveTrigger() {
      return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(e) {
      const i = It.getDataAttributes(this._element);
      for (const n of Object.keys(i)) Rh.has(n) && delete i[n];
      return e = we(we({}, i), typeof e == "object" && e ? e : {}), e = this._mergeConfigObj(e), e = this._configAfterMerge(e), this._typeCheckConfig(e), e;
    }
    _configAfterMerge(e) {
      return e.container = e.container === false ? document.body : Rt(e.container), typeof e.delay == "number" && (e.delay = { show: e.delay, hide: e.delay }), typeof e.title == "number" && (e.title = e.title.toString()), typeof e.content == "number" && (e.content = e.content.toString()), e;
    }
    _getDelegateConfig() {
      const e = {};
      for (const [i, n] of Object.entries(this._config)) this.constructor.Default[i] !== n && (e[i] = n);
      return e.selector = false, e.trigger = "manual", e;
    }
    _disposePopper() {
      this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
    }
    static jQueryInterface(e) {
      return this.each(function() {
        const i = ni.getOrCreateInstance(this, e);
        if (typeof e == "string") {
          if (typeof i[e] == "undefined") throw new TypeError(`No method named "${e}"`);
          i[e]();
        }
      });
    }
  }
  it(ni);
  const tp = "popover", ip = ".popover-header", np = ".popover-body", sp = vi(we({}, ni.Default), { content: "", offset: [0, 8], placement: "right", template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>', trigger: "click" }), rp = vi(we({}, ni.DefaultType), { content: "(null|string|element|function)" });
  class xr extends ni {
    static get Default() {
      return sp;
    }
    static get DefaultType() {
      return rp;
    }
    static get NAME() {
      return tp;
    }
    _isWithContent() {
      return this._getTitle() || this._getContent();
    }
    _getContentForTemplate() {
      return { [ip]: this._getTitle(), [np]: this._getContent() };
    }
    _getContent() {
      return this._resolvePossibleFunction(this._config.content);
    }
    static jQueryInterface(e) {
      return this.each(function() {
        const i = xr.getOrCreateInstance(this, e);
        if (typeof e == "string") {
          if (typeof i[e] == "undefined") throw new TypeError(`No method named "${e}"`);
          i[e]();
        }
      });
    }
  }
  it(xr);
  const op = "scrollspy", ap = "bs.scrollspy", Cr = `.${ap}`, lp = ".data-api", up = `activate${Cr}`, Jo = `click${Cr}`, cp = `load${Cr}${lp}`, dp = "dropdown-item", bi = "active", fp = '[data-bs-spy="scroll"]', Ms = "[href]", hp = ".nav, .list-group", ea = ".nav-link", pp = ".nav-item", gp = ".list-group-item", mp = `${ea}, ${pp} > ${ea}, ${gp}`, vp = ".dropdown", yp = ".dropdown-toggle", bp = { offset: null, rootMargin: "0px 0px -25%", smoothScroll: false, target: null, threshold: [0.1, 0.5, 1] }, Ep = { offset: "(number|null)", rootMargin: "string", smoothScroll: "boolean", target: "element", threshold: "array" };
  class Xn extends ut {
    constructor(e, i) {
      super(e, i), this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map(), this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element, this._activeTarget = null, this._observer = null, this._previousScrollData = { visibleEntryTop: 0, parentScrollTop: 0 }, this.refresh();
    }
    static get Default() {
      return bp;
    }
    static get DefaultType() {
      return Ep;
    }
    static get NAME() {
      return op;
    }
    refresh() {
      this._initializeTargetsAndObservables(), this._maybeEnableSmoothScroll(), this._observer ? this._observer.disconnect() : this._observer = this._getNewObserver();
      for (const e of this._observableSections.values()) this._observer.observe(e);
    }
    dispose() {
      this._observer.disconnect(), super.dispose();
    }
    _configAfterMerge(e) {
      return e.target = Rt(e.target) || document.body, e.rootMargin = e.offset ? `${e.offset}px 0px -30%` : e.rootMargin, typeof e.threshold == "string" && (e.threshold = e.threshold.split(",").map((i) => Number.parseFloat(i))), e;
    }
    _maybeEnableSmoothScroll() {
      this._config.smoothScroll && (q.off(this._config.target, Jo), q.on(this._config.target, Jo, Ms, (e) => {
        const i = this._observableSections.get(e.target.hash);
        if (i) {
          e.preventDefault();
          const n = this._rootElement || window, r = i.offsetTop - this._element.offsetTop;
          if (n.scrollTo) {
            n.scrollTo({ top: r, behavior: "smooth" });
            return;
          }
          n.scrollTop = r;
        }
      }));
    }
    _getNewObserver() {
      const e = { root: this._rootElement, threshold: this._config.threshold, rootMargin: this._config.rootMargin };
      return new IntersectionObserver((i) => this._observerCallback(i), e);
    }
    _observerCallback(e) {
      const i = (l) => this._targetLinks.get(`#${l.target.id}`), n = (l) => {
        this._previousScrollData.visibleEntryTop = l.target.offsetTop, this._process(i(l));
      }, r = (this._rootElement || document.documentElement).scrollTop, o = r >= this._previousScrollData.parentScrollTop;
      this._previousScrollData.parentScrollTop = r;
      for (const l of e) {
        if (!l.isIntersecting) {
          this._activeTarget = null, this._clearActiveClass(i(l));
          continue;
        }
        const c = l.target.offsetTop >= this._previousScrollData.visibleEntryTop;
        if (o && c) {
          if (n(l), !r) return;
          continue;
        }
        !o && !c && n(l);
      }
    }
    _initializeTargetsAndObservables() {
      this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map();
      const e = ie.find(Ms, this._config.target);
      for (const i of e) {
        if (!i.hash || Ht(i)) continue;
        const n = ie.findOne(decodeURI(i.hash), this._element);
        Di(n) && (this._targetLinks.set(decodeURI(i.hash), i), this._observableSections.set(i.hash, n));
      }
    }
    _process(e) {
      this._activeTarget !== e && (this._clearActiveClass(this._config.target), this._activeTarget = e, e.classList.add(bi), this._activateParents(e), q.trigger(this._element, up, { relatedTarget: e }));
    }
    _activateParents(e) {
      if (e.classList.contains(dp)) {
        ie.findOne(yp, e.closest(vp)).classList.add(bi);
        return;
      }
      for (const i of ie.parents(e, hp)) for (const n of ie.prev(i, mp)) n.classList.add(bi);
    }
    _clearActiveClass(e) {
      e.classList.remove(bi);
      const i = ie.find(`${Ms}.${bi}`, e);
      for (const n of i) n.classList.remove(bi);
    }
    static jQueryInterface(e) {
      return this.each(function() {
        const i = Xn.getOrCreateInstance(this, e);
        if (typeof e == "string") {
          if (i[e] === void 0 || e.startsWith("_") || e === "constructor") throw new TypeError(`No method named "${e}"`);
          i[e]();
        }
      });
    }
  }
  q.on(window, cp, () => {
    for (const t of ie.find(fp)) Xn.getOrCreateInstance(t);
  });
  it(Xn);
  const Tp = "tab", _p = "bs.tab", si = `.${_p}`, Sp = `hide${si}`, xp = `hidden${si}`, Cp = `show${si}`, Ip = `shown${si}`, Ap = `click${si}`, wp = `keydown${si}`, Op = `load${si}`, Mp = "ArrowLeft", ta = "ArrowRight", Lp = "ArrowUp", ia = "ArrowDown", Ls = "Home", na = "End", qt = "active", sa = "fade", Ps = "show", Pp = "dropdown", Ml = ".dropdown-toggle", Dp = ".dropdown-menu", Ds = `:not(${Ml})`, $p = '.list-group, .nav, [role="tablist"]', zp = ".nav-item, .list-group-item", kp = `.nav-link${Ds}, .list-group-item${Ds}, [role="tab"]${Ds}`, Ll = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', $s = `${kp}, ${Ll}`, Np = `.${qt}[data-bs-toggle="tab"], .${qt}[data-bs-toggle="pill"], .${qt}[data-bs-toggle="list"]`;
  class ti extends ut {
    constructor(e) {
      super(e), this._parent = this._element.closest($p), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), q.on(this._element, wp, (i) => this._keydown(i)));
    }
    static get NAME() {
      return Tp;
    }
    show() {
      const e = this._element;
      if (this._elemIsActive(e)) return;
      const i = this._getActiveElem(), n = i ? q.trigger(i, Sp, { relatedTarget: e }) : null;
      q.trigger(e, Cp, { relatedTarget: i }).defaultPrevented || n && n.defaultPrevented || (this._deactivate(i, e), this._activate(e, i));
    }
    _activate(e, i) {
      if (!e) return;
      e.classList.add(qt), this._activate(ie.getElementFromSelector(e));
      const n = () => {
        if (e.getAttribute("role") !== "tab") {
          e.classList.add(Ps);
          return;
        }
        e.removeAttribute("tabindex"), e.setAttribute("aria-selected", true), this._toggleDropDown(e, true), q.trigger(e, Ip, { relatedTarget: i });
      };
      this._queueCallback(n, e, e.classList.contains(sa));
    }
    _deactivate(e, i) {
      if (!e) return;
      e.classList.remove(qt), e.blur(), this._deactivate(ie.getElementFromSelector(e));
      const n = () => {
        if (e.getAttribute("role") !== "tab") {
          e.classList.remove(Ps);
          return;
        }
        e.setAttribute("aria-selected", false), e.setAttribute("tabindex", "-1"), this._toggleDropDown(e, false), q.trigger(e, xp, { relatedTarget: i });
      };
      this._queueCallback(n, e, e.classList.contains(sa));
    }
    _keydown(e) {
      if (![Mp, ta, Lp, ia, Ls, na].includes(e.key)) return;
      e.stopPropagation(), e.preventDefault();
      const i = this._getChildren().filter((r) => !Ht(r));
      let n;
      if ([Ls, na].includes(e.key)) n = i[e.key === Ls ? 0 : i.length - 1];
      else {
        const r = [ta, ia].includes(e.key);
        n = Tr(i, e.target, r, true);
      }
      n && (n.focus({ preventScroll: true }), ti.getOrCreateInstance(n).show());
    }
    _getChildren() {
      return ie.find($s, this._parent);
    }
    _getActiveElem() {
      return this._getChildren().find((e) => this._elemIsActive(e)) || null;
    }
    _setInitialAttributes(e, i) {
      this._setAttributeIfNotExists(e, "role", "tablist");
      for (const n of i) this._setInitialAttributesOnChild(n);
    }
    _setInitialAttributesOnChild(e) {
      e = this._getInnerElement(e);
      const i = this._elemIsActive(e), n = this._getOuterElement(e);
      e.setAttribute("aria-selected", i), n !== e && this._setAttributeIfNotExists(n, "role", "presentation"), i || e.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(e, "role", "tab"), this._setInitialAttributesOnTargetPanel(e);
    }
    _setInitialAttributesOnTargetPanel(e) {
      const i = ie.getElementFromSelector(e);
      i && (this._setAttributeIfNotExists(i, "role", "tabpanel"), e.id && this._setAttributeIfNotExists(i, "aria-labelledby", `${e.id}`));
    }
    _toggleDropDown(e, i) {
      const n = this._getOuterElement(e);
      if (!n.classList.contains(Pp)) return;
      const r = (o, l) => {
        const c = ie.findOne(o, n);
        c && c.classList.toggle(l, i);
      };
      r(Ml, qt), r(Dp, Ps), n.setAttribute("aria-expanded", i);
    }
    _setAttributeIfNotExists(e, i, n) {
      e.hasAttribute(i) || e.setAttribute(i, n);
    }
    _elemIsActive(e) {
      return e.classList.contains(qt);
    }
    _getInnerElement(e) {
      return e.matches($s) ? e : ie.findOne($s, e);
    }
    _getOuterElement(e) {
      return e.closest(zp) || e;
    }
    static jQueryInterface(e) {
      return this.each(function() {
        const i = ti.getOrCreateInstance(this);
        if (typeof e == "string") {
          if (i[e] === void 0 || e.startsWith("_") || e === "constructor") throw new TypeError(`No method named "${e}"`);
          i[e]();
        }
      });
    }
  }
  q.on(document, Ap, Ll, function(t) {
    ["A", "AREA"].includes(this.tagName) && t.preventDefault(), !Ht(this) && ti.getOrCreateInstance(this).show();
  });
  q.on(window, Op, () => {
    for (const t of ie.find(Np)) ti.getOrCreateInstance(t);
  });
  it(ti);
  const Rp = "toast", Hp = "bs.toast", Wt = `.${Hp}`, Bp = `mouseover${Wt}`, Vp = `mouseout${Wt}`, Wp = `focusin${Wt}`, Fp = `focusout${Wt}`, Gp = `hide${Wt}`, jp = `hidden${Wt}`, Yp = `show${Wt}`, Xp = `shown${Wt}`, qp = "fade", ra = "hide", xn = "show", Cn = "showing", Up = { animation: "boolean", autohide: "boolean", delay: "number" }, Kp = { animation: true, autohide: true, delay: 5e3 };
  class qn extends ut {
    constructor(e, i) {
      super(e, i), this._timeout = null, this._hasMouseInteraction = false, this._hasKeyboardInteraction = false, this._setListeners();
    }
    static get Default() {
      return Kp;
    }
    static get DefaultType() {
      return Up;
    }
    static get NAME() {
      return Rp;
    }
    show() {
      if (q.trigger(this._element, Yp).defaultPrevented) return;
      this._clearTimeout(), this._config.animation && this._element.classList.add(qp);
      const i = () => {
        this._element.classList.remove(Cn), q.trigger(this._element, Xp), this._maybeScheduleHide();
      };
      this._element.classList.remove(ra), Qi(this._element), this._element.classList.add(xn, Cn), this._queueCallback(i, this._element, this._config.animation);
    }
    hide() {
      if (!this.isShown() || q.trigger(this._element, Gp).defaultPrevented) return;
      const i = () => {
        this._element.classList.add(ra), this._element.classList.remove(Cn, xn), q.trigger(this._element, jp);
      };
      this._element.classList.add(Cn), this._queueCallback(i, this._element, this._config.animation);
    }
    dispose() {
      this._clearTimeout(), this.isShown() && this._element.classList.remove(xn), super.dispose();
    }
    isShown() {
      return this._element.classList.contains(xn);
    }
    _maybeScheduleHide() {
      this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout(() => {
        this.hide();
      }, this._config.delay)));
    }
    _onInteraction(e, i) {
      switch (e.type) {
        case "mouseover":
        case "mouseout": {
          this._hasMouseInteraction = i;
          break;
        }
        case "focusin":
        case "focusout": {
          this._hasKeyboardInteraction = i;
          break;
        }
      }
      if (i) {
        this._clearTimeout();
        return;
      }
      const n = e.relatedTarget;
      this._element === n || this._element.contains(n) || this._maybeScheduleHide();
    }
    _setListeners() {
      q.on(this._element, Bp, (e) => this._onInteraction(e, true)), q.on(this._element, Vp, (e) => this._onInteraction(e, false)), q.on(this._element, Wp, (e) => this._onInteraction(e, true)), q.on(this._element, Fp, (e) => this._onInteraction(e, false));
    }
    _clearTimeout() {
      clearTimeout(this._timeout), this._timeout = null;
    }
    static jQueryInterface(e) {
      return this.each(function() {
        const i = qn.getOrCreateInstance(this, e);
        if (typeof e == "string") {
          if (typeof i[e] == "undefined") throw new TypeError(`No method named "${e}"`);
          i[e](this);
        }
      });
    }
  }
  Gn(qn);
  it(qn);
  window.bootstrap = { Tooltip: ni, Modal: ei, Offcanvas: wt, Collapse: Oi, Dropdown: at, Tab: ti };
  function oa(t) {
    return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
  }
  function Ir(t = {}, e = {}) {
    const i = ["__proto__", "constructor", "prototype"];
    Object.keys(e).filter((n) => i.indexOf(n) < 0).forEach((n) => {
      typeof t[n] == "undefined" ? t[n] = e[n] : oa(e[n]) && oa(t[n]) && Object.keys(e[n]).length > 0 && Ir(t[n], e[n]);
    });
  }
  const Pl = { body: {}, addEventListener() {
  }, removeEventListener() {
  }, activeElement: { blur() {
  }, nodeName: "" }, querySelector() {
    return null;
  }, querySelectorAll() {
    return [];
  }, getElementById() {
    return null;
  }, createEvent() {
    return { initEvent() {
    } };
  }, createElement() {
    return { children: [], childNodes: [], style: {}, setAttribute() {
    }, getElementsByTagName() {
      return [];
    } };
  }, createElementNS() {
    return {};
  }, importNode() {
    return null;
  }, location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" } };
  function Oe() {
    const t = typeof document != "undefined" ? document : {};
    return Ir(t, Pl), t;
  }
  const Zp = { document: Pl, navigator: { userAgent: "" }, location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" }, history: { replaceState() {
  }, pushState() {
  }, go() {
  }, back() {
  } }, CustomEvent: function() {
    return this;
  }, addEventListener() {
  }, removeEventListener() {
  }, getComputedStyle() {
    return { getPropertyValue() {
      return "";
    } };
  }, Image() {
  }, Date() {
  }, screen: {}, setTimeout() {
  }, clearTimeout() {
  }, matchMedia() {
    return {};
  }, requestAnimationFrame(t) {
    return typeof setTimeout == "undefined" ? (t(), null) : setTimeout(t, 0);
  }, cancelAnimationFrame(t) {
    typeof setTimeout != "undefined" && clearTimeout(t);
  } };
  function ve() {
    const t = typeof window != "undefined" ? window : {};
    return Ir(t, Zp), t;
  }
  function zt(t = "") {
    return t.trim().split(" ").filter((e) => !!e.trim());
  }
  function Qp(t) {
    const e = t;
    Object.keys(e).forEach((i) => {
      try {
        e[i] = null;
      } catch (n) {
      }
      try {
        delete e[i];
      } catch (n) {
      }
    });
  }
  function Mi(t, e = 0) {
    return setTimeout(t, e);
  }
  function Qe() {
    return Date.now();
  }
  function Jp(t) {
    const e = ve();
    let i;
    return e.getComputedStyle && (i = e.getComputedStyle(t, null)), !i && t.currentStyle && (i = t.currentStyle), i || (i = t.style), i;
  }
  function ur(t, e = "x") {
    const i = ve();
    let n, r, o;
    const l = Jp(t);
    return i.WebKitCSSMatrix ? (r = l.transform || l.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map((c) => c.replace(",", ".")).join(", ")), o = new i.WebKitCSSMatrix(r === "none" ? "" : r)) : (o = l.MozTransform || l.OTransform || l.MsTransform || l.msTransform || l.transform || l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = o.toString().split(",")), e === "x" && (i.WebKitCSSMatrix ? r = o.m41 : n.length === 16 ? r = parseFloat(n[12]) : r = parseFloat(n[4])), e === "y" && (i.WebKitCSSMatrix ? r = o.m42 : n.length === 16 ? r = parseFloat(n[13]) : r = parseFloat(n[5])), r || 0;
  }
  function Yi(t) {
    return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
  }
  function eg(t) {
    return typeof window != "undefined" && typeof window.HTMLElement != "undefined" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
  }
  function je(...t) {
    const e = Object(t[0]);
    for (let i = 1; i < t.length; i += 1) {
      const n = t[i];
      if (n != null && !eg(n)) {
        const r = Object.keys(Object(n)).filter((o) => o !== "__proto__" && o !== "constructor" && o !== "prototype");
        for (let o = 0, l = r.length; o < l; o += 1) {
          const c = r[o], d = Object.getOwnPropertyDescriptor(n, c);
          d !== void 0 && d.enumerable && (Yi(e[c]) && Yi(n[c]) ? n[c].__swiper__ ? e[c] = n[c] : je(e[c], n[c]) : !Yi(e[c]) && Yi(n[c]) ? (e[c] = {}, n[c].__swiper__ ? e[c] = n[c] : je(e[c], n[c])) : e[c] = n[c]);
        }
      }
    }
    return e;
  }
  function Yt(t, e, i) {
    t.style.setProperty(e, i);
  }
  function Dl({ swiper: t, targetPosition: e, side: i }) {
    const n = ve(), r = -t.translate;
    let o = null, l;
    const c = t.params.speed;
    t.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(t.cssModeFrameID);
    const d = e > r ? "next" : "prev", v = (y, _) => d === "next" && y >= _ || d === "prev" && y <= _, b = () => {
      l = (/* @__PURE__ */ new Date()).getTime(), o === null && (o = l);
      const y = Math.max(Math.min((l - o) / c, 1), 0), _ = 0.5 - Math.cos(y * Math.PI) / 2;
      let p = r + _ * (e - r);
      if (v(p, e) && (p = e), t.wrapperEl.scrollTo({ [i]: p }), v(p, e)) {
        t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
          t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({ [i]: p });
        }), n.cancelAnimationFrame(t.cssModeFrameID);
        return;
      }
      t.cssModeFrameID = n.requestAnimationFrame(b);
    };
    b();
  }
  function ri(t) {
    return t.querySelector(".swiper-slide-transform") || t.shadowRoot && t.shadowRoot.querySelector(".swiper-slide-transform") || t;
  }
  function Me(t, e = "") {
    const i = ve(), n = [...t.children];
    return i.HTMLSlotElement && t instanceof HTMLSlotElement && n.push(...t.assignedElements()), e ? n.filter((r) => r.matches(e)) : n;
  }
  function tg(t, e) {
    const i = [e];
    for (; i.length > 0; ) {
      const n = i.shift();
      if (t === n) return true;
      i.push(...n.children, ...n.shadowRoot ? n.shadowRoot.children : [], ...n.assignedElements ? n.assignedElements() : []);
    }
  }
  function ig(t, e) {
    const i = ve();
    let n = e.contains(t);
    return !n && i.HTMLSlotElement && e instanceof HTMLSlotElement && (n = [...e.assignedElements()].includes(t), n || (n = tg(t, e))), n;
  }
  function zn(t) {
    try {
      console.warn(t);
      return;
    } catch (e) {
    }
  }
  function Ye(t, e = []) {
    const i = document.createElement(t);
    return i.classList.add(...Array.isArray(e) ? e : zt(e)), i;
  }
  function kn(t) {
    const e = ve(), i = Oe(), n = t.getBoundingClientRect(), r = i.body, o = t.clientTop || r.clientTop || 0, l = t.clientLeft || r.clientLeft || 0, c = t === e ? e.scrollY : t.scrollTop, d = t === e ? e.scrollX : t.scrollLeft;
    return { top: n.top + c - o, left: n.left + d - l };
  }
  function ng(t, e) {
    const i = [];
    for (; t.previousElementSibling; ) {
      const n = t.previousElementSibling;
      e ? n.matches(e) && i.push(n) : i.push(n), t = n;
    }
    return i;
  }
  function sg(t, e) {
    const i = [];
    for (; t.nextElementSibling; ) {
      const n = t.nextElementSibling;
      e ? n.matches(e) && i.push(n) : i.push(n), t = n;
    }
    return i;
  }
  function Nt(t, e) {
    return ve().getComputedStyle(t, null).getPropertyValue(e);
  }
  function Ki(t) {
    let e = t, i;
    if (e) {
      for (i = 0; (e = e.previousSibling) !== null; ) e.nodeType === 1 && (i += 1);
      return i;
    }
  }
  function Kt(t, e) {
    const i = [];
    let n = t.parentElement;
    for (; n; ) e ? n.matches(e) && i.push(n) : i.push(n), n = n.parentElement;
    return i;
  }
  function Ui(t, e) {
    function i(n) {
      n.target === t && (e.call(t, n), t.removeEventListener("transitionend", i));
    }
    e && t.addEventListener("transitionend", i);
  }
  function cr(t, e, i) {
    const n = ve();
    return t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
  }
  function ue(t) {
    return (Array.isArray(t) ? t : [t]).filter((e) => !!e);
  }
  function Un(t) {
    return (e) => Math.abs(e) > 0 && t.browser && t.browser.need3dFix && Math.abs(e) % 90 === 0 ? e + 1e-3 : e;
  }
  function yt(t, e = "") {
    typeof trustedTypes != "undefined" ? t.innerHTML = trustedTypes.createPolicy("html", { createHTML: (i) => i }).createHTML(e) : t.innerHTML = e;
  }
  let zs;
  function rg() {
    const t = ve(), e = Oe();
    return { smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style, touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch) };
  }
  function $l() {
    return zs || (zs = rg()), zs;
  }
  let ks;
  function og({ userAgent: t } = {}) {
    const e = $l(), i = ve(), n = i.navigator.platform, r = t || i.navigator.userAgent, o = { ios: false, android: false }, l = i.screen.width, c = i.screen.height, d = r.match(/(Android);?[\s\/]+([\d.]+)?/);
    let v = r.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
    const b = r.match(/(iPod)(.*OS\s([\d_]+))?/), y = !v && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/), _ = n === "Win32";
    let p = n === "MacIntel";
    const m = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
    return !v && p && e.touch && m.indexOf(`${l}x${c}`) >= 0 && (v = r.match(/(Version)\/([\d.]+)/), v || (v = [0, 1, "13_0_0"]), p = false), d && !_ && (o.os = "android", o.android = true), (v || y || b) && (o.os = "ios", o.ios = true), o;
  }
  function zl(t = {}) {
    return ks || (ks = og(t)), ks;
  }
  let Ns;
  function ag() {
    const t = ve(), e = zl();
    let i = false;
    function n() {
      const c = t.navigator.userAgent.toLowerCase();
      return c.indexOf("safari") >= 0 && c.indexOf("chrome") < 0 && c.indexOf("android") < 0;
    }
    if (n()) {
      const c = String(t.navigator.userAgent);
      if (c.includes("Version/")) {
        const [d, v] = c.split("Version/")[1].split(" ")[0].split(".").map((b) => Number(b));
        i = d < 16 || d === 16 && v < 2;
      }
    }
    const r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent), o = n(), l = o || r && e.ios;
    return { isSafari: i || o, needPerspectiveFix: i, need3dFix: l, isWebView: r };
  }
  function kl() {
    return Ns || (Ns = ag()), Ns;
  }
  function lg({ swiper: t, on: e, emit: i }) {
    const n = ve();
    let r = null, o = null;
    const l = () => {
      !t || t.destroyed || !t.initialized || (i("beforeResize"), i("resize"));
    }, c = () => {
      !t || t.destroyed || !t.initialized || (r = new ResizeObserver((b) => {
        o = n.requestAnimationFrame(() => {
          const { width: y, height: _ } = t;
          let p = y, m = _;
          b.forEach(({ contentBoxSize: C, contentRect: S, target: h }) => {
            h && h !== t.el || (p = S ? S.width : (C[0] || C).inlineSize, m = S ? S.height : (C[0] || C).blockSize);
          }), (p !== y || m !== _) && l();
        });
      }), r.observe(t.el));
    }, d = () => {
      o && n.cancelAnimationFrame(o), r && r.unobserve && t.el && (r.unobserve(t.el), r = null);
    }, v = () => {
      !t || t.destroyed || !t.initialized || i("orientationchange");
    };
    e("init", () => {
      if (t.params.resizeObserver && typeof n.ResizeObserver != "undefined") {
        c();
        return;
      }
      n.addEventListener("resize", l), n.addEventListener("orientationchange", v);
    }), e("destroy", () => {
      d(), n.removeEventListener("resize", l), n.removeEventListener("orientationchange", v);
    });
  }
  function ug({ swiper: t, extendParams: e, on: i, emit: n }) {
    const r = [], o = ve(), l = (v, b = {}) => {
      const y = o.MutationObserver || o.WebkitMutationObserver, _ = new y((p) => {
        if (t.__preventObserver__) return;
        if (p.length === 1) {
          n("observerUpdate", p[0]);
          return;
        }
        const m = function() {
          n("observerUpdate", p[0]);
        };
        o.requestAnimationFrame ? o.requestAnimationFrame(m) : o.setTimeout(m, 0);
      });
      _.observe(v, { attributes: typeof b.attributes == "undefined" ? true : b.attributes, childList: t.isElement || (typeof b.childList == "undefined" ? true : b).childList, characterData: typeof b.characterData == "undefined" ? true : b.characterData }), r.push(_);
    }, c = () => {
      if (t.params.observer) {
        if (t.params.observeParents) {
          const v = Kt(t.hostEl);
          for (let b = 0; b < v.length; b += 1) l(v[b]);
        }
        l(t.hostEl, { childList: t.params.observeSlideChildren }), l(t.wrapperEl, { attributes: false });
      }
    }, d = () => {
      r.forEach((v) => {
        v.disconnect();
      }), r.splice(0, r.length);
    };
    e({ observer: false, observeParents: false, observeSlideChildren: false }), i("init", c), i("destroy", d);
  }
  var cg = { on(t, e, i) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    const r = i ? "unshift" : "push";
    return t.split(" ").forEach((o) => {
      n.eventsListeners[o] || (n.eventsListeners[o] = []), n.eventsListeners[o][r](e);
    }), n;
  }, once(t, e, i) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    function r(...o) {
      n.off(t, r), r.__emitterProxy && delete r.__emitterProxy, e.apply(n, o);
    }
    return r.__emitterProxy = e, n.on(t, r, i);
  }, onAny(t, e) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof t != "function") return i;
    const n = e ? "unshift" : "push";
    return i.eventsAnyListeners.indexOf(t) < 0 && i.eventsAnyListeners[n](t), i;
  }, offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const i = e.eventsAnyListeners.indexOf(t);
    return i >= 0 && e.eventsAnyListeners.splice(i, 1), e;
  }, off(t, e) {
    const i = this;
    return !i.eventsListeners || i.destroyed || !i.eventsListeners || t.split(" ").forEach((n) => {
      typeof e == "undefined" ? i.eventsListeners[n] = [] : i.eventsListeners[n] && i.eventsListeners[n].forEach((r, o) => {
        (r === e || r.__emitterProxy && r.__emitterProxy === e) && i.eventsListeners[n].splice(o, 1);
      });
    }), i;
  }, emit(...t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners) return e;
    let i, n, r;
    return typeof t[0] == "string" || Array.isArray(t[0]) ? (i = t[0], n = t.slice(1, t.length), r = e) : (i = t[0].events, n = t[0].data, r = t[0].context || e), n.unshift(r), (Array.isArray(i) ? i : i.split(" ")).forEach((l) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((c) => {
        c.apply(r, [l, ...n]);
      }), e.eventsListeners && e.eventsListeners[l] && e.eventsListeners[l].forEach((c) => {
        c.apply(r, n);
      });
    }), e;
  } };
  function dg() {
    const t = this;
    let e, i;
    const n = t.el;
    typeof t.params.width != "undefined" && t.params.width !== null ? e = t.params.width : e = n.clientWidth, typeof t.params.height != "undefined" && t.params.height !== null ? i = t.params.height : i = n.clientHeight, !(e === 0 && t.isHorizontal() || i === 0 && t.isVertical()) && (e = e - parseInt(Nt(n, "padding-left") || 0, 10) - parseInt(Nt(n, "padding-right") || 0, 10), i = i - parseInt(Nt(n, "padding-top") || 0, 10) - parseInt(Nt(n, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(i) && (i = 0), Object.assign(t, { width: e, height: i, size: t.isHorizontal() ? e : i }));
  }
  function fg() {
    const t = this;
    function e(k, z) {
      return parseFloat(k.getPropertyValue(t.getDirectionLabel(z)) || 0);
    }
    const i = t.params, { wrapperEl: n, slidesEl: r, rtlTranslate: o, wrongRTL: l } = t, c = t.virtual && i.virtual.enabled, d = c ? t.virtual.slides.length : t.slides.length, v = Me(r, `.${t.params.slideClass}, swiper-slide`), b = c ? t.virtual.slides.length : v.length;
    let y = [];
    const _ = [], p = [];
    let m = i.slidesOffsetBefore;
    typeof m == "function" && (m = i.slidesOffsetBefore.call(t));
    let C = i.slidesOffsetAfter;
    typeof C == "function" && (C = i.slidesOffsetAfter.call(t));
    const S = t.snapGrid.length, h = t.slidesGrid.length, E = t.size - m - C;
    let I = i.spaceBetween, O = -m, L = 0, f = 0;
    if (typeof E == "undefined") return;
    typeof I == "string" && I.indexOf("%") >= 0 ? I = parseFloat(I.replace("%", "")) / 100 * E : typeof I == "string" && (I = parseFloat(I)), t.virtualSize = -I - m - C, v.forEach((k) => {
      o ? k.style.marginLeft = "" : k.style.marginRight = "", k.style.marginBottom = "", k.style.marginTop = "";
    }), i.centeredSlides && i.cssMode && (Yt(n, "--swiper-centered-offset-before", ""), Yt(n, "--swiper-centered-offset-after", "")), i.cssMode && (Yt(n, "--swiper-slides-offset-before", `${m}px`), Yt(n, "--swiper-slides-offset-after", `${C}px`));
    const P = i.grid && i.grid.rows > 1 && t.grid;
    P ? t.grid.initSlides(v) : t.grid && t.grid.unsetSlides();
    let D;
    const H = i.slidesPerView === "auto" && i.breakpoints && Object.keys(i.breakpoints).filter((k) => typeof i.breakpoints[k].slidesPerView != "undefined").length > 0;
    for (let k = 0; k < b; k += 1) {
      D = 0;
      const z = v[k];
      if (!(z && (P && t.grid.updateSlide(k, z, v), Nt(z, "display") === "none"))) {
        if (c && i.slidesPerView === "auto") i.virtual.slidesPerViewAutoSlideSize && (D = i.virtual.slidesPerViewAutoSlideSize), D && z && (i.roundLengths && (D = Math.floor(D)), z.style[t.getDirectionLabel("width")] = `${D}px`);
        else if (i.slidesPerView === "auto") {
          H && (z.style[t.getDirectionLabel("width")] = "");
          const B = getComputedStyle(z), V = z.style.transform, X = z.style.webkitTransform;
          if (V && (z.style.transform = "none"), X && (z.style.webkitTransform = "none"), i.roundLengths) D = t.isHorizontal() ? cr(z, "width") : cr(z, "height");
          else {
            const Z = e(B, "width"), F = e(B, "padding-left"), W = e(B, "padding-right"), Y = e(B, "margin-left"), J = e(B, "margin-right"), re = B.getPropertyValue("box-sizing");
            if (re && re === "border-box") D = Z + Y + J;
            else {
              const { clientWidth: fe, offsetWidth: _e } = z;
              D = Z + F + W + Y + J + (_e - fe);
            }
          }
          V && (z.style.transform = V), X && (z.style.webkitTransform = X), i.roundLengths && (D = Math.floor(D));
        } else D = (E - (i.slidesPerView - 1) * I) / i.slidesPerView, i.roundLengths && (D = Math.floor(D)), z && (z.style[t.getDirectionLabel("width")] = `${D}px`);
        z && (z.swiperSlideSize = D), p.push(D), i.centeredSlides ? (O = O + D / 2 + L / 2 + I, L === 0 && k !== 0 && (O = O - E / 2 - I), k === 0 && (O = O - E / 2 - I), Math.abs(O) < 1 / 1e3 && (O = 0), i.roundLengths && (O = Math.floor(O)), f % i.slidesPerGroup === 0 && y.push(O), _.push(O)) : (i.roundLengths && (O = Math.floor(O)), (f - Math.min(t.params.slidesPerGroupSkip, f)) % t.params.slidesPerGroup === 0 && y.push(O), _.push(O), O = O + D + I), t.virtualSize += D + I, L = D, f += 1;
      }
    }
    if (t.virtualSize = Math.max(t.virtualSize, E) + C, o && l && (i.effect === "slide" || i.effect === "coverflow") && (n.style.width = `${t.virtualSize + I}px`), i.setWrapperSize && (n.style[t.getDirectionLabel("width")] = `${t.virtualSize + I}px`), P && t.grid.updateWrapperSize(D, y), !i.centeredSlides) {
      const k = i.slidesPerView !== "auto" && i.slidesPerView % 1 !== 0, z = i.snapToSlideEdge && !i.loop && (i.slidesPerView === "auto" || k);
      let B = y.length;
      if (z) {
        let X;
        if (i.slidesPerView === "auto") {
          X = 1;
          let Z = 0;
          for (let F = p.length - 1; F >= 0 && (Z += p[F] + (F < p.length - 1 ? I : 0), Z <= E); F -= 1) X = p.length - F;
        } else X = Math.floor(i.slidesPerView);
        B = Math.max(b - X, 0);
      }
      const V = [];
      for (let X = 0; X < y.length; X += 1) {
        let Z = y[X];
        i.roundLengths && (Z = Math.floor(Z)), z ? X <= B && V.push(Z) : y[X] <= t.virtualSize - E && V.push(Z);
      }
      y = V, Math.floor(t.virtualSize - E) - Math.floor(y[y.length - 1]) > 1 && (z || y.push(t.virtualSize - E));
    }
    if (c && i.loop) {
      const k = p[0] + I;
      if (i.slidesPerGroup > 1) {
        const z = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / i.slidesPerGroup), B = k * i.slidesPerGroup;
        for (let V = 0; V < z; V += 1) y.push(y[y.length - 1] + B);
      }
      for (let z = 0; z < t.virtual.slidesBefore + t.virtual.slidesAfter; z += 1) i.slidesPerGroup === 1 && y.push(y[y.length - 1] + k), _.push(_[_.length - 1] + k), t.virtualSize += k;
    }
    if (y.length === 0 && (y = [0]), I !== 0) {
      const k = t.isHorizontal() && o ? "marginLeft" : t.getDirectionLabel("marginRight");
      v.filter((z, B) => !i.cssMode || i.loop ? true : B !== v.length - 1).forEach((z) => {
        z.style[k] = `${I}px`;
      });
    }
    if (i.centeredSlides && i.centeredSlidesBounds) {
      let k = 0;
      p.forEach((B) => {
        k += B + (I || 0);
      }), k -= I;
      const z = k > E ? k - E : 0;
      y = y.map((B) => B <= 0 ? -m : B > z ? z + C : B);
    }
    if (i.centerInsufficientSlides) {
      let k = 0;
      if (p.forEach((z) => {
        k += z + (I || 0);
      }), k -= I, k < E) {
        const z = (E - k) / 2;
        y.forEach((B, V) => {
          y[V] = B - z;
        }), _.forEach((B, V) => {
          _[V] = B + z;
        });
      }
    }
    if (Object.assign(t, { slides: v, snapGrid: y, slidesGrid: _, slidesSizesGrid: p }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
      Yt(n, "--swiper-centered-offset-before", `${-y[0]}px`), Yt(n, "--swiper-centered-offset-after", `${t.size / 2 - p[p.length - 1] / 2}px`);
      const k = -t.snapGrid[0], z = -t.slidesGrid[0];
      t.snapGrid = t.snapGrid.map((B) => B + k), t.slidesGrid = t.slidesGrid.map((B) => B + z);
    }
    if (b !== d && t.emit("slidesLengthChange"), y.length !== S && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), _.length !== h && t.emit("slidesGridLengthChange"), i.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !c && !i.cssMode && (i.effect === "slide" || i.effect === "fade")) {
      const k = `${i.containerModifierClass}backface-hidden`, z = t.el.classList.contains(k);
      b <= i.maxBackfaceHiddenSlides ? z || t.el.classList.add(k) : z && t.el.classList.remove(k);
    }
  }
  function hg(t) {
    const e = this, i = [], n = e.virtual && e.params.virtual.enabled;
    let r = 0, o;
    typeof t == "number" ? e.setTransition(t) : t === true && e.setTransition(e.params.speed);
    const l = (c) => n ? e.slides[e.getSlideIndexByData(c)] : e.slides[c];
    if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1) if (e.params.centeredSlides) (e.visibleSlides || []).forEach((c) => {
      i.push(c);
    });
    else for (o = 0; o < Math.ceil(e.params.slidesPerView); o += 1) {
      const c = e.activeIndex + o;
      if (c > e.slides.length && !n) break;
      i.push(l(c));
    }
    else i.push(l(e.activeIndex));
    for (o = 0; o < i.length; o += 1) if (typeof i[o] != "undefined") {
      const c = i[o].offsetHeight;
      r = c > r ? c : r;
    }
    (r || r === 0) && (e.wrapperEl.style.height = `${r}px`);
  }
  function pg() {
    const t = this, e = t.slides, i = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
    for (let n = 0; n < e.length; n += 1) e[n].swiperSlideOffset = (t.isHorizontal() ? e[n].offsetLeft : e[n].offsetTop) - i - t.cssOverflowAdjustment();
  }
  const aa = (t, e, i) => {
    e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
  };
  function gg(t = this && this.translate || 0) {
    const e = this, i = e.params, { slides: n, rtlTranslate: r, snapGrid: o } = e;
    if (n.length === 0) return;
    typeof n[0].swiperSlideOffset == "undefined" && e.updateSlidesOffset();
    let l = -t;
    r && (l = t), e.visibleSlidesIndexes = [], e.visibleSlides = [];
    let c = i.spaceBetween;
    typeof c == "string" && c.indexOf("%") >= 0 ? c = parseFloat(c.replace("%", "")) / 100 * e.size : typeof c == "string" && (c = parseFloat(c));
    for (let d = 0; d < n.length; d += 1) {
      const v = n[d];
      let b = v.swiperSlideOffset;
      i.cssMode && i.centeredSlides && (b -= n[0].swiperSlideOffset);
      const y = (l + (i.centeredSlides ? e.minTranslate() : 0) - b) / (v.swiperSlideSize + c), _ = (l - o[0] + (i.centeredSlides ? e.minTranslate() : 0) - b) / (v.swiperSlideSize + c), p = -(l - b), m = p + e.slidesSizesGrid[d], C = p >= 0 && p <= e.size - e.slidesSizesGrid[d], S = p >= 0 && p < e.size - 1 || m > 1 && m <= e.size || p <= 0 && m >= e.size;
      S && (e.visibleSlides.push(v), e.visibleSlidesIndexes.push(d)), aa(v, S, i.slideVisibleClass), aa(v, C, i.slideFullyVisibleClass), v.progress = r ? -y : y, v.originalProgress = r ? -_ : _;
    }
  }
  function mg(t) {
    const e = this;
    if (typeof t == "undefined") {
      const b = e.rtlTranslate ? -1 : 1;
      t = e && e.translate && e.translate * b || 0;
    }
    const i = e.params, n = e.maxTranslate() - e.minTranslate();
    let { progress: r, isBeginning: o, isEnd: l, progressLoop: c } = e;
    const d = o, v = l;
    if (n === 0) r = 0, o = true, l = true;
    else {
      r = (t - e.minTranslate()) / n;
      const b = Math.abs(t - e.minTranslate()) < 1, y = Math.abs(t - e.maxTranslate()) < 1;
      o = b || r <= 0, l = y || r >= 1, b && (r = 0), y && (r = 1);
    }
    if (i.loop) {
      const b = e.getSlideIndexByData(0), y = e.getSlideIndexByData(e.slides.length - 1), _ = e.slidesGrid[b], p = e.slidesGrid[y], m = e.slidesGrid[e.slidesGrid.length - 1], C = Math.abs(t);
      C >= _ ? c = (C - _) / m : c = (C + m - p) / m, c > 1 && (c -= 1);
    }
    Object.assign(e, { progress: r, progressLoop: c, isBeginning: o, isEnd: l }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && e.updateSlidesProgress(t), o && !d && e.emit("reachBeginning toEdge"), l && !v && e.emit("reachEnd toEdge"), (d && !o || v && !l) && e.emit("fromEdge"), e.emit("progress", r);
  }
  const Rs = (t, e, i) => {
    e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
  };
  function vg() {
    const t = this, { slides: e, params: i, slidesEl: n, activeIndex: r } = t, o = t.virtual && i.virtual.enabled, l = t.grid && i.grid && i.grid.rows > 1, c = (y) => Me(n, `.${i.slideClass}${y}, swiper-slide${y}`)[0];
    let d, v, b;
    if (o) if (i.loop) {
      let y = r - t.virtual.slidesBefore;
      y < 0 && (y = t.virtual.slides.length + y), y >= t.virtual.slides.length && (y -= t.virtual.slides.length), d = c(`[data-swiper-slide-index="${y}"]`);
    } else d = c(`[data-swiper-slide-index="${r}"]`);
    else l ? (d = e.find((y) => y.column === r), b = e.find((y) => y.column === r + 1), v = e.find((y) => y.column === r - 1)) : d = e[r];
    d && (l || (b = sg(d, `.${i.slideClass}, swiper-slide`)[0], i.loop && !b && (b = e[0]), v = ng(d, `.${i.slideClass}, swiper-slide`)[0], i.loop && !v === 0 && (v = e[e.length - 1]))), e.forEach((y) => {
      Rs(y, y === d, i.slideActiveClass), Rs(y, y === b, i.slideNextClass), Rs(y, y === v, i.slidePrevClass);
    }), t.emitSlidesClasses();
  }
  const On = (t, e) => {
    if (!t || t.destroyed || !t.params) return;
    const i = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`, n = e.closest(i());
    if (n) {
      let r = n.querySelector(`.${t.params.lazyPreloaderClass}`);
      !r && t.isElement && (n.shadowRoot ? r = n.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
        n.shadowRoot && (r = n.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`), r && !r.lazyPreloaderManaged && r.remove());
      })), r && !r.lazyPreloaderManaged && r.remove();
    }
  }, Hs = (t, e) => {
    if (!t.slides[e]) return;
    const i = t.slides[e].querySelector('[loading="lazy"]');
    i && i.removeAttribute("loading");
  }, dr = (t) => {
    if (!t || t.destroyed || !t.params) return;
    let e = t.params.lazyPreloadPrevNext;
    const i = t.slides.length;
    if (!i || !e || e < 0) return;
    e = Math.min(e, i);
    const n = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView), r = t.activeIndex;
    if (t.params.grid && t.params.grid.rows > 1) {
      const l = r, c = [l - e];
      c.push(...Array.from({ length: e }).map((d, v) => l + n + v)), t.slides.forEach((d, v) => {
        c.includes(d.column) && Hs(t, v);
      });
      return;
    }
    const o = r + n - 1;
    if (t.params.rewind || t.params.loop) for (let l = r - e; l <= o + e; l += 1) {
      const c = (l % i + i) % i;
      (c < r || c > o) && Hs(t, c);
    }
    else for (let l = Math.max(r - e, 0); l <= Math.min(o + e, i - 1); l += 1) l !== r && (l > o || l < r) && Hs(t, l);
  };
  function yg(t) {
    const { slidesGrid: e, params: i } = t, n = t.rtlTranslate ? t.translate : -t.translate;
    let r;
    for (let o = 0; o < e.length; o += 1) typeof e[o + 1] != "undefined" ? n >= e[o] && n < e[o + 1] - (e[o + 1] - e[o]) / 2 ? r = o : n >= e[o] && n < e[o + 1] && (r = o + 1) : n >= e[o] && (r = o);
    return i.normalizeSlideIndex && (r < 0 || typeof r == "undefined") && (r = 0), r;
  }
  function bg(t) {
    const e = this, i = e.rtlTranslate ? e.translate : -e.translate, { snapGrid: n, params: r, activeIndex: o, realIndex: l, snapIndex: c } = e;
    let d = t, v;
    const b = (p) => {
      let m = p - e.virtual.slidesBefore;
      return m < 0 && (m = e.virtual.slides.length + m), m >= e.virtual.slides.length && (m -= e.virtual.slides.length), m;
    };
    if (typeof d == "undefined" && (d = yg(e)), n.indexOf(i) >= 0) v = n.indexOf(i);
    else {
      const p = Math.min(r.slidesPerGroupSkip, d);
      v = p + Math.floor((d - p) / r.slidesPerGroup);
    }
    if (v >= n.length && (v = n.length - 1), d === o && !e.params.loop) {
      v !== c && (e.snapIndex = v, e.emit("snapIndexChange"));
      return;
    }
    if (d === o && e.params.loop && e.virtual && e.params.virtual.enabled) {
      e.realIndex = b(d);
      return;
    }
    const y = e.grid && r.grid && r.grid.rows > 1;
    let _;
    if (e.virtual && r.virtual.enabled) r.loop ? _ = b(d) : _ = d;
    else if (y) {
      const p = e.slides.find((C) => C.column === d);
      let m = parseInt(p.getAttribute("data-swiper-slide-index"), 10);
      Number.isNaN(m) && (m = Math.max(e.slides.indexOf(p), 0)), _ = Math.floor(m / r.grid.rows);
    } else if (e.slides[d]) {
      const p = e.slides[d].getAttribute("data-swiper-slide-index");
      p ? _ = parseInt(p, 10) : _ = d;
    } else _ = d;
    Object.assign(e, { previousSnapIndex: c, snapIndex: v, previousRealIndex: l, realIndex: _, previousIndex: o, activeIndex: d }), e.initialized && dr(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (l !== _ && e.emit("realIndexChange"), e.emit("slideChange"));
  }
  function Eg(t, e) {
    const i = this, n = i.params;
    let r = t.closest(`.${n.slideClass}, swiper-slide`);
    !r && i.isElement && e && e.length > 1 && e.includes(t) && [...e.slice(e.indexOf(t) + 1, e.length)].forEach((c) => {
      !r && c.matches && c.matches(`.${n.slideClass}, swiper-slide`) && (r = c);
    });
    let o = false, l;
    if (r) {
      for (let c = 0; c < i.slides.length; c += 1) if (i.slides[c] === r) {
        o = true, l = c;
        break;
      }
    }
    if (r && o) i.clickedSlide = r, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10) : i.clickedIndex = l;
    else {
      i.clickedSlide = void 0, i.clickedIndex = void 0;
      return;
    }
    n.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
  }
  var Tg = { updateSize: dg, updateSlides: fg, updateAutoHeight: hg, updateSlidesOffset: pg, updateSlidesProgress: gg, updateProgress: mg, updateSlidesClasses: vg, updateActiveIndex: bg, updateClickedSlide: Eg };
  function _g(t = this.isHorizontal() ? "x" : "y") {
    const e = this, { params: i, rtlTranslate: n, translate: r, wrapperEl: o } = e;
    if (i.virtualTranslate) return n ? -r : r;
    if (i.cssMode) return r;
    let l = ur(o, t);
    return l += e.cssOverflowAdjustment(), n && (l = -l), l || 0;
  }
  function Sg(t, e) {
    const i = this, { rtlTranslate: n, params: r, wrapperEl: o, progress: l } = i;
    let c = 0, d = 0;
    const v = 0;
    i.isHorizontal() ? c = n ? -t : t : d = t, r.roundLengths && (c = Math.floor(c), d = Math.floor(d)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? c : d, r.cssMode ? o[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -c : -d : r.virtualTranslate || (i.isHorizontal() ? c -= i.cssOverflowAdjustment() : d -= i.cssOverflowAdjustment(), o.style.transform = `translate3d(${c}px, ${d}px, ${v}px)`);
    let b;
    const y = i.maxTranslate() - i.minTranslate();
    y === 0 ? b = 0 : b = (t - i.minTranslate()) / y, b !== l && i.updateProgress(t), i.emit("setTranslate", i.translate, e);
  }
  function xg() {
    return -this.snapGrid[0];
  }
  function Cg() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }
  function Ig(t = 0, e = this.params.speed, i = true, n = true, r) {
    const o = this, { params: l, wrapperEl: c } = o;
    if (o.animating && l.preventInteractionOnTransition) return false;
    const d = o.minTranslate(), v = o.maxTranslate();
    let b;
    if (n && t > d ? b = d : n && t < v ? b = v : b = t, o.updateProgress(b), l.cssMode) {
      const y = o.isHorizontal();
      if (e === 0) c[y ? "scrollLeft" : "scrollTop"] = -b;
      else {
        if (!o.support.smoothScroll) return Dl({ swiper: o, targetPosition: -b, side: y ? "left" : "top" }), true;
        c.scrollTo({ [y ? "left" : "top"]: -b, behavior: "smooth" });
      }
      return true;
    }
    return e === 0 ? (o.setTransition(0), o.setTranslate(b), i && (o.emit("beforeTransitionStart", e, r), o.emit("transitionEnd"))) : (o.setTransition(e), o.setTranslate(b), i && (o.emit("beforeTransitionStart", e, r), o.emit("transitionStart")), o.animating || (o.animating = true, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function(_) {
      !o || o.destroyed || _.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, o.animating = false, i && o.emit("transitionEnd"));
    }), o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))), true;
  }
  var Ag = { getTranslate: _g, setTranslate: Sg, minTranslate: xg, maxTranslate: Cg, translateTo: Ig };
  function wg(t, e) {
    const i = this;
    i.params.cssMode || (i.wrapperEl.style.transitionDuration = `${t}ms`, i.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : ""), i.emit("setTransition", t, e);
  }
  function Nl({ swiper: t, runCallbacks: e, direction: i, step: n }) {
    const { activeIndex: r, previousIndex: o } = t;
    let l = i;
    l || (r > o ? l = "next" : r < o ? l = "prev" : l = "reset"), t.emit(`transition${n}`), e && l === "reset" ? t.emit(`slideResetTransition${n}`) : e && r !== o && (t.emit(`slideChangeTransition${n}`), l === "next" ? t.emit(`slideNextTransition${n}`) : t.emit(`slidePrevTransition${n}`));
  }
  function Og(t = true, e) {
    const i = this, { params: n } = i;
    n.cssMode || (n.autoHeight && i.updateAutoHeight(), Nl({ swiper: i, runCallbacks: t, direction: e, step: "Start" }));
  }
  function Mg(t = true, e) {
    const i = this, { params: n } = i;
    i.animating = false, !n.cssMode && (i.setTransition(0), Nl({ swiper: i, runCallbacks: t, direction: e, step: "End" }));
  }
  var Lg = { setTransition: wg, transitionStart: Og, transitionEnd: Mg };
  function Pg(t = 0, e, i = true, n, r) {
    typeof t == "string" && (t = parseInt(t, 10));
    const o = this;
    let l = t;
    l < 0 && (l = 0);
    const { params: c, snapGrid: d, slidesGrid: v, previousIndex: b, activeIndex: y, rtlTranslate: _, wrapperEl: p, enabled: m } = o;
    if (!m && !n && !r || o.destroyed || o.animating && c.preventInteractionOnTransition) return false;
    typeof e == "undefined" && (e = o.params.speed);
    const C = Math.min(o.params.slidesPerGroupSkip, l);
    let S = C + Math.floor((l - C) / o.params.slidesPerGroup);
    S >= d.length && (S = d.length - 1);
    const h = -d[S];
    if (c.normalizeSlideIndex) for (let P = 0; P < v.length; P += 1) {
      const D = -Math.floor(h * 100), H = Math.floor(v[P] * 100), k = Math.floor(v[P + 1] * 100);
      typeof v[P + 1] != "undefined" ? D >= H && D < k - (k - H) / 2 ? l = P : D >= H && D < k && (l = P + 1) : D >= H && (l = P);
    }
    if (o.initialized && l !== y && (!o.allowSlideNext && (_ ? h > o.translate && h > o.minTranslate() : h < o.translate && h < o.minTranslate()) || !o.allowSlidePrev && h > o.translate && h > o.maxTranslate() && (y || 0) !== l)) return false;
    l !== (b || 0) && i && o.emit("beforeSlideChangeStart"), o.updateProgress(h);
    let E;
    l > y ? E = "next" : l < y ? E = "prev" : E = "reset";
    const I = o.virtual && o.params.virtual.enabled;
    if (!(I && r) && (_ && -h === o.translate || !_ && h === o.translate)) return o.updateActiveIndex(l), c.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), c.effect !== "slide" && o.setTranslate(h), E !== "reset" && (o.transitionStart(i, E), o.transitionEnd(i, E)), false;
    if (c.cssMode) {
      const P = o.isHorizontal(), D = _ ? h : -h;
      if (e === 0) I && (o.wrapperEl.style.scrollSnapType = "none", o._immediateVirtual = true), I && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0 ? (o._cssModeVirtualInitialSet = true, requestAnimationFrame(() => {
        p[P ? "scrollLeft" : "scrollTop"] = D;
      })) : p[P ? "scrollLeft" : "scrollTop"] = D, I && requestAnimationFrame(() => {
        o.wrapperEl.style.scrollSnapType = "", o._immediateVirtual = false;
      });
      else {
        if (!o.support.smoothScroll) return Dl({ swiper: o, targetPosition: D, side: P ? "left" : "top" }), true;
        p.scrollTo({ [P ? "left" : "top"]: D, behavior: "smooth" });
      }
      return true;
    }
    const f = kl().isSafari;
    return I && !r && f && o.isElement && o.virtual.update(false, false, l), o.setTransition(e), o.setTranslate(h), o.updateActiveIndex(l), o.updateSlidesClasses(), o.emit("beforeTransitionStart", e, n), o.transitionStart(i, E), e === 0 ? o.transitionEnd(i, E) : o.animating || (o.animating = true, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(D) {
      !o || o.destroyed || D.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(i, E));
    }), o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)), true;
  }
  function Dg(t = 0, e, i = true, n) {
    typeof t == "string" && (t = parseInt(t, 10));
    const r = this;
    if (r.destroyed) return;
    typeof e == "undefined" && (e = r.params.speed);
    const o = r.grid && r.params.grid && r.params.grid.rows > 1;
    let l = t;
    if (r.params.loop) if (r.virtual && r.params.virtual.enabled) l = l + r.virtual.slidesBefore;
    else {
      let c;
      if (o) {
        const C = l * r.params.grid.rows;
        c = r.slides.find((S) => S.getAttribute("data-swiper-slide-index") * 1 === C).column;
      } else c = r.getSlideIndexByData(l);
      const d = o ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length, { centeredSlides: v, slidesOffsetBefore: b, slidesOffsetAfter: y } = r.params, _ = v || !!b || !!y;
      let p = r.params.slidesPerView;
      p === "auto" ? p = r.slidesPerViewDynamic() : (p = Math.ceil(parseFloat(r.params.slidesPerView, 10)), _ && p % 2 === 0 && (p = p + 1));
      let m = d - c < p;
      if (_ && (m = m || c < Math.ceil(p / 2)), n && _ && r.params.slidesPerView !== "auto" && !o && (m = false), m) {
        const C = _ ? c < r.activeIndex ? "prev" : "next" : c - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
        r.loopFix({ direction: C, slideTo: true, activeSlideIndex: C === "next" ? c + 1 : c - d + 1, slideRealIndex: C === "next" ? r.realIndex : void 0 });
      }
      if (o) {
        const C = l * r.params.grid.rows;
        l = r.slides.find((S) => S.getAttribute("data-swiper-slide-index") * 1 === C).column;
      } else l = r.getSlideIndexByData(l);
    }
    return requestAnimationFrame(() => {
      r.slideTo(l, e, i, n);
    }), r;
  }
  function $g(t, e = true, i) {
    const n = this, { enabled: r, params: o, animating: l } = n;
    if (!r || n.destroyed) return n;
    typeof t == "undefined" && (t = n.params.speed);
    let c = o.slidesPerGroup;
    o.slidesPerView === "auto" && o.slidesPerGroup === 1 && o.slidesPerGroupAuto && (c = Math.max(n.slidesPerViewDynamic("current", true), 1));
    const d = n.activeIndex < o.slidesPerGroupSkip ? 1 : c, v = n.virtual && o.virtual.enabled;
    if (o.loop) {
      if (l && !v && o.loopPreventsSliding) return false;
      if (n.loopFix({ direction: "next" }), n._clientLeft = n.wrapperEl.clientLeft, n.activeIndex === n.slides.length - 1 && o.cssMode) return requestAnimationFrame(() => {
        n.slideTo(n.activeIndex + d, t, e, i);
      }), true;
    }
    return o.rewind && n.isEnd ? n.slideTo(0, t, e, i) : n.slideTo(n.activeIndex + d, t, e, i);
  }
  function zg(t, e = true, i) {
    const n = this, { params: r, snapGrid: o, slidesGrid: l, rtlTranslate: c, enabled: d, animating: v } = n;
    if (!d || n.destroyed) return n;
    typeof t == "undefined" && (t = n.params.speed);
    const b = n.virtual && r.virtual.enabled;
    if (r.loop) {
      if (v && !b && r.loopPreventsSliding) return false;
      n.loopFix({ direction: "prev" }), n._clientLeft = n.wrapperEl.clientLeft;
    }
    const y = c ? n.translate : -n.translate;
    function _(E) {
      return E < 0 ? -Math.floor(Math.abs(E)) : Math.floor(E);
    }
    const p = _(y), m = o.map((E) => _(E)), C = r.freeMode && r.freeMode.enabled;
    let S = o[m.indexOf(p) - 1];
    if (typeof S == "undefined" && (r.cssMode || C)) {
      let E;
      o.forEach((I, O) => {
        p >= I && (E = O);
      }), typeof E != "undefined" && (S = C ? o[E] : o[E > 0 ? E - 1 : E]);
    }
    let h = 0;
    if (typeof S != "undefined" && (h = l.indexOf(S), h < 0 && (h = n.activeIndex - 1), r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (h = h - n.slidesPerViewDynamic("previous", true) + 1, h = Math.max(h, 0))), r.rewind && n.isBeginning) {
      const E = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
      return n.slideTo(E, t, e, i);
    } else if (r.loop && n.activeIndex === 0 && r.cssMode) return requestAnimationFrame(() => {
      n.slideTo(h, t, e, i);
    }), true;
    return n.slideTo(h, t, e, i);
  }
  function kg(t, e = true, i) {
    const n = this;
    if (!n.destroyed) return typeof t == "undefined" && (t = n.params.speed), n.slideTo(n.activeIndex, t, e, i);
  }
  function Ng(t, e = true, i, n = 0.5) {
    const r = this;
    if (r.destroyed) return;
    typeof t == "undefined" && (t = r.params.speed);
    let o = r.activeIndex;
    const l = Math.min(r.params.slidesPerGroupSkip, o), c = l + Math.floor((o - l) / r.params.slidesPerGroup), d = r.rtlTranslate ? r.translate : -r.translate;
    if (d >= r.snapGrid[c]) {
      const v = r.snapGrid[c], b = r.snapGrid[c + 1];
      d - v > (b - v) * n && (o += r.params.slidesPerGroup);
    } else {
      const v = r.snapGrid[c - 1], b = r.snapGrid[c];
      d - v <= (b - v) * n && (o -= r.params.slidesPerGroup);
    }
    return o = Math.max(o, 0), o = Math.min(o, r.slidesGrid.length - 1), r.slideTo(o, t, e, i);
  }
  function Rg() {
    const t = this;
    if (t.destroyed) return;
    const { params: e, slidesEl: i } = t, n = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
    let r = t.getSlideIndexWhenGrid(t.clickedIndex), o;
    const l = t.isElement ? "swiper-slide" : `.${e.slideClass}`, c = t.grid && t.params.grid && t.params.grid.rows > 1;
    if (e.loop) {
      if (t.animating) return;
      o = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? t.slideToLoop(o) : r > (c ? (t.slides.length - n) / 2 - (t.params.grid.rows - 1) : t.slides.length - n) ? (t.loopFix(), r = t.getSlideIndex(Me(i, `${l}[data-swiper-slide-index="${o}"]`)[0]), Mi(() => {
        t.slideTo(r);
      })) : t.slideTo(r);
    } else t.slideTo(r);
  }
  var Hg = { slideTo: Pg, slideToLoop: Dg, slideNext: $g, slidePrev: zg, slideReset: kg, slideToClosest: Ng, slideToClickedSlide: Rg };
  function Bg(t, e) {
    const i = this, { params: n, slidesEl: r } = i;
    if (!n.loop || i.virtual && i.params.virtual.enabled) return;
    const o = () => {
      Me(r, `.${n.slideClass}, swiper-slide`).forEach((m, C) => {
        m.setAttribute("data-swiper-slide-index", C);
      });
    }, l = () => {
      const p = Me(r, `.${n.slideBlankClass}`);
      p.forEach((m) => {
        m.remove();
      }), p.length > 0 && (i.recalcSlides(), i.updateSlides());
    }, c = i.grid && n.grid && n.grid.rows > 1;
    n.loopAddBlankSlides && (n.slidesPerGroup > 1 || c) && l();
    const d = n.slidesPerGroup * (c ? n.grid.rows : 1), v = i.slides.length % d !== 0, b = c && i.slides.length % n.grid.rows !== 0, y = (p) => {
      for (let m = 0; m < p; m += 1) {
        const C = i.isElement ? Ye("swiper-slide", [n.slideBlankClass]) : Ye("div", [n.slideClass, n.slideBlankClass]);
        i.slidesEl.append(C);
      }
    };
    if (v) {
      if (n.loopAddBlankSlides) {
        const p = d - i.slides.length % d;
        y(p), i.recalcSlides(), i.updateSlides();
      } else zn("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      o();
    } else if (b) {
      if (n.loopAddBlankSlides) {
        const p = n.grid.rows - i.slides.length % n.grid.rows;
        y(p), i.recalcSlides(), i.updateSlides();
      } else zn("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      o();
    } else o();
    const _ = n.centeredSlides || !!n.slidesOffsetBefore || !!n.slidesOffsetAfter;
    i.loopFix({ slideRealIndex: t, direction: _ ? void 0 : "next", initial: e });
  }
  function Vg({ slideRealIndex: t, slideTo: e = true, direction: i, setTranslate: n, activeSlideIndex: r, initial: o, byController: l, byMousewheel: c } = {}) {
    const d = this;
    if (!d.params.loop) return;
    d.emit("beforeLoopFix");
    const { slides: v, allowSlidePrev: b, allowSlideNext: y, slidesEl: _, params: p } = d, { centeredSlides: m, slidesOffsetBefore: C, slidesOffsetAfter: S, initialSlide: h } = p, E = m || !!C || !!S;
    if (d.allowSlidePrev = true, d.allowSlideNext = true, d.virtual && p.virtual.enabled) {
      e && (!E && d.snapIndex === 0 ? d.slideTo(d.virtual.slides.length, 0, false, true) : E && d.snapIndex < p.slidesPerView ? d.slideTo(d.virtual.slides.length + d.snapIndex, 0, false, true) : d.snapIndex === d.snapGrid.length - 1 && d.slideTo(d.virtual.slidesBefore, 0, false, true)), d.allowSlidePrev = b, d.allowSlideNext = y, d.emit("loopFix");
      return;
    }
    let I = p.slidesPerView;
    I === "auto" ? I = d.slidesPerViewDynamic() : (I = Math.ceil(parseFloat(p.slidesPerView, 10)), E && I % 2 === 0 && (I = I + 1));
    const O = p.slidesPerGroupAuto ? I : p.slidesPerGroup;
    let L = E ? Math.max(O, Math.ceil(I / 2)) : O;
    L % O !== 0 && (L += O - L % O), L += p.loopAdditionalSlides, d.loopedSlides = L;
    const f = d.grid && p.grid && p.grid.rows > 1;
    v.length < I + L || d.params.effect === "cards" && v.length < I + L * 2 ? zn("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : f && p.grid.fill === "row" && zn("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const P = [], D = [], H = f ? Math.ceil(v.length / p.grid.rows) : v.length, k = o && H - h < I && !E;
    let z = k ? h : d.activeIndex;
    typeof r == "undefined" ? r = d.getSlideIndex(v.find((Y) => Y.classList.contains(p.slideActiveClass))) : z = r;
    const B = i === "next" || !i, V = i === "prev" || !i;
    let X = 0, Z = 0;
    const W = (f ? v[r].column : r) + (E && typeof n == "undefined" ? -I / 2 + 0.5 : 0);
    if (W < L) {
      X = Math.max(L - W, O);
      for (let Y = 0; Y < L - W; Y += 1) {
        const J = Y - Math.floor(Y / H) * H;
        if (f) {
          const re = H - J - 1;
          for (let fe = v.length - 1; fe >= 0; fe -= 1) v[fe].column === re && P.push(fe);
        } else P.push(H - J - 1);
      }
    } else if (W + I > H - L) {
      Z = Math.max(W - (H - L * 2), O), k && (Z = Math.max(Z, I - H + h + 1));
      for (let Y = 0; Y < Z; Y += 1) {
        const J = Y - Math.floor(Y / H) * H;
        f ? v.forEach((re, fe) => {
          re.column === J && D.push(fe);
        }) : D.push(J);
      }
    }
    if (d.__preventObserver__ = true, requestAnimationFrame(() => {
      d.__preventObserver__ = false;
    }), d.params.effect === "cards" && v.length < I + L * 2 && (D.includes(r) && D.splice(D.indexOf(r), 1), P.includes(r) && P.splice(P.indexOf(r), 1)), V && P.forEach((Y) => {
      v[Y].swiperLoopMoveDOM = true, _.prepend(v[Y]), v[Y].swiperLoopMoveDOM = false;
    }), B && D.forEach((Y) => {
      v[Y].swiperLoopMoveDOM = true, _.append(v[Y]), v[Y].swiperLoopMoveDOM = false;
    }), d.recalcSlides(), p.slidesPerView === "auto" ? d.updateSlides() : f && (P.length > 0 && V || D.length > 0 && B) && d.slides.forEach((Y, J) => {
      d.grid.updateSlide(J, Y, d.slides);
    }), p.watchSlidesProgress && d.updateSlidesOffset(), e) {
      if (P.length > 0 && V) {
        if (typeof t == "undefined") {
          const Y = d.slidesGrid[z], re = d.slidesGrid[z + X] - Y;
          c ? d.setTranslate(d.translate - re) : (d.slideTo(z + Math.ceil(X), 0, false, true), n && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - re, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - re));
        } else if (n) {
          const Y = f ? P.length / p.grid.rows : P.length;
          d.slideTo(d.activeIndex + Y, 0, false, true), d.touchEventsData.currentTranslate = d.translate;
        }
      } else if (D.length > 0 && B) if (typeof t == "undefined") {
        const Y = d.slidesGrid[z], re = d.slidesGrid[z - Z] - Y;
        c ? d.setTranslate(d.translate - re) : (d.slideTo(z - Z, 0, false, true), n && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - re, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - re));
      } else {
        const Y = f ? D.length / p.grid.rows : D.length;
        d.slideTo(d.activeIndex - Y, 0, false, true);
      }
    }
    if (d.allowSlidePrev = b, d.allowSlideNext = y, d.controller && d.controller.control && !l) {
      const Y = { slideRealIndex: t, direction: i, setTranslate: n, activeSlideIndex: r, byController: true };
      Array.isArray(d.controller.control) ? d.controller.control.forEach((J) => {
        !J.destroyed && J.params.loop && J.loopFix(vi(we({}, Y), { slideTo: J.params.slidesPerView === p.slidesPerView ? e : false }));
      }) : d.controller.control instanceof d.constructor && d.controller.control.params.loop && d.controller.control.loopFix(vi(we({}, Y), { slideTo: d.controller.control.params.slidesPerView === p.slidesPerView ? e : false }));
    }
    d.emit("loopFix");
  }
  function Wg() {
    const t = this, { params: e, slidesEl: i } = t;
    if (!e.loop || !i || t.virtual && t.params.virtual.enabled) return;
    t.recalcSlides();
    const n = [];
    t.slides.forEach((r) => {
      const o = typeof r.swiperSlideIndex == "undefined" ? r.getAttribute("data-swiper-slide-index") * 1 : r.swiperSlideIndex;
      n[o] = r;
    }), t.slides.forEach((r) => {
      r.removeAttribute("data-swiper-slide-index");
    }), n.forEach((r) => {
      i.append(r);
    }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
  }
  var Fg = { loopCreate: Bg, loopFix: Vg, loopDestroy: Wg };
  function Gg(t) {
    const e = this;
    if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
    const i = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
    e.isElement && (e.__preventObserver__ = true), i.style.cursor = "move", i.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
      e.__preventObserver__ = false;
    });
  }
  function jg() {
    const t = this;
    t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = true), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
      t.__preventObserver__ = false;
    }));
  }
  var Yg = { setGrabCursor: Gg, unsetGrabCursor: jg };
  function Xg(t, e = this) {
    function i(n) {
      if (!n || n === Oe() || n === ve()) return null;
      n.assignedSlot && (n = n.assignedSlot);
      const r = n.closest(t);
      return !r && !n.getRootNode ? null : r || i(n.getRootNode().host);
    }
    return i(e);
  }
  function la(t, e, i) {
    const n = ve(), { params: r } = t, o = r.edgeSwipeDetection, l = r.edgeSwipeThreshold;
    return o && (i <= l || i >= n.innerWidth - l) ? o === "prevent" ? (e.preventDefault(), true) : false : true;
  }
  function qg(t) {
    const e = this, i = Oe();
    let n = t;
    n.originalEvent && (n = n.originalEvent);
    const r = e.touchEventsData;
    if (n.type === "pointerdown") {
      if (r.pointerId !== null && r.pointerId !== n.pointerId) return;
      r.pointerId = n.pointerId;
    } else n.type === "touchstart" && n.targetTouches.length === 1 && (r.touchId = n.targetTouches[0].identifier);
    if (n.type === "touchstart") {
      la(e, n, n.targetTouches[0].pageX);
      return;
    }
    const { params: o, touches: l, enabled: c } = e;
    if (!c || !o.simulateTouch && n.pointerType === "mouse" || e.animating && o.preventInteractionOnTransition) return;
    !e.animating && o.cssMode && o.loop && e.loopFix();
    let d = n.target;
    if (o.touchEventsTarget === "wrapper" && !ig(d, e.wrapperEl) || "which" in n && n.which === 3 || "button" in n && n.button > 0 || r.isTouched && r.isMoved) return;
    const v = !!o.noSwipingClass && o.noSwipingClass !== "", b = n.composedPath ? n.composedPath() : n.path;
    v && n.target && n.target.shadowRoot && b && (d = b[0]);
    const y = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`, _ = !!(n.target && n.target.shadowRoot);
    if (o.noSwiping && (_ ? Xg(y, d) : d.closest(y))) {
      e.allowClick = true;
      return;
    }
    if (o.swipeHandler && !d.closest(o.swipeHandler)) return;
    l.currentX = n.pageX, l.currentY = n.pageY;
    const p = l.currentX, m = l.currentY;
    if (!la(e, n, p)) return;
    Object.assign(r, { isTouched: true, isMoved: false, allowTouchCallbacks: true, isScrolling: void 0, startMoving: void 0 }), l.startX = p, l.startY = m, r.touchStartTime = Qe(), e.allowClick = true, e.updateSize(), e.swipeDirection = void 0, o.threshold > 0 && (r.allowThresholdMove = false);
    let C = true;
    d.matches(r.focusableElements) && (C = false, d.nodeName === "SELECT" && (r.isTouched = false)), i.activeElement && i.activeElement.matches(r.focusableElements) && i.activeElement !== d && (n.pointerType === "mouse" || n.pointerType !== "mouse" && !d.matches(r.focusableElements)) && i.activeElement.blur();
    const S = C && e.allowTouchMove && o.touchStartPreventDefault;
    (o.touchStartForcePreventDefault || S) && !d.isContentEditable && n.preventDefault(), o.freeMode && o.freeMode.enabled && e.freeMode && e.animating && !o.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", n);
  }
  function Ug(t) {
    const e = Oe(), i = this, n = i.touchEventsData, { params: r, touches: o, rtlTranslate: l, enabled: c } = i;
    if (!c || !r.simulateTouch && t.pointerType === "mouse") return;
    let d = t;
    if (d.originalEvent && (d = d.originalEvent), d.type === "pointermove" && (n.touchId !== null || d.pointerId !== n.pointerId)) return;
    let v;
    if (d.type === "touchmove") {
      if (v = [...d.changedTouches].find((L) => L.identifier === n.touchId), !v || v.identifier !== n.touchId) return;
    } else v = d;
    if (!n.isTouched) {
      n.startMoving && n.isScrolling && i.emit("touchMoveOpposite", d);
      return;
    }
    const b = v.pageX, y = v.pageY;
    if (d.preventedByNestedSwiper) {
      o.startX = b, o.startY = y;
      return;
    }
    if (!i.allowTouchMove) {
      d.target.matches(n.focusableElements) || (i.allowClick = false), n.isTouched && (Object.assign(o, { startX: b, startY: y, currentX: b, currentY: y }), n.touchStartTime = Qe());
      return;
    }
    if (r.touchReleaseOnEdges && !r.loop) if (i.isVertical()) {
      if (y < o.startY && i.translate <= i.maxTranslate() || y > o.startY && i.translate >= i.minTranslate()) {
        n.isTouched = false, n.isMoved = false;
        return;
      }
    } else {
      if (l && (b > o.startX && -i.translate <= i.maxTranslate() || b < o.startX && -i.translate >= i.minTranslate())) return;
      if (!l && (b < o.startX && i.translate <= i.maxTranslate() || b > o.startX && i.translate >= i.minTranslate())) return;
    }
    if (e.activeElement && e.activeElement.matches(n.focusableElements) && e.activeElement !== d.target && d.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && d.target === e.activeElement && d.target.matches(n.focusableElements)) {
      n.isMoved = true, i.allowClick = false;
      return;
    }
    n.allowTouchCallbacks && i.emit("touchMove", d), o.previousX = o.currentX, o.previousY = o.currentY, o.currentX = b, o.currentY = y;
    const _ = o.currentX - o.startX, p = o.currentY - o.startY;
    if (i.params.threshold && Math.sqrt(De(_, 2) + De(p, 2)) < i.params.threshold) return;
    if (typeof n.isScrolling == "undefined") {
      let L;
      i.isHorizontal() && o.currentY === o.startY || i.isVertical() && o.currentX === o.startX ? n.isScrolling = false : _ * _ + p * p >= 25 && (L = Math.atan2(Math.abs(p), Math.abs(_)) * 180 / Math.PI, n.isScrolling = i.isHorizontal() ? L > r.touchAngle : 90 - L > r.touchAngle);
    }
    if (n.isScrolling && i.emit("touchMoveOpposite", d), typeof n.startMoving == "undefined" && (o.currentX !== o.startX || o.currentY !== o.startY) && (n.startMoving = true), n.isScrolling || d.type === "touchmove" && n.preventTouchMoveFromPointerMove) {
      n.isTouched = false;
      return;
    }
    if (!n.startMoving) return;
    i.allowClick = false, !r.cssMode && d.cancelable && d.preventDefault(), r.touchMoveStopPropagation && !r.nested && d.stopPropagation();
    let m = i.isHorizontal() ? _ : p, C = i.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
    r.oneWayMovement && (m = Math.abs(m) * (l ? 1 : -1), C = Math.abs(C) * (l ? 1 : -1)), o.diff = m, m *= r.touchRatio, l && (m = -m, C = -C);
    const S = i.touchesDirection;
    i.swipeDirection = m > 0 ? "prev" : "next", i.touchesDirection = C > 0 ? "prev" : "next";
    const h = i.params.loop && !r.cssMode, E = i.touchesDirection === "next" && i.allowSlideNext || i.touchesDirection === "prev" && i.allowSlidePrev;
    if (!n.isMoved) {
      if (h && E && i.loopFix({ direction: i.swipeDirection }), n.startTranslate = i.getTranslate(), i.setTransition(0), i.animating) {
        const L = new window.CustomEvent("transitionend", { bubbles: true, cancelable: true, detail: { bySwiperTouchMove: true } });
        i.wrapperEl.dispatchEvent(L);
      }
      n.allowMomentumBounce = false, r.grabCursor && (i.allowSlideNext === true || i.allowSlidePrev === true) && i.setGrabCursor(true), i.emit("sliderFirstMove", d);
    }
    if ((/* @__PURE__ */ new Date()).getTime(), r._loopSwapReset !== false && n.isMoved && n.allowThresholdMove && S !== i.touchesDirection && h && E && Math.abs(m) >= 1) {
      Object.assign(o, { startX: b, startY: y, currentX: b, currentY: y, startTranslate: n.currentTranslate }), n.loopSwapReset = true, n.startTranslate = n.currentTranslate;
      return;
    }
    i.emit("sliderMove", d), n.isMoved = true, n.currentTranslate = m + n.startTranslate;
    let I = true, O = r.resistanceRatio;
    if (r.touchReleaseOnEdges && (O = 0), m > 0 ? (h && E && n.allowThresholdMove && n.currentTranslate > (r.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] - (r.slidesPerView !== "auto" && i.slides.length - r.slidesPerView >= 2 ? i.slidesSizesGrid[i.activeIndex + 1] + i.params.spaceBetween : 0) - i.params.spaceBetween : i.minTranslate()) && i.loopFix({ direction: "prev", setTranslate: true, activeSlideIndex: 0 }), n.currentTranslate > i.minTranslate() && (I = false, r.resistance && (n.currentTranslate = i.minTranslate() - 1 + De(-i.minTranslate() + n.startTranslate + m, O)))) : m < 0 && (h && E && n.allowThresholdMove && n.currentTranslate < (r.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween + (r.slidesPerView !== "auto" && i.slides.length - r.slidesPerView >= 2 ? i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween : 0) : i.maxTranslate()) && i.loopFix({ direction: "next", setTranslate: true, activeSlideIndex: i.slides.length - (r.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10))) }), n.currentTranslate < i.maxTranslate() && (I = false, r.resistance && (n.currentTranslate = i.maxTranslate() + 1 - De(i.maxTranslate() - n.startTranslate - m, O)))), I && (d.preventedByNestedSwiper = true), !i.allowSlideNext && i.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !i.allowSlidePrev && i.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !i.allowSlidePrev && !i.allowSlideNext && (n.currentTranslate = n.startTranslate), r.threshold > 0) if (Math.abs(m) > r.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = true, o.startX = o.currentX, o.startY = o.currentY, n.currentTranslate = n.startTranslate, o.diff = i.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
    !r.followFinger || r.cssMode || ((r.freeMode && r.freeMode.enabled && i.freeMode || r.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(n.currentTranslate), i.setTranslate(n.currentTranslate));
  }
  function Kg(t) {
    const e = this, i = e.touchEventsData;
    let n = t;
    n.originalEvent && (n = n.originalEvent);
    let r;
    if (n.type === "touchend" || n.type === "touchcancel") {
      if (r = [...n.changedTouches].find((L) => L.identifier === i.touchId), !r || r.identifier !== i.touchId) return;
    } else {
      if (i.touchId !== null || n.pointerId !== i.pointerId) return;
      r = n;
    }
    if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && !(["pointercancel", "contextmenu"].includes(n.type) && (e.browser.isSafari || e.browser.isWebView))) return;
    i.pointerId = null, i.touchId = null;
    const { params: l, touches: c, rtlTranslate: d, slidesGrid: v, enabled: b } = e;
    if (!b || !l.simulateTouch && n.pointerType === "mouse") return;
    if (i.allowTouchCallbacks && e.emit("touchEnd", n), i.allowTouchCallbacks = false, !i.isTouched) {
      i.isMoved && l.grabCursor && e.setGrabCursor(false), i.isMoved = false, i.startMoving = false;
      return;
    }
    l.grabCursor && i.isMoved && i.isTouched && (e.allowSlideNext === true || e.allowSlidePrev === true) && e.setGrabCursor(false);
    const y = Qe(), _ = y - i.touchStartTime;
    if (e.allowClick) {
      const L = n.path || n.composedPath && n.composedPath();
      e.updateClickedSlide(L && L[0] || n.target, L), e.emit("tap click", n), _ < 300 && y - i.lastClickTime < 300 && e.emit("doubleTap doubleClick", n);
    }
    if (i.lastClickTime = Qe(), Mi(() => {
      e.destroyed || (e.allowClick = true);
    }), !i.isTouched || !i.isMoved || !e.swipeDirection || c.diff === 0 && !i.loopSwapReset || i.currentTranslate === i.startTranslate && !i.loopSwapReset) {
      i.isTouched = false, i.isMoved = false, i.startMoving = false;
      return;
    }
    i.isTouched = false, i.isMoved = false, i.startMoving = false;
    let p;
    if (l.followFinger ? p = d ? e.translate : -e.translate : p = -i.currentTranslate, l.cssMode) return;
    if (l.freeMode && l.freeMode.enabled) {
      e.freeMode.onTouchEnd({ currentPos: p });
      return;
    }
    const m = p >= -e.maxTranslate() && !e.params.loop;
    let C = 0, S = e.slidesSizesGrid[0];
    for (let L = 0; L < v.length; L += L < l.slidesPerGroupSkip ? 1 : l.slidesPerGroup) {
      const f = L < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
      typeof v[L + f] != "undefined" ? (m || p >= v[L] && p < v[L + f]) && (C = L, S = v[L + f] - v[L]) : (m || p >= v[L]) && (C = L, S = v[v.length - 1] - v[v.length - 2]);
    }
    let h = null, E = null;
    l.rewind && (e.isBeginning ? E = l.virtual && l.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (h = 0));
    const I = (p - v[C]) / S, O = C < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
    if (_ > l.longSwipesMs) {
      if (!l.longSwipes) {
        e.slideTo(e.activeIndex);
        return;
      }
      e.swipeDirection === "next" && (I >= l.longSwipesRatio ? e.slideTo(l.rewind && e.isEnd ? h : C + O) : e.slideTo(C)), e.swipeDirection === "prev" && (I > 1 - l.longSwipesRatio ? e.slideTo(C + O) : E !== null && I < 0 && Math.abs(I) > l.longSwipesRatio ? e.slideTo(E) : e.slideTo(C));
    } else {
      if (!l.shortSwipes) {
        e.slideTo(e.activeIndex);
        return;
      }
      e.navigation && (n.target === e.navigation.nextEl || n.target === e.navigation.prevEl) ? n.target === e.navigation.nextEl ? e.slideTo(C + O) : e.slideTo(C) : (e.swipeDirection === "next" && e.slideTo(h !== null ? h : C + O), e.swipeDirection === "prev" && e.slideTo(E !== null ? E : C));
    }
  }
  function ua() {
    const t = this, { params: e, el: i } = t;
    if (i && i.offsetWidth === 0) return;
    e.breakpoints && t.setBreakpoint();
    const { allowSlideNext: n, allowSlidePrev: r, snapGrid: o } = t, l = t.virtual && t.params.virtual.enabled;
    t.allowSlideNext = true, t.allowSlidePrev = true, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
    const c = l && e.loop;
    if ((e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !c) {
      const d = l ? t.virtual.slides : t.slides;
      t.slideTo(d.length - 1, 0, false, true);
    } else t.params.loop && !l ? t.slideToLoop(t.realIndex, 0, false, true) : t.slideTo(t.activeIndex, 0, false, true);
    t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
      t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
    }, 500)), t.allowSlidePrev = r, t.allowSlideNext = n, t.params.watchOverflow && o !== t.snapGrid && t.checkOverflow();
  }
  function Zg(t) {
    const e = this;
    e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
  }
  function Qg() {
    const t = this, { wrapperEl: e, rtlTranslate: i, enabled: n } = t;
    if (!n) return;
    t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
    let r;
    const o = t.maxTranslate() - t.minTranslate();
    o === 0 ? r = 0 : r = (t.translate - t.minTranslate()) / o, r !== t.progress && t.updateProgress(i ? -t.translate : t.translate), t.emit("setTranslate", t.translate, false);
  }
  function Jg(t) {
    const e = this;
    On(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
  }
  function em() {
    const t = this;
    t.documentTouchHandlerProceeded || (t.documentTouchHandlerProceeded = true, t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
  }
  const Rl = (t, e) => {
    const i = Oe(), { params: n, el: r, wrapperEl: o, device: l } = t, c = !!n.nested, d = e === "on" ? "addEventListener" : "removeEventListener", v = e;
    !r || typeof r == "string" || (i[d]("touchstart", t.onDocumentTouchStart, { passive: false, capture: c }), r[d]("touchstart", t.onTouchStart, { passive: false }), r[d]("pointerdown", t.onTouchStart, { passive: false }), i[d]("touchmove", t.onTouchMove, { passive: false, capture: c }), i[d]("pointermove", t.onTouchMove, { passive: false, capture: c }), i[d]("touchend", t.onTouchEnd, { passive: true }), i[d]("pointerup", t.onTouchEnd, { passive: true }), i[d]("pointercancel", t.onTouchEnd, { passive: true }), i[d]("touchcancel", t.onTouchEnd, { passive: true }), i[d]("pointerout", t.onTouchEnd, { passive: true }), i[d]("pointerleave", t.onTouchEnd, { passive: true }), i[d]("contextmenu", t.onTouchEnd, { passive: true }), (n.preventClicks || n.preventClicksPropagation) && r[d]("click", t.onClick, true), n.cssMode && o[d]("scroll", t.onScroll), n.updateOnWindowResize ? t[v](l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", ua, true) : t[v]("observerUpdate", ua, true), r[d]("load", t.onLoad, { capture: true }));
  };
  function tm() {
    const t = this, { params: e } = t;
    t.onTouchStart = qg.bind(t), t.onTouchMove = Ug.bind(t), t.onTouchEnd = Kg.bind(t), t.onDocumentTouchStart = em.bind(t), e.cssMode && (t.onScroll = Qg.bind(t)), t.onClick = Zg.bind(t), t.onLoad = Jg.bind(t), Rl(t, "on");
  }
  function im() {
    Rl(this, "off");
  }
  var nm = { attachEvents: tm, detachEvents: im };
  const ca = (t, e) => t.grid && e.grid && e.grid.rows > 1;
  function sm() {
    const t = this, { realIndex: e, initialized: i, params: n, el: r } = t, o = n.breakpoints;
    if (!o || o && Object.keys(o).length === 0) return;
    const l = Oe(), c = n.breakpointsBase === "window" || !n.breakpointsBase ? n.breakpointsBase : "container", d = ["window", "container"].includes(n.breakpointsBase) || !n.breakpointsBase ? t.el : l.querySelector(n.breakpointsBase), v = t.getBreakpoint(o, c, d);
    if (!v || t.currentBreakpoint === v) return;
    const y = (v in o ? o[v] : void 0) || t.originalParams, _ = ca(t, n), p = ca(t, y), m = t.params.grabCursor, C = y.grabCursor, S = n.enabled;
    _ && !p ? (r.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), t.emitContainerClasses()) : !_ && p && (r.classList.add(`${n.containerModifierClass}grid`), (y.grid.fill && y.grid.fill === "column" || !y.grid.fill && n.grid.fill === "column") && r.classList.add(`${n.containerModifierClass}grid-column`), t.emitContainerClasses()), m && !C ? t.unsetGrabCursor() : !m && C && t.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((f) => {
      if (typeof y[f] == "undefined") return;
      const P = n[f] && n[f].enabled, D = y[f] && y[f].enabled;
      P && !D && t[f].disable(), !P && D && t[f].enable();
    });
    const h = y.direction && y.direction !== n.direction, E = n.loop && (y.slidesPerView !== n.slidesPerView || h), I = n.loop;
    h && i && t.changeDirection(), je(t.params, y);
    const O = t.params.enabled, L = t.params.loop;
    Object.assign(t, { allowTouchMove: t.params.allowTouchMove, allowSlideNext: t.params.allowSlideNext, allowSlidePrev: t.params.allowSlidePrev }), S && !O ? t.disable() : !S && O && t.enable(), t.currentBreakpoint = v, t.emit("_beforeBreakpoint", y), i && (E ? (t.loopDestroy(), t.loopCreate(e), t.updateSlides()) : !I && L ? (t.loopCreate(e), t.updateSlides()) : I && !L && t.loopDestroy()), t.emit("breakpoint", y);
  }
  function rm(t, e = "window", i) {
    if (!t || e === "container" && !i) return;
    let n = false;
    const r = ve(), o = e === "window" ? r.innerHeight : i.clientHeight, l = Object.keys(t).map((c) => {
      if (typeof c == "string" && c.indexOf("@") === 0) {
        const d = parseFloat(c.substr(1));
        return { value: o * d, point: c };
      }
      return { value: c, point: c };
    });
    l.sort((c, d) => parseInt(c.value, 10) - parseInt(d.value, 10));
    for (let c = 0; c < l.length; c += 1) {
      const { point: d, value: v } = l[c];
      e === "window" ? r.matchMedia(`(min-width: ${v}px)`).matches && (n = d) : v <= i.clientWidth && (n = d);
    }
    return n || "max";
  }
  var om = { setBreakpoint: sm, getBreakpoint: rm };
  function am(t, e) {
    const i = [];
    return t.forEach((n) => {
      typeof n == "object" ? Object.keys(n).forEach((r) => {
        n[r] && i.push(e + r);
      }) : typeof n == "string" && i.push(e + n);
    }), i;
  }
  function lm() {
    const t = this, { classNames: e, params: i, rtl: n, el: r, device: o } = t, l = am(["initialized", i.direction, { "free-mode": t.params.freeMode && i.freeMode.enabled }, { autoheight: i.autoHeight }, { rtl: n }, { grid: i.grid && i.grid.rows > 1 }, { "grid-column": i.grid && i.grid.rows > 1 && i.grid.fill === "column" }, { android: o.android }, { ios: o.ios }, { "css-mode": i.cssMode }, { centered: i.cssMode && i.centeredSlides }, { "watch-progress": i.watchSlidesProgress }], i.containerModifierClass);
    e.push(...l), r.classList.add(...e), t.emitContainerClasses();
  }
  function um() {
    const t = this, { el: e, classNames: i } = t;
    !e || typeof e == "string" || (e.classList.remove(...i), t.emitContainerClasses());
  }
  var cm = { addClasses: lm, removeClasses: um };
  function dm() {
    const t = this, { isLocked: e, params: i } = t, { slidesOffsetBefore: n } = i;
    if (n) {
      const r = t.slides.length - 1, o = t.slidesGrid[r] + t.slidesSizesGrid[r] + n * 2;
      t.isLocked = t.size > o;
    } else t.isLocked = t.snapGrid.length === 1;
    i.allowSlideNext === true && (t.allowSlideNext = !t.isLocked), i.allowSlidePrev === true && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = false), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
  }
  var fm = { checkOverflow: dm }, da = { init: true, direction: "horizontal", oneWayMovement: false, swiperElementNodeName: "SWIPER-CONTAINER", touchEventsTarget: "wrapper", initialSlide: 0, speed: 300, cssMode: false, updateOnWindowResize: true, resizeObserver: true, nested: false, createElements: false, eventsPrefix: "swiper", enabled: true, focusableElements: "input, select, option, textarea, button, video, label", width: null, height: null, preventInteractionOnTransition: false, userAgent: null, url: null, edgeSwipeDetection: false, edgeSwipeThreshold: 20, autoHeight: false, setWrapperSize: false, virtualTranslate: false, effect: "slide", breakpoints: void 0, breakpointsBase: "window", spaceBetween: 0, slidesPerView: 1, slidesPerGroup: 1, slidesPerGroupSkip: 0, slidesPerGroupAuto: false, centeredSlides: false, centeredSlidesBounds: false, slidesOffsetBefore: 0, slidesOffsetAfter: 0, normalizeSlideIndex: true, centerInsufficientSlides: false, snapToSlideEdge: false, watchOverflow: true, roundLengths: false, touchRatio: 1, touchAngle: 45, simulateTouch: true, shortSwipes: true, longSwipes: true, longSwipesRatio: 0.5, longSwipesMs: 300, followFinger: true, allowTouchMove: true, threshold: 5, touchMoveStopPropagation: false, touchStartPreventDefault: true, touchStartForcePreventDefault: false, touchReleaseOnEdges: false, uniqueNavElements: true, resistance: true, resistanceRatio: 0.85, watchSlidesProgress: false, grabCursor: false, preventClicks: true, preventClicksPropagation: true, slideToClickedSlide: false, loop: false, loopAddBlankSlides: true, loopAdditionalSlides: 0, loopPreventsSliding: true, rewind: false, allowSlidePrev: true, allowSlideNext: true, swipeHandler: null, noSwiping: true, noSwipingClass: "swiper-no-swiping", noSwipingSelector: null, passiveListeners: true, maxBackfaceHiddenSlides: 10, containerModifierClass: "swiper-", slideClass: "swiper-slide", slideBlankClass: "swiper-slide-blank", slideActiveClass: "swiper-slide-active", slideVisibleClass: "swiper-slide-visible", slideFullyVisibleClass: "swiper-slide-fully-visible", slideNextClass: "swiper-slide-next", slidePrevClass: "swiper-slide-prev", wrapperClass: "swiper-wrapper", lazyPreloaderClass: "swiper-lazy-preloader", lazyPreloadPrevNext: 0, runCallbacksOnInit: true, _emitClasses: false };
  function hm(t, e) {
    return function(n = {}) {
      const r = Object.keys(n)[0], o = n[r];
      if (typeof o != "object" || o === null) {
        je(e, n);
        return;
      }
      if (t[r] === true && (t[r] = { enabled: true }), r === "navigation" && t[r] && t[r].enabled && !t[r].prevEl && !t[r].nextEl && (t[r].auto = true), ["pagination", "scrollbar"].indexOf(r) >= 0 && t[r] && t[r].enabled && !t[r].el && (t[r].auto = true), !(r in t && "enabled" in o)) {
        je(e, n);
        return;
      }
      typeof t[r] == "object" && !("enabled" in t[r]) && (t[r].enabled = true), t[r] || (t[r] = { enabled: false }), je(e, n);
    };
  }
  const Bs = { eventsEmitter: cg, update: Tg, translate: Ag, transition: Lg, slide: Hg, loop: Fg, grabCursor: Yg, events: nm, breakpoints: om, checkOverflow: fm, classes: cm }, Vs = {};
  class Be {
    constructor(...e) {
      let i, n;
      e.length === 1 && e[0].constructor && Object.prototype.toString.call(e[0]).slice(8, -1) === "Object" ? n = e[0] : [i, n] = e, n || (n = {}), n = je({}, n), i && !n.el && (n.el = i);
      const r = Oe();
      if (n.el && typeof n.el == "string" && r.querySelectorAll(n.el).length > 1) {
        const d = [];
        return r.querySelectorAll(n.el).forEach((v) => {
          const b = je({}, n, { el: v });
          d.push(new Be(b));
        }), d;
      }
      const o = this;
      o.__swiper__ = true, o.support = $l(), o.device = zl({ userAgent: n.userAgent }), o.browser = kl(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], n.modules && Array.isArray(n.modules) && n.modules.forEach((d) => {
        typeof d == "function" && o.modules.indexOf(d) < 0 && o.modules.push(d);
      });
      const l = {};
      o.modules.forEach((d) => {
        d({ params: n, swiper: o, extendParams: hm(n, l), on: o.on.bind(o), once: o.once.bind(o), off: o.off.bind(o), emit: o.emit.bind(o) });
      });
      const c = je({}, da, l);
      return o.params = je({}, c, Vs, n), o.originalParams = je({}, o.params), o.passedParams = je({}, n), o.params && o.params.on && Object.keys(o.params.on).forEach((d) => {
        o.on(d, o.params.on[d]);
      }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, { enabled: o.params.enabled, el: i, classNames: [], slides: [], slidesGrid: [], snapGrid: [], slidesSizesGrid: [], isHorizontal() {
        return o.params.direction === "horizontal";
      }, isVertical() {
        return o.params.direction === "vertical";
      }, activeIndex: 0, realIndex: 0, isBeginning: true, isEnd: false, translate: 0, previousTranslate: 0, progress: 0, velocity: 0, animating: false, cssOverflowAdjustment() {
        return Math.trunc(this.translate / De(2, 23)) * De(2, 23);
      }, allowSlideNext: o.params.allowSlideNext, allowSlidePrev: o.params.allowSlidePrev, touchEventsData: { isTouched: void 0, isMoved: void 0, allowTouchCallbacks: void 0, touchStartTime: void 0, isScrolling: void 0, currentTranslate: void 0, startTranslate: void 0, allowThresholdMove: void 0, focusableElements: o.params.focusableElements, lastClickTime: 0, clickTimeout: void 0, velocities: [], allowMomentumBounce: void 0, startMoving: void 0, pointerId: null, touchId: null }, allowClick: true, allowTouchMove: o.params.allowTouchMove, touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 }, imagesToLoad: [], imagesLoaded: 0 }), o.emit("_swiper"), o.params.init && o.init(), o;
    }
    getDirectionLabel(e) {
      return this.isHorizontal() ? e : { width: "height", "margin-top": "margin-left", "margin-bottom ": "margin-right", "margin-left": "margin-top", "margin-right": "margin-bottom", "padding-left": "padding-top", "padding-right": "padding-bottom", marginRight: "marginBottom" }[e];
    }
    getSlideIndex(e) {
      const { slidesEl: i, params: n } = this, r = Me(i, `.${n.slideClass}, swiper-slide`), o = Ki(r[0]);
      return Ki(e) - o;
    }
    getSlideIndexByData(e) {
      return this.getSlideIndex(this.slides.find((i) => i.getAttribute("data-swiper-slide-index") * 1 === e));
    }
    getSlideIndexWhenGrid(e) {
      return this.grid && this.params.grid && this.params.grid.rows > 1 && (this.params.grid.fill === "column" ? e = Math.floor(e / this.params.grid.rows) : this.params.grid.fill === "row" && (e = e % Math.ceil(this.slides.length / this.params.grid.rows))), e;
    }
    recalcSlides() {
      const e = this, { slidesEl: i, params: n } = e;
      e.slides = Me(i, `.${n.slideClass}, swiper-slide`);
    }
    enable() {
      const e = this;
      e.enabled || (e.enabled = true, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
    }
    disable() {
      const e = this;
      e.enabled && (e.enabled = false, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
    }
    setProgress(e, i) {
      const n = this;
      e = Math.min(Math.max(e, 0), 1);
      const r = n.minTranslate(), l = (n.maxTranslate() - r) * e + r;
      n.translateTo(l, typeof i == "undefined" ? 0 : i), n.updateActiveIndex(), n.updateSlidesClasses();
    }
    emitContainerClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const i = e.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(e.params.containerModifierClass) === 0);
      e.emit("_containerClasses", i.join(" "));
    }
    getSlideClasses(e) {
      const i = this;
      return i.destroyed ? "" : e.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(i.params.slideClass) === 0).join(" ");
    }
    emitSlidesClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const i = [];
      e.slides.forEach((n) => {
        const r = e.getSlideClasses(n);
        i.push({ slideEl: n, classNames: r }), e.emit("_slideClass", n, r);
      }), e.emit("_slideClasses", i);
    }
    slidesPerViewDynamic(e = "current", i = false) {
      const n = this, { params: r, slides: o, slidesGrid: l, slidesSizesGrid: c, size: d, activeIndex: v } = n;
      let b = 1;
      if (typeof r.slidesPerView == "number") return r.slidesPerView;
      if (r.centeredSlides) {
        let y = o[v] ? Math.ceil(o[v].swiperSlideSize) : 0, _;
        for (let p = v + 1; p < o.length; p += 1) o[p] && !_ && (y += Math.ceil(o[p].swiperSlideSize), b += 1, y > d && (_ = true));
        for (let p = v - 1; p >= 0; p -= 1) o[p] && !_ && (y += o[p].swiperSlideSize, b += 1, y > d && (_ = true));
      } else if (e === "current") for (let y = v + 1; y < o.length; y += 1) (i ? l[y] + c[y] - l[v] < d : l[y] - l[v] < d) && (b += 1);
      else for (let y = v - 1; y >= 0; y -= 1) l[v] - l[y] < d && (b += 1);
      return b;
    }
    update() {
      const e = this;
      if (!e || e.destroyed) return;
      const { snapGrid: i, params: n } = e;
      n.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((l) => {
        l.complete && On(e, l);
      }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
      function r() {
        const l = e.rtlTranslate ? e.translate * -1 : e.translate, c = Math.min(Math.max(l, e.maxTranslate()), e.minTranslate());
        e.setTranslate(c), e.updateActiveIndex(), e.updateSlidesClasses();
      }
      let o;
      if (n.freeMode && n.freeMode.enabled && !n.cssMode) r(), n.autoHeight && e.updateAutoHeight();
      else {
        if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
          const l = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
          o = e.slideTo(l.length - 1, 0, false, true);
        } else o = e.slideTo(e.activeIndex, 0, false, true);
        o || r();
      }
      n.watchOverflow && i !== e.snapGrid && e.checkOverflow(), e.emit("update");
    }
    changeDirection(e, i = true) {
      const n = this, r = n.params.direction;
      return e || (e = r === "horizontal" ? "vertical" : "horizontal"), e === r || e !== "horizontal" && e !== "vertical" || (n.el.classList.remove(`${n.params.containerModifierClass}${r}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach((o) => {
        e === "vertical" ? o.style.width = "" : o.style.height = "";
      }), n.emit("changeDirection"), i && n.update()), n;
    }
    changeLanguageDirection(e) {
      const i = this;
      i.rtl && e === "rtl" || !i.rtl && e === "ltr" || (i.rtl = e === "rtl", i.rtlTranslate = i.params.direction === "horizontal" && i.rtl, i.rtl ? (i.el.classList.add(`${i.params.containerModifierClass}rtl`), i.el.dir = "rtl") : (i.el.classList.remove(`${i.params.containerModifierClass}rtl`), i.el.dir = "ltr"), i.update());
    }
    mount(e) {
      const i = this;
      if (i.mounted) return true;
      let n = e || i.params.el;
      if (typeof n == "string" && (n = document.querySelector(n)), !n) return false;
      n.swiper = i, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === i.params.swiperElementNodeName.toUpperCase() && (i.isElement = true);
      const r = () => `.${(i.params.wrapperClass || "").trim().split(" ").join(".")}`;
      let l = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(r()) : Me(n, r())[0];
      return !l && i.params.createElements && (l = Ye("div", i.params.wrapperClass), n.append(l), Me(n, `.${i.params.slideClass}`).forEach((c) => {
        l.append(c);
      })), Object.assign(i, { el: n, wrapperEl: l, slidesEl: i.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : l, hostEl: i.isElement ? n.parentNode.host : n, mounted: true, rtl: n.dir.toLowerCase() === "rtl" || Nt(n, "direction") === "rtl", rtlTranslate: i.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || Nt(n, "direction") === "rtl"), wrongRTL: Nt(l, "display") === "-webkit-box" }), true;
    }
    init(e) {
      const i = this;
      if (i.initialized || i.mount(e) === false) return i;
      i.emit("beforeInit"), i.params.breakpoints && i.setBreakpoint(), i.addClasses(), i.updateSize(), i.updateSlides(), i.params.watchOverflow && i.checkOverflow(), i.params.grabCursor && i.enabled && i.setGrabCursor(), i.params.loop && i.virtual && i.params.virtual.enabled ? i.slideTo(i.params.initialSlide + i.virtual.slidesBefore, 0, i.params.runCallbacksOnInit, false, true) : i.slideTo(i.params.initialSlide, 0, i.params.runCallbacksOnInit, false, true), i.params.loop && i.loopCreate(void 0, true), i.attachEvents();
      const r = [...i.el.querySelectorAll('[loading="lazy"]')];
      return i.isElement && r.push(...i.hostEl.querySelectorAll('[loading="lazy"]')), r.forEach((o) => {
        o.complete ? On(i, o) : o.addEventListener("load", (l) => {
          On(i, l.target);
        });
      }), dr(i), i.initialized = true, dr(i), i.emit("init"), i.emit("afterInit"), i;
    }
    destroy(e = true, i = true) {
      const n = this, { params: r, el: o, wrapperEl: l, slides: c } = n;
      return typeof n.params == "undefined" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = false, n.detachEvents(), r.loop && n.loopDestroy(), i && (n.removeClasses(), o && typeof o != "string" && o.removeAttribute("style"), l && l.removeAttribute("style"), c && c.length && c.forEach((d) => {
        d.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), d.removeAttribute("style"), d.removeAttribute("data-swiper-slide-index");
      })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((d) => {
        n.off(d);
      }), e !== false && (n.el && typeof n.el != "string" && (n.el.swiper = null), Qp(n)), n.destroyed = true), null;
    }
    static extendDefaults(e) {
      je(Vs, e);
    }
    static get extendedDefaults() {
      return Vs;
    }
    static get defaults() {
      return da;
    }
    static installModule(e) {
      Be.prototype.__modules__ || (Be.prototype.__modules__ = []);
      const i = Be.prototype.__modules__;
      typeof e == "function" && i.indexOf(e) < 0 && i.push(e);
    }
    static use(e) {
      return Array.isArray(e) ? (e.forEach((i) => Be.installModule(i)), Be) : (Be.installModule(e), Be);
    }
  }
  Object.keys(Bs).forEach((t) => {
    Object.keys(Bs[t]).forEach((e) => {
      Be.prototype[e] = Bs[t][e];
    });
  });
  Be.use([lg, ug]);
  function pm({ swiper: t, extendParams: e, on: i, emit: n }) {
    e({ virtual: { enabled: false, slides: [], cache: true, slidesPerViewAutoSlideSize: 320, renderSlide: null, renderExternal: null, renderExternalUpdate: true, addSlidesBefore: 0, addSlidesAfter: 0 } });
    let r;
    const o = Oe();
    t.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] };
    const l = o.createElement("div");
    function c(p, m) {
      const C = t.params.virtual;
      if (C.cache && t.virtual.cache[m]) return t.virtual.cache[m];
      let S;
      return C.renderSlide ? (S = C.renderSlide.call(t, p, m), typeof S == "string" && (yt(l, S), S = l.children[0])) : t.isElement ? S = Ye("swiper-slide") : S = Ye("div", t.params.slideClass), S.setAttribute("data-swiper-slide-index", m), C.renderSlide || yt(S, p), C.cache && (t.virtual.cache[m] = S), S;
    }
    function d(p, m, C) {
      const { slidesPerGroup: S, centeredSlides: h, slidesPerView: E, loop: I, initialSlide: O } = t.params;
      if (m && !I && O > 0) return;
      const { addSlidesBefore: L, addSlidesAfter: f, slidesPerViewAutoSlideSize: P } = t.params.virtual, { from: D, to: H, slides: k, slidesGrid: z, offset: B } = t.virtual;
      t.params.cssMode || t.updateActiveIndex();
      const V = typeof C == "undefined" ? t.activeIndex || 0 : C;
      let X;
      t.rtlTranslate ? X = "right" : X = t.isHorizontal() ? "left" : "top";
      let Z;
      if (E === "auto") if (P) {
        let K = t.size;
        K || (K = t.isHorizontal() ? t.el.getBoundingClientRect().width : t.el.getBoundingClientRect().height), Z = Math.max(1, Math.ceil(K / P));
      } else Z = 1;
      else Z = E;
      let F, W;
      h ? (F = Math.floor(Z / 2) + S + f, W = Math.floor(Z / 2) + S + L) : (F = Z + (S - 1) + f, W = (I ? Z : S) + L);
      let Y = V - W, J = V + F;
      I || (Y = Math.max(Y, 0), J = Math.min(J, k.length - 1));
      let re = (t.slidesGrid[Y] || 0) - (t.slidesGrid[0] || 0);
      I && V >= W ? (Y -= W, h || (re += t.slidesGrid[0])) : I && V < W && (Y = -W, h && (re += t.slidesGrid[0])), Object.assign(t.virtual, { from: Y, to: J, offset: re, slidesGrid: t.slidesGrid, slidesBefore: W, slidesAfter: F });
      function fe() {
        t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), n("virtualUpdate");
      }
      if (D === Y && H === J && !p) {
        t.slidesGrid !== z && re !== B && t.slides.forEach((K) => {
          K.style[X] = `${re - Math.abs(t.cssOverflowAdjustment())}px`;
        }), t.updateProgress(), n("virtualUpdate");
        return;
      }
      if (t.params.virtual.renderExternal) {
        t.params.virtual.renderExternal.call(t, { offset: re, from: Y, to: J, slides: (function() {
          const ne = [];
          for (let Ee = Y; Ee <= J; Ee += 1) ne.push(k[Ee]);
          return ne;
        })() }), t.params.virtual.renderExternalUpdate ? fe() : n("virtualUpdate");
        return;
      }
      const _e = [], be = [], U = (K) => {
        let ne = K;
        return K < 0 ? ne = k.length + K : ne >= k.length && (ne = ne - k.length), ne;
      };
      if (p) t.slides.filter((K) => K.matches(`.${t.params.slideClass}, swiper-slide`)).forEach((K) => {
        K.remove();
      });
      else for (let K = D; K <= H; K += 1) if (K < Y || K > J) {
        const ne = U(K);
        t.slides.filter((Ee) => Ee.matches(`.${t.params.slideClass}[data-swiper-slide-index="${ne}"], swiper-slide[data-swiper-slide-index="${ne}"]`)).forEach((Ee) => {
          Ee.remove();
        });
      }
      const Q = I ? -k.length : 0, ee = I ? k.length * 2 : k.length;
      for (let K = Q; K < ee; K += 1) if (K >= Y && K <= J) {
        const ne = U(K);
        typeof H == "undefined" || p ? be.push(ne) : (K > H && be.push(ne), K < D && _e.push(ne));
      }
      if (be.forEach((K) => {
        t.slidesEl.append(c(k[K], K));
      }), I) for (let K = _e.length - 1; K >= 0; K -= 1) {
        const ne = _e[K];
        t.slidesEl.prepend(c(k[ne], ne));
      }
      else _e.sort((K, ne) => ne - K), _e.forEach((K) => {
        t.slidesEl.prepend(c(k[K], K));
      });
      Me(t.slidesEl, ".swiper-slide, swiper-slide").forEach((K) => {
        K.style[X] = `${re - Math.abs(t.cssOverflowAdjustment())}px`;
      }), fe();
    }
    function v(p) {
      if (typeof p == "object" && "length" in p) for (let m = 0; m < p.length; m += 1) p[m] && t.virtual.slides.push(p[m]);
      else t.virtual.slides.push(p);
      d(true);
    }
    function b(p) {
      const m = t.activeIndex;
      let C = m + 1, S = 1;
      if (Array.isArray(p)) {
        for (let h = 0; h < p.length; h += 1) p[h] && t.virtual.slides.unshift(p[h]);
        C = m + p.length, S = p.length;
      } else t.virtual.slides.unshift(p);
      if (t.params.virtual.cache) {
        const h = t.virtual.cache, E = {};
        Object.keys(h).forEach((I) => {
          const O = h[I], L = O.getAttribute("data-swiper-slide-index");
          L && O.setAttribute("data-swiper-slide-index", parseInt(L, 10) + S), E[parseInt(I, 10) + S] = O;
        }), t.virtual.cache = E;
      }
      d(true), t.slideTo(C, 0);
    }
    function y(p) {
      if (typeof p == "undefined" || p === null) return;
      let m = t.activeIndex;
      if (Array.isArray(p)) for (let C = p.length - 1; C >= 0; C -= 1) t.params.virtual.cache && (delete t.virtual.cache[p[C]], Object.keys(t.virtual.cache).forEach((S) => {
        S > p && (t.virtual.cache[S - 1] = t.virtual.cache[S], t.virtual.cache[S - 1].setAttribute("data-swiper-slide-index", S - 1), delete t.virtual.cache[S]);
      })), t.virtual.slides.splice(p[C], 1), p[C] < m && (m -= 1), m = Math.max(m, 0);
      else t.params.virtual.cache && (delete t.virtual.cache[p], Object.keys(t.virtual.cache).forEach((C) => {
        C > p && (t.virtual.cache[C - 1] = t.virtual.cache[C], t.virtual.cache[C - 1].setAttribute("data-swiper-slide-index", C - 1), delete t.virtual.cache[C]);
      })), t.virtual.slides.splice(p, 1), p < m && (m -= 1), m = Math.max(m, 0);
      d(true), t.slideTo(m, 0);
    }
    function _() {
      t.virtual.slides = [], t.params.virtual.cache && (t.virtual.cache = {}), d(true), t.slideTo(0, 0);
    }
    i("beforeInit", () => {
      if (!t.params.virtual.enabled) return;
      let p;
      if (typeof t.passedParams.virtual.slides == "undefined") {
        const m = [...t.slidesEl.children].filter((C) => C.matches(`.${t.params.slideClass}, swiper-slide`));
        m && m.length && (t.virtual.slides = [...m], p = true, m.forEach((C, S) => {
          C.setAttribute("data-swiper-slide-index", S), t.virtual.cache[S] = C, C.remove();
        }));
      }
      p || (t.virtual.slides = t.params.virtual.slides), t.classNames.push(`${t.params.containerModifierClass}virtual`), t.params.watchSlidesProgress = true, t.originalParams.watchSlidesProgress = true, d(false, true);
    }), i("setTranslate", () => {
      t.params.virtual.enabled && (t.params.cssMode && !t._immediateVirtual ? (clearTimeout(r), r = setTimeout(() => {
        d();
      }, 100)) : d());
    }), i("init update resize", () => {
      t.params.virtual.enabled && t.params.cssMode && Yt(t.wrapperEl, "--swiper-virtual-size", `${t.virtualSize}px`);
    }), Object.assign(t.virtual, { appendSlide: v, prependSlide: b, removeSlide: y, removeAllSlides: _, update: d });
  }
  function gm({ swiper: t, extendParams: e, on: i, emit: n }) {
    const r = Oe(), o = ve();
    t.keyboard = { enabled: false }, e({ keyboard: { enabled: false, onlyInViewport: true, pageUpDown: true, speed: void 0 } });
    function l(v) {
      if (!t.enabled) return;
      const { rtlTranslate: b } = t;
      let y = v;
      y.originalEvent && (y = y.originalEvent);
      const _ = y.keyCode || y.charCode, p = t.params.keyboard.pageUpDown, m = p && _ === 33, C = p && _ === 34, S = _ === 37, h = _ === 39, E = _ === 38, I = _ === 40;
      if (!t.allowSlideNext && (t.isHorizontal() && h || t.isVertical() && I || C) || !t.allowSlidePrev && (t.isHorizontal() && S || t.isVertical() && E || m)) return false;
      if (y.shiftKey || y.altKey || y.ctrlKey || y.metaKey || r.activeElement && (r.activeElement.isContentEditable || r.activeElement.nodeName && (r.activeElement.nodeName.toLowerCase() === "input" || r.activeElement.nodeName.toLowerCase() === "textarea"))) return;
      if (t.params.keyboard.onlyInViewport && (m || C || S || h || E || I)) {
        let L = false;
        if (Kt(t.el, `.${t.params.slideClass}, swiper-slide`).length > 0 && Kt(t.el, `.${t.params.slideActiveClass}`).length === 0) return;
        const f = t.el, P = f.clientWidth, D = f.clientHeight, H = o.innerWidth, k = o.innerHeight, z = kn(f);
        b && (z.left -= f.scrollLeft);
        const B = [[z.left, z.top], [z.left + P, z.top], [z.left, z.top + D], [z.left + P, z.top + D]];
        for (let V = 0; V < B.length; V += 1) {
          const X = B[V];
          if (X[0] >= 0 && X[0] <= H && X[1] >= 0 && X[1] <= k) {
            if (X[0] === 0 && X[1] === 0) continue;
            L = true;
          }
        }
        if (!L) return;
      }
      const O = t.params.keyboard.speed;
      t.isHorizontal() ? ((m || C || S || h) && (y.preventDefault ? y.preventDefault() : y.returnValue = false), ((C || h) && !b || (m || S) && b) && t.slideNext(O), ((m || S) && !b || (C || h) && b) && t.slidePrev(O)) : ((m || C || E || I) && (y.preventDefault ? y.preventDefault() : y.returnValue = false), (C || I) && t.slideNext(O), (m || E) && t.slidePrev(O)), n("keyPress", _);
    }
    function c() {
      t.keyboard.enabled || (r.addEventListener("keydown", l), t.keyboard.enabled = true);
    }
    function d() {
      t.keyboard.enabled && (r.removeEventListener("keydown", l), t.keyboard.enabled = false);
    }
    i("init", () => {
      t.params.keyboard.enabled && c();
    }), i("destroy", () => {
      t.keyboard.enabled && d();
    }), Object.assign(t.keyboard, { enable: c, disable: d });
  }
  function mm({ swiper: t, extendParams: e, on: i, emit: n }) {
    const r = ve();
    e({ mousewheel: { enabled: false, releaseOnEdges: false, invert: false, forceToAxis: false, sensitivity: 1, eventsTarget: "container", thresholdDelta: null, thresholdTime: null, noMousewheelClass: "swiper-no-mousewheel" } }), t.mousewheel = { enabled: false };
    let o, l = Qe(), c;
    const d = [];
    function v(E) {
      let f = 0, P = 0, D = 0, H = 0;
      return "detail" in E && (P = E.detail), "wheelDelta" in E && (P = -E.wheelDelta / 120), "wheelDeltaY" in E && (P = -E.wheelDeltaY / 120), "wheelDeltaX" in E && (f = -E.wheelDeltaX / 120), "axis" in E && E.axis === E.HORIZONTAL_AXIS && (f = P, P = 0), D = f * 10, H = P * 10, "deltaY" in E && (H = E.deltaY), "deltaX" in E && (D = E.deltaX), E.shiftKey && !D && (D = H, H = 0), (D || H) && E.deltaMode && (E.deltaMode === 1 ? (D *= 40, H *= 40) : (D *= 800, H *= 800)), D && !f && (f = D < 1 ? -1 : 1), H && !P && (P = H < 1 ? -1 : 1), { spinX: f, spinY: P, pixelX: D, pixelY: H };
    }
    function b() {
      t.enabled && (t.mouseEntered = true);
    }
    function y() {
      t.enabled && (t.mouseEntered = false);
    }
    function _(E) {
      return t.params.mousewheel.thresholdDelta && E.delta < t.params.mousewheel.thresholdDelta || t.params.mousewheel.thresholdTime && Qe() - l < t.params.mousewheel.thresholdTime ? false : E.delta >= 6 && Qe() - l < 60 ? true : (E.direction < 0 ? (!t.isEnd || t.params.loop) && !t.animating && (t.slideNext(), n("scroll", E.raw)) : (!t.isBeginning || t.params.loop) && !t.animating && (t.slidePrev(), n("scroll", E.raw)), l = new r.Date().getTime(), false);
    }
    function p(E) {
      const I = t.params.mousewheel;
      if (E.direction < 0) {
        if (t.isEnd && !t.params.loop && I.releaseOnEdges) return true;
      } else if (t.isBeginning && !t.params.loop && I.releaseOnEdges) return true;
      return false;
    }
    function m(E) {
      let I = E, O = true;
      if (!t.enabled || E.target.closest(`.${t.params.mousewheel.noMousewheelClass}`)) return;
      const L = t.params.mousewheel;
      t.params.cssMode && I.preventDefault();
      let f = t.el;
      t.params.mousewheel.eventsTarget !== "container" && (f = document.querySelector(t.params.mousewheel.eventsTarget));
      const P = f && f.contains(I.target);
      if (!t.mouseEntered && !P && !L.releaseOnEdges) return true;
      I.originalEvent && (I = I.originalEvent);
      let D = 0;
      const H = t.rtlTranslate ? -1 : 1, k = v(I);
      if (L.forceToAxis) if (t.isHorizontal()) if (Math.abs(k.pixelX) > Math.abs(k.pixelY)) D = -k.pixelX * H;
      else return true;
      else if (Math.abs(k.pixelY) > Math.abs(k.pixelX)) D = -k.pixelY;
      else return true;
      else D = Math.abs(k.pixelX) > Math.abs(k.pixelY) ? -k.pixelX * H : -k.pixelY;
      if (D === 0) return true;
      L.invert && (D = -D);
      let z = t.getTranslate() + D * L.sensitivity;
      if (z >= t.minTranslate() && (z = t.minTranslate()), z <= t.maxTranslate() && (z = t.maxTranslate()), O = t.params.loop ? true : !(z === t.minTranslate() || z === t.maxTranslate()), O && t.params.nested && I.stopPropagation(), !t.params.freeMode || !t.params.freeMode.enabled) {
        const B = { time: Qe(), delta: Math.abs(D), direction: Math.sign(D), raw: E };
        d.length >= 2 && d.shift();
        const V = d.length ? d[d.length - 1] : void 0;
        if (d.push(B), V ? (B.direction !== V.direction || B.delta > V.delta || B.time > V.time + 150) && _(B) : _(B), p(B)) return true;
      } else {
        const B = { time: Qe(), delta: Math.abs(D), direction: Math.sign(D) }, V = c && B.time < c.time + 500 && B.delta <= c.delta && B.direction === c.direction;
        if (!V) {
          c = void 0;
          let X = t.getTranslate() + D * L.sensitivity;
          const Z = t.isBeginning, F = t.isEnd;
          if (X >= t.minTranslate() && (X = t.minTranslate()), X <= t.maxTranslate() && (X = t.maxTranslate()), t.setTransition(0), t.setTranslate(X), t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses(), (!Z && t.isBeginning || !F && t.isEnd) && t.updateSlidesClasses(), t.params.loop && t.loopFix({ direction: B.direction < 0 ? "next" : "prev", byMousewheel: true }), t.params.freeMode.sticky) {
            clearTimeout(o), o = void 0, d.length >= 15 && d.shift();
            const W = d.length ? d[d.length - 1] : void 0, Y = d[0];
            if (d.push(B), W && (B.delta > W.delta || B.direction !== W.direction)) d.splice(0);
            else if (d.length >= 15 && B.time - Y.time < 500 && Y.delta - B.delta >= 1 && B.delta <= 6) {
              const J = D > 0 ? 0.8 : 0.2;
              c = B, d.splice(0), o = Mi(() => {
                t.destroyed || !t.params || t.slideToClosest(t.params.speed, true, void 0, J);
              }, 0);
            }
            o || (o = Mi(() => {
              if (t.destroyed || !t.params) return;
              const J = 0.5;
              c = B, d.splice(0), t.slideToClosest(t.params.speed, true, void 0, J);
            }, 500));
          }
          if (V || n("scroll", I), t.params.autoplay && t.params.autoplay.disableOnInteraction && t.autoplay.stop(), L.releaseOnEdges && (X === t.minTranslate() || X === t.maxTranslate())) return true;
        }
      }
      return I.preventDefault ? I.preventDefault() : I.returnValue = false, false;
    }
    function C(E) {
      let I = t.el;
      t.params.mousewheel.eventsTarget !== "container" && (I = document.querySelector(t.params.mousewheel.eventsTarget)), I[E]("mouseenter", b), I[E]("mouseleave", y), I[E]("wheel", m);
    }
    function S() {
      return t.params.cssMode ? (t.wrapperEl.removeEventListener("wheel", m), true) : t.mousewheel.enabled ? false : (C("addEventListener"), t.mousewheel.enabled = true, true);
    }
    function h() {
      return t.params.cssMode ? (t.wrapperEl.addEventListener(event, m), true) : t.mousewheel.enabled ? (C("removeEventListener"), t.mousewheel.enabled = false, true) : false;
    }
    i("init", () => {
      !t.params.mousewheel.enabled && t.params.cssMode && h(), t.params.mousewheel.enabled && S();
    }), i("destroy", () => {
      t.params.cssMode && S(), t.mousewheel.enabled && h();
    }), Object.assign(t.mousewheel, { enable: S, disable: h });
  }
  function Ar(t, e, i, n) {
    return t.params.createElements && Object.keys(n).forEach((r) => {
      if (!i[r] && i.auto === true) {
        let o = Me(t.el, `.${n[r]}`)[0];
        o || (o = Ye("div", n[r]), o.className = n[r], t.el.append(o)), i[r] = o, e[r] = o;
      }
    }), i;
  }
  const fa = '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>';
  function vm({ swiper: t, extendParams: e, on: i, emit: n }) {
    e({ navigation: { nextEl: null, prevEl: null, addIcons: true, hideOnClick: false, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock", navigationDisabledClass: "swiper-navigation-disabled" } }), t.navigation = { nextEl: null, prevEl: null, arrowSvg: fa };
    function r(p) {
      let m;
      return p && typeof p == "string" && t.isElement && (m = t.el.querySelector(p) || t.hostEl.querySelector(p), m) ? m : (p && (typeof p == "string" && (m = [...document.querySelectorAll(p)]), t.params.uniqueNavElements && typeof p == "string" && m && m.length > 1 && t.el.querySelectorAll(p).length === 1 ? m = t.el.querySelector(p) : m && m.length === 1 && (m = m[0])), p && !m ? p : m);
    }
    function o(p, m) {
      const C = t.params.navigation;
      p = ue(p), p.forEach((S) => {
        S && (S.classList[m ? "add" : "remove"](...C.disabledClass.split(" ")), S.tagName === "BUTTON" && (S.disabled = m), t.params.watchOverflow && t.enabled && S.classList[t.isLocked ? "add" : "remove"](C.lockClass));
      });
    }
    function l() {
      const { nextEl: p, prevEl: m } = t.navigation;
      if (t.params.loop) {
        o(m, false), o(p, false);
        return;
      }
      o(m, t.isBeginning && !t.params.rewind), o(p, t.isEnd && !t.params.rewind);
    }
    function c(p) {
      p.preventDefault(), !(t.isBeginning && !t.params.loop && !t.params.rewind) && (t.slidePrev(), n("navigationPrev"));
    }
    function d(p) {
      p.preventDefault(), !(t.isEnd && !t.params.loop && !t.params.rewind) && (t.slideNext(), n("navigationNext"));
    }
    function v() {
      const p = t.params.navigation;
      if (t.params.navigation = Ar(t, t.originalParams.navigation, t.params.navigation, { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }), !(p.nextEl || p.prevEl)) return;
      let m = r(p.nextEl), C = r(p.prevEl);
      Object.assign(t.navigation, { nextEl: m, prevEl: C }), m = ue(m), C = ue(C);
      const S = (h, E) => {
        if (h) {
          if (p.addIcons && h.matches(".swiper-button-next,.swiper-button-prev") && !h.querySelector("svg")) {
            const I = document.createElement("div");
            yt(I, fa), h.appendChild(I.querySelector("svg")), I.remove();
          }
          h.addEventListener("click", E === "next" ? d : c);
        }
        !t.enabled && h && h.classList.add(...p.lockClass.split(" "));
      };
      m.forEach((h) => S(h, "next")), C.forEach((h) => S(h, "prev"));
    }
    function b() {
      let { nextEl: p, prevEl: m } = t.navigation;
      p = ue(p), m = ue(m);
      const C = (S, h) => {
        S.removeEventListener("click", h === "next" ? d : c), S.classList.remove(...t.params.navigation.disabledClass.split(" "));
      };
      p.forEach((S) => C(S, "next")), m.forEach((S) => C(S, "prev"));
    }
    i("init", () => {
      t.params.navigation.enabled === false ? _() : (v(), l());
    }), i("toEdge fromEdge lock unlock", () => {
      l();
    }), i("destroy", () => {
      b();
    }), i("enable disable", () => {
      let { nextEl: p, prevEl: m } = t.navigation;
      if (p = ue(p), m = ue(m), t.enabled) {
        l();
        return;
      }
      [...p, ...m].filter((C) => !!C).forEach((C) => C.classList.add(t.params.navigation.lockClass));
    }), i("click", (p, m) => {
      let { nextEl: C, prevEl: S } = t.navigation;
      C = ue(C), S = ue(S);
      const h = m.target;
      let E = S.includes(h) || C.includes(h);
      if (t.isElement && !E) {
        const I = m.path || m.composedPath && m.composedPath();
        I && (E = I.find((O) => C.includes(O) || S.includes(O)));
      }
      if (t.params.navigation.hideOnClick && !E) {
        if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === h || t.pagination.el.contains(h))) return;
        let I;
        C.length ? I = C[0].classList.contains(t.params.navigation.hiddenClass) : S.length && (I = S[0].classList.contains(t.params.navigation.hiddenClass)), n(I === true ? "navigationShow" : "navigationHide"), [...C, ...S].filter((O) => !!O).forEach((O) => O.classList.toggle(t.params.navigation.hiddenClass));
      }
    });
    const y = () => {
      t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")), v(), l();
    }, _ = () => {
      t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")), b();
    };
    Object.assign(t.navigation, { enable: y, disable: _, update: l, init: v, destroy: b });
  }
  function xt(t = "") {
    return `.${t.trim().replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, "\\$1").replace(/ /g, ".")}`;
  }
  function ym({ swiper: t, extendParams: e, on: i, emit: n }) {
    const r = "swiper-pagination";
    e({ pagination: { el: null, bulletElement: "span", clickable: false, hideOnClick: false, renderBullet: null, renderProgressbar: null, renderFraction: null, renderCustom: null, progressbarOpposite: false, type: "bullets", dynamicBullets: false, dynamicMainBullets: 1, formatFractionCurrent: (h) => h, formatFractionTotal: (h) => h, bulletClass: `${r}-bullet`, bulletActiveClass: `${r}-bullet-active`, modifierClass: `${r}-`, currentClass: `${r}-current`, totalClass: `${r}-total`, hiddenClass: `${r}-hidden`, progressbarFillClass: `${r}-progressbar-fill`, progressbarOppositeClass: `${r}-progressbar-opposite`, clickableClass: `${r}-clickable`, lockClass: `${r}-lock`, horizontalClass: `${r}-horizontal`, verticalClass: `${r}-vertical`, paginationDisabledClass: `${r}-disabled` } }), t.pagination = { el: null, bullets: [] };
    let o, l = 0;
    function c() {
      return !t.params.pagination.el || !t.pagination.el || Array.isArray(t.pagination.el) && t.pagination.el.length === 0;
    }
    function d(h, E) {
      const { bulletActiveClass: I } = t.params.pagination;
      h && (h = h[`${E === "prev" ? "previous" : "next"}ElementSibling`], h && (h.classList.add(`${I}-${E}`), h = h[`${E === "prev" ? "previous" : "next"}ElementSibling`], h && h.classList.add(`${I}-${E}-${E}`)));
    }
    function v(h, E, I) {
      if (h = h % I, E = E % I, E === h + 1) return "next";
      if (E === h - 1) return "previous";
    }
    function b(h) {
      const E = h.target.closest(xt(t.params.pagination.bulletClass));
      if (!E) return;
      h.preventDefault();
      const I = Ki(E) * t.params.slidesPerGroup;
      if (t.params.loop) {
        if (t.realIndex === I) return;
        const O = v(t.realIndex, I, t.slides.length);
        O === "next" ? t.slideNext() : O === "previous" ? t.slidePrev() : t.slideToLoop(I);
      } else t.slideTo(I);
    }
    function y() {
      const h = t.rtl, E = t.params.pagination;
      if (c()) return;
      let I = t.pagination.el;
      I = ue(I);
      let O, L;
      const f = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length, P = t.params.loop ? Math.ceil(f / t.params.slidesPerGroup) : t.snapGrid.length;
      if (t.params.loop ? (L = t.previousRealIndex || 0, O = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex) : typeof t.snapIndex != "undefined" ? (O = t.snapIndex, L = t.previousSnapIndex) : (L = t.previousIndex || 0, O = t.activeIndex || 0), E.type === "bullets" && t.pagination.bullets && t.pagination.bullets.length > 0) {
        const D = t.pagination.bullets;
        let H, k, z;
        if (E.dynamicBullets && (o = cr(D[0], t.isHorizontal() ? "width" : "height"), I.forEach((B) => {
          B.style[t.isHorizontal() ? "width" : "height"] = `${o * (E.dynamicMainBullets + 4)}px`;
        }), E.dynamicMainBullets > 1 && L !== void 0 && (l += O - (L || 0), l > E.dynamicMainBullets - 1 ? l = E.dynamicMainBullets - 1 : l < 0 && (l = 0)), H = Math.max(O - l, 0), k = H + (Math.min(D.length, E.dynamicMainBullets) - 1), z = (k + H) / 2), D.forEach((B) => {
          const V = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((X) => `${E.bulletActiveClass}${X}`)].map((X) => typeof X == "string" && X.includes(" ") ? X.split(" ") : X).flat();
          B.classList.remove(...V);
        }), I.length > 1) D.forEach((B) => {
          const V = Ki(B);
          V === O ? B.classList.add(...E.bulletActiveClass.split(" ")) : t.isElement && B.setAttribute("part", "bullet"), E.dynamicBullets && (V >= H && V <= k && B.classList.add(...`${E.bulletActiveClass}-main`.split(" ")), V === H && d(B, "prev"), V === k && d(B, "next"));
        });
        else {
          const B = D[O];
          if (B && B.classList.add(...E.bulletActiveClass.split(" ")), t.isElement && D.forEach((V, X) => {
            V.setAttribute("part", X === O ? "bullet-active" : "bullet");
          }), E.dynamicBullets) {
            const V = D[H], X = D[k];
            for (let Z = H; Z <= k; Z += 1) D[Z] && D[Z].classList.add(...`${E.bulletActiveClass}-main`.split(" "));
            d(V, "prev"), d(X, "next");
          }
        }
        if (E.dynamicBullets) {
          const B = Math.min(D.length, E.dynamicMainBullets + 4), V = (o * B - o) / 2 - z * o, X = h ? "right" : "left";
          D.forEach((Z) => {
            Z.style[t.isHorizontal() ? X : "top"] = `${V}px`;
          });
        }
      }
      I.forEach((D, H) => {
        if (E.type === "fraction" && (D.querySelectorAll(xt(E.currentClass)).forEach((k) => {
          k.textContent = E.formatFractionCurrent(O + 1);
        }), D.querySelectorAll(xt(E.totalClass)).forEach((k) => {
          k.textContent = E.formatFractionTotal(P);
        })), E.type === "progressbar") {
          let k;
          E.progressbarOpposite ? k = t.isHorizontal() ? "vertical" : "horizontal" : k = t.isHorizontal() ? "horizontal" : "vertical";
          const z = (O + 1) / P;
          let B = 1, V = 1;
          k === "horizontal" ? B = z : V = z, D.querySelectorAll(xt(E.progressbarFillClass)).forEach((X) => {
            X.style.transform = `translate3d(0,0,0) scaleX(${B}) scaleY(${V})`, X.style.transitionDuration = `${t.params.speed}ms`;
          });
        }
        E.type === "custom" && E.renderCustom ? (yt(D, E.renderCustom(t, O + 1, P)), H === 0 && n("paginationRender", D)) : (H === 0 && n("paginationRender", D), n("paginationUpdate", D)), t.params.watchOverflow && t.enabled && D.classList[t.isLocked ? "add" : "remove"](E.lockClass);
      });
    }
    function _() {
      const h = t.params.pagination;
      if (c()) return;
      const E = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.grid && t.params.grid.rows > 1 ? t.slides.length / Math.ceil(t.params.grid.rows) : t.slides.length;
      let I = t.pagination.el;
      I = ue(I);
      let O = "";
      if (h.type === "bullets") {
        let L = t.params.loop ? Math.ceil(E / t.params.slidesPerGroup) : t.snapGrid.length;
        t.params.freeMode && t.params.freeMode.enabled && L > E && (L = E);
        for (let f = 0; f < L; f += 1) h.renderBullet ? O += h.renderBullet.call(t, f, h.bulletClass) : O += `<${h.bulletElement} ${t.isElement ? 'part="bullet"' : ""} class="${h.bulletClass}"></${h.bulletElement}>`;
      }
      h.type === "fraction" && (h.renderFraction ? O = h.renderFraction.call(t, h.currentClass, h.totalClass) : O = `<span class="${h.currentClass}"></span> / <span class="${h.totalClass}"></span>`), h.type === "progressbar" && (h.renderProgressbar ? O = h.renderProgressbar.call(t, h.progressbarFillClass) : O = `<span class="${h.progressbarFillClass}"></span>`), t.pagination.bullets = [], I.forEach((L) => {
        h.type !== "custom" && yt(L, O || ""), h.type === "bullets" && t.pagination.bullets.push(...L.querySelectorAll(xt(h.bulletClass)));
      }), h.type !== "custom" && n("paginationRender", I[0]);
    }
    function p() {
      t.params.pagination = Ar(t, t.originalParams.pagination, t.params.pagination, { el: "swiper-pagination" });
      const h = t.params.pagination;
      if (!h.el) return;
      let E;
      typeof h.el == "string" && t.isElement && (E = t.el.querySelector(h.el)), !E && typeof h.el == "string" && (E = [...document.querySelectorAll(h.el)]), E || (E = h.el), !(!E || E.length === 0) && (t.params.uniqueNavElements && typeof h.el == "string" && Array.isArray(E) && E.length > 1 && (E = [...t.el.querySelectorAll(h.el)], E.length > 1 && (E = E.find((I) => Kt(I, ".swiper")[0] === t.el))), Array.isArray(E) && E.length === 1 && (E = E[0]), Object.assign(t.pagination, { el: E }), E = ue(E), E.forEach((I) => {
        h.type === "bullets" && h.clickable && I.classList.add(...(h.clickableClass || "").split(" ")), I.classList.add(h.modifierClass + h.type), I.classList.add(t.isHorizontal() ? h.horizontalClass : h.verticalClass), h.type === "bullets" && h.dynamicBullets && (I.classList.add(`${h.modifierClass}${h.type}-dynamic`), l = 0, h.dynamicMainBullets < 1 && (h.dynamicMainBullets = 1)), h.type === "progressbar" && h.progressbarOpposite && I.classList.add(h.progressbarOppositeClass), h.clickable && I.addEventListener("click", b), t.enabled || I.classList.add(h.lockClass);
      }));
    }
    function m() {
      const h = t.params.pagination;
      if (c()) return;
      let E = t.pagination.el;
      E && (E = ue(E), E.forEach((I) => {
        I.classList.remove(h.hiddenClass), I.classList.remove(h.modifierClass + h.type), I.classList.remove(t.isHorizontal() ? h.horizontalClass : h.verticalClass), h.clickable && (I.classList.remove(...(h.clickableClass || "").split(" ")), I.removeEventListener("click", b));
      })), t.pagination.bullets && t.pagination.bullets.forEach((I) => I.classList.remove(...h.bulletActiveClass.split(" ")));
    }
    i("changeDirection", () => {
      if (!t.pagination || !t.pagination.el) return;
      const h = t.params.pagination;
      let { el: E } = t.pagination;
      E = ue(E), E.forEach((I) => {
        I.classList.remove(h.horizontalClass, h.verticalClass), I.classList.add(t.isHorizontal() ? h.horizontalClass : h.verticalClass);
      });
    }), i("init", () => {
      t.params.pagination.enabled === false ? S() : (p(), _(), y());
    }), i("activeIndexChange", () => {
      typeof t.snapIndex == "undefined" && y();
    }), i("snapIndexChange", () => {
      y();
    }), i("snapGridLengthChange", () => {
      _(), y();
    }), i("destroy", () => {
      m();
    }), i("enable disable", () => {
      let { el: h } = t.pagination;
      h && (h = ue(h), h.forEach((E) => E.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass)));
    }), i("lock unlock", () => {
      y();
    }), i("click", (h, E) => {
      const I = E.target, O = ue(t.pagination.el);
      if (t.params.pagination.el && t.params.pagination.hideOnClick && O && O.length > 0 && !I.classList.contains(t.params.pagination.bulletClass)) {
        if (t.navigation && (t.navigation.nextEl && I === t.navigation.nextEl || t.navigation.prevEl && I === t.navigation.prevEl)) return;
        const L = O[0].classList.contains(t.params.pagination.hiddenClass);
        n(L === true ? "paginationShow" : "paginationHide"), O.forEach((f) => f.classList.toggle(t.params.pagination.hiddenClass));
      }
    });
    const C = () => {
      t.el.classList.remove(t.params.pagination.paginationDisabledClass);
      let { el: h } = t.pagination;
      h && (h = ue(h), h.forEach((E) => E.classList.remove(t.params.pagination.paginationDisabledClass))), p(), _(), y();
    }, S = () => {
      t.el.classList.add(t.params.pagination.paginationDisabledClass);
      let { el: h } = t.pagination;
      h && (h = ue(h), h.forEach((E) => E.classList.add(t.params.pagination.paginationDisabledClass))), m();
    };
    Object.assign(t.pagination, { enable: C, disable: S, render: _, update: y, init: p, destroy: m });
  }
  function bm({ swiper: t, extendParams: e, on: i, emit: n }) {
    const r = Oe();
    let o = false, l = null, c = null, d, v, b, y;
    e({ scrollbar: { el: null, dragSize: "auto", hide: false, draggable: false, snapOnRelease: true, lockClass: "swiper-scrollbar-lock", dragClass: "swiper-scrollbar-drag", scrollbarDisabledClass: "swiper-scrollbar-disabled", horizontalClass: "swiper-scrollbar-horizontal", verticalClass: "swiper-scrollbar-vertical" } }), t.scrollbar = { el: null, dragEl: null };
    function _() {
      if (!t.params.scrollbar.el || !t.scrollbar.el) return;
      const { scrollbar: z, rtlTranslate: B } = t, { dragEl: V, el: X } = z, Z = t.params.scrollbar, F = t.params.loop ? t.progressLoop : t.progress;
      let W = v, Y = (b - v) * F;
      B ? (Y = -Y, Y > 0 ? (W = v - Y, Y = 0) : -Y + v > b && (W = b + Y)) : Y < 0 ? (W = v + Y, Y = 0) : Y + v > b && (W = b - Y), t.isHorizontal() ? (V.style.transform = `translate3d(${Y}px, 0, 0)`, V.style.width = `${W}px`) : (V.style.transform = `translate3d(0px, ${Y}px, 0)`, V.style.height = `${W}px`), Z.hide && (clearTimeout(l), X.style.opacity = 1, l = setTimeout(() => {
        X.style.opacity = 0, X.style.transitionDuration = "400ms";
      }, 1e3));
    }
    function p(z) {
      !t.params.scrollbar.el || !t.scrollbar.el || (t.scrollbar.dragEl.style.transitionDuration = `${z}ms`);
    }
    function m() {
      if (!t.params.scrollbar.el || !t.scrollbar.el) return;
      const { scrollbar: z } = t, { dragEl: B, el: V } = z;
      B.style.width = "", B.style.height = "", b = t.isHorizontal() ? V.offsetWidth : V.offsetHeight, y = t.size / (t.virtualSize + t.params.slidesOffsetBefore - (t.params.centeredSlides ? t.snapGrid[0] : 0)), t.params.scrollbar.dragSize === "auto" ? v = b * y : v = parseInt(t.params.scrollbar.dragSize, 10), t.isHorizontal() ? B.style.width = `${v}px` : B.style.height = `${v}px`, y >= 1 ? V.style.display = "none" : V.style.display = "", t.params.scrollbar.hide && (V.style.opacity = 0), t.params.watchOverflow && t.enabled && z.el.classList[t.isLocked ? "add" : "remove"](t.params.scrollbar.lockClass);
    }
    function C(z) {
      return t.isHorizontal() ? z.clientX : z.clientY;
    }
    function S(z) {
      const { scrollbar: B, rtlTranslate: V } = t, { el: X } = B;
      let Z;
      Z = (C(z) - kn(X)[t.isHorizontal() ? "left" : "top"] - (d !== null ? d : v / 2)) / (b - v), Z = Math.max(Math.min(Z, 1), 0), V && (Z = 1 - Z);
      const F = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * Z;
      t.updateProgress(F), t.setTranslate(F), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    function h(z) {
      const B = t.params.scrollbar, { scrollbar: V, wrapperEl: X } = t, { el: Z, dragEl: F } = V;
      o = true, d = z.target === F ? C(z) - z.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null, z.preventDefault(), z.stopPropagation(), X.style.transitionDuration = "100ms", F.style.transitionDuration = "100ms", S(z), clearTimeout(c), Z.style.transitionDuration = "0ms", B.hide && (Z.style.opacity = 1), t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "none"), n("scrollbarDragStart", z);
    }
    function E(z) {
      const { scrollbar: B, wrapperEl: V } = t, { el: X, dragEl: Z } = B;
      o && (z.preventDefault && z.cancelable ? z.preventDefault() : z.returnValue = false, S(z), V.style.transitionDuration = "0ms", X.style.transitionDuration = "0ms", Z.style.transitionDuration = "0ms", n("scrollbarDragMove", z));
    }
    function I(z) {
      const B = t.params.scrollbar, { scrollbar: V, wrapperEl: X } = t, { el: Z } = V;
      o && (o = false, t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "", X.style.transitionDuration = ""), B.hide && (clearTimeout(c), c = Mi(() => {
        Z.style.opacity = 0, Z.style.transitionDuration = "400ms";
      }, 1e3)), n("scrollbarDragEnd", z), B.snapOnRelease && t.slideToClosest());
    }
    function O(z) {
      const { scrollbar: B, params: V } = t, X = B.el;
      if (!X) return;
      const Z = X, F = V.passiveListeners ? { passive: false, capture: false } : false, W = V.passiveListeners ? { passive: true, capture: false } : false;
      if (!Z) return;
      const Y = z === "on" ? "addEventListener" : "removeEventListener";
      Z[Y]("pointerdown", h, F), r[Y]("pointermove", E, F), r[Y]("pointerup", I, W);
    }
    function L() {
      !t.params.scrollbar.el || !t.scrollbar.el || O("on");
    }
    function f() {
      !t.params.scrollbar.el || !t.scrollbar.el || O("off");
    }
    function P() {
      const { scrollbar: z, el: B } = t;
      t.params.scrollbar = Ar(t, t.originalParams.scrollbar, t.params.scrollbar, { el: "swiper-scrollbar" });
      const V = t.params.scrollbar;
      if (!V.el) return;
      let X;
      if (typeof V.el == "string" && t.isElement && (X = t.el.querySelector(V.el)), !X && typeof V.el == "string") {
        if (X = r.querySelectorAll(V.el), !X.length) return;
      } else X || (X = V.el);
      t.params.uniqueNavElements && typeof V.el == "string" && X.length > 1 && B.querySelectorAll(V.el).length === 1 && (X = B.querySelector(V.el)), X.length > 0 && (X = X[0]), X.classList.add(t.isHorizontal() ? V.horizontalClass : V.verticalClass);
      let Z;
      X && (Z = X.querySelector(xt(t.params.scrollbar.dragClass)), Z || (Z = Ye("div", t.params.scrollbar.dragClass), X.append(Z))), Object.assign(z, { el: X, dragEl: Z }), V.draggable && L(), X && X.classList[t.enabled ? "remove" : "add"](...zt(t.params.scrollbar.lockClass));
    }
    function D() {
      const z = t.params.scrollbar, B = t.scrollbar.el;
      B && B.classList.remove(...zt(t.isHorizontal() ? z.horizontalClass : z.verticalClass)), f();
    }
    i("changeDirection", () => {
      if (!t.scrollbar || !t.scrollbar.el) return;
      const z = t.params.scrollbar;
      let { el: B } = t.scrollbar;
      B = ue(B), B.forEach((V) => {
        V.classList.remove(z.horizontalClass, z.verticalClass), V.classList.add(t.isHorizontal() ? z.horizontalClass : z.verticalClass);
      });
    }), i("init", () => {
      t.params.scrollbar.enabled === false ? k() : (P(), m(), _());
    }), i("update resize observerUpdate lock unlock changeDirection", () => {
      m();
    }), i("setTranslate", () => {
      _();
    }), i("setTransition", (z, B) => {
      p(B);
    }), i("enable disable", () => {
      const { el: z } = t.scrollbar;
      z && z.classList[t.enabled ? "remove" : "add"](...zt(t.params.scrollbar.lockClass));
    }), i("destroy", () => {
      D();
    });
    const H = () => {
      t.el.classList.remove(...zt(t.params.scrollbar.scrollbarDisabledClass)), t.scrollbar.el && t.scrollbar.el.classList.remove(...zt(t.params.scrollbar.scrollbarDisabledClass)), P(), m(), _();
    }, k = () => {
      t.el.classList.add(...zt(t.params.scrollbar.scrollbarDisabledClass)), t.scrollbar.el && t.scrollbar.el.classList.add(...zt(t.params.scrollbar.scrollbarDisabledClass)), D();
    };
    Object.assign(t.scrollbar, { enable: H, disable: k, updateSize: m, setTranslate: _, init: P, destroy: D });
  }
  function Em({ swiper: t, extendParams: e, on: i }) {
    e({ parallax: { enabled: false } });
    const n = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", r = (c, d) => {
      const { rtl: v } = t, b = v ? -1 : 1, y = c.getAttribute("data-swiper-parallax") || "0";
      let _ = c.getAttribute("data-swiper-parallax-x"), p = c.getAttribute("data-swiper-parallax-y");
      const m = c.getAttribute("data-swiper-parallax-scale"), C = c.getAttribute("data-swiper-parallax-opacity"), S = c.getAttribute("data-swiper-parallax-rotate");
      if (_ || p ? (_ = _ || "0", p = p || "0") : t.isHorizontal() ? (_ = y, p = "0") : (p = y, _ = "0"), _.indexOf("%") >= 0 ? _ = `${parseInt(_, 10) * d * b}%` : _ = `${_ * d * b}px`, p.indexOf("%") >= 0 ? p = `${parseInt(p, 10) * d}%` : p = `${p * d}px`, typeof C != "undefined" && C !== null) {
        const E = C - (C - 1) * (1 - Math.abs(d));
        c.style.opacity = E;
      }
      let h = `translate3d(${_}, ${p}, 0px)`;
      if (typeof m != "undefined" && m !== null) {
        const E = m - (m - 1) * (1 - Math.abs(d));
        h += ` scale(${E})`;
      }
      if (S && typeof S != "undefined" && S !== null) {
        const E = S * d * -1;
        h += ` rotate(${E}deg)`;
      }
      c.style.transform = h;
    }, o = () => {
      const { el: c, slides: d, progress: v, snapGrid: b, isElement: y } = t, _ = Me(c, n);
      t.isElement && _.push(...Me(t.hostEl, n)), _.forEach((p) => {
        r(p, v);
      }), d.forEach((p, m) => {
        let C = p.progress;
        t.params.slidesPerGroup > 1 && t.params.slidesPerView !== "auto" && (C += Math.ceil(m / 2) - v * (b.length - 1)), C = Math.min(Math.max(C, -1), 1), p.querySelectorAll(`${n}, [data-swiper-parallax-rotate]`).forEach((S) => {
          r(S, C);
        });
      });
    }, l = (c = t.params.speed) => {
      const { el: d, hostEl: v } = t, b = [...d.querySelectorAll(n)];
      t.isElement && b.push(...v.querySelectorAll(n)), b.forEach((y) => {
        let _ = parseInt(y.getAttribute("data-swiper-parallax-duration"), 10) || c;
        c === 0 && (_ = 0), y.style.transitionDuration = `${_}ms`;
      });
    };
    i("beforeInit", () => {
      t.params.parallax.enabled && (t.params.watchSlidesProgress = true, t.originalParams.watchSlidesProgress = true);
    }), i("init", () => {
      t.params.parallax.enabled && o();
    }), i("setTranslate", () => {
      t.params.parallax.enabled && o();
    }), i("setTransition", (c, d) => {
      t.params.parallax.enabled && l(d);
    });
  }
  function Tm({ swiper: t, extendParams: e, on: i, emit: n }) {
    const r = ve();
    e({ zoom: { enabled: false, limitToOriginalSize: false, maxRatio: 3, minRatio: 1, panOnMouseMove: false, toggle: true, containerClass: "swiper-zoom-container", zoomedSlideClass: "swiper-slide-zoomed" } }), t.zoom = { enabled: false };
    let o = 1, l = false, c = false, d = { x: 0, y: 0 };
    const v = -3;
    let b, y;
    const _ = [], p = { originX: 0, originY: 0, slideEl: void 0, slideWidth: void 0, slideHeight: void 0, imageEl: void 0, imageWrapEl: void 0, maxRatio: 3 }, m = { isTouched: void 0, isMoved: void 0, currentX: void 0, currentY: void 0, minX: void 0, minY: void 0, maxX: void 0, maxY: void 0, width: void 0, height: void 0, startX: void 0, startY: void 0, touchesStart: {}, touchesCurrent: {} }, C = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
    let S = 1;
    Object.defineProperty(t.zoom, "scale", { get() {
      return S;
    }, set(U) {
      if (S !== U) {
        const Q = p.imageEl, ee = p.slideEl;
        n("zoomChange", U, Q, ee);
      }
      S = U;
    } });
    function h() {
      if (_.length < 2) return 1;
      const U = _[0].pageX, Q = _[0].pageY, ee = _[1].pageX, K = _[1].pageY;
      return Math.sqrt(De(ee - U, 2) + De(K - Q, 2));
    }
    function E() {
      const U = t.params.zoom, Q = p.imageWrapEl.getAttribute("data-swiper-zoom") || U.maxRatio;
      if (U.limitToOriginalSize && p.imageEl && p.imageEl.naturalWidth) {
        const ee = p.imageEl.naturalWidth / p.imageEl.offsetWidth;
        return Math.min(ee, Q);
      }
      return Q;
    }
    function I() {
      if (_.length < 2) return { x: null, y: null };
      const U = p.imageEl.getBoundingClientRect();
      return [(_[0].pageX + (_[1].pageX - _[0].pageX) / 2 - U.x - r.scrollX) / o, (_[0].pageY + (_[1].pageY - _[0].pageY) / 2 - U.y - r.scrollY) / o];
    }
    function O() {
      return t.isElement ? "swiper-slide" : `.${t.params.slideClass}`;
    }
    function L(U) {
      const Q = O();
      return !!(U.target.matches(Q) || t.slides.filter((ee) => ee.contains(U.target)).length > 0);
    }
    function f(U) {
      const Q = `.${t.params.zoom.containerClass}`;
      return !!(U.target.matches(Q) || [...t.hostEl.querySelectorAll(Q)].filter((ee) => ee.contains(U.target)).length > 0);
    }
    function P(U) {
      if (U.pointerType === "mouse" && _.splice(0, _.length), !L(U)) return;
      const Q = t.params.zoom;
      if (b = false, y = false, _.push(U), !(_.length < 2)) {
        if (b = true, p.scaleStart = h(), !p.slideEl) {
          p.slideEl = U.target.closest(`.${t.params.slideClass}, swiper-slide`), p.slideEl || (p.slideEl = t.slides[t.activeIndex]);
          let ee = p.slideEl.querySelector(`.${Q.containerClass}`);
          if (ee && (ee = ee.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = ee, ee ? p.imageWrapEl = Kt(p.imageEl, `.${Q.containerClass}`)[0] : p.imageWrapEl = void 0, !p.imageWrapEl) {
            p.imageEl = void 0;
            return;
          }
          p.maxRatio = E();
        }
        if (p.imageEl) {
          const [ee, K] = I();
          p.originX = ee, p.originY = K, p.imageEl.style.transitionDuration = "0ms";
        }
        l = true;
      }
    }
    function D(U) {
      if (!L(U)) return;
      const Q = t.params.zoom, ee = t.zoom, K = _.findIndex((ne) => ne.pointerId === U.pointerId);
      K >= 0 && (_[K] = U), !(_.length < 2) && (y = true, p.scaleMove = h(), p.imageEl && (ee.scale = p.scaleMove / p.scaleStart * o, ee.scale > p.maxRatio && (ee.scale = p.maxRatio - 1 + De(ee.scale - p.maxRatio + 1, 0.5)), ee.scale < Q.minRatio && (ee.scale = Q.minRatio + 1 - De(Q.minRatio - ee.scale + 1, 0.5)), p.imageEl.style.transform = `translate3d(0,0,0) scale(${ee.scale})`));
    }
    function H(U) {
      if (!L(U) || U.pointerType === "mouse" && U.type === "pointerout") return;
      const Q = t.params.zoom, ee = t.zoom, K = _.findIndex((ne) => ne.pointerId === U.pointerId);
      K >= 0 && _.splice(K, 1), !(!b || !y) && (b = false, y = false, p.imageEl && (ee.scale = Math.max(Math.min(ee.scale, p.maxRatio), Q.minRatio), p.imageEl.style.transitionDuration = `${t.params.speed}ms`, p.imageEl.style.transform = `translate3d(0,0,0) scale(${ee.scale})`, o = ee.scale, l = false, ee.scale > 1 && p.slideEl ? p.slideEl.classList.add(`${Q.zoomedSlideClass}`) : ee.scale <= 1 && p.slideEl && p.slideEl.classList.remove(`${Q.zoomedSlideClass}`), ee.scale === 1 && (p.originX = 0, p.originY = 0, p.slideEl = void 0)));
    }
    let k;
    function z() {
      t.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function B() {
      clearTimeout(k), t.touchEventsData.preventTouchMoveFromPointerMove = true, k = setTimeout(() => {
        t.destroyed || z();
      });
    }
    function V(U) {
      const Q = t.device;
      if (!p.imageEl || m.isTouched) return;
      Q.android && U.cancelable && U.preventDefault(), m.isTouched = true;
      const ee = _.length > 0 ? _[0] : U;
      m.touchesStart.x = ee.pageX, m.touchesStart.y = ee.pageY;
    }
    function X(U) {
      const ee = U.pointerType === "mouse" && t.params.zoom.panOnMouseMove;
      if (!L(U) || !f(U)) return;
      const K = t.zoom;
      if (!p.imageEl) return;
      if (!m.isTouched || !p.slideEl) {
        ee && W(U);
        return;
      }
      if (ee) {
        W(U);
        return;
      }
      m.isMoved || (m.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, m.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, m.startX = ur(p.imageWrapEl, "x") || 0, m.startY = ur(p.imageWrapEl, "y") || 0, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight, p.imageWrapEl.style.transitionDuration = "0ms");
      const ne = m.width * K.scale, Ee = m.height * K.scale;
      if (m.minX = Math.min(p.slideWidth / 2 - ne / 2, 0), m.maxX = -m.minX, m.minY = Math.min(p.slideHeight / 2 - Ee / 2, 0), m.maxY = -m.minY, m.touchesCurrent.x = _.length > 0 ? _[0].pageX : U.pageX, m.touchesCurrent.y = _.length > 0 ? _[0].pageY : U.pageY, Math.max(Math.abs(m.touchesCurrent.x - m.touchesStart.x), Math.abs(m.touchesCurrent.y - m.touchesStart.y)) > 5 && (t.allowClick = false), !m.isMoved && !l) {
        if (t.isHorizontal() && (Math.floor(m.minX) === Math.floor(m.startX) && m.touchesCurrent.x < m.touchesStart.x || Math.floor(m.maxX) === Math.floor(m.startX) && m.touchesCurrent.x > m.touchesStart.x)) {
          m.isTouched = false, z();
          return;
        }
        if (!t.isHorizontal() && (Math.floor(m.minY) === Math.floor(m.startY) && m.touchesCurrent.y < m.touchesStart.y || Math.floor(m.maxY) === Math.floor(m.startY) && m.touchesCurrent.y > m.touchesStart.y)) {
          m.isTouched = false, z();
          return;
        }
      }
      U.cancelable && U.preventDefault(), U.stopPropagation(), B(), m.isMoved = true;
      const xe = (K.scale - o) / (p.maxRatio - t.params.zoom.minRatio), { originX: Ke, originY: ge } = p;
      m.currentX = m.touchesCurrent.x - m.touchesStart.x + m.startX + xe * (m.width - Ke * 2), m.currentY = m.touchesCurrent.y - m.touchesStart.y + m.startY + xe * (m.height - ge * 2), m.currentX < m.minX && (m.currentX = m.minX + 1 - De(m.minX - m.currentX + 1, 0.8)), m.currentX > m.maxX && (m.currentX = m.maxX - 1 + De(m.currentX - m.maxX + 1, 0.8)), m.currentY < m.minY && (m.currentY = m.minY + 1 - De(m.minY - m.currentY + 1, 0.8)), m.currentY > m.maxY && (m.currentY = m.maxY - 1 + De(m.currentY - m.maxY + 1, 0.8)), C.prevPositionX || (C.prevPositionX = m.touchesCurrent.x), C.prevPositionY || (C.prevPositionY = m.touchesCurrent.y), C.prevTime || (C.prevTime = Date.now()), C.x = (m.touchesCurrent.x - C.prevPositionX) / (Date.now() - C.prevTime) / 2, C.y = (m.touchesCurrent.y - C.prevPositionY) / (Date.now() - C.prevTime) / 2, Math.abs(m.touchesCurrent.x - C.prevPositionX) < 2 && (C.x = 0), Math.abs(m.touchesCurrent.y - C.prevPositionY) < 2 && (C.y = 0), C.prevPositionX = m.touchesCurrent.x, C.prevPositionY = m.touchesCurrent.y, C.prevTime = Date.now(), p.imageWrapEl.style.transform = `translate3d(${m.currentX}px, ${m.currentY}px,0)`;
    }
    function Z() {
      const U = t.zoom;
      if (_.length = 0, !p.imageEl) return;
      if (!m.isTouched || !m.isMoved) {
        m.isTouched = false, m.isMoved = false;
        return;
      }
      m.isTouched = false, m.isMoved = false;
      let Q = 300, ee = 300;
      const K = C.x * Q, ne = m.currentX + K, Ee = C.y * ee, Fe = m.currentY + Ee;
      C.x !== 0 && (Q = Math.abs((ne - m.currentX) / C.x)), C.y !== 0 && (ee = Math.abs((Fe - m.currentY) / C.y));
      const xe = Math.max(Q, ee);
      m.currentX = ne, m.currentY = Fe;
      const Ke = m.width * U.scale, ge = m.height * U.scale;
      m.minX = Math.min(p.slideWidth / 2 - Ke / 2, 0), m.maxX = -m.minX, m.minY = Math.min(p.slideHeight / 2 - ge / 2, 0), m.maxY = -m.minY, m.currentX = Math.max(Math.min(m.currentX, m.maxX), m.minX), m.currentY = Math.max(Math.min(m.currentY, m.maxY), m.minY), p.imageWrapEl.style.transitionDuration = `${xe}ms`, p.imageWrapEl.style.transform = `translate3d(${m.currentX}px, ${m.currentY}px,0)`;
    }
    function F() {
      const U = t.zoom;
      p.slideEl && t.activeIndex !== t.slides.indexOf(p.slideEl) && (p.imageEl && (p.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), p.imageWrapEl && (p.imageWrapEl.style.transform = "translate3d(0,0,0)"), p.slideEl.classList.remove(`${t.params.zoom.zoomedSlideClass}`), U.scale = 1, o = 1, p.slideEl = void 0, p.imageEl = void 0, p.imageWrapEl = void 0, p.originX = 0, p.originY = 0);
    }
    function W(U) {
      if (o <= 1 || !p.imageWrapEl || !L(U) || !f(U)) return;
      const Q = r.getComputedStyle(p.imageWrapEl).transform, ee = new r.DOMMatrix(Q);
      if (!c) {
        c = true, d.x = U.clientX, d.y = U.clientY, m.startX = ee.e, m.startY = ee.f, m.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, m.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight;
        return;
      }
      const K = (U.clientX - d.x) * v, ne = (U.clientY - d.y) * v, Ee = m.width * o, Fe = m.height * o, xe = p.slideWidth, Ke = p.slideHeight, ge = Math.min(xe / 2 - Ee / 2, 0), ye = -ge, Ae = Math.min(Ke / 2 - Fe / 2, 0), bt = -Ae, nt = Math.max(Math.min(m.startX + K, ye), ge), ct = Math.max(Math.min(m.startY + ne, bt), Ae);
      p.imageWrapEl.style.transitionDuration = "0ms", p.imageWrapEl.style.transform = `translate3d(${nt}px, ${ct}px, 0)`, d.x = U.clientX, d.y = U.clientY, m.startX = nt, m.startY = ct, m.currentX = nt, m.currentY = ct;
    }
    function Y(U) {
      const Q = t.zoom, ee = t.params.zoom;
      if (!p.slideEl) {
        U && U.target && (p.slideEl = U.target.closest(`.${t.params.slideClass}, swiper-slide`)), p.slideEl || (t.params.virtual && t.params.virtual.enabled && t.virtual ? p.slideEl = Me(t.slidesEl, `.${t.params.slideActiveClass}`)[0] : p.slideEl = t.slides[t.activeIndex]);
        let ft = p.slideEl.querySelector(`.${ee.containerClass}`);
        ft && (ft = ft.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = ft, ft ? p.imageWrapEl = Kt(p.imageEl, `.${ee.containerClass}`)[0] : p.imageWrapEl = void 0;
      }
      if (!p.imageEl || !p.imageWrapEl) return;
      p.maxRatio = E(), t.params.cssMode && (t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.touchAction = "none"), p.slideEl.classList.add(`${ee.zoomedSlideClass}`);
      let K, ne, Ee, Fe, xe, Ke, ge, ye, Ae, bt, nt, ct, Mt, Le, dt, Ge, st, Te;
      typeof m.touchesStart.x == "undefined" && U ? (K = U.pageX, ne = U.pageY) : (K = m.touchesStart.x, ne = m.touchesStart.y);
      const Et = o, Ce = typeof U == "number" ? U : null;
      o === 1 && Ce && (K = void 0, ne = void 0, m.touchesStart.x = void 0, m.touchesStart.y = void 0);
      const $e = E();
      Q.scale = Ce || $e, o = Ce || $e, U && !(o === 1 && Ce) ? (st = p.slideEl.offsetWidth, Te = p.slideEl.offsetHeight, Ee = kn(p.slideEl).left + r.scrollX, Fe = kn(p.slideEl).top + r.scrollY, xe = Ee + st / 2 - K, Ke = Fe + Te / 2 - ne, Ae = p.imageEl.offsetWidth || p.imageEl.clientWidth, bt = p.imageEl.offsetHeight || p.imageEl.clientHeight, nt = Ae * Q.scale, ct = bt * Q.scale, Mt = Math.min(st / 2 - nt / 2, 0), Le = Math.min(Te / 2 - ct / 2, 0), dt = -Mt, Ge = -Le, Et > 0 && Ce && typeof m.currentX == "number" && typeof m.currentY == "number" ? (ge = m.currentX * Q.scale / Et, ye = m.currentY * Q.scale / Et) : (ge = xe * Q.scale, ye = Ke * Q.scale), ge < Mt && (ge = Mt), ge > dt && (ge = dt), ye < Le && (ye = Le), ye > Ge && (ye = Ge)) : (ge = 0, ye = 0), Ce && Q.scale === 1 && (p.originX = 0, p.originY = 0), m.currentX = ge, m.currentY = ye, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = `translate3d(${ge}px, ${ye}px,0)`, p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = `translate3d(0,0,0) scale(${Q.scale})`;
    }
    function J() {
      const U = t.zoom, Q = t.params.zoom;
      if (!p.slideEl) {
        t.params.virtual && t.params.virtual.enabled && t.virtual ? p.slideEl = Me(t.slidesEl, `.${t.params.slideActiveClass}`)[0] : p.slideEl = t.slides[t.activeIndex];
        let ee = p.slideEl.querySelector(`.${Q.containerClass}`);
        ee && (ee = ee.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = ee, ee ? p.imageWrapEl = Kt(p.imageEl, `.${Q.containerClass}`)[0] : p.imageWrapEl = void 0;
      }
      !p.imageEl || !p.imageWrapEl || (p.maxRatio = E(), t.params.cssMode && (t.wrapperEl.style.overflow = "", t.wrapperEl.style.touchAction = ""), U.scale = 1, o = 1, m.currentX = void 0, m.currentY = void 0, m.touchesStart.x = void 0, m.touchesStart.y = void 0, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = "translate3d(0,0,0)", p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = "translate3d(0,0,0) scale(1)", p.slideEl.classList.remove(`${Q.zoomedSlideClass}`), p.slideEl = void 0, p.originX = 0, p.originY = 0, t.params.zoom.panOnMouseMove && (d = { x: 0, y: 0 }, c && (c = false, m.startX = 0, m.startY = 0)));
    }
    function re(U) {
      const Q = t.zoom;
      Q.scale && Q.scale !== 1 ? J() : Y(U);
    }
    function fe() {
      const U = t.params.passiveListeners ? { passive: true, capture: false } : false, Q = t.params.passiveListeners ? { passive: false, capture: true } : true;
      return { passiveListener: U, activeListenerWithCapture: Q };
    }
    function _e() {
      const U = t.zoom;
      if (U.enabled) return;
      U.enabled = true;
      const { passiveListener: Q, activeListenerWithCapture: ee } = fe();
      t.wrapperEl.addEventListener("pointerdown", P, Q), t.wrapperEl.addEventListener("pointermove", D, ee), ["pointerup", "pointercancel", "pointerout"].forEach((K) => {
        t.wrapperEl.addEventListener(K, H, Q);
      }), t.wrapperEl.addEventListener("pointermove", X, ee);
    }
    function be() {
      const U = t.zoom;
      if (!U.enabled) return;
      U.enabled = false;
      const { passiveListener: Q, activeListenerWithCapture: ee } = fe();
      t.wrapperEl.removeEventListener("pointerdown", P, Q), t.wrapperEl.removeEventListener("pointermove", D, ee), ["pointerup", "pointercancel", "pointerout"].forEach((K) => {
        t.wrapperEl.removeEventListener(K, H, Q);
      }), t.wrapperEl.removeEventListener("pointermove", X, ee);
    }
    i("init", () => {
      t.params.zoom.enabled && _e();
    }), i("destroy", () => {
      be();
    }), i("touchStart", (U, Q) => {
      t.zoom.enabled && V(Q);
    }), i("touchEnd", (U, Q) => {
      t.zoom.enabled && Z();
    }), i("doubleTap", (U, Q) => {
      !t.animating && t.params.zoom.enabled && t.zoom.enabled && t.params.zoom.toggle && re(Q);
    }), i("transitionEnd", () => {
      t.zoom.enabled && t.params.zoom.enabled && F();
    }), i("slideChange", () => {
      t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode && F();
    }), Object.assign(t.zoom, { enable: _e, disable: be, in: Y, out: J, toggle: re });
  }
  function _m({ swiper: t, extendParams: e, on: i }) {
    e({ controller: { control: void 0, inverse: false, by: "slide" } }), t.controller = { control: void 0 };
    function n(d, v) {
      const b = /* @__PURE__ */ (function() {
        let m, C, S;
        return (h, E) => {
          for (C = -1, m = h.length; m - C > 1; ) S = m + C >> 1, h[S] <= E ? C = S : m = S;
          return m;
        };
      })();
      this.x = d, this.y = v, this.lastIndex = d.length - 1;
      let y, _;
      return this.interpolate = function(m) {
        return m ? (_ = b(this.x, m), y = _ - 1, (m - this.x[y]) * (this.y[_] - this.y[y]) / (this.x[_] - this.x[y]) + this.y[y]) : 0;
      }, this;
    }
    function r(d) {
      t.controller.spline = t.params.loop ? new n(t.slidesGrid, d.slidesGrid) : new n(t.snapGrid, d.snapGrid);
    }
    function o(d, v) {
      const b = t.controller.control;
      let y, _;
      const p = t.constructor;
      function m(C) {
        if (C.destroyed) return;
        const S = t.rtlTranslate ? -t.translate : t.translate;
        t.params.controller.by === "slide" && (r(C), _ = -t.controller.spline.interpolate(-S)), (!_ || t.params.controller.by === "container") && (y = (C.maxTranslate() - C.minTranslate()) / (t.maxTranslate() - t.minTranslate()), (Number.isNaN(y) || !Number.isFinite(y)) && (y = 1), _ = (S - t.minTranslate()) * y + C.minTranslate()), t.params.controller.inverse && (_ = C.maxTranslate() - _), C.updateProgress(_), C.setTranslate(_, t), C.updateActiveIndex(), C.updateSlidesClasses();
      }
      if (Array.isArray(b)) for (let C = 0; C < b.length; C += 1) b[C] !== v && b[C] instanceof p && m(b[C]);
      else b instanceof p && v !== b && m(b);
    }
    function l(d, v) {
      const b = t.constructor, y = t.controller.control;
      let _;
      function p(m) {
        m.destroyed || (m.setTransition(d, t), d !== 0 && (m.transitionStart(), m.params.autoHeight && Mi(() => {
          m.updateAutoHeight();
        }), Ui(m.wrapperEl, () => {
          y && m.transitionEnd();
        })));
      }
      if (Array.isArray(y)) for (_ = 0; _ < y.length; _ += 1) y[_] !== v && y[_] instanceof b && p(y[_]);
      else y instanceof b && v !== y && p(y);
    }
    function c() {
      t.controller.control && t.controller.spline && (t.controller.spline = void 0, delete t.controller.spline);
    }
    i("beforeInit", () => {
      if (typeof window != "undefined" && (typeof t.params.controller.control == "string" || t.params.controller.control instanceof HTMLElement)) {
        (typeof t.params.controller.control == "string" ? [...document.querySelectorAll(t.params.controller.control)] : [t.params.controller.control]).forEach((v) => {
          if (t.controller.control || (t.controller.control = []), v && v.swiper) t.controller.control.push(v.swiper);
          else if (v) {
            const b = `${t.params.eventsPrefix}init`, y = (_) => {
              t.controller.control.push(_.detail[0]), t.update(), v.removeEventListener(b, y);
            };
            v.addEventListener(b, y);
          }
        });
        return;
      }
      t.controller.control = t.params.controller.control;
    }), i("update", () => {
      c();
    }), i("resize", () => {
      c();
    }), i("observerUpdate", () => {
      c();
    }), i("setTranslate", (d, v, b) => {
      !t.controller.control || t.controller.control.destroyed || t.controller.setTranslate(v, b);
    }), i("setTransition", (d, v, b) => {
      !t.controller.control || t.controller.control.destroyed || t.controller.setTransition(v, b);
    }), Object.assign(t.controller, { setTranslate: o, setTransition: l });
  }
  function Sm({ swiper: t, extendParams: e, on: i }) {
    e({ a11y: { enabled: true, notificationClass: "swiper-notification", prevSlideMessage: "Previous slide", nextSlideMessage: "Next slide", firstSlideMessage: "This is the first slide", lastSlideMessage: "This is the last slide", paginationBulletMessage: "Go to slide {{index}}", slideLabelMessage: "{{index}} / {{slidesLength}}", containerMessage: null, containerRoleDescriptionMessage: null, containerRole: null, itemRoleDescriptionMessage: null, slideRole: "group", id: null, scrollOnFocus: true, wrapperLiveRegion: true } }), t.a11y = { clicked: false };
    let n = null, r, o, l = (/* @__PURE__ */ new Date()).getTime();
    function c(F) {
      const W = n;
      W.length !== 0 && yt(W, F);
    }
    function d(F = 16) {
      const W = () => Math.round(16 * Math.random()).toString(16);
      return "x".repeat(F).replace(/x/g, W);
    }
    function v(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("tabIndex", "0");
      });
    }
    function b(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("tabIndex", "-1");
      });
    }
    function y(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("role", W);
      });
    }
    function _(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-roledescription", W);
      });
    }
    function p(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-controls", W);
      });
    }
    function m(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-label", W);
      });
    }
    function C(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("id", W);
      });
    }
    function S(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-live", W);
      });
    }
    function h(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("aria-disabled", true);
      });
    }
    function E(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("aria-disabled", false);
      });
    }
    function I(F) {
      if (F.keyCode !== 13 && F.keyCode !== 32) return;
      const W = t.params.a11y, Y = F.target;
      if (!(t.pagination && t.pagination.el && (Y === t.pagination.el || t.pagination.el.contains(F.target)) && !F.target.matches(xt(t.params.pagination.bulletClass)))) {
        if (t.navigation && t.navigation.prevEl && t.navigation.nextEl) {
          const J = ue(t.navigation.prevEl);
          ue(t.navigation.nextEl).includes(Y) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? c(W.lastSlideMessage) : c(W.nextSlideMessage)), J.includes(Y) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? c(W.firstSlideMessage) : c(W.prevSlideMessage));
        }
        t.pagination && Y.matches(xt(t.params.pagination.bulletClass)) && Y.click();
      }
    }
    function O() {
      if (t.params.loop || t.params.rewind || !t.navigation) return;
      const { nextEl: F, prevEl: W } = t.navigation;
      W && (t.isBeginning ? (h(W), b(W)) : (E(W), v(W))), F && (t.isEnd ? (h(F), b(F)) : (E(F), v(F)));
    }
    function L() {
      return t.pagination && t.pagination.bullets && t.pagination.bullets.length;
    }
    function f() {
      return L() && t.params.pagination.clickable;
    }
    function P() {
      const F = t.params.a11y;
      L() && t.pagination.bullets.forEach((W) => {
        t.params.pagination.clickable && (v(W), t.params.pagination.renderBullet || (y(W, "button"), m(W, F.paginationBulletMessage.replace(/\{\{index\}\}/, Ki(W) + 1)))), W.matches(xt(t.params.pagination.bulletActiveClass)) ? W.setAttribute("aria-current", "true") : W.removeAttribute("aria-current");
      });
    }
    const D = (F, W, Y) => {
      v(F), F.tagName !== "BUTTON" && (y(F, "button"), F.addEventListener("keydown", I)), m(F, Y), p(F, W);
    }, H = (F) => {
      o && o !== F.target && !o.contains(F.target) && (r = true), t.a11y.clicked = true;
    }, k = () => {
      r = false, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t.destroyed || (t.a11y.clicked = false);
        });
      });
    }, z = (F) => {
      l = (/* @__PURE__ */ new Date()).getTime();
    }, B = (F) => {
      if (t.a11y.clicked || !t.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - l < 100) return;
      const W = F.target.closest(`.${t.params.slideClass}, swiper-slide`);
      if (!W || !t.slides.includes(W)) return;
      o = W;
      const Y = t.virtual && t.params.virtual.enabled, J = (Y ? parseInt(W.getAttribute("data-swiper-slide-index"), 10) : t.slides.indexOf(W)) === t.activeIndex, re = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(W);
      J || re || F.sourceCapabilities && F.sourceCapabilities.firesTouchEvents || (t.isHorizontal() ? t.el.scrollLeft = 0 : t.el.scrollTop = 0, requestAnimationFrame(() => {
        r || (t.params.loop ? t.slideToLoop(t.getSlideIndexWhenGrid(parseInt(W.getAttribute("data-swiper-slide-index"))), 0) : Y ? t.slideTo(t.getSlideIndexWhenGrid(parseInt(W.getAttribute("data-swiper-slide-index"), 10)), 0) : t.slideTo(t.getSlideIndexWhenGrid(t.slides.indexOf(W)), 0), r = false);
      }));
    }, V = () => {
      const F = t.params.a11y;
      F.itemRoleDescriptionMessage && _(t.slides, F.itemRoleDescriptionMessage), F.slideRole && y(t.slides, F.slideRole);
      const W = t.slides.length;
      F.slideLabelMessage && t.slides.forEach((Y, J) => {
        const re = t.params.loop ? parseInt(Y.getAttribute("data-swiper-slide-index"), 10) : J, fe = F.slideLabelMessage.replace(/\{\{index\}\}/, re + 1).replace(/\{\{slidesLength\}\}/, W);
        m(Y, fe);
      });
    }, X = () => {
      const F = t.params.a11y;
      t.el.append(n);
      const W = t.el;
      F.containerRoleDescriptionMessage && _(W, F.containerRoleDescriptionMessage), F.containerMessage && m(W, F.containerMessage), F.containerRole && y(W, F.containerRole);
      const Y = t.wrapperEl, J = F.id || Y.getAttribute("id") || `swiper-wrapper-${d(16)}`;
      if (C(Y, J), F.wrapperLiveRegion) {
        const be = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
        S(Y, be);
      }
      V();
      let { nextEl: re, prevEl: fe } = t.navigation ? t.navigation : {};
      re = ue(re), fe = ue(fe), re && re.forEach((be) => D(be, J, F.nextSlideMessage)), fe && fe.forEach((be) => D(be, J, F.prevSlideMessage)), f() && ue(t.pagination.el).forEach((U) => {
        U.addEventListener("keydown", I);
      }), Oe().addEventListener("visibilitychange", z), t.el.addEventListener("focus", B, true), t.el.addEventListener("pointerdown", H, true), t.el.addEventListener("pointerup", k, true);
    };
    function Z() {
      n && n.remove();
      let { nextEl: F, prevEl: W } = t.navigation ? t.navigation : {};
      F = ue(F), W = ue(W), F && F.forEach((J) => J.removeEventListener("keydown", I)), W && W.forEach((J) => J.removeEventListener("keydown", I)), f() && ue(t.pagination.el).forEach((re) => {
        re.removeEventListener("keydown", I);
      }), Oe().removeEventListener("visibilitychange", z), t.el && typeof t.el != "string" && (t.el.removeEventListener("focus", B, true), t.el.removeEventListener("pointerdown", H, true), t.el.removeEventListener("pointerup", k, true));
    }
    i("beforeInit", () => {
      n = Ye("span", t.params.a11y.notificationClass), n.setAttribute("aria-live", "assertive"), n.setAttribute("aria-atomic", "true");
    }), i("afterInit", () => {
      t.params.a11y.enabled && X();
    }), i("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
      t.params.a11y.enabled && V();
    }), i("fromEdge toEdge afterInit lock unlock", () => {
      t.params.a11y.enabled && O();
    }), i("paginationUpdate", () => {
      t.params.a11y.enabled && P();
    }), i("destroy", () => {
      t.params.a11y.enabled && Z();
    });
  }
  function xm({ swiper: t, extendParams: e, on: i }) {
    e({ history: { enabled: false, root: "", replaceState: false, key: "slides", keepQuery: false } });
    let n = false, r = {};
    const o = (_) => _.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), l = (_) => {
      const p = ve();
      let m;
      _ ? m = new URL(_) : m = p.location;
      const C = m.pathname.slice(1).split("/").filter((I) => I !== ""), S = C.length, h = C[S - 2], E = C[S - 1];
      return { key: h, value: E };
    }, c = (_, p) => {
      const m = ve();
      if (!n || !t.params.history.enabled) return;
      let C;
      t.params.url ? C = new URL(t.params.url) : C = m.location;
      const S = t.virtual && t.params.virtual.enabled ? t.slidesEl.querySelector(`[data-swiper-slide-index="${p}"]`) : t.slides[p];
      let h = o(S.getAttribute("data-history"));
      if (t.params.history.root.length > 0) {
        let I = t.params.history.root;
        I[I.length - 1] === "/" && (I = I.slice(0, I.length - 1)), h = `${I}/${_ ? `${_}/` : ""}${h}`;
      } else C.pathname.includes(_) || (h = `${_ ? `${_}/` : ""}${h}`);
      t.params.history.keepQuery && (h += C.search);
      const E = m.history.state;
      E && E.value === h || (t.params.history.replaceState ? m.history.replaceState({ value: h }, null, h) : m.history.pushState({ value: h }, null, h));
    }, d = (_, p, m) => {
      if (p) for (let C = 0, S = t.slides.length; C < S; C += 1) {
        const h = t.slides[C];
        if (o(h.getAttribute("data-history")) === p) {
          const I = t.getSlideIndex(h);
          t.slideTo(I, _, m);
        }
      }
      else t.slideTo(0, _, m);
    }, v = () => {
      r = l(t.params.url), d(t.params.speed, r.value, false);
    }, b = () => {
      const _ = ve();
      if (t.params.history) {
        if (!_.history || !_.history.pushState) {
          t.params.history.enabled = false, t.params.hashNavigation.enabled = true;
          return;
        }
        if (n = true, r = l(t.params.url), !r.key && !r.value) {
          t.params.history.replaceState || _.addEventListener("popstate", v);
          return;
        }
        d(0, r.value, t.params.runCallbacksOnInit), t.params.history.replaceState || _.addEventListener("popstate", v);
      }
    }, y = () => {
      const _ = ve();
      t.params.history.replaceState || _.removeEventListener("popstate", v);
    };
    i("init", () => {
      t.params.history.enabled && b();
    }), i("destroy", () => {
      t.params.history.enabled && y();
    }), i("transitionEnd _freeModeNoMomentumRelease", () => {
      n && c(t.params.history.key, t.activeIndex);
    }), i("slideChange", () => {
      n && t.params.cssMode && c(t.params.history.key, t.activeIndex);
    });
  }
  function Cm({ swiper: t, extendParams: e, emit: i, on: n }) {
    let r = false;
    const o = Oe(), l = ve();
    e({ hashNavigation: { enabled: false, replaceState: false, watchState: false, getSlideIndex(y, _) {
      if (t.virtual && t.params.virtual.enabled) {
        const p = t.slides.find((C) => C.getAttribute("data-hash") === _);
        return p ? parseInt(p.getAttribute("data-swiper-slide-index"), 10) : 0;
      }
      return t.getSlideIndex(Me(t.slidesEl, `.${t.params.slideClass}[data-hash="${_}"], swiper-slide[data-hash="${_}"]`)[0]);
    } } });
    const c = () => {
      i("hashChange");
      const y = o.location.hash.replace("#", ""), _ = t.virtual && t.params.virtual.enabled ? t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`) : t.slides[t.activeIndex], p = _ ? _.getAttribute("data-hash") : "";
      if (y !== p) {
        const m = t.params.hashNavigation.getSlideIndex(t, y);
        if (typeof m == "undefined" || Number.isNaN(m)) return;
        t.slideTo(m);
      }
    }, d = () => {
      if (!r || !t.params.hashNavigation.enabled) return;
      const y = t.virtual && t.params.virtual.enabled ? t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`) : t.slides[t.activeIndex], _ = y ? y.getAttribute("data-hash") || y.getAttribute("data-history") : "";
      t.params.hashNavigation.replaceState && l.history && l.history.replaceState ? (l.history.replaceState(null, null, `#${_}` || ""), i("hashSet")) : (o.location.hash = _ || "", i("hashSet"));
    }, v = () => {
      if (!t.params.hashNavigation.enabled || t.params.history && t.params.history.enabled) return;
      r = true;
      const y = o.location.hash.replace("#", "");
      if (y) {
        const p = t.params.hashNavigation.getSlideIndex(t, y);
        t.slideTo(p || 0, 0, t.params.runCallbacksOnInit, true);
      }
      t.params.hashNavigation.watchState && l.addEventListener("hashchange", c);
    }, b = () => {
      t.params.hashNavigation.watchState && l.removeEventListener("hashchange", c);
    };
    n("init", () => {
      t.params.hashNavigation.enabled && v();
    }), n("destroy", () => {
      t.params.hashNavigation.enabled && b();
    }), n("transitionEnd _freeModeNoMomentumRelease", () => {
      r && d();
    }), n("slideChange", () => {
      r && t.params.cssMode && d();
    });
  }
  function Im({ swiper: t, extendParams: e, on: i, emit: n, params: r }) {
    t.autoplay = { running: false, paused: false, timeLeft: 0 }, e({ autoplay: { enabled: false, delay: 3e3, waitForTransition: true, disableOnInteraction: false, stopOnLastSlide: false, reverseDirection: false, pauseOnMouseEnter: false } });
    let o, l, c = r && r.autoplay ? r.autoplay.delay : 3e3, d = r && r.autoplay ? r.autoplay.delay : 3e3, v, b = (/* @__PURE__ */ new Date()).getTime(), y, _, p, m, C, S;
    function h(W) {
      !t || t.destroyed || !t.wrapperEl || W.target === t.wrapperEl && (t.wrapperEl.removeEventListener("transitionend", h), !(S || W.detail && W.detail.bySwiperTouchMove) && H());
    }
    const E = () => {
      if (t.destroyed || !t.autoplay.running) return;
      t.autoplay.paused ? y = true : y && (d = v, y = false);
      const W = t.autoplay.paused ? v : b + d - (/* @__PURE__ */ new Date()).getTime();
      t.autoplay.timeLeft = W, n("autoplayTimeLeft", W, W / c), l = requestAnimationFrame(() => {
        E();
      });
    }, I = () => {
      let W;
      return t.virtual && t.params.virtual.enabled ? W = t.slides.find((J) => J.classList.contains("swiper-slide-active")) : W = t.slides[t.activeIndex], W ? parseInt(W.getAttribute("data-swiper-autoplay"), 10) : void 0;
    }, O = () => {
      let W = t.params.autoplay.delay;
      const Y = I();
      return !Number.isNaN(Y) && Y > 0 && (W = Y), W;
    }, L = (W) => {
      if (t.destroyed || !t.autoplay.running) return;
      cancelAnimationFrame(l), E();
      let Y = W;
      typeof Y == "undefined" && (Y = O(), c = Y, d = Y), v = Y;
      const J = t.params.speed, re = () => {
        !t || t.destroyed || (t.params.autoplay.reverseDirection ? !t.isBeginning || t.params.loop || t.params.rewind ? (t.slidePrev(J, true, true), n("autoplay")) : t.params.autoplay.stopOnLastSlide || (t.slideTo(t.slides.length - 1, J, true, true), n("autoplay")) : !t.isEnd || t.params.loop || t.params.rewind ? (t.slideNext(J, true, true), n("autoplay")) : t.params.autoplay.stopOnLastSlide || (t.slideTo(0, J, true, true), n("autoplay")), t.params.cssMode && (b = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
          L();
        })));
      };
      return Y > 0 ? (clearTimeout(o), o = setTimeout(() => {
        re();
      }, Y)) : requestAnimationFrame(() => {
        re();
      }), Y;
    }, f = () => {
      b = (/* @__PURE__ */ new Date()).getTime(), t.autoplay.running = true, L(), n("autoplayStart");
    }, P = () => {
      t.autoplay.running = false, clearTimeout(o), cancelAnimationFrame(l), n("autoplayStop");
    }, D = (W, Y) => {
      if (t.destroyed || !t.autoplay.running) return;
      clearTimeout(o), W || (C = true);
      const J = () => {
        n("autoplayPause"), t.params.autoplay.waitForTransition ? t.wrapperEl.addEventListener("transitionend", h) : H();
      };
      if (t.autoplay.paused = true, Y) {
        J();
        return;
      }
      v = (v || t.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - b), !(t.isEnd && v < 0 && !t.params.loop) && (v < 0 && (v = 0), J());
    }, H = () => {
      t.isEnd && v < 0 && !t.params.loop || t.destroyed || !t.autoplay.running || (b = (/* @__PURE__ */ new Date()).getTime(), C ? (C = false, L(v)) : L(), t.autoplay.paused = false, n("autoplayResume"));
    }, k = () => {
      if (t.destroyed || !t.autoplay.running) return;
      const W = Oe();
      W.visibilityState === "hidden" && (C = true, D(true)), W.visibilityState === "visible" && H();
    }, z = (W) => {
      W.pointerType === "mouse" && (C = true, S = true, !(t.animating || t.autoplay.paused) && D(true));
    }, B = (W) => {
      W.pointerType === "mouse" && (S = false, t.autoplay.paused && H());
    }, V = () => {
      t.params.autoplay.pauseOnMouseEnter && (t.el.addEventListener("pointerenter", z), t.el.addEventListener("pointerleave", B));
    }, X = () => {
      t.el && typeof t.el != "string" && (t.el.removeEventListener("pointerenter", z), t.el.removeEventListener("pointerleave", B));
    }, Z = () => {
      Oe().addEventListener("visibilitychange", k);
    }, F = () => {
      Oe().removeEventListener("visibilitychange", k);
    };
    i("init", () => {
      t.params.autoplay.enabled && (V(), Z(), f());
    }), i("destroy", () => {
      X(), F(), t.autoplay.running && P();
    }), i("_freeModeStaticRelease", () => {
      (p || C) && H();
    }), i("_freeModeNoMomentumRelease", () => {
      t.params.autoplay.disableOnInteraction ? P() : D(true, true);
    }), i("beforeTransitionStart", (W, Y, J) => {
      t.destroyed || !t.autoplay.running || (J || !t.params.autoplay.disableOnInteraction ? D(true, true) : P());
    }), i("sliderFirstMove", () => {
      if (!(t.destroyed || !t.autoplay.running)) {
        if (t.params.autoplay.disableOnInteraction) {
          P();
          return;
        }
        _ = true, p = false, C = false, m = setTimeout(() => {
          C = true, p = true, D(true);
        }, 200);
      }
    }), i("touchEnd", () => {
      if (!(t.destroyed || !t.autoplay.running || !_)) {
        if (clearTimeout(m), clearTimeout(o), t.params.autoplay.disableOnInteraction) {
          p = false, _ = false;
          return;
        }
        p && t.params.cssMode && H(), p = false, _ = false;
      }
    }), i("slideChange", () => {
      t.destroyed || !t.autoplay.running || t.autoplay.paused && (v = O(), c = O());
    }), Object.assign(t.autoplay, { start: f, stop: P, pause: D, resume: H });
  }
  function Am({ swiper: t, extendParams: e, on: i }) {
    e({ thumbs: { swiper: null, multipleActiveThumbs: true, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-thumbs" } });
    let n = false, r = false;
    t.thumbs = { swiper: null };
    function o() {
      const b = t.thumbs.swiper;
      return !b || b.destroyed ? false : b.params.virtual && b.params.virtual.enabled;
    }
    function l() {
      const b = t.thumbs.swiper;
      if (!b || b.destroyed) return;
      const y = b.clickedIndex, _ = b.clickedSlide;
      if (_ && _.classList.contains(t.params.thumbs.slideThumbActiveClass) || typeof y == "undefined" || y === null) return;
      let p;
      b.params.loop ? p = parseInt(b.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : p = y, t.params.loop ? t.slideToLoop(p) : t.slideTo(p);
    }
    function c() {
      const { thumbs: b } = t.params;
      if (n) return false;
      n = true;
      const y = t.constructor;
      if (b.swiper instanceof y) {
        if (b.swiper.destroyed) return n = false, false;
        t.thumbs.swiper = b.swiper, Object.assign(t.thumbs.swiper.originalParams, { watchSlidesProgress: true, slideToClickedSlide: false }), Object.assign(t.thumbs.swiper.params, { watchSlidesProgress: true, slideToClickedSlide: false }), t.thumbs.swiper.update();
      } else if (Yi(b.swiper)) {
        const _ = Object.assign({}, b.swiper);
        Object.assign(_, { watchSlidesProgress: true, slideToClickedSlide: false }), t.thumbs.swiper = new y(_), r = true;
      }
      return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass), t.thumbs.swiper.on("tap", l), o() && t.thumbs.swiper.on("virtualUpdate", () => {
        d(false, { autoScroll: false });
      }), true;
    }
    function d(b, y) {
      var C;
      const _ = t.thumbs.swiper;
      if (!_ || _.destroyed) return;
      let p = 1;
      const m = t.params.thumbs.slideThumbActiveClass;
      if (t.params.slidesPerView > 1 && !t.params.centeredSlides && (p = t.params.slidesPerView), t.params.thumbs.multipleActiveThumbs || (p = 1), p = Math.floor(p), _.slides.forEach((S) => S.classList.remove(m)), _.params.loop || o()) for (let S = 0; S < p; S += 1) Me(_.slidesEl, `[data-swiper-slide-index="${t.realIndex + S}"]`).forEach((h) => {
        h.classList.add(m);
      });
      else for (let S = 0; S < p; S += 1) _.slides[t.realIndex + S] && _.slides[t.realIndex + S].classList.add(m);
      ((C = y == null ? void 0 : y.autoScroll) == null || C) && v(b ? 0 : void 0);
    }
    function v(b) {
      const y = t.thumbs.swiper;
      if (!y || y.destroyed) return;
      const _ = y.params.slidesPerView === "auto" ? y.slidesPerViewDynamic() : y.params.slidesPerView, p = t.params.thumbs.autoScrollOffset, m = p && !y.params.loop;
      if (t.realIndex !== y.realIndex || m) {
        const C = y.activeIndex;
        let S, h;
        if (y.params.loop) {
          const E = y.slides.find((I) => I.getAttribute("data-swiper-slide-index") === `${t.realIndex}`);
          S = y.slides.indexOf(E), h = t.activeIndex > t.previousIndex ? "next" : "prev";
        } else S = t.realIndex, h = S > t.previousIndex ? "next" : "prev";
        m && (S += h === "next" ? p : -1 * p), y.visibleSlidesIndexes && y.visibleSlidesIndexes.indexOf(S) < 0 && (y.params.centeredSlides ? S > C ? S = S - Math.floor(_ / 2) + 1 : S = S + Math.floor(_ / 2) - 1 : S > C && y.params.slidesPerGroup, y.slideTo(S, b));
      }
    }
    i("beforeInit", () => {
      const { thumbs: b } = t.params;
      if (!(!b || !b.swiper)) if (typeof b.swiper == "string" || b.swiper instanceof HTMLElement) {
        const y = Oe(), _ = () => {
          const m = typeof b.swiper == "string" ? y.querySelector(b.swiper) : b.swiper;
          if (m && m.swiper) b.swiper = m.swiper, c(), d(true);
          else if (m) {
            const C = `${t.params.eventsPrefix}init`, S = (h) => {
              b.swiper = h.detail[0], m.removeEventListener(C, S), c(), d(true), b.swiper.update(), t.update();
            };
            m.addEventListener(C, S);
          }
          return m;
        }, p = () => {
          if (t.destroyed) return;
          _() || requestAnimationFrame(p);
        };
        requestAnimationFrame(p);
      } else c(), d(true);
    }), i("slideChange update resize observerUpdate", () => {
      d();
    }), i("setTransition", (b, y) => {
      const _ = t.thumbs.swiper;
      !_ || _.destroyed || _.setTransition(y);
    }), i("beforeDestroy", () => {
      const b = t.thumbs.swiper;
      !b || b.destroyed || r && b.destroy();
    }), Object.assign(t.thumbs, { init: c, update: d });
  }
  function wm({ swiper: t, extendParams: e, emit: i, once: n }) {
    e({ freeMode: { enabled: false, momentum: true, momentumRatio: 1, momentumBounce: true, momentumBounceRatio: 1, momentumVelocityRatio: 1, sticky: false, minimumVelocity: 0.02 } });
    function r() {
      if (t.params.cssMode) return;
      const c = t.getTranslate();
      t.setTranslate(c), t.setTransition(0), t.touchEventsData.velocities.length = 0, t.freeMode.onTouchEnd({ currentPos: t.rtl ? t.translate : -t.translate });
    }
    function o() {
      if (t.params.cssMode) return;
      const { touchEventsData: c, touches: d } = t;
      c.velocities.length === 0 && c.velocities.push({ position: d[t.isHorizontal() ? "startX" : "startY"], time: c.touchStartTime }), c.velocities.push({ position: d[t.isHorizontal() ? "currentX" : "currentY"], time: Qe() });
    }
    function l({ currentPos: c }) {
      if (t.params.cssMode) return;
      const { params: d, wrapperEl: v, rtlTranslate: b, snapGrid: y, touchEventsData: _ } = t, m = Qe() - _.touchStartTime;
      if (c < -t.minTranslate()) {
        t.slideTo(t.activeIndex);
        return;
      }
      if (c > -t.maxTranslate()) {
        t.slides.length < y.length ? t.slideTo(y.length - 1) : t.slideTo(t.slides.length - 1);
        return;
      }
      if (d.freeMode.momentum) {
        if (_.velocities.length > 1) {
          const f = _.velocities.pop(), P = _.velocities.pop(), D = f.position - P.position, H = f.time - P.time;
          t.velocity = D / H, t.velocity /= 2, Math.abs(t.velocity) < d.freeMode.minimumVelocity && (t.velocity = 0), (H > 150 || Qe() - f.time > 300) && (t.velocity = 0);
        } else t.velocity = 0;
        t.velocity *= d.freeMode.momentumVelocityRatio, _.velocities.length = 0;
        let C = 1e3 * d.freeMode.momentumRatio;
        const S = t.velocity * C;
        let h = t.translate + S;
        b && (h = -h);
        let E = false, I;
        const O = Math.abs(t.velocity) * 20 * d.freeMode.momentumBounceRatio;
        let L;
        if (h < t.maxTranslate()) d.freeMode.momentumBounce ? (h + t.maxTranslate() < -O && (h = t.maxTranslate() - O), I = t.maxTranslate(), E = true, _.allowMomentumBounce = true) : h = t.maxTranslate(), d.loop && d.centeredSlides && (L = true);
        else if (h > t.minTranslate()) d.freeMode.momentumBounce ? (h - t.minTranslate() > O && (h = t.minTranslate() + O), I = t.minTranslate(), E = true, _.allowMomentumBounce = true) : h = t.minTranslate(), d.loop && d.centeredSlides && (L = true);
        else if (d.freeMode.sticky) {
          let f;
          for (let P = 0; P < y.length; P += 1) if (y[P] > -h) {
            f = P;
            break;
          }
          Math.abs(y[f] - h) < Math.abs(y[f - 1] - h) || t.swipeDirection === "next" ? h = y[f] : h = y[f - 1], h = -h;
        }
        if (L && n("transitionEnd", () => {
          t.loopFix();
        }), t.velocity !== 0) {
          if (b ? C = Math.abs((-h - t.translate) / t.velocity) : C = Math.abs((h - t.translate) / t.velocity), d.freeMode.sticky) {
            const f = Math.abs((b ? -h : h) - t.translate), P = t.slidesSizesGrid[t.activeIndex];
            f < P ? C = d.speed : f < 2 * P ? C = d.speed * 1.5 : C = d.speed * 2.5;
          }
        } else if (d.freeMode.sticky) {
          t.slideToClosest();
          return;
        }
        d.freeMode.momentumBounce && E ? (t.updateProgress(I), t.setTransition(C), t.setTranslate(h), t.transitionStart(true, t.swipeDirection), t.animating = true, Ui(v, () => {
          !t || t.destroyed || !_.allowMomentumBounce || (i("momentumBounce"), t.setTransition(d.speed), setTimeout(() => {
            t.setTranslate(I), Ui(v, () => {
              !t || t.destroyed || t.transitionEnd();
            });
          }, 0));
        })) : t.velocity ? (i("_freeModeNoMomentumRelease"), t.updateProgress(h), t.setTransition(C), t.setTranslate(h), t.transitionStart(true, t.swipeDirection), t.animating || (t.animating = true, Ui(v, () => {
          !t || t.destroyed || t.transitionEnd();
        }))) : t.updateProgress(h), t.updateActiveIndex(), t.updateSlidesClasses();
      } else if (d.freeMode.sticky) {
        t.slideToClosest();
        return;
      } else d.freeMode && i("_freeModeNoMomentumRelease");
      (!d.freeMode.momentum || m >= d.longSwipesMs) && (i("_freeModeStaticRelease"), t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
    }
    Object.assign(t, { freeMode: { onTouchStart: r, onTouchMove: o, onTouchEnd: l } });
  }
  function Om({ swiper: t, extendParams: e, on: i }) {
    e({ grid: { rows: 1, fill: "column" } });
    let n, r, o, l;
    const c = () => {
      let m = t.params.spaceBetween;
      return typeof m == "string" && m.indexOf("%") >= 0 ? m = parseFloat(m.replace("%", "")) / 100 * t.size : typeof m == "string" && (m = parseFloat(m)), m;
    }, d = (m) => {
      const { slidesPerView: C } = t.params, { rows: S, fill: h } = t.params.grid, E = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : m.length;
      o = Math.floor(E / S), Math.floor(E / S) === E / S ? n = E : n = Math.ceil(E / S) * S, C !== "auto" && h === "row" && (n = Math.max(n, Math.floor(C) * S)), r = n / S;
    }, v = () => {
      t.slides && t.slides.forEach((m) => {
        m.swiperSlideGridSet && (m.style.height = "", m.style[t.getDirectionLabel("margin-top")] = "");
      });
    }, b = (m, C, S) => {
      const { slidesPerGroup: h } = t.params, E = c(), { rows: I, fill: O } = t.params.grid, L = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : S.length;
      let f, P, D;
      if (O === "row" && h > 1) {
        const H = Math.floor(m / (h * I)), k = m - I * h * H, z = H === 0 ? h : Math.min(Math.ceil((L - H * I * h) / I), h);
        D = Math.floor(k / z), P = k - D * z + H * h, f = P + D * n / I, C.style.order = f;
      } else O === "column" ? (P = Math.floor(m / I), D = m - P * I, (P > o || P === o && D === I - 1) && (D += 1, D >= I && (D = 0, P += 1))) : (D = Math.floor(m / r), P = m - D * r);
      C.row = D, C.column = P, C.style.height = `calc((100% - ${(I - 1) * E}px) / ${I})`, C.style[t.getDirectionLabel("margin-top")] = D !== 0 ? E && `${E}px` : "", C.swiperSlideGridSet = true;
    }, y = (m, C) => {
      const { centeredSlides: S, roundLengths: h } = t.params, E = c(), { rows: I } = t.params.grid;
      if (t.virtualSize = (m + E) * n, t.virtualSize = Math.ceil(t.virtualSize / I) - E, t.params.cssMode || (t.wrapperEl.style[t.getDirectionLabel("width")] = `${t.virtualSize + E}px`), S) {
        const O = [];
        for (let L = 0; L < C.length; L += 1) {
          let f = C[L];
          h && (f = Math.floor(f)), C[L] < t.virtualSize + C[0] && O.push(f);
        }
        C.splice(0, C.length), C.push(...O);
      }
    }, _ = () => {
      l = t.params.grid && t.params.grid.rows > 1;
    }, p = () => {
      const { params: m, el: C } = t, S = m.grid && m.grid.rows > 1;
      l && !S ? (C.classList.remove(`${m.containerModifierClass}grid`, `${m.containerModifierClass}grid-column`), o = 1, t.emitContainerClasses()) : !l && S && (C.classList.add(`${m.containerModifierClass}grid`), m.grid.fill === "column" && C.classList.add(`${m.containerModifierClass}grid-column`), t.emitContainerClasses()), l = S;
    };
    i("init", _), i("update", p), t.grid = { initSlides: d, unsetSlides: v, updateSlide: b, updateWrapperSize: y };
  }
  function Mm(t) {
    const e = this, { params: i, slidesEl: n } = e;
    i.loop && e.loopDestroy();
    const r = (o) => {
      if (typeof o == "string") {
        const l = document.createElement("div");
        yt(l, o), n.append(l.children[0]), yt(l, "");
      } else n.append(o);
    };
    if (typeof t == "object" && "length" in t) for (let o = 0; o < t.length; o += 1) t[o] && r(t[o]);
    else r(t);
    e.recalcSlides(), i.loop && e.loopCreate(), (!i.observer || e.isElement) && e.update();
  }
  function Lm(t) {
    const e = this, { params: i, activeIndex: n, slidesEl: r } = e;
    i.loop && e.loopDestroy();
    let o = n + 1;
    const l = (c) => {
      if (typeof c == "string") {
        const d = document.createElement("div");
        yt(d, c), r.prepend(d.children[0]), yt(d, "");
      } else r.prepend(c);
    };
    if (typeof t == "object" && "length" in t) {
      for (let c = 0; c < t.length; c += 1) t[c] && l(t[c]);
      o = n + t.length;
    } else l(t);
    e.recalcSlides(), i.loop && e.loopCreate(), (!i.observer || e.isElement) && e.update(), e.slideTo(o, 0, false);
  }
  function Pm(t, e) {
    const i = this, { params: n, activeIndex: r, slidesEl: o } = i;
    let l = r;
    n.loop && (l -= i.loopedSlides, i.loopDestroy(), i.recalcSlides());
    const c = i.slides.length;
    if (t <= 0) {
      i.prependSlide(e);
      return;
    }
    if (t >= c) {
      i.appendSlide(e);
      return;
    }
    let d = l > t ? l + 1 : l;
    const v = [];
    for (let b = c - 1; b >= t; b -= 1) {
      const y = i.slides[b];
      y.remove(), v.unshift(y);
    }
    if (typeof e == "object" && "length" in e) {
      for (let b = 0; b < e.length; b += 1) e[b] && o.append(e[b]);
      d = l > t ? l + e.length : l;
    } else o.append(e);
    for (let b = 0; b < v.length; b += 1) o.append(v[b]);
    i.recalcSlides(), n.loop && i.loopCreate(), (!n.observer || i.isElement) && i.update(), n.loop ? i.slideTo(d + i.loopedSlides, 0, false) : i.slideTo(d, 0, false);
  }
  function Dm(t) {
    const e = this, { params: i, activeIndex: n } = e;
    let r = n;
    i.loop && (r -= e.loopedSlides, e.loopDestroy());
    let o = r, l;
    if (typeof t == "object" && "length" in t) {
      for (let c = 0; c < t.length; c += 1) l = t[c], e.slides[l] && e.slides[l].remove(), l < o && (o -= 1);
      o = Math.max(o, 0);
    } else l = t, e.slides[l] && e.slides[l].remove(), l < o && (o -= 1), o = Math.max(o, 0);
    e.recalcSlides(), i.loop && e.loopCreate(), (!i.observer || e.isElement) && e.update(), i.loop ? e.slideTo(o + e.loopedSlides, 0, false) : e.slideTo(o, 0, false);
  }
  function $m() {
    const t = this, e = [];
    for (let i = 0; i < t.slides.length; i += 1) e.push(i);
    t.removeSlide(e);
  }
  function zm({ swiper: t }) {
    Object.assign(t, { appendSlide: Mm.bind(t), prependSlide: Lm.bind(t), addSlide: Pm.bind(t), removeSlide: Dm.bind(t), removeAllSlides: $m.bind(t) });
  }
  function zi(t) {
    const { effect: e, swiper: i, on: n, setTranslate: r, setTransition: o, overwriteParams: l, perspective: c, recreateShadows: d, getEffectParams: v } = t;
    n("beforeInit", () => {
      if (i.params.effect !== e) return;
      i.classNames.push(`${i.params.containerModifierClass}${e}`), c && c() && i.classNames.push(`${i.params.containerModifierClass}3d`);
      const y = l ? l() : {};
      Object.assign(i.params, y), Object.assign(i.originalParams, y);
    }), n("setTranslate _virtualUpdated", () => {
      i.params.effect === e && r();
    }), n("setTransition", (y, _) => {
      i.params.effect === e && o(_);
    }), n("transitionEnd", () => {
      if (i.params.effect === e && d) {
        if (!v || !v().slideShadows) return;
        i.slides.forEach((y) => {
          y.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((_) => _.remove());
        }), d();
      }
    });
    let b;
    n("virtualUpdate", () => {
      i.params.effect === e && (i.slides.length || (b = true), requestAnimationFrame(() => {
        b && i.slides && i.slides.length && (r(), b = false);
      }));
    });
  }
  function nn(t, e) {
    const i = ri(e);
    return i !== e && (i.style.backfaceVisibility = "hidden", i.style["-webkit-backface-visibility"] = "hidden"), i;
  }
  function Kn({ swiper: t, duration: e, transformElements: i, allSlides: n }) {
    const { activeIndex: r } = t, o = (l) => l.parentElement ? l.parentElement : t.slides.find((d) => d.shadowRoot && d.shadowRoot === l.parentNode);
    if (t.params.virtualTranslate && e !== 0) {
      let l = false, c;
      n ? c = i : c = i.filter((d) => {
        const v = d.classList.contains("swiper-slide-transform") ? o(d) : d;
        return t.getSlideIndex(v) === r;
      }), c.forEach((d) => {
        Ui(d, () => {
          if (l || !t || t.destroyed) return;
          l = true, t.animating = false;
          const v = new window.CustomEvent("transitionend", { bubbles: true, cancelable: true });
          t.wrapperEl.dispatchEvent(v);
        });
      });
    }
  }
  function km({ swiper: t, extendParams: e, on: i }) {
    e({ fadeEffect: { crossFade: false } }), zi({ effect: "fade", swiper: t, on: i, setTranslate: () => {
      const { slides: o } = t, l = t.params.fadeEffect;
      for (let c = 0; c < o.length; c += 1) {
        const d = t.slides[c];
        let b = -d.swiperSlideOffset;
        t.params.virtualTranslate || (b -= t.translate);
        let y = 0;
        t.isHorizontal() || (y = b, b = 0);
        const _ = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(d.progress), 0) : 1 + Math.min(Math.max(d.progress, -1), 0), p = nn(l, d);
        p.style.opacity = _, p.style.transform = `translate3d(${b}px, ${y}px, 0px)`;
      }
    }, setTransition: (o) => {
      const l = t.slides.map((c) => ri(c));
      l.forEach((c) => {
        c.style.transitionDuration = `${o}ms`;
      }), Kn({ swiper: t, duration: o, transformElements: l, allSlides: true });
    }, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, spaceBetween: 0, virtualTranslate: !t.params.cssMode }) });
  }
  function Nm({ swiper: t, extendParams: e, on: i }) {
    e({ cubeEffect: { slideShadows: true, shadow: true, shadowOffset: 20, shadowScale: 0.94 } });
    const n = (c, d, v) => {
      let b = v ? c.querySelector(".swiper-slide-shadow-left") : c.querySelector(".swiper-slide-shadow-top"), y = v ? c.querySelector(".swiper-slide-shadow-right") : c.querySelector(".swiper-slide-shadow-bottom");
      b || (b = Ye("div", `swiper-slide-shadow-cube swiper-slide-shadow-${v ? "left" : "top"}`.split(" ")), c.append(b)), y || (y = Ye("div", `swiper-slide-shadow-cube swiper-slide-shadow-${v ? "right" : "bottom"}`.split(" ")), c.append(y)), b && (b.style.opacity = Math.max(-d, 0)), y && (y.style.opacity = Math.max(d, 0));
    };
    zi({ effect: "cube", swiper: t, on: i, setTranslate: () => {
      const { el: c, wrapperEl: d, slides: v, width: b, height: y, rtlTranslate: _, size: p, browser: m } = t, C = Un(t), S = t.params.cubeEffect, h = t.isHorizontal(), E = t.virtual && t.params.virtual.enabled;
      let I = 0, O;
      S.shadow && (h ? (O = t.wrapperEl.querySelector(".swiper-cube-shadow"), O || (O = Ye("div", "swiper-cube-shadow"), t.wrapperEl.append(O)), O.style.height = `${b}px`) : (O = c.querySelector(".swiper-cube-shadow"), O || (O = Ye("div", "swiper-cube-shadow"), c.append(O))));
      for (let f = 0; f < v.length; f += 1) {
        const P = v[f];
        let D = f;
        E && (D = parseInt(P.getAttribute("data-swiper-slide-index"), 10));
        let H = D * 90, k = Math.floor(H / 360);
        _ && (H = -H, k = Math.floor(-H / 360));
        const z = Math.max(Math.min(P.progress, 1), -1);
        let B = 0, V = 0, X = 0;
        D % 4 === 0 ? (B = -k * 4 * p, X = 0) : (D - 1) % 4 === 0 ? (B = 0, X = -k * 4 * p) : (D - 2) % 4 === 0 ? (B = p + k * 4 * p, X = p) : (D - 3) % 4 === 0 && (B = -p, X = 3 * p + p * 4 * k), _ && (B = -B), h || (V = B, B = 0);
        const Z = `rotateX(${C(h ? 0 : -H)}deg) rotateY(${C(h ? H : 0)}deg) translate3d(${B}px, ${V}px, ${X}px)`;
        z <= 1 && z > -1 && (I = D * 90 + z * 90, _ && (I = -D * 90 - z * 90)), P.style.transform = Z, S.slideShadows && n(P, z, h);
      }
      if (d.style.transformOrigin = `50% 50% -${p / 2}px`, d.style["-webkit-transform-origin"] = `50% 50% -${p / 2}px`, S.shadow) if (h) O.style.transform = `translate3d(0px, ${b / 2 + S.shadowOffset}px, ${-b / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${S.shadowScale})`;
      else {
        const f = Math.abs(I) - Math.floor(Math.abs(I) / 90) * 90, P = 1.5 - (Math.sin(f * 2 * Math.PI / 360) / 2 + Math.cos(f * 2 * Math.PI / 360) / 2), D = S.shadowScale, H = S.shadowScale / P, k = S.shadowOffset;
        O.style.transform = `scale3d(${D}, 1, ${H}) translate3d(0px, ${y / 2 + k}px, ${-y / 2 / H}px) rotateX(-89.99deg)`;
      }
      const L = (m.isSafari || m.isWebView) && m.needPerspectiveFix ? -p / 2 : 0;
      d.style.transform = `translate3d(0px,0,${L}px) rotateX(${C(t.isHorizontal() ? 0 : I)}deg) rotateY(${C(t.isHorizontal() ? -I : 0)}deg)`, d.style.setProperty("--swiper-cube-translate-z", `${L}px`);
    }, setTransition: (c) => {
      const { el: d, slides: v } = t;
      if (v.forEach((b) => {
        b.style.transitionDuration = `${c}ms`, b.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((y) => {
          y.style.transitionDuration = `${c}ms`;
        });
      }), t.params.cubeEffect.shadow && !t.isHorizontal()) {
        const b = d.querySelector(".swiper-cube-shadow");
        b && (b.style.transitionDuration = `${c}ms`);
      }
    }, recreateShadows: () => {
      const c = t.isHorizontal();
      t.slides.forEach((d) => {
        const v = Math.max(Math.min(d.progress, 1), -1);
        n(d, v, c);
      });
    }, getEffectParams: () => t.params.cubeEffect, perspective: () => true, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, resistanceRatio: 0, spaceBetween: 0, centeredSlides: false, virtualTranslate: true }) });
  }
  function Li(t, e, i) {
    const n = `swiper-slide-shadow${i ? `-${i}` : ""}${t ? ` swiper-slide-shadow-${t}` : ""}`, r = ri(e);
    let o = r.querySelector(`.${n.split(" ").join(".")}`);
    return o || (o = Ye("div", n.split(" ")), r.append(o)), o;
  }
  function Rm({ swiper: t, extendParams: e, on: i }) {
    e({ flipEffect: { slideShadows: true, limitRotation: true } });
    const n = (c, d) => {
      let v = t.isHorizontal() ? c.querySelector(".swiper-slide-shadow-left") : c.querySelector(".swiper-slide-shadow-top"), b = t.isHorizontal() ? c.querySelector(".swiper-slide-shadow-right") : c.querySelector(".swiper-slide-shadow-bottom");
      v || (v = Li("flip", c, t.isHorizontal() ? "left" : "top")), b || (b = Li("flip", c, t.isHorizontal() ? "right" : "bottom")), v && (v.style.opacity = Math.max(-d, 0)), b && (b.style.opacity = Math.max(d, 0));
    };
    zi({ effect: "flip", swiper: t, on: i, setTranslate: () => {
      const { slides: c, rtlTranslate: d } = t, v = t.params.flipEffect, b = Un(t);
      for (let y = 0; y < c.length; y += 1) {
        const _ = c[y];
        let p = _.progress;
        t.params.flipEffect.limitRotation && (p = Math.max(Math.min(_.progress, 1), -1));
        const m = _.swiperSlideOffset;
        let S = -180 * p, h = 0, E = t.params.cssMode ? -m - t.translate : -m, I = 0;
        t.isHorizontal() ? d && (S = -S) : (I = E, E = 0, h = -S, S = 0), _.style.zIndex = -Math.abs(Math.round(p)) + c.length, v.slideShadows && n(_, p);
        const O = `translate3d(${E}px, ${I}px, 0px) rotateX(${b(h)}deg) rotateY(${b(S)}deg)`, L = nn(v, _);
        L.style.transform = O;
      }
    }, setTransition: (c) => {
      const d = t.slides.map((v) => ri(v));
      d.forEach((v) => {
        v.style.transitionDuration = `${c}ms`, v.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((b) => {
          b.style.transitionDuration = `${c}ms`;
        });
      }), Kn({ swiper: t, duration: c, transformElements: d });
    }, recreateShadows: () => {
      t.params.flipEffect, t.slides.forEach((c) => {
        let d = c.progress;
        t.params.flipEffect.limitRotation && (d = Math.max(Math.min(c.progress, 1), -1)), n(c, d);
      });
    }, getEffectParams: () => t.params.flipEffect, perspective: () => true, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, spaceBetween: 0, virtualTranslate: !t.params.cssMode }) });
  }
  function Hm({ swiper: t, extendParams: e, on: i }) {
    e({ coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: true } }), zi({ effect: "coverflow", swiper: t, on: i, setTranslate: () => {
      const { width: o, height: l, slides: c, slidesSizesGrid: d } = t, v = t.params.coverflowEffect, b = t.isHorizontal(), y = t.translate, _ = b ? -y + o / 2 : -y + l / 2, p = b ? v.rotate : -v.rotate, m = v.depth, C = Un(t);
      for (let S = 0, h = c.length; S < h; S += 1) {
        const E = c[S], I = d[S], O = E.swiperSlideOffset, L = (_ - O - I / 2) / I, f = typeof v.modifier == "function" ? v.modifier(L) : L * v.modifier;
        let P = b ? p * f : 0, D = b ? 0 : p * f, H = -m * Math.abs(f), k = v.stretch;
        typeof k == "string" && k.indexOf("%") !== -1 && (k = parseFloat(v.stretch) / 100 * I);
        let z = b ? 0 : k * f, B = b ? k * f : 0, V = 1 - (1 - v.scale) * Math.abs(f);
        Math.abs(B) < 1e-3 && (B = 0), Math.abs(z) < 1e-3 && (z = 0), Math.abs(H) < 1e-3 && (H = 0), Math.abs(P) < 1e-3 && (P = 0), Math.abs(D) < 1e-3 && (D = 0), Math.abs(V) < 1e-3 && (V = 0);
        const X = `translate3d(${B}px,${z}px,${H}px)  rotateX(${C(D)}deg) rotateY(${C(P)}deg) scale(${V})`, Z = nn(v, E);
        if (Z.style.transform = X, E.style.zIndex = -Math.abs(Math.round(f)) + 1, v.slideShadows) {
          let F = b ? E.querySelector(".swiper-slide-shadow-left") : E.querySelector(".swiper-slide-shadow-top"), W = b ? E.querySelector(".swiper-slide-shadow-right") : E.querySelector(".swiper-slide-shadow-bottom");
          F || (F = Li("coverflow", E, b ? "left" : "top")), W || (W = Li("coverflow", E, b ? "right" : "bottom")), F && (F.style.opacity = f > 0 ? f : 0), W && (W.style.opacity = -f > 0 ? -f : 0);
        }
      }
    }, setTransition: (o) => {
      t.slides.map((c) => ri(c)).forEach((c) => {
        c.style.transitionDuration = `${o}ms`, c.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((d) => {
          d.style.transitionDuration = `${o}ms`;
        });
      });
    }, perspective: () => true, overwriteParams: () => ({ watchSlidesProgress: true }) });
  }
  function Bm({ swiper: t, extendParams: e, on: i }) {
    e({ creativeEffect: { limitProgress: 1, shadowPerProgress: false, progressMultiplier: 1, perspective: true, prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 }, next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 } } });
    const n = (l) => typeof l == "string" ? l : `${l}px`;
    zi({ effect: "creative", swiper: t, on: i, setTranslate: () => {
      const { slides: l, wrapperEl: c, slidesSizesGrid: d } = t, v = t.params.creativeEffect, { progressMultiplier: b } = v, y = t.params.centeredSlides, _ = Un(t);
      if (y) {
        const p = d[0] / 2 - t.params.slidesOffsetBefore || 0;
        c.style.transform = `translateX(calc(50% - ${p}px))`;
      }
      for (let p = 0; p < l.length; p += 1) {
        const m = l[p], C = m.progress, S = Math.min(Math.max(m.progress, -v.limitProgress), v.limitProgress);
        let h = S;
        y || (h = Math.min(Math.max(m.originalProgress, -v.limitProgress), v.limitProgress));
        const E = m.swiperSlideOffset, I = [t.params.cssMode ? -E - t.translate : -E, 0, 0], O = [0, 0, 0];
        let L = false;
        t.isHorizontal() || (I[1] = I[0], I[0] = 0);
        let f = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 };
        S < 0 ? (f = v.next, L = true) : S > 0 && (f = v.prev, L = true), I.forEach((V, X) => {
          I[X] = `calc(${V}px + (${n(f.translate[X])} * ${Math.abs(S * b)}))`;
        }), O.forEach((V, X) => {
          let Z = f.rotate[X] * Math.abs(S * b);
          O[X] = Z;
        }), m.style.zIndex = -Math.abs(Math.round(C)) + l.length;
        const P = I.join(", "), D = `rotateX(${_(O[0])}deg) rotateY(${_(O[1])}deg) rotateZ(${_(O[2])}deg)`, H = h < 0 ? `scale(${1 + (1 - f.scale) * h * b})` : `scale(${1 - (1 - f.scale) * h * b})`, k = h < 0 ? 1 + (1 - f.opacity) * h * b : 1 - (1 - f.opacity) * h * b, z = `translate3d(${P}) ${D} ${H}`;
        if (L && f.shadow || !L) {
          let V = m.querySelector(".swiper-slide-shadow");
          if (!V && f.shadow && (V = Li("creative", m)), V) {
            const X = v.shadowPerProgress ? S * (1 / v.limitProgress) : S;
            V.style.opacity = Math.min(Math.max(Math.abs(X), 0), 1);
          }
        }
        const B = nn(v, m);
        B.style.transform = z, B.style.opacity = k, f.origin && (B.style.transformOrigin = f.origin);
      }
    }, setTransition: (l) => {
      const c = t.slides.map((d) => ri(d));
      c.forEach((d) => {
        d.style.transitionDuration = `${l}ms`, d.querySelectorAll(".swiper-slide-shadow").forEach((v) => {
          v.style.transitionDuration = `${l}ms`;
        });
      }), Kn({ swiper: t, duration: l, transformElements: c, allSlides: true });
    }, perspective: () => t.params.creativeEffect.perspective, overwriteParams: () => ({ watchSlidesProgress: true, virtualTranslate: !t.params.cssMode }) });
  }
  function Vm({ swiper: t, extendParams: e, on: i }) {
    e({ cardsEffect: { slideShadows: true, rotate: true, perSlideRotate: 2, perSlideOffset: 8 } }), zi({ effect: "cards", swiper: t, on: i, setTranslate: () => {
      const { slides: o, activeIndex: l, rtlTranslate: c } = t, d = t.params.cardsEffect, { startTranslate: v, isTouched: b } = t.touchEventsData, y = c ? -t.translate : t.translate;
      for (let _ = 0; _ < o.length; _ += 1) {
        const p = o[_], m = p.progress, C = Math.min(Math.max(m, -4), 4);
        let S = p.swiperSlideOffset;
        t.params.centeredSlides && !t.params.cssMode && (t.wrapperEl.style.transform = `translateX(${t.minTranslate()}px)`), t.params.centeredSlides && t.params.cssMode && (S -= o[0].swiperSlideOffset);
        let h = t.params.cssMode ? -S - t.translate : -S, E = 0;
        const I = -100 * Math.abs(C);
        let O = 1, L = -d.perSlideRotate * C, f = d.perSlideOffset - Math.abs(C) * 0.75;
        const P = t.virtual && t.params.virtual.enabled ? t.virtual.from + _ : _, D = (P === l || P === l - 1) && C > 0 && C < 1 && (b || t.params.cssMode) && y < v, H = (P === l || P === l + 1) && C < 0 && C > -1 && (b || t.params.cssMode) && y > v;
        if (D || H) {
          const V = De(1 - Math.abs((Math.abs(C) - 0.5) / 0.5), 0.5);
          L += -28 * C * V, O += -0.5 * V, f += 96 * V, E = `${(d.rotate || t.isHorizontal() ? -25 : 0) * V * Math.abs(C)}%`;
        }
        if (C < 0 ? h = `calc(${h}px ${c ? "-" : "+"} (${f * Math.abs(C)}%))` : C > 0 ? h = `calc(${h}px ${c ? "-" : "+"} (-${f * Math.abs(C)}%))` : h = `${h}px`, !t.isHorizontal()) {
          const V = E;
          E = h, h = V;
        }
        const k = C < 0 ? `${1 + (1 - O) * C}` : `${1 - (1 - O) * C}`, z = `
        translate3d(${h}, ${E}, ${I}px)
        rotateZ(${d.rotate ? c ? -L : L : 0}deg)
        scale(${k})
      `;
        if (d.slideShadows) {
          let V = p.querySelector(".swiper-slide-shadow");
          V || (V = Li("cards", p)), V && (V.style.opacity = Math.min(Math.max((Math.abs(C) - 0.5) / 0.5, 0), 1));
        }
        p.style.zIndex = -Math.abs(Math.round(m)) + o.length;
        const B = nn(d, p);
        B.style.transform = z;
      }
    }, setTransition: (o) => {
      const l = t.slides.map((c) => ri(c));
      l.forEach((c) => {
        c.style.transitionDuration = `${o}ms`, c.querySelectorAll(".swiper-slide-shadow").forEach((d) => {
          d.style.transitionDuration = `${o}ms`;
        });
      }), Kn({ swiper: t, duration: o, transformElements: l });
    }, perspective: () => true, overwriteParams: () => ({ _loopSwapReset: false, watchSlidesProgress: true, loopAdditionalSlides: t.params.cardsEffect.rotate ? 3 : 2, centeredSlides: true, virtualTranslate: !t.params.cssMode }) });
  }
  const Wm = [pm, gm, mm, vm, ym, bm, Em, Tm, _m, Sm, xm, Cm, Im, Am, wm, Om, zm, km, Nm, Rm, Hm, Bm, Vm];
  Be.use(Wm);
  function Fm(t) {
    const { effect: e, swiper: i, on: n, setTranslate: r, setTransition: o, overwriteParams: l, perspective: c, recreateShadows: d, getEffectParams: v } = t;
    n("beforeInit", () => {
      if (i.params.effect !== e) return;
      i.classNames.push(`${i.params.containerModifierClass}${e}`), c && c() && i.classNames.push(`${i.params.containerModifierClass}3d`);
      const y = l ? l() : {};
      Object.assign(i.params, y), Object.assign(i.originalParams, y);
    }), n("setTranslate _virtualUpdated", () => {
      i.params.effect === e && r();
    }), n("setTransition", (y, _) => {
      i.params.effect === e && o(_);
    }), n("transitionEnd", () => {
      if (i.params.effect === e && d) {
        if (!v || !v().slideShadows) return;
        i.slides.forEach((y) => {
          y.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((_) => _.remove());
        }), d();
      }
    });
    let b;
    n("virtualUpdate", () => {
      i.params.effect === e && (i.slides.length || (b = true), requestAnimationFrame(() => {
        b && i.slides && i.slides.length && (r(), b = false);
      }));
    });
  }
  function Gm(t) {
    return t.querySelector(".swiper-slide-transform") || t.shadowRoot && t.shadowRoot.querySelector(".swiper-slide-transform") || t;
  }
  function jm(t, e) {
    function i(n) {
      n.target === t && (e.call(t, n), t.removeEventListener("transitionend", i));
    }
    e && t.addEventListener("transitionend", i);
  }
  function Ym({ swiper: t, duration: e, transformElements: i, allSlides: n }) {
    const { activeIndex: r } = t;
    if (t.params.virtualTranslate && e !== 0) {
      let o = false, l;
      l = i, l.forEach((c) => {
        jm(c, () => {
          if (o || !t || t.destroyed) return;
          o = true, t.animating = false;
          const d = new window.CustomEvent("transitionend", { bubbles: true, cancelable: true });
          t.wrapperEl.dispatchEvent(d);
        });
      });
    }
  }
  function Xm({ swiper: t, extendParams: e, on: i }) {
    e({ stackLiftEffect: {} });
    const n = () => {
      const { slides: c } = t, d = Math.round(c.length > 0 ? c[0].progress : 0), v = c.length;
      for (let b = 0; b < v; b += 1) {
        const y = c[b];
        let p = -y.swiperSlideOffset;
        t.params.virtualTranslate || (p -= t.translate);
        let m = b - d;
        m < 0 && (m += v);
        let C = o(m), S = r(y, m);
        y.style.setProperty("--swiper-stack-lift-translate-x", `${p}px`), y.style.setProperty("--swiper-stack-lift-translate-y", `${C}px`), y.style.setProperty("--swiper-stack-lift-scale", S), y.style.setProperty("--swiper-stack-lift-z-index", v - m), m === 0 ? y.style.setProperty("--swiper-stack-lift-opacity", 0) : y.style.setProperty("--swiper-stack-lift-opacity", 1), y.dataset.sliderIndex = m;
      }
    };
    function r(c, d) {
      return (c.offsetWidth - 64 * d) / (c.offsetWidth * 1);
    }
    function o(c) {
      return c === 0 ? 0 : c === 1 ? 15 : 15 + (c - 1) * 12;
    }
    Fm({ effect: "stack-lift", swiper: t, on: i, setTranslate: n, setTransition: (c) => {
      const d = t.slides.map((v) => Gm(v));
      d.forEach((v) => {
        v.style.transitionDuration = `${c}ms`;
      }), Ym({ swiper: t, duration: c, transformElements: d, allSlides: true });
    }, perspective: () => true, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0, watchSlidesProgress: true, centeredSlides: false, speed: 700, virtualTranslate: !t.params.cssMode }) });
  }
  Be.use([Xm]);
  window.GSP = window.GSP || {};
  window.GSP.Swiper = { Swiper: Be };
  function qm(t, e, i) {
    if (t == null) return [];
    if (t instanceof EventTarget) return [t];
    if (typeof t == "string") {
      const r = document.querySelectorAll(t);
      return r ? Array.from(r) : [];
    }
    return Array.from(t).filter((n) => n != null);
  }
  const Um = { some: 0, all: 1 };
  function Km(t, e, { root: i, margin: n, amount: r = "some" } = {}) {
    const o = qm(t), l = /* @__PURE__ */ new WeakMap(), c = (v) => {
      v.forEach((b) => {
        const y = l.get(b.target);
        if (b.isIntersecting !== !!y) if (b.isIntersecting) {
          const _ = e(b.target, b);
          typeof _ == "function" ? l.set(b.target, _) : d.unobserve(b.target);
        } else typeof y == "function" && (y(b), l.delete(b.target));
      });
    }, d = new IntersectionObserver(c, { root: i, rootMargin: n, threshold: typeof r == "number" ? r : Um[r] });
    return o.forEach((v) => d.observe(v)), () => d.disconnect();
  }
  window.GSP = window.GSP || {};
  window.GSP.Motion = { inView: Km };
  var Nn = function() {
    return Nn = Object.assign || function(t) {
      for (var e, i = 1, n = arguments.length; i < n; i++) for (var r in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      return t;
    }, Nn.apply(this, arguments);
  }, Zm = (function() {
    function t(e, i, n) {
      var r = this;
      this.endVal = i, this.options = n, this.version = "2.10.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: true, useGrouping: true, useIndianSeparators: false, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", autoAnimate: false, autoAnimateDelay: 200, autoAnimateOnce: false }, this.finalEndVal = null, this.useEasing = true, this.countDown = false, this.error = "", this.startVal = 0, this.paused = true, this.once = false, this.count = function(o) {
        r.startTime || (r.startTime = o);
        var l = o - r.startTime;
        r.remaining = r.duration - l, r.useEasing ? r.countDown ? r.frameVal = r.startVal - r.easingFn(l, 0, r.startVal - r.endVal, r.duration) : r.frameVal = r.easingFn(l, r.startVal, r.endVal - r.startVal, r.duration) : r.frameVal = r.startVal + (r.endVal - r.startVal) * (l / r.duration);
        var c = r.countDown ? r.frameVal < r.endVal : r.frameVal > r.endVal;
        r.frameVal = c ? r.endVal : r.frameVal, r.frameVal = Number(r.frameVal.toFixed(r.options.decimalPlaces)), r.printValue(r.frameVal), l < r.duration ? r.rAF = requestAnimationFrame(r.count) : r.finalEndVal !== null ? r.update(r.finalEndVal) : r.options.onCompleteCallback && r.options.onCompleteCallback();
      }, this.formatNumber = function(o) {
        var l, c, d, v, b = o < 0 ? "-" : "";
        l = Math.abs(o).toFixed(r.options.decimalPlaces);
        var y = (l += "").split(".");
        if (c = y[0], d = y.length > 1 ? r.options.decimal + y[1] : "", r.options.useGrouping) {
          v = "";
          for (var _ = 3, p = 0, m = 0, C = c.length; m < C; ++m) r.options.useIndianSeparators && m === 4 && (_ = 2, p = 1), m !== 0 && p % _ == 0 && (v = r.options.separator + v), p++, v = c[C - m - 1] + v;
          c = v;
        }
        return r.options.numerals && r.options.numerals.length && (c = c.replace(/[0-9]/g, (function(S) {
          return r.options.numerals[+S];
        })), d = d.replace(/[0-9]/g, (function(S) {
          return r.options.numerals[+S];
        }))), b + r.options.prefix + c + d + r.options.suffix;
      }, this.easeOutExpo = function(o, l, c, d) {
        return c * (1 - Math.pow(2, -10 * o / d)) * 1024 / 1023 + l;
      }, this.options = Nn(Nn({}, this.defaults), n), this.options.enableScrollSpy && (this.options.autoAnimate = true), this.options.scrollSpyDelay !== void 0 && (this.options.autoAnimateDelay = this.options.scrollSpyDelay), this.options.scrollSpyOnce && (this.options.autoAnimateOnce = true), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.el = typeof e == "string" ? document.getElementById(e) : e, i = i == null ? this.parse(this.el.innerHTML) : i, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(i), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = false), this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window != "undefined" && this.options.autoAnimate && (this.error || typeof IntersectionObserver == "undefined" ? this.error ? console.error(this.error, e) : console.error("IntersectionObserver is not supported by this browser") : this.setupObserver());
    }
    return t.prototype.setupObserver = function() {
      var e = this, i = t.observedElements.get(this.el);
      i && i.unobserve(), t.observedElements.set(this.el, this), this.observer = new IntersectionObserver((function(n) {
        for (var r = 0, o = n; r < o.length; r++) {
          var l = o[r];
          l.isIntersecting && e.paused && !e.once ? (e.paused = false, e.autoAnimateTimeout = setTimeout((function() {
            return e.start();
          }), e.options.autoAnimateDelay), e.options.autoAnimateOnce && (e.once = true, e.observer.disconnect())) : l.isIntersecting || e.paused || (clearTimeout(e.autoAnimateTimeout), e.reset());
        }
      }), { threshold: 0 }), this.observer.observe(this.el);
    }, t.prototype.unobserve = function() {
      var e;
      clearTimeout(this.autoAnimateTimeout), (e = this.observer) === null || e === void 0 || e.disconnect(), t.observedElements.delete(this.el);
    }, t.prototype.onDestroy = function() {
      clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = true, this.unobserve(), this.options.onCompleteCallback = null, this.options.onStartCallback = null;
    }, t.prototype.determineDirectionAndSmartEasing = function() {
      var e = this.finalEndVal ? this.finalEndVal : this.endVal;
      this.countDown = this.startVal > e;
      var i = e - this.startVal;
      if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
        this.finalEndVal = e;
        var n = this.countDown ? 1 : -1;
        this.endVal = e + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
      } else this.endVal = e, this.finalEndVal = null;
      this.finalEndVal !== null ? this.useEasing = false : this.useEasing = this.options.useEasing;
    }, t.prototype.start = function(e) {
      this.error || (this.options.onStartCallback && this.options.onStartCallback(), e && (this.options.onCompleteCallback = e), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = false, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, t.prototype.pauseResume = function() {
      this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, t.prototype.reset = function() {
      clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = true, this.once = false, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, t.prototype.update = function(e) {
      cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(e), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, t.prototype.printValue = function(e) {
      var i;
      if (this.el) {
        var n = this.formattingFn(e);
        !((i = this.options.plugin) === null || i === void 0) && i.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
      }
    }, t.prototype.ensureNumber = function(e) {
      return typeof e == "number" && !isNaN(e);
    }, t.prototype.validateValue = function(e) {
      var i = Number(e);
      return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(e), null);
    }, t.prototype.resetDuration = function() {
      this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, t.prototype.parse = function(e) {
      var i = function(l) {
        return l.replace(/([.,'  ])/g, "\\$1");
      }, n = i(this.options.separator), r = i(this.options.decimal), o = e.replace(new RegExp(n, "g"), "").replace(new RegExp(r, "g"), ".");
      return parseFloat(o);
    }, t.observedElements = /* @__PURE__ */ new WeakMap(), t;
  })();
  window.CountUp = Zm;
  function Qm(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
  }
  var Ws = { exports: {} }, Fs = { exports: {} }, Mn = { exports: {} }, Jm = Mn.exports, ha;
  function Hl() {
    return ha || (ha = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i() : e.EvEmitter = i();
      })(typeof window != "undefined" ? window : Jm, function() {
        function e() {
        }
        var i = e.prototype;
        return i.on = function(n, r) {
          if (!(!n || !r)) {
            var o = this._events = this._events || {}, l = o[n] = o[n] || [];
            return l.indexOf(r) == -1 && l.push(r), this;
          }
        }, i.once = function(n, r) {
          if (!(!n || !r)) {
            this.on(n, r);
            var o = this._onceEvents = this._onceEvents || {}, l = o[n] = o[n] || {};
            return l[r] = true, this;
          }
        }, i.off = function(n, r) {
          var o = this._events && this._events[n];
          if (!(!o || !o.length)) {
            var l = o.indexOf(r);
            return l != -1 && o.splice(l, 1), this;
          }
        }, i.emitEvent = function(n, r) {
          var o = this._events && this._events[n];
          if (!(!o || !o.length)) {
            o = o.slice(0), r = r || [];
            for (var l = this._onceEvents && this._onceEvents[n], c = 0; c < o.length; c++) {
              var d = o[c], v = l && l[d];
              v && (this.off(n, d), delete l[d]), d.apply(this, r);
            }
            return this;
          }
        }, i.allOff = function() {
          delete this._events, delete this._onceEvents;
        }, e;
      });
    })(Mn)), Mn.exports;
  }
  var Gs = { exports: {} };
  var pa;
  function sn() {
    return pa || (pa = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i() : e.getSize = i();
      })(window, function() {
        function i(p) {
          var m = parseFloat(p), C = p.indexOf("%") == -1 && !isNaN(m);
          return C && m;
        }
        function n() {
        }
        var r = typeof console == "undefined" ? n : function(p) {
          console.error(p);
        }, o = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"], l = o.length;
        function c() {
          for (var p = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, m = 0; m < l; m++) {
            var C = o[m];
            p[C] = 0;
          }
          return p;
        }
        function d(p) {
          var m = getComputedStyle(p);
          return m || r("Style returned " + m + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), m;
        }
        var v = false, b;
        function y() {
          if (!v) {
            v = true;
            var p = document.createElement("div");
            p.style.width = "200px", p.style.padding = "1px 2px 3px 4px", p.style.borderStyle = "solid", p.style.borderWidth = "1px 2px 3px 4px", p.style.boxSizing = "border-box";
            var m = document.body || document.documentElement;
            m.appendChild(p);
            var C = d(p);
            b = Math.round(i(C.width)) == 200, _.isBoxSizeOuter = b, m.removeChild(p);
          }
        }
        function _(p) {
          if (y(), typeof p == "string" && (p = document.querySelector(p)), !(!p || typeof p != "object" || !p.nodeType)) {
            var m = d(p);
            if (m.display == "none") return c();
            var C = {};
            C.width = p.offsetWidth, C.height = p.offsetHeight;
            for (var S = C.isBorderBox = m.boxSizing == "border-box", h = 0; h < l; h++) {
              var E = o[h], I = m[E], O = parseFloat(I);
              C[E] = isNaN(O) ? 0 : O;
            }
            var L = C.paddingLeft + C.paddingRight, f = C.paddingTop + C.paddingBottom, P = C.marginLeft + C.marginRight, D = C.marginTop + C.marginBottom, H = C.borderLeftWidth + C.borderRightWidth, k = C.borderTopWidth + C.borderBottomWidth, z = S && b, B = i(m.width);
            B !== false && (C.width = B + (z ? 0 : L + H));
            var V = i(m.height);
            return V !== false && (C.height = V + (z ? 0 : f + k)), C.innerWidth = C.width - (L + H), C.innerHeight = C.height - (f + k), C.outerWidth = C.width + P, C.outerHeight = C.height + D, C;
          }
        }
        return _;
      });
    })(Gs)), Gs.exports;
  }
  var js = { exports: {} }, Ys = { exports: {} }, ga;
  function Bl() {
    return ga || (ga = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i() : e.matchesSelector = i();
      })(window, function() {
        var i = (function() {
          var n = window.Element.prototype;
          if (n.matches) return "matches";
          if (n.matchesSelector) return "matchesSelector";
          for (var r = ["webkit", "moz", "ms", "o"], o = 0; o < r.length; o++) {
            var l = r[o], c = l + "MatchesSelector";
            if (n[c]) return c;
          }
        })();
        return function(r, o) {
          return r[i](o);
        };
      });
    })(Ys)), Ys.exports;
  }
  var ma;
  function Vl() {
    return ma || (ma = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i(e, Bl()) : e.fizzyUIUtils = i(e, e.matchesSelector);
      })(window, function(i, n) {
        var r = {};
        r.extend = function(c, d) {
          for (var v in d) c[v] = d[v];
          return c;
        }, r.modulo = function(c, d) {
          return (c % d + d) % d;
        };
        var o = Array.prototype.slice;
        r.makeArray = function(c) {
          if (Array.isArray(c)) return c;
          if (c == null) return [];
          var d = typeof c == "object" && typeof c.length == "number";
          return d ? o.call(c) : [c];
        }, r.removeFrom = function(c, d) {
          var v = c.indexOf(d);
          v != -1 && c.splice(v, 1);
        }, r.getParent = function(c, d) {
          for (; c.parentNode && c != document.body; ) if (c = c.parentNode, n(c, d)) return c;
        }, r.getQueryElement = function(c) {
          return typeof c == "string" ? document.querySelector(c) : c;
        }, r.handleEvent = function(c) {
          var d = "on" + c.type;
          this[d] && this[d](c);
        }, r.filterFindElements = function(c, d) {
          c = r.makeArray(c);
          var v = [];
          return c.forEach(function(b) {
            if (b instanceof HTMLElement) {
              if (!d) {
                v.push(b);
                return;
              }
              n(b, d) && v.push(b);
              for (var y = b.querySelectorAll(d), _ = 0; _ < y.length; _++) v.push(y[_]);
            }
          }), v;
        }, r.debounceMethod = function(c, d, v) {
          v = v || 100;
          var b = c.prototype[d], y = d + "Timeout";
          c.prototype[d] = function() {
            var _ = this[y];
            clearTimeout(_);
            var p = arguments, m = this;
            this[y] = setTimeout(function() {
              b.apply(m, p), delete m[y];
            }, v);
          };
        }, r.docReady = function(c) {
          var d = document.readyState;
          d == "complete" || d == "interactive" ? setTimeout(c) : document.addEventListener("DOMContentLoaded", c);
        }, r.toDashed = function(c) {
          return c.replace(/(.)([A-Z])/g, function(d, v, b) {
            return v + "-" + b;
          }).toLowerCase();
        };
        var l = i.console;
        return r.htmlInit = function(c, d) {
          r.docReady(function() {
            var v = r.toDashed(d), b = "data-" + v, y = document.querySelectorAll("[" + b + "]"), _ = document.querySelectorAll(".js-" + v), p = r.makeArray(y).concat(r.makeArray(_)), m = b + "-options", C = i.jQuery;
            p.forEach(function(S) {
              var h = S.getAttribute(b) || S.getAttribute(m), E;
              try {
                E = h && JSON.parse(h);
              } catch (O) {
                l && l.error("Error parsing " + b + " on " + S.className + ": " + O);
                return;
              }
              var I = new c(S, E);
              C && C.data(S, d, I);
            });
          });
        }, r;
      });
    })(js)), js.exports;
  }
  var Xs = { exports: {} }, va;
  function ev() {
    return va || (va = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i(Hl(), sn()) : (e.Outlayer = {}, e.Outlayer.Item = i(e.EvEmitter, e.getSize));
      })(window, function(i, n) {
        function r(S) {
          for (var h in S) return false;
          return h = null, true;
        }
        var o = document.documentElement.style, l = typeof o.transition == "string" ? "transition" : "WebkitTransition", c = typeof o.transform == "string" ? "transform" : "WebkitTransform", d = { WebkitTransition: "webkitTransitionEnd", transition: "transitionend" }[l], v = { transform: c, transition: l, transitionDuration: l + "Duration", transitionProperty: l + "Property", transitionDelay: l + "Delay" };
        function b(S, h) {
          S && (this.element = S, this.layout = h, this.position = { x: 0, y: 0 }, this._create());
        }
        var y = b.prototype = Object.create(i.prototype);
        y.constructor = b, y._create = function() {
          this._transn = { ingProperties: {}, clean: {}, onEnd: {} }, this.css({ position: "absolute" });
        }, y.handleEvent = function(S) {
          var h = "on" + S.type;
          this[h] && this[h](S);
        }, y.getSize = function() {
          this.size = n(this.element);
        }, y.css = function(S) {
          var h = this.element.style;
          for (var E in S) {
            var I = v[E] || E;
            h[I] = S[E];
          }
        }, y.getPosition = function() {
          var S = getComputedStyle(this.element), h = this.layout._getOption("originLeft"), E = this.layout._getOption("originTop"), I = S[h ? "left" : "right"], O = S[E ? "top" : "bottom"], L = parseFloat(I), f = parseFloat(O), P = this.layout.size;
          I.indexOf("%") != -1 && (L = L / 100 * P.width), O.indexOf("%") != -1 && (f = f / 100 * P.height), L = isNaN(L) ? 0 : L, f = isNaN(f) ? 0 : f, L -= h ? P.paddingLeft : P.paddingRight, f -= E ? P.paddingTop : P.paddingBottom, this.position.x = L, this.position.y = f;
        }, y.layoutPosition = function() {
          var S = this.layout.size, h = {}, E = this.layout._getOption("originLeft"), I = this.layout._getOption("originTop"), O = E ? "paddingLeft" : "paddingRight", L = E ? "left" : "right", f = E ? "right" : "left", P = this.position.x + S[O];
          h[L] = this.getXValue(P), h[f] = "";
          var D = I ? "paddingTop" : "paddingBottom", H = I ? "top" : "bottom", k = I ? "bottom" : "top", z = this.position.y + S[D];
          h[H] = this.getYValue(z), h[k] = "", this.css(h), this.emitEvent("layout", [this]);
        }, y.getXValue = function(S) {
          var h = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && !h ? S / this.layout.size.width * 100 + "%" : S + "px";
        }, y.getYValue = function(S) {
          var h = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && h ? S / this.layout.size.height * 100 + "%" : S + "px";
        }, y._transitionTo = function(S, h) {
          this.getPosition();
          var E = this.position.x, I = this.position.y, O = S == this.position.x && h == this.position.y;
          if (this.setPosition(S, h), O && !this.isTransitioning) {
            this.layoutPosition();
            return;
          }
          var L = S - E, f = h - I, P = {};
          P.transform = this.getTranslate(L, f), this.transition({ to: P, onTransitionEnd: { transform: this.layoutPosition }, isCleaning: true });
        }, y.getTranslate = function(S, h) {
          var E = this.layout._getOption("originLeft"), I = this.layout._getOption("originTop");
          return S = E ? S : -S, h = I ? h : -h, "translate3d(" + S + "px, " + h + "px, 0)";
        }, y.goTo = function(S, h) {
          this.setPosition(S, h), this.layoutPosition();
        }, y.moveTo = y._transitionTo, y.setPosition = function(S, h) {
          this.position.x = parseFloat(S), this.position.y = parseFloat(h);
        }, y._nonTransition = function(S) {
          this.css(S.to), S.isCleaning && this._removeStyles(S.to);
          for (var h in S.onTransitionEnd) S.onTransitionEnd[h].call(this);
        }, y.transition = function(S) {
          if (!parseFloat(this.layout.options.transitionDuration)) {
            this._nonTransition(S);
            return;
          }
          var h = this._transn;
          for (var E in S.onTransitionEnd) h.onEnd[E] = S.onTransitionEnd[E];
          for (E in S.to) h.ingProperties[E] = true, S.isCleaning && (h.clean[E] = true);
          S.from && (this.css(S.from), this.element.offsetHeight), this.enableTransition(S.to), this.css(S.to), this.isTransitioning = true;
        };
        function _(S) {
          return S.replace(/([A-Z])/g, function(h) {
            return "-" + h.toLowerCase();
          });
        }
        var p = "opacity," + _(c);
        y.enableTransition = function() {
          if (!this.isTransitioning) {
            var S = this.layout.options.transitionDuration;
            S = typeof S == "number" ? S + "ms" : S, this.css({ transitionProperty: p, transitionDuration: S, transitionDelay: this.staggerDelay || 0 }), this.element.addEventListener(d, this, false);
          }
        }, y.onwebkitTransitionEnd = function(S) {
          this.ontransitionend(S);
        }, y.onotransitionend = function(S) {
          this.ontransitionend(S);
        };
        var m = { "-webkit-transform": "transform" };
        y.ontransitionend = function(S) {
          if (S.target === this.element) {
            var h = this._transn, E = m[S.propertyName] || S.propertyName;
            if (delete h.ingProperties[E], r(h.ingProperties) && this.disableTransition(), E in h.clean && (this.element.style[S.propertyName] = "", delete h.clean[E]), E in h.onEnd) {
              var I = h.onEnd[E];
              I.call(this), delete h.onEnd[E];
            }
            this.emitEvent("transitionEnd", [this]);
          }
        }, y.disableTransition = function() {
          this.removeTransitionStyles(), this.element.removeEventListener(d, this, false), this.isTransitioning = false;
        }, y._removeStyles = function(S) {
          var h = {};
          for (var E in S) h[E] = "";
          this.css(h);
        };
        var C = { transitionProperty: "", transitionDuration: "", transitionDelay: "" };
        return y.removeTransitionStyles = function() {
          this.css(C);
        }, y.stagger = function(S) {
          S = isNaN(S) ? 0 : S, this.staggerDelay = S + "ms";
        }, y.removeElem = function() {
          this.element.parentNode.removeChild(this.element), this.css({ display: "" }), this.emitEvent("remove", [this]);
        }, y.remove = function() {
          if (!parseFloat(this.layout.options.transitionDuration)) {
            this.removeElem();
            return;
          }
          this.once("transitionEnd", function() {
            this.removeElem();
          }), this.hide();
        }, y.reveal = function() {
          delete this.isHidden, this.css({ display: "" });
          var S = this.layout.options, h = {}, E = this.getHideRevealTransitionEndProperty("visibleStyle");
          h[E] = this.onRevealTransitionEnd, this.transition({ from: S.hiddenStyle, to: S.visibleStyle, isCleaning: true, onTransitionEnd: h });
        }, y.onRevealTransitionEnd = function() {
          this.isHidden || this.emitEvent("reveal");
        }, y.getHideRevealTransitionEndProperty = function(S) {
          var h = this.layout.options[S];
          if (h.opacity) return "opacity";
          for (var E in h) return E;
        }, y.hide = function() {
          this.isHidden = true, this.css({ display: "" });
          var S = this.layout.options, h = {}, E = this.getHideRevealTransitionEndProperty("hiddenStyle");
          h[E] = this.onHideTransitionEnd, this.transition({ from: S.visibleStyle, to: S.hiddenStyle, isCleaning: true, onTransitionEnd: h });
        }, y.onHideTransitionEnd = function() {
          this.isHidden && (this.css({ display: "none" }), this.emitEvent("hide"));
        }, y.destroy = function() {
          this.css({ position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: "" });
        }, b;
      });
    })(Xs)), Xs.exports;
  }
  var ya;
  function Zn() {
    return ya || (ya = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i(e, Hl(), sn(), Vl(), ev()) : e.Outlayer = i(e, e.EvEmitter, e.getSize, e.fizzyUIUtils, e.Outlayer.Item);
      })(window, function(i, n, r, o, l) {
        var c = i.console, d = i.jQuery, v = function() {
        }, b = 0, y = {};
        function _(h, E) {
          var I = o.getQueryElement(h);
          if (!I) {
            c && c.error("Bad element for " + this.constructor.namespace + ": " + (I || h));
            return;
          }
          this.element = I, d && (this.$element = d(this.element)), this.options = o.extend({}, this.constructor.defaults), this.option(E);
          var O = ++b;
          this.element.outlayerGUID = O, y[O] = this, this._create();
          var L = this._getOption("initLayout");
          L && this.layout();
        }
        _.namespace = "outlayer", _.Item = l, _.defaults = { containerStyle: { position: "relative" }, initLayout: true, originLeft: true, originTop: true, resize: true, resizeContainer: true, transitionDuration: "0.4s", hiddenStyle: { opacity: 0, transform: "scale(0.001)" }, visibleStyle: { opacity: 1, transform: "scale(1)" } };
        var p = _.prototype;
        o.extend(p, n.prototype), p.option = function(h) {
          o.extend(this.options, h);
        }, p._getOption = function(h) {
          var E = this.constructor.compatOptions[h];
          return E && this.options[E] !== void 0 ? this.options[E] : this.options[h];
        }, _.compatOptions = { initLayout: "isInitLayout", horizontal: "isHorizontal", layoutInstant: "isLayoutInstant", originLeft: "isOriginLeft", originTop: "isOriginTop", resize: "isResizeBound", resizeContainer: "isResizingContainer" }, p._create = function() {
          this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), o.extend(this.element.style, this.options.containerStyle);
          var h = this._getOption("resize");
          h && this.bindResize();
        }, p.reloadItems = function() {
          this.items = this._itemize(this.element.children);
        }, p._itemize = function(h) {
          for (var E = this._filterFindItemElements(h), I = this.constructor.Item, O = [], L = 0; L < E.length; L++) {
            var f = E[L], P = new I(f, this);
            O.push(P);
          }
          return O;
        }, p._filterFindItemElements = function(h) {
          return o.filterFindElements(h, this.options.itemSelector);
        }, p.getItemElements = function() {
          return this.items.map(function(h) {
            return h.element;
          });
        }, p.layout = function() {
          this._resetLayout(), this._manageStamps();
          var h = this._getOption("layoutInstant"), E = h !== void 0 ? h : !this._isLayoutInited;
          this.layoutItems(this.items, E), this._isLayoutInited = true;
        }, p._init = p.layout, p._resetLayout = function() {
          this.getSize();
        }, p.getSize = function() {
          this.size = r(this.element);
        }, p._getMeasurement = function(h, E) {
          var I = this.options[h], O;
          I ? (typeof I == "string" ? O = this.element.querySelector(I) : I instanceof HTMLElement && (O = I), this[h] = O ? r(O)[E] : I) : this[h] = 0;
        }, p.layoutItems = function(h, E) {
          h = this._getItemsForLayout(h), this._layoutItems(h, E), this._postLayout();
        }, p._getItemsForLayout = function(h) {
          return h.filter(function(E) {
            return !E.isIgnored;
          });
        }, p._layoutItems = function(h, E) {
          if (this._emitCompleteOnItems("layout", h), !(!h || !h.length)) {
            var I = [];
            h.forEach(function(O) {
              var L = this._getItemLayoutPosition(O);
              L.item = O, L.isInstant = E || O.isLayoutInstant, I.push(L);
            }, this), this._processLayoutQueue(I);
          }
        }, p._getItemLayoutPosition = function() {
          return { x: 0, y: 0 };
        }, p._processLayoutQueue = function(h) {
          this.updateStagger(), h.forEach(function(E, I) {
            this._positionItem(E.item, E.x, E.y, E.isInstant, I);
          }, this);
        }, p.updateStagger = function() {
          var h = this.options.stagger;
          if (h == null) {
            this.stagger = 0;
            return;
          }
          return this.stagger = S(h), this.stagger;
        }, p._positionItem = function(h, E, I, O, L) {
          O ? h.goTo(E, I) : (h.stagger(L * this.stagger), h.moveTo(E, I));
        }, p._postLayout = function() {
          this.resizeContainer();
        }, p.resizeContainer = function() {
          var h = this._getOption("resizeContainer");
          if (h) {
            var E = this._getContainerSize();
            E && (this._setContainerMeasure(E.width, true), this._setContainerMeasure(E.height, false));
          }
        }, p._getContainerSize = v, p._setContainerMeasure = function(h, E) {
          if (h !== void 0) {
            var I = this.size;
            I.isBorderBox && (h += E ? I.paddingLeft + I.paddingRight + I.borderLeftWidth + I.borderRightWidth : I.paddingBottom + I.paddingTop + I.borderTopWidth + I.borderBottomWidth), h = Math.max(h, 0), this.element.style[E ? "width" : "height"] = h + "px";
          }
        }, p._emitCompleteOnItems = function(h, E) {
          var I = this;
          function O() {
            I.dispatchEvent(h + "Complete", null, [E]);
          }
          var L = E.length;
          if (!E || !L) {
            O();
            return;
          }
          var f = 0;
          function P() {
            f++, f == L && O();
          }
          E.forEach(function(D) {
            D.once(h, P);
          });
        }, p.dispatchEvent = function(h, E, I) {
          var O = E ? [E].concat(I) : I;
          if (this.emitEvent(h, O), d) if (this.$element = this.$element || d(this.element), E) {
            var L = d.Event(E);
            L.type = h, this.$element.trigger(L, I);
          } else this.$element.trigger(h, I);
        }, p.ignore = function(h) {
          var E = this.getItem(h);
          E && (E.isIgnored = true);
        }, p.unignore = function(h) {
          var E = this.getItem(h);
          E && delete E.isIgnored;
        }, p.stamp = function(h) {
          h = this._find(h), h && (this.stamps = this.stamps.concat(h), h.forEach(this.ignore, this));
        }, p.unstamp = function(h) {
          h = this._find(h), h && h.forEach(function(E) {
            o.removeFrom(this.stamps, E), this.unignore(E);
          }, this);
        }, p._find = function(h) {
          if (h) return typeof h == "string" && (h = this.element.querySelectorAll(h)), h = o.makeArray(h), h;
        }, p._manageStamps = function() {
          !this.stamps || !this.stamps.length || (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
        }, p._getBoundingRect = function() {
          var h = this.element.getBoundingClientRect(), E = this.size;
          this._boundingRect = { left: h.left + E.paddingLeft + E.borderLeftWidth, top: h.top + E.paddingTop + E.borderTopWidth, right: h.right - (E.paddingRight + E.borderRightWidth), bottom: h.bottom - (E.paddingBottom + E.borderBottomWidth) };
        }, p._manageStamp = v, p._getElementOffset = function(h) {
          var E = h.getBoundingClientRect(), I = this._boundingRect, O = r(h), L = { left: E.left - I.left - O.marginLeft, top: E.top - I.top - O.marginTop, right: I.right - E.right - O.marginRight, bottom: I.bottom - E.bottom - O.marginBottom };
          return L;
        }, p.handleEvent = o.handleEvent, p.bindResize = function() {
          i.addEventListener("resize", this), this.isResizeBound = true;
        }, p.unbindResize = function() {
          i.removeEventListener("resize", this), this.isResizeBound = false;
        }, p.onresize = function() {
          this.resize();
        }, o.debounceMethod(_, "onresize", 100), p.resize = function() {
          !this.isResizeBound || !this.needsResizeLayout() || this.layout();
        }, p.needsResizeLayout = function() {
          var h = r(this.element), E = this.size && h;
          return E && h.innerWidth !== this.size.innerWidth;
        }, p.addItems = function(h) {
          var E = this._itemize(h);
          return E.length && (this.items = this.items.concat(E)), E;
        }, p.appended = function(h) {
          var E = this.addItems(h);
          E.length && (this.layoutItems(E, true), this.reveal(E));
        }, p.prepended = function(h) {
          var E = this._itemize(h);
          if (E.length) {
            var I = this.items.slice(0);
            this.items = E.concat(I), this._resetLayout(), this._manageStamps(), this.layoutItems(E, true), this.reveal(E), this.layoutItems(I);
          }
        }, p.reveal = function(h) {
          if (this._emitCompleteOnItems("reveal", h), !(!h || !h.length)) {
            var E = this.updateStagger();
            h.forEach(function(I, O) {
              I.stagger(O * E), I.reveal();
            });
          }
        }, p.hide = function(h) {
          if (this._emitCompleteOnItems("hide", h), !(!h || !h.length)) {
            var E = this.updateStagger();
            h.forEach(function(I, O) {
              I.stagger(O * E), I.hide();
            });
          }
        }, p.revealItemElements = function(h) {
          var E = this.getItems(h);
          this.reveal(E);
        }, p.hideItemElements = function(h) {
          var E = this.getItems(h);
          this.hide(E);
        }, p.getItem = function(h) {
          for (var E = 0; E < this.items.length; E++) {
            var I = this.items[E];
            if (I.element == h) return I;
          }
        }, p.getItems = function(h) {
          h = o.makeArray(h);
          var E = [];
          return h.forEach(function(I) {
            var O = this.getItem(I);
            O && E.push(O);
          }, this), E;
        }, p.remove = function(h) {
          var E = this.getItems(h);
          this._emitCompleteOnItems("remove", E), !(!E || !E.length) && E.forEach(function(I) {
            I.remove(), o.removeFrom(this.items, I);
          }, this);
        }, p.destroy = function() {
          var h = this.element.style;
          h.height = "", h.position = "", h.width = "", this.items.forEach(function(I) {
            I.destroy();
          }), this.unbindResize();
          var E = this.element.outlayerGUID;
          delete y[E], delete this.element.outlayerGUID, d && d.removeData(this.element, this.constructor.namespace);
        }, _.data = function(h) {
          h = o.getQueryElement(h);
          var E = h && h.outlayerGUID;
          return E && y[E];
        }, _.create = function(h, E) {
          var I = m(_);
          return I.defaults = o.extend({}, _.defaults), o.extend(I.defaults, E), I.compatOptions = o.extend({}, _.compatOptions), I.namespace = h, I.data = _.data, I.Item = m(l), o.htmlInit(I, h), d && d.bridget && d.bridget(h, I), I;
        };
        function m(h) {
          function E() {
            h.apply(this, arguments);
          }
          return E.prototype = Object.create(h.prototype), E.prototype.constructor = E, E;
        }
        var C = { ms: 1, s: 1e3 };
        function S(h) {
          if (typeof h == "number") return h;
          var E = h.match(/(^\d*\.?\d*)(\w*)/), I = E && E[1], O = E && E[2];
          if (!I.length) return 0;
          I = parseFloat(I);
          var L = C[O] || 1;
          return I * L;
        }
        return _.Item = l, _;
      });
    })(Fs)), Fs.exports;
  }
  var qs = { exports: {} }, ba;
  function tv() {
    return ba || (ba = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i(Zn()) : (e.Isotope = e.Isotope || {}, e.Isotope.Item = i(e.Outlayer));
      })(window, function(i) {
        function n() {
          i.Item.apply(this, arguments);
        }
        var r = n.prototype = Object.create(i.Item.prototype), o = r._create;
        r._create = function() {
          this.id = this.layout.itemGUID++, o.call(this), this.sortData = {};
        }, r.updateSortData = function() {
          if (!this.isIgnored) {
            this.sortData.id = this.id, this.sortData["original-order"] = this.id, this.sortData.random = Math.random();
            var c = this.layout.options.getSortData, d = this.layout._sorters;
            for (var v in c) {
              var b = d[v];
              this.sortData[v] = b(this.element, this);
            }
          }
        };
        var l = r.destroy;
        return r.destroy = function() {
          l.apply(this, arguments), this.css({ display: "" });
        }, n;
      });
    })(qs)), qs.exports;
  }
  var Us = { exports: {} }, Ea;
  function Qn() {
    return Ea || (Ea = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i(sn(), Zn()) : (e.Isotope = e.Isotope || {}, e.Isotope.LayoutMode = i(e.getSize, e.Outlayer));
      })(window, function(i, n) {
        function r(c) {
          this.isotope = c, c && (this.options = c.options[this.namespace], this.element = c.element, this.items = c.filteredItems, this.size = c.size);
        }
        var o = r.prototype, l = ["_resetLayout", "_getItemLayoutPosition", "_manageStamp", "_getContainerSize", "_getElementOffset", "needsResizeLayout", "_getOption"];
        return l.forEach(function(c) {
          o[c] = function() {
            return n.prototype[c].apply(this.isotope, arguments);
          };
        }), o.needsVerticalResizeLayout = function() {
          var c = i(this.isotope.element), d = this.isotope.size && c;
          return d && c.innerHeight != this.isotope.size.innerHeight;
        }, o._getMeasurement = function() {
          this.isotope._getMeasurement.apply(this, arguments);
        }, o.getColumnWidth = function() {
          this.getSegmentSize("column", "Width");
        }, o.getRowHeight = function() {
          this.getSegmentSize("row", "Height");
        }, o.getSegmentSize = function(c, d) {
          var v = c + d, b = "outer" + d;
          if (this._getMeasurement(v, b), !this[v]) {
            var y = this.getFirstItemSize();
            this[v] = y && y[b] || this.isotope.size["inner" + d];
          }
        }, o.getFirstItemSize = function() {
          var c = this.isotope.filteredItems[0];
          return c && c.element && i(c.element);
        }, o.layout = function() {
          this.isotope.layout.apply(this.isotope, arguments);
        }, o.getSize = function() {
          this.isotope.getSize(), this.size = this.isotope.size;
        }, r.modes = {}, r.create = function(c, d) {
          function v() {
            r.apply(this, arguments);
          }
          return v.prototype = Object.create(o), v.prototype.constructor = v, d && (v.options = d), v.prototype.namespace = c, r.modes[c] = v, v;
        }, r;
      });
    })(Us)), Us.exports;
  }
  var Ks = { exports: {} }, Zs = { exports: {} };
  var Ta;
  function iv() {
    return Ta || (Ta = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i(Zn(), sn()) : e.Masonry = i(e.Outlayer, e.getSize);
      })(window, function(i, n) {
        var r = i.create("masonry");
        r.compatOptions.fitWidth = "isFitWidth";
        var o = r.prototype;
        return o._resetLayout = function() {
          this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
          for (var l = 0; l < this.cols; l++) this.colYs.push(0);
          this.maxY = 0, this.horizontalColIndex = 0;
        }, o.measureColumns = function() {
          if (this.getContainerWidth(), !this.columnWidth) {
            var l = this.items[0], c = l && l.element;
            this.columnWidth = c && n(c).outerWidth || this.containerWidth;
          }
          var d = this.columnWidth += this.gutter, v = this.containerWidth + this.gutter, b = v / d, y = d - v % d, _ = y && y < 1 ? "round" : "floor";
          b = Math[_](b), this.cols = Math.max(b, 1);
        }, o.getContainerWidth = function() {
          var l = this._getOption("fitWidth"), c = l ? this.element.parentNode : this.element, d = n(c);
          this.containerWidth = d && d.innerWidth;
        }, o._getItemLayoutPosition = function(l) {
          l.getSize();
          var c = l.size.outerWidth % this.columnWidth, d = c && c < 1 ? "round" : "ceil", v = Math[d](l.size.outerWidth / this.columnWidth);
          v = Math.min(v, this.cols);
          for (var b = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition", y = this[b](v, l), _ = { x: this.columnWidth * y.col, y: y.y }, p = y.y + l.size.outerHeight, m = v + y.col, C = y.col; C < m; C++) this.colYs[C] = p;
          return _;
        }, o._getTopColPosition = function(l) {
          var c = this._getTopColGroup(l), d = Math.min.apply(Math, c);
          return { col: c.indexOf(d), y: d };
        }, o._getTopColGroup = function(l) {
          if (l < 2) return this.colYs;
          for (var c = [], d = this.cols + 1 - l, v = 0; v < d; v++) c[v] = this._getColGroupY(v, l);
          return c;
        }, o._getColGroupY = function(l, c) {
          if (c < 2) return this.colYs[l];
          var d = this.colYs.slice(l, l + c);
          return Math.max.apply(Math, d);
        }, o._getHorizontalColPosition = function(l, c) {
          var d = this.horizontalColIndex % this.cols, v = l > 1 && d + l > this.cols;
          d = v ? 0 : d;
          var b = c.size.outerWidth && c.size.outerHeight;
          return this.horizontalColIndex = b ? d + l : this.horizontalColIndex, { col: d, y: this._getColGroupY(d, l) };
        }, o._manageStamp = function(l) {
          var c = n(l), d = this._getElementOffset(l), v = this._getOption("originLeft"), b = v ? d.left : d.right, y = b + c.outerWidth, _ = Math.floor(b / this.columnWidth);
          _ = Math.max(0, _);
          var p = Math.floor(y / this.columnWidth);
          p -= y % this.columnWidth ? 0 : 1, p = Math.min(this.cols - 1, p);
          for (var m = this._getOption("originTop"), C = (m ? d.top : d.bottom) + c.outerHeight, S = _; S <= p; S++) this.colYs[S] = Math.max(C, this.colYs[S]);
        }, o._getContainerSize = function() {
          this.maxY = Math.max.apply(Math, this.colYs);
          var l = { height: this.maxY };
          return this._getOption("fitWidth") && (l.width = this._getContainerFitWidth()), l;
        }, o._getContainerFitWidth = function() {
          for (var l = 0, c = this.cols; --c && this.colYs[c] === 0; ) l++;
          return (this.cols - l) * this.columnWidth - this.gutter;
        }, o.needsResizeLayout = function() {
          var l = this.containerWidth;
          return this.getContainerWidth(), l != this.containerWidth;
        }, r;
      });
    })(Zs)), Zs.exports;
  }
  var _a;
  function nv() {
    return _a || (_a = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i(Qn(), iv()) : i(e.Isotope.LayoutMode, e.Masonry);
      })(window, function(i, n) {
        var r = i.create("masonry"), o = r.prototype, l = { _getElementOffset: true, layout: true, _getMeasurement: true };
        for (var c in n.prototype) l[c] || (o[c] = n.prototype[c]);
        var d = o.measureColumns;
        o.measureColumns = function() {
          this.items = this.isotope.filteredItems, d.call(this);
        };
        var v = o._getOption;
        return o._getOption = function(b) {
          return b == "fitWidth" ? this.options.isFitWidth !== void 0 ? this.options.isFitWidth : this.options.fitWidth : v.apply(this.isotope, arguments);
        }, r;
      });
    })(Ks)), Ks.exports;
  }
  var Qs = { exports: {} }, Sa;
  function sv() {
    return Sa || (Sa = 1, (function(t, e) {
      (function(i, n) {
        t.exports = n(Qn());
      })(window, function(n) {
        var r = n.create("fitRows"), o = r.prototype;
        return o._resetLayout = function() {
          this.x = 0, this.y = 0, this.maxY = 0, this._getMeasurement("gutter", "outerWidth");
        }, o._getItemLayoutPosition = function(l) {
          l.getSize();
          var c = l.size.outerWidth + this.gutter, d = this.isotope.size.innerWidth + this.gutter;
          this.x !== 0 && c + this.x > d && (this.x = 0, this.y = this.maxY);
          var v = { x: this.x, y: this.y };
          return this.maxY = Math.max(this.maxY, this.y + l.size.outerHeight), this.x += c, v;
        }, o._getContainerSize = function() {
          return { height: this.maxY };
        }, r;
      });
    })(Qs)), Qs.exports;
  }
  var Js = { exports: {} }, xa;
  function rv() {
    return xa || (xa = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i(Qn()) : i(e.Isotope.LayoutMode);
      })(window, function(i) {
        var n = i.create("vertical", { horizontalAlignment: 0 }), r = n.prototype;
        return r._resetLayout = function() {
          this.y = 0;
        }, r._getItemLayoutPosition = function(o) {
          o.getSize();
          var l = (this.isotope.size.innerWidth - o.size.outerWidth) * this.options.horizontalAlignment, c = this.y;
          return this.y += o.size.outerHeight, { x: l, y: c };
        }, r._getContainerSize = function() {
          return { height: this.y };
        }, n;
      });
    })(Js)), Js.exports;
  }
  var Ca;
  function ov() {
    return Ca || (Ca = 1, (function(t) {
      (function(e, i) {
        t.exports ? t.exports = i(e, Zn(), sn(), Bl(), Vl(), tv(), Qn(), nv(), sv(), rv()) : e.Isotope = i(e, e.Outlayer, e.getSize, e.matchesSelector, e.fizzyUIUtils, e.Isotope.Item, e.Isotope.LayoutMode);
      })(window, function(i, n, r, o, l, c, d) {
        var v = i.jQuery, b = String.prototype.trim ? function(S) {
          return S.trim();
        } : function(S) {
          return S.replace(/^\s+|\s+$/g, "");
        }, y = n.create("isotope", { layoutMode: "masonry", isJQueryFiltering: true, sortAscending: true });
        y.Item = c, y.LayoutMode = d;
        var _ = y.prototype;
        _._create = function() {
          this.itemGUID = 0, this._sorters = {}, this._getSorters(), n.prototype._create.call(this), this.modes = {}, this.filteredItems = this.items, this.sortHistory = ["original-order"];
          for (var S in d.modes) this._initLayoutMode(S);
        }, _.reloadItems = function() {
          this.itemGUID = 0, n.prototype.reloadItems.call(this);
        }, _._itemize = function() {
          for (var S = n.prototype._itemize.apply(this, arguments), h = 0; h < S.length; h++) {
            var E = S[h];
            E.id = this.itemGUID++;
          }
          return this._updateItemsSortData(S), S;
        }, _._initLayoutMode = function(S) {
          var h = d.modes[S], E = this.options[S] || {};
          this.options[S] = h.options ? l.extend(h.options, E) : E, this.modes[S] = new h(this);
        }, _.layout = function() {
          if (!this._isLayoutInited && this._getOption("initLayout")) {
            this.arrange();
            return;
          }
          this._layout();
        }, _._layout = function() {
          var S = this._getIsInstant();
          this._resetLayout(), this._manageStamps(), this.layoutItems(this.filteredItems, S), this._isLayoutInited = true;
        }, _.arrange = function(S) {
          this.option(S), this._getIsInstant();
          var h = this._filter(this.items);
          this.filteredItems = h.matches, this._bindArrangeComplete(), this._isInstant ? this._noTransition(this._hideReveal, [h]) : this._hideReveal(h), this._sort(), this._layout();
        }, _._init = _.arrange, _._hideReveal = function(S) {
          this.reveal(S.needReveal), this.hide(S.needHide);
        }, _._getIsInstant = function() {
          var S = this._getOption("layoutInstant"), h = S !== void 0 ? S : !this._isLayoutInited;
          return this._isInstant = h, h;
        }, _._bindArrangeComplete = function() {
          var S, h, E, I = this;
          function O() {
            S && h && E && I.dispatchEvent("arrangeComplete", null, [I.filteredItems]);
          }
          this.once("layoutComplete", function() {
            S = true, O();
          }), this.once("hideComplete", function() {
            h = true, O();
          }), this.once("revealComplete", function() {
            E = true, O();
          });
        }, _._filter = function(S) {
          var h = this.options.filter;
          h = h || "*";
          for (var E = [], I = [], O = [], L = this._getFilterTest(h), f = 0; f < S.length; f++) {
            var P = S[f];
            if (!P.isIgnored) {
              var D = L(P);
              D && E.push(P), D && P.isHidden ? I.push(P) : !D && !P.isHidden && O.push(P);
            }
          }
          return { matches: E, needReveal: I, needHide: O };
        }, _._getFilterTest = function(S) {
          return v && this.options.isJQueryFiltering ? function(h) {
            return v(h.element).is(S);
          } : typeof S == "function" ? function(h) {
            return S(h.element);
          } : function(h) {
            return o(h.element, S);
          };
        }, _.updateSortData = function(S) {
          var h;
          S ? (S = l.makeArray(S), h = this.getItems(S)) : h = this.items, this._getSorters(), this._updateItemsSortData(h);
        }, _._getSorters = function() {
          var S = this.options.getSortData;
          for (var h in S) {
            var E = S[h];
            this._sorters[h] = p(E);
          }
        }, _._updateItemsSortData = function(S) {
          for (var h = S && S.length, E = 0; h && E < h; E++) {
            var I = S[E];
            I.updateSortData();
          }
        };
        var p = /* @__PURE__ */ (function() {
          function S(E) {
            if (typeof E != "string") return E;
            var I = b(E).split(" "), O = I[0], L = O.match(/^\[(.+)\]$/), f = L && L[1], P = h(f, O), D = y.sortDataParsers[I[1]];
            return E = D ? function(H) {
              return H && D(P(H));
            } : function(H) {
              return H && P(H);
            }, E;
          }
          function h(E, I) {
            return E ? function(L) {
              return L.getAttribute(E);
            } : function(L) {
              var f = L.querySelector(I);
              return f && f.textContent;
            };
          }
          return S;
        })();
        y.sortDataParsers = { parseInt: function(S) {
          return parseInt(S, 10);
        }, parseFloat: function(S) {
          return parseFloat(S);
        } }, _._sort = function() {
          if (this.options.sortBy) {
            var S = l.makeArray(this.options.sortBy);
            this._getIsSameSortBy(S) || (this.sortHistory = S.concat(this.sortHistory));
            var h = m(this.sortHistory, this.options.sortAscending);
            this.filteredItems.sort(h);
          }
        }, _._getIsSameSortBy = function(S) {
          for (var h = 0; h < S.length; h++) if (S[h] != this.sortHistory[h]) return false;
          return true;
        };
        function m(S, h) {
          return function(I, O) {
            for (var L = 0; L < S.length; L++) {
              var f = S[L], P = I.sortData[f], D = O.sortData[f];
              if (P > D || P < D) {
                var H = h[f] !== void 0 ? h[f] : h, k = H ? 1 : -1;
                return (P > D ? 1 : -1) * k;
              }
            }
            return 0;
          };
        }
        _._mode = function() {
          var S = this.options.layoutMode, h = this.modes[S];
          if (!h) throw new Error("No layout mode: " + S);
          return h.options = this.options[S], h;
        }, _._resetLayout = function() {
          n.prototype._resetLayout.call(this), this._mode()._resetLayout();
        }, _._getItemLayoutPosition = function(S) {
          return this._mode()._getItemLayoutPosition(S);
        }, _._manageStamp = function(S) {
          this._mode()._manageStamp(S);
        }, _._getContainerSize = function() {
          return this._mode()._getContainerSize();
        }, _.needsResizeLayout = function() {
          return this._mode().needsResizeLayout();
        }, _.appended = function(S) {
          var h = this.addItems(S);
          if (h.length) {
            var E = this._filterRevealAdded(h);
            this.filteredItems = this.filteredItems.concat(E);
          }
        }, _.prepended = function(S) {
          var h = this._itemize(S);
          if (h.length) {
            this._resetLayout(), this._manageStamps();
            var E = this._filterRevealAdded(h);
            this.layoutItems(this.filteredItems), this.filteredItems = E.concat(this.filteredItems), this.items = h.concat(this.items);
          }
        }, _._filterRevealAdded = function(S) {
          var h = this._filter(S);
          return this.hide(h.needHide), this.reveal(h.matches), this.layoutItems(h.matches, true), h.matches;
        }, _.insert = function(S) {
          var h = this.addItems(S);
          if (h.length) {
            var E, I, O = h.length;
            for (E = 0; E < O; E++) I = h[E], this.element.appendChild(I.element);
            var L = this._filter(h).matches;
            for (E = 0; E < O; E++) h[E].isLayoutInstant = true;
            for (this.arrange(), E = 0; E < O; E++) delete h[E].isLayoutInstant;
            this.reveal(L);
          }
        };
        var C = _.remove;
        return _.remove = function(S) {
          S = l.makeArray(S);
          var h = this.getItems(S);
          C.call(this, S);
          for (var E = h && h.length, I = 0; E && I < E; I++) {
            var O = h[I];
            l.removeFrom(this.filteredItems, O);
          }
        }, _.shuffle = function() {
          for (var S = 0; S < this.items.length; S++) {
            var h = this.items[S];
            h.sortData.random = Math.random();
          }
          this.options.sortBy = "random", this._sort(), this._layout();
        }, _._noTransition = function(S, h) {
          var E = this.options.transitionDuration;
          this.options.transitionDuration = 0;
          var I = S.apply(this, h);
          return this.options.transitionDuration = E, I;
        }, _.getFilteredItemElements = function() {
          return this.filteredItems.map(function(S) {
            return S.element;
          });
        }, y;
      });
    })(Ws)), Ws.exports;
  }
  var av = ov();
  const Wl = Qm(av);
  window.jQuery && (function(t) {
    t.bridget = t.bridget || function(e, i) {
      t.fn[e] = function(n) {
        return this.each(function() {
          new i(this, n);
        });
      };
    }, t.bridget("isotope", Wl);
  })(window.jQuery);
  window.Isotope = Wl;
  var kt = function() {
    return kt = Object.assign || function(e) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (e[o] = i[o]);
      }
      return e;
    }, kt.apply(this, arguments);
  };
  function lv() {
    for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
    for (var n = Array(t), r = 0, e = 0; e < i; e++) for (var o = arguments[e], l = 0, c = o.length; l < c; l++, r++) n[r] = o[l];
    return n;
  }
  var pe = { afterAppendSlide: "lgAfterAppendSlide", init: "lgInit", hasVideo: "lgHasVideo", containerResize: "lgContainerResize", updateSlides: "lgUpdateSlides", afterAppendSubHtml: "lgAfterAppendSubHtml", beforeOpen: "lgBeforeOpen", afterOpen: "lgAfterOpen", slideItemLoad: "lgSlideItemLoad", beforeSlide: "lgBeforeSlide", afterSlide: "lgAfterSlide", posterClick: "lgPosterClick", dragStart: "lgDragStart", dragMove: "lgDragMove", dragEnd: "lgDragEnd", beforeNextSlide: "lgBeforeNextSlide", beforePrevSlide: "lgBeforePrevSlide", beforeClose: "lgBeforeClose", afterClose: "lgAfterClose" }, uv = { mode: "lg-slide", easing: "ease", speed: 400, licenseKey: "0000-0000-000-0000", height: "100%", width: "100%", addClass: "", startClass: "lg-start-zoom", backdropDuration: 300, container: "", startAnimationDuration: 400, zoomFromOrigin: true, hideBarsDelay: 0, showBarsAfter: 1e4, slideDelay: 0, supportLegacyBrowser: true, allowMediaOverlap: false, videoMaxSize: "1280-720", loadYouTubePoster: true, defaultCaptionHeight: 0, ariaLabelledby: "", ariaDescribedby: "", resetScrollPosition: true, hideScrollbar: false, closable: true, swipeToClose: true, closeOnTap: true, showCloseIcon: true, showMaximizeIcon: false, loop: true, escKey: true, keyPress: true, trapFocus: true, controls: true, slideEndAnimation: true, hideControlOnEnd: false, mousewheel: false, getCaptionFromTitleOrAlt: true, appendSubHtmlTo: ".lg-sub-html", subHtmlSelectorRelative: false, preload: 2, numberOfSlideItemsInDom: 10, selector: "", selectWithin: "", nextHtml: "", prevHtml: "", index: 0, iframeWidth: "100%", iframeHeight: "100%", iframeMaxWidth: "100%", iframeMaxHeight: "100%", download: true, counter: true, appendCounterTo: ".lg-toolbar", swipeThreshold: 50, enableSwipe: true, enableDrag: true, dynamic: false, dynamicEl: [], extraProps: [], exThumbImage: "", isMobile: void 0, mobileSettings: { controls: false, showCloseIcon: false, download: false }, plugins: [], strings: { closeGallery: "Close gallery", toggleMaximize: "Toggle maximize", previousSlide: "Previous slide", nextSlide: "Next slide", download: "Download", playVideo: "Play video", mediaLoadingFailed: "Oops... Failed to load content..." } };
  function cv() {
    (function() {
      if (typeof window.CustomEvent == "function") return false;
      function t(e, i) {
        i = i || { bubbles: false, cancelable: false, detail: null };
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(e, i.bubbles, i.cancelable, i.detail), n;
      }
      window.CustomEvent = t;
    })(), (function() {
      Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
    })();
  }
  var Fl = (function() {
    function t(e) {
      return this.cssVenderPrefixes = ["TransitionDuration", "TransitionTimingFunction", "Transform", "Transition"], this.selector = this._getSelector(e), this.firstElement = this._getFirstEl(), this;
    }
    return t.generateUUID = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
        var i = Math.random() * 16 | 0, n = e == "x" ? i : i & 3 | 8;
        return n.toString(16);
      });
    }, t.prototype._getSelector = function(e, i) {
      if (i === void 0 && (i = document), typeof e != "string") return e;
      i = i || document;
      var n = e.substring(0, 1);
      return n === "#" ? i.querySelector(e) : i.querySelectorAll(e);
    }, t.prototype._each = function(e) {
      return this.selector ? (this.selector.length !== void 0 ? [].forEach.call(this.selector, e) : e(this.selector, 0), this) : this;
    }, t.prototype._setCssVendorPrefix = function(e, i, n) {
      var r = i.replace(/-([a-z])/gi, function(o, l) {
        return l.toUpperCase();
      });
      this.cssVenderPrefixes.indexOf(r) !== -1 ? (e.style[r.charAt(0).toLowerCase() + r.slice(1)] = n, e.style["webkit" + r] = n, e.style["moz" + r] = n, e.style["ms" + r] = n, e.style["o" + r] = n) : e.style[r] = n;
    }, t.prototype._getFirstEl = function() {
      return this.selector && this.selector.length !== void 0 ? this.selector[0] : this.selector;
    }, t.prototype.isEventMatched = function(e, i) {
      var n = i.split(".");
      return e.split(".").filter(function(r) {
        return r;
      }).every(function(r) {
        return n.indexOf(r) !== -1;
      });
    }, t.prototype.attr = function(e, i) {
      return i === void 0 ? this.firstElement ? this.firstElement.getAttribute(e) : "" : (this._each(function(n) {
        n.setAttribute(e, i);
      }), this);
    }, t.prototype.find = function(e) {
      return se(this._getSelector(e, this.selector));
    }, t.prototype.first = function() {
      return this.selector && this.selector.length !== void 0 ? se(this.selector[0]) : se(this.selector);
    }, t.prototype.eq = function(e) {
      return se(this.selector[e]);
    }, t.prototype.parent = function() {
      return se(this.selector.parentElement);
    }, t.prototype.get = function() {
      return this._getFirstEl();
    }, t.prototype.removeAttr = function(e) {
      var i = e.split(" ");
      return this._each(function(n) {
        i.forEach(function(r) {
          return n.removeAttribute(r);
        });
      }), this;
    }, t.prototype.wrap = function(e) {
      if (!this.firstElement) return this;
      var i = document.createElement("div");
      return i.className = e, this.firstElement.parentNode.insertBefore(i, this.firstElement), this.firstElement.parentNode.removeChild(this.firstElement), i.appendChild(this.firstElement), this;
    }, t.prototype.addClass = function(e) {
      return e === void 0 && (e = ""), this._each(function(i) {
        e.split(" ").forEach(function(n) {
          n && i.classList.add(n);
        });
      }), this;
    }, t.prototype.removeClass = function(e) {
      return this._each(function(i) {
        e.split(" ").forEach(function(n) {
          n && i.classList.remove(n);
        });
      }), this;
    }, t.prototype.hasClass = function(e) {
      return this.firstElement ? this.firstElement.classList.contains(e) : false;
    }, t.prototype.hasAttribute = function(e) {
      return this.firstElement ? this.firstElement.hasAttribute(e) : false;
    }, t.prototype.toggleClass = function(e) {
      return this.firstElement ? (this.hasClass(e) ? this.removeClass(e) : this.addClass(e), this) : this;
    }, t.prototype.css = function(e, i) {
      var n = this;
      return this._each(function(r) {
        n._setCssVendorPrefix(r, e, i);
      }), this;
    }, t.prototype.on = function(e, i) {
      var n = this;
      return this.selector ? (e.split(" ").forEach(function(r) {
        Array.isArray(t.eventListeners[r]) || (t.eventListeners[r] = []), t.eventListeners[r].push(i), n.selector.addEventListener(r.split(".")[0], i);
      }), this) : this;
    }, t.prototype.once = function(e, i) {
      var n = this;
      return this.on(e, function() {
        n.off(e), i(e);
      }), this;
    }, t.prototype.off = function(e) {
      var i = this;
      return this.selector ? (Object.keys(t.eventListeners).forEach(function(n) {
        i.isEventMatched(e, n) && (t.eventListeners[n].forEach(function(r) {
          i.selector.removeEventListener(n.split(".")[0], r);
        }), t.eventListeners[n] = []);
      }), this) : this;
    }, t.prototype.trigger = function(e, i) {
      if (!this.firstElement) return this;
      var n = new CustomEvent(e.split(".")[0], { detail: i || null });
      return this.firstElement.dispatchEvent(n), this;
    }, t.prototype.load = function(e) {
      var i = this;
      return fetch(e).then(function(n) {
        return n.text();
      }).then(function(n) {
        i.selector.innerHTML = n;
      }), this;
    }, t.prototype.html = function(e) {
      return e === void 0 ? this.firstElement ? this.firstElement.innerHTML : "" : (this._each(function(i) {
        i.innerHTML = e;
      }), this);
    }, t.prototype.append = function(e) {
      return this._each(function(i) {
        typeof e == "string" ? i.insertAdjacentHTML("beforeend", e) : i.appendChild(e);
      }), this;
    }, t.prototype.prepend = function(e) {
      return this._each(function(i) {
        typeof e == "string" ? i.insertAdjacentHTML("afterbegin", e) : e instanceof HTMLElement && i.insertBefore(e.cloneNode(true), i.firstChild);
      }), this;
    }, t.prototype.remove = function() {
      return this._each(function(e) {
        e.parentNode.removeChild(e);
      }), this;
    }, t.prototype.empty = function() {
      return this._each(function(e) {
        e.innerHTML = "";
      }), this;
    }, t.prototype.scrollTop = function(e) {
      return e !== void 0 ? (document.body.scrollTop = e, document.documentElement.scrollTop = e, this) : window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }, t.prototype.scrollLeft = function(e) {
      return e !== void 0 ? (document.body.scrollLeft = e, document.documentElement.scrollLeft = e, this) : window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    }, t.prototype.offset = function() {
      if (!this.firstElement) return { left: 0, top: 0 };
      var e = this.firstElement.getBoundingClientRect(), i = se("body").style().marginLeft;
      return { left: e.left - parseFloat(i) + this.scrollLeft(), top: e.top + this.scrollTop() };
    }, t.prototype.style = function() {
      return this.firstElement ? this.firstElement.currentStyle || window.getComputedStyle(this.firstElement) : {};
    }, t.prototype.width = function() {
      var e = this.style();
      return this.firstElement.clientWidth - parseFloat(e.paddingLeft) - parseFloat(e.paddingRight);
    }, t.prototype.height = function() {
      var e = this.style();
      return this.firstElement.clientHeight - parseFloat(e.paddingTop) - parseFloat(e.paddingBottom);
    }, t.eventListeners = {}, t;
  })();
  function se(t) {
    return cv(), new Fl(t);
  }
  var dv = ["src", "sources", "subHtml", "subHtmlUrl", "html", "video", "poster", "slideName", "responsive", "srcset", "sizes", "iframe", "downloadUrl", "download", "width", "facebookShareUrl", "tweetText", "iframeTitle", "twitterShareUrl", "pinterestShareUrl", "pinterestText", "fbHtml", "disqusIdentifier", "disqusUrl"];
  function fv(t) {
    return t === "href" ? "src" : (t = t.replace("data-", ""), t = t.charAt(0).toLowerCase() + t.slice(1), t = t.replace(/-([a-z])/g, function(e) {
      return e[1].toUpperCase();
    }), t);
  }
  var Ie = { fetchCaptionFromUrl: function(t, e, i) {
    fetch(t).then(function(n) {
      return n.text();
    }).then(function(n) {
      if (i === "append") {
        var r = '<div class="lg-sub-html">' + n + "</div>";
        e.append(r);
      } else e.html(n);
    });
  }, getSize: function(t, e, i, n) {
    i === void 0 && (i = 0);
    var r = se(t), o = r.attr("data-lg-size") || n;
    if (o) {
      var l = o.split(",");
      if (l[1]) for (var c = window.innerWidth, d = 0; d < l.length; d++) {
        var v = l[d], b = parseInt(v.split("-")[2], 10);
        if (b > c) {
          o = v;
          break;
        }
        d === l.length - 1 && (o = v);
      }
      var y = o.split("-"), _ = parseInt(y[0], 10), p = parseInt(y[1], 10), m = e.width(), C = e.height() - i, S = Math.min(m, _), h = Math.min(C, p), E = Math.min(S / _, h / p);
      return { width: _ * E, height: p * E };
    }
  }, getTransform: function(t, e, i, n, r) {
    if (r) {
      var o = se(t).find("img").first();
      if (o.get()) {
        var l = e.get().getBoundingClientRect(), c = l.width, d = e.height() - (i + n), v = o.width(), b = o.height(), y = o.style(), _ = (c - v) / 2 - o.offset().left + (parseFloat(y.paddingLeft) || 0) + (parseFloat(y.borderLeft) || 0) + se(window).scrollLeft() + l.left, p = (d - b) / 2 - o.offset().top + (parseFloat(y.paddingTop) || 0) + (parseFloat(y.borderTop) || 0) + se(window).scrollTop() + i, m = v / r.width, C = b / r.height, S = "translate3d(" + (_ *= -1) + "px, " + (p *= -1) + "px, 0) scale3d(" + m + ", " + C + ", 1)";
        return S;
      }
    }
  }, getIframeMarkup: function(t, e, i, n, r, o) {
    var l = o ? 'title="' + o + '"' : "";
    return '<div class="lg-media-cont lg-has-iframe" style="width:' + t + "; max-width:" + i + "; height: " + e + "; max-height:" + n + `">
                    <iframe class="lg-object" frameborder="0" ` + l + ' src="' + r + `"  allowfullscreen="true"></iframe>
                </div>`;
  }, getImgMarkup: function(t, e, i, n, r, o) {
    var l = n ? 'srcset="' + n + '"' : "", c = r ? 'sizes="' + r + '"' : "", d = "<img " + i + " " + l + "  " + c + ' class="lg-object lg-image" data-index="' + t + '" src="' + e + '" />', v = "";
    if (o) {
      var b = typeof o == "string" ? JSON.parse(o) : o;
      v = b.map(function(y) {
        var _ = "";
        return Object.keys(y).forEach(function(p) {
          _ += " " + p + '="' + y[p] + '"';
        }), "<source " + _ + "></source>";
      });
    }
    return "" + v + d;
  }, getResponsiveSrc: function(t) {
    for (var e = [], i = [], n = "", r = 0; r < t.length; r++) {
      var o = t[r].split(" ");
      o[0] === "" && o.splice(0, 1), i.push(o[0]), e.push(o[1]);
    }
    for (var l = window.innerWidth, c = 0; c < e.length; c++) if (parseInt(e[c], 10) > l) {
      n = i[c];
      break;
    }
    return n;
  }, isImageLoaded: function(t) {
    return !(!t || !t.complete || t.naturalWidth === 0);
  }, getVideoPosterMarkup: function(t, e, i, n, r) {
    var o = "";
    r && r.youtube ? o = "lg-has-youtube" : r && r.vimeo ? o = "lg-has-vimeo" : o = "lg-has-html5";
    var l = e;
    return typeof e != "string" && (l = e.outerHTML), '<div class="lg-video-cont ' + o + '" style="' + i + `">
                <div class="lg-video-play-button">
                <svg
                    viewBox="0 0 20 20"
                    preserveAspectRatio="xMidYMid"
                    focusable="false"
                    aria-labelledby="` + n + `"
                    role="img"
                    class="lg-video-play-icon"
                >
                    <title>` + n + `</title>
                    <polygon class="lg-video-play-icon-inner" points="1,0 20,10 1,20"></polygon>
                </svg>
                <svg class="lg-video-play-icon-bg" viewBox="0 0 50 50" focusable="false">
                    <circle cx="50%" cy="50%" r="20"></circle></svg>
                <svg class="lg-video-play-icon-circle" viewBox="0 0 50 50" focusable="false">
                    <circle cx="50%" cy="50%" r="20"></circle>
                </svg>
            </div>
            ` + l + `
            <img class="lg-object lg-video-poster" src="` + t + `" />
        </div>`;
  }, getFocusableElements: function(t) {
    var e = t.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'), i = [].filter.call(e, function(n) {
      var r = window.getComputedStyle(n);
      return r.display !== "none" && r.visibility !== "hidden";
    });
    return i;
  }, getDynamicOptions: function(t, e, i, n) {
    var r = [], o = lv(dv, e);
    return [].forEach.call(t, function(l) {
      for (var c = {}, d = 0; d < l.attributes.length; d++) {
        var v = l.attributes[d];
        if (v.specified) {
          var b = fv(v.name), y = "";
          o.indexOf(b) > -1 && (y = b), y && (c[y] = v.value);
        }
      }
      var _ = se(l), p = _.find("img").first().attr("alt"), m = _.attr("title"), C = n ? _.attr(n) : _.find("img").first().attr("src");
      c.thumb = C, i && !c.subHtml && (c.subHtml = m || p || ""), c.alt = p || m || "", r.push(c);
    }), r;
  }, isMobile: function() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }, isVideo: function(t, e, i) {
    if (!t) {
      if (e) return { html5: true };
      console.error("lightGallery :- data-src is not provided on slide item " + (i + 1) + ". Please make sure the selector property is properly configured. More info - https://www.lightgalleryjs.com/demos/html-markup/");
      return;
    }
    var n = t.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com|be-nocookie\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)([\&|?][\S]*)*/i), r = t.match(/\/\/(?:www\.)?(?:player\.)?vimeo.com\/(?:video\/)?([0-9a-z\-_]+)(.*)?/i), o = t.match(/https?:\/\/(.+)?(wistia\.com|wi\.st)\/(medias|embed)\/([0-9a-z\-_]+)(.*)/);
    if (n) return { youtube: n };
    if (r) return { vimeo: r };
    if (o) return { wistia: o };
  } }, Ia = 0, hv = (function() {
    function t(e, i) {
      if (this.lgOpened = false, this.index = 0, this.plugins = [], this.lGalleryOn = false, this.lgBusy = false, this.currentItemsInDom = [], this.prevScrollTop = 0, this.bodyPaddingRight = 0, this.isDummyImageRemoved = false, this.dragOrSwipeEnabled = false, this.mediaContainerPosition = { top: 0, bottom: 0 }, !e) return this;
      if (Ia++, this.lgId = Ia, this.el = e, this.LGel = se(e), this.generateSettings(i), this.buildModules(), this.settings.dynamic && this.settings.dynamicEl !== void 0 && !Array.isArray(this.settings.dynamicEl)) throw "When using dynamic mode, you must also define dynamicEl as an Array.";
      return this.galleryItems = this.getItems(), this.normalizeSettings(), this.init(), this.validateLicense(), this;
    }
    return t.prototype.generateSettings = function(e) {
      if (this.settings = kt(kt({}, uv), e), this.settings.isMobile && typeof this.settings.isMobile == "function" ? this.settings.isMobile() : Ie.isMobile()) {
        var i = kt(kt({}, this.settings.mobileSettings), this.settings.mobileSettings);
        this.settings = kt(kt({}, this.settings), i);
      }
    }, t.prototype.normalizeSettings = function() {
      if (this.settings.slideEndAnimation && (this.settings.hideControlOnEnd = false), this.settings.closable || (this.settings.swipeToClose = false), this.zoomFromOrigin = this.settings.zoomFromOrigin, this.settings.dynamic && (this.zoomFromOrigin = false), this.settings.container) {
        var e = this.settings.container;
        if (typeof e == "function") this.settings.container = e();
        else if (typeof e == "string") {
          var i = document.querySelector(e);
          this.settings.container = i != null ? i : document.body;
        }
      } else this.settings.container = document.body;
      this.settings.preload = Math.min(this.settings.preload, this.galleryItems.length);
    }, t.prototype.init = function() {
      var e = this;
      this.addSlideVideoInfo(this.galleryItems), this.buildStructure(), this.LGel.trigger(pe.init, { instance: this }), this.settings.keyPress && this.keyPress(), setTimeout(function() {
        e.enableDrag(), e.enableSwipe(), e.triggerPosterClick();
      }, 50), this.arrow(), this.settings.mousewheel && this.mousewheel(), this.settings.dynamic || this.openGalleryOnItemClick();
    }, t.prototype.openGalleryOnItemClick = function() {
      for (var e = this, i = function(o) {
        var l = n.items[o], c = se(l), d = Fl.generateUUID();
        c.attr("data-lg-id", d).on("click.lgcustom-item-" + d, function(v) {
          v.preventDefault();
          var b = e.settings.index || o;
          e.openGallery(b, l);
        });
      }, n = this, r = 0; r < this.items.length; r++) i(r);
    }, t.prototype.buildModules = function() {
      var e = this;
      this.settings.plugins.forEach(function(i) {
        e.plugins.push(new i(e, se));
      });
    }, t.prototype.validateLicense = function() {
      this.settings.licenseKey ? this.settings.licenseKey === "0000-0000-000-0000" && console.warn("lightGallery: " + this.settings.licenseKey + " license key is not valid for production use") : console.error("Please provide a valid license key");
    }, t.prototype.getSlideItem = function(e) {
      return se(this.getSlideItemId(e));
    }, t.prototype.getSlideItemId = function(e) {
      return "#lg-item-" + this.lgId + "-" + e;
    }, t.prototype.getIdName = function(e) {
      return e + "-" + this.lgId;
    }, t.prototype.getElementById = function(e) {
      return se("#" + this.getIdName(e));
    }, t.prototype.manageSingleSlideClassName = function() {
      this.galleryItems.length < 2 ? this.outer.addClass("lg-single-item") : this.outer.removeClass("lg-single-item");
    }, t.prototype.buildStructure = function() {
      var e = this, i = this.$container && this.$container.get();
      if (!i) {
        var n = "", r = "";
        this.settings.controls && (n = '<button type="button" id="' + this.getIdName("lg-prev") + '" aria-label="' + this.settings.strings.previousSlide + '" class="lg-prev lg-icon"> ' + this.settings.prevHtml + ` </button>
                <button type="button" id="` + this.getIdName("lg-next") + '" aria-label="' + this.settings.strings.nextSlide + '" class="lg-next lg-icon"> ' + this.settings.nextHtml + " </button>"), this.settings.appendSubHtmlTo !== ".lg-item" && (r = '<div class="lg-sub-html" role="status" aria-live="polite"></div>');
        var o = "";
        this.settings.allowMediaOverlap && (o += "lg-media-overlap ");
        var l = this.settings.ariaLabelledby ? 'aria-labelledby="' + this.settings.ariaLabelledby + '"' : "", c = this.settings.ariaDescribedby ? 'aria-describedby="' + this.settings.ariaDescribedby + '"' : "", d = "lg-container " + this.settings.addClass + " " + (document.body !== this.settings.container ? "lg-inline" : ""), v = this.settings.closable && this.settings.showCloseIcon ? '<button type="button" aria-label="' + this.settings.strings.closeGallery + '" id="' + this.getIdName("lg-close") + '" class="lg-close lg-icon"></button>' : "", b = this.settings.showMaximizeIcon ? '<button type="button" aria-label="' + this.settings.strings.toggleMaximize + '" id="' + this.getIdName("lg-maximize") + '" class="lg-maximize lg-icon"></button>' : "", y = `
        <div class="` + d + '" id="' + this.getIdName("lg-container") + '" tabindex="-1" aria-modal="true" ' + l + " " + c + ` role="dialog"
        >
            <div id="` + this.getIdName("lg-backdrop") + `" class="lg-backdrop"></div>

            <div id="` + this.getIdName("lg-outer") + '" class="lg-outer lg-use-css3 lg-css3 lg-hide-items ' + o + ` ">

              <div id="` + this.getIdName("lg-content") + `" class="lg-content">
                <div id="` + this.getIdName("lg-inner") + `" class="lg-inner">
                </div>
                ` + n + `
              </div>
                <div id="` + this.getIdName("lg-toolbar") + `" class="lg-toolbar lg-group">
                    ` + b + `
                    ` + v + `
                    </div>
                    ` + (this.settings.appendSubHtmlTo === ".lg-outer" ? r : "") + `
                <div id="` + this.getIdName("lg-components") + `" class="lg-components">
                    ` + (this.settings.appendSubHtmlTo === ".lg-sub-html" ? r : "") + `
                </div>
            </div>
        </div>
        `;
        se(this.settings.container).append(y), document.body !== this.settings.container && se(this.settings.container).css("position", "relative"), this.outer = this.getElementById("lg-outer"), this.$lgComponents = this.getElementById("lg-components"), this.$backdrop = this.getElementById("lg-backdrop"), this.$container = this.getElementById("lg-container"), this.$inner = this.getElementById("lg-inner"), this.$content = this.getElementById("lg-content"), this.$toolbar = this.getElementById("lg-toolbar"), this.$backdrop.css("transition-duration", this.settings.backdropDuration + "ms");
        var _ = this.settings.mode + " ";
        this.manageSingleSlideClassName(), this.settings.enableDrag && (_ += "lg-grab "), this.outer.addClass(_), this.$inner.css("transition-timing-function", this.settings.easing), this.$inner.css("transition-duration", this.settings.speed + "ms"), this.settings.download && this.$toolbar.append('<a id="' + this.getIdName("lg-download") + '" target="_blank" rel="noopener" aria-label="' + this.settings.strings.download + '" download class="lg-download lg-icon"></a>'), this.counter(), se(window).on("resize.lg.global" + this.lgId + " orientationchange.lg.global" + this.lgId, function() {
          e.refreshOnResize();
        }), this.hideBars(), this.manageCloseGallery(), this.toggleMaximize(), this.initModules();
      }
    }, t.prototype.refreshOnResize = function() {
      if (this.lgOpened) {
        var e = this.galleryItems[this.index], i = e.__slideVideoInfo;
        this.mediaContainerPosition = this.getMediaContainerPosition();
        var n = this.mediaContainerPosition, r = n.top, o = n.bottom;
        if (this.currentImageSize = Ie.getSize(this.items[this.index], this.outer, r + o, i && this.settings.videoMaxSize), i && this.resizeVideoSlide(this.index, this.currentImageSize), this.zoomFromOrigin && !this.isDummyImageRemoved) {
          var l = this.getDummyImgStyles(this.currentImageSize);
          this.outer.find(".lg-current .lg-dummy-img").first().attr("style", l);
        }
        this.LGel.trigger(pe.containerResize);
      }
    }, t.prototype.resizeVideoSlide = function(e, i) {
      var n = this.getVideoContStyle(i), r = this.getSlideItem(e);
      r.find(".lg-video-cont").attr("style", n);
    }, t.prototype.updateSlides = function(e, i) {
      if (this.index > e.length - 1 && (this.index = e.length - 1), e.length === 1 && (this.index = 0), !e.length) {
        this.closeGallery();
        return;
      }
      var n = this.galleryItems[i].src;
      this.galleryItems = e, this.updateControls(), this.$inner.empty(), this.currentItemsInDom = [];
      var r = 0;
      this.galleryItems.some(function(o, l) {
        return o.src === n ? (r = l, true) : false;
      }), this.currentItemsInDom = this.organizeSlideItems(r, -1), this.loadContent(r, true), this.getSlideItem(r).addClass("lg-current"), this.index = r, this.updateCurrentCounter(r), this.LGel.trigger(pe.updateSlides);
    }, t.prototype.getItems = function() {
      if (this.items = [], this.settings.dynamic) return this.settings.dynamicEl || [];
      if (this.settings.selector === "this") this.items.push(this.el);
      else if (this.settings.selector) if (typeof this.settings.selector == "string") if (this.settings.selectWithin) {
        var e = se(this.settings.selectWithin);
        this.items = e.find(this.settings.selector).get();
      } else this.items = this.el.querySelectorAll(this.settings.selector);
      else this.items = this.settings.selector;
      else this.items = this.el.children;
      return Ie.getDynamicOptions(this.items, this.settings.extraProps, this.settings.getCaptionFromTitleOrAlt, this.settings.exThumbImage);
    }, t.prototype.shouldHideScrollbar = function() {
      return this.settings.hideScrollbar && document.body === this.settings.container;
    }, t.prototype.hideScrollbar = function() {
      if (this.shouldHideScrollbar()) {
        this.bodyPaddingRight = parseFloat(se("body").style().paddingRight);
        var e = document.documentElement.getBoundingClientRect(), i = window.innerWidth - e.width;
        se(document.body).css("padding-right", i + this.bodyPaddingRight + "px"), se(document.body).addClass("lg-overlay-open");
      }
    }, t.prototype.resetScrollBar = function() {
      this.shouldHideScrollbar() && (se(document.body).css("padding-right", this.bodyPaddingRight + "px"), se(document.body).removeClass("lg-overlay-open"));
    }, t.prototype.openGallery = function(e, i) {
      var n = this;
      if (e === void 0 && (e = this.settings.index), !this.lgOpened) {
        this.lgOpened = true, this.outer.removeClass("lg-hide-items"), this.hideScrollbar(), this.$container.addClass("lg-show");
        var r = this.getItemsToBeInsertedToDom(e, e);
        this.currentItemsInDom = r;
        var o = "";
        r.forEach(function(_) {
          o = o + ('<div id="' + _ + '" class="lg-item"></div>');
        }), this.$inner.append(o), this.addHtml(e);
        var l = "";
        this.mediaContainerPosition = this.getMediaContainerPosition();
        var c = this.mediaContainerPosition, d = c.top, v = c.bottom;
        this.settings.allowMediaOverlap || this.setMediaContainerPosition(d, v);
        var b = this.galleryItems[e].__slideVideoInfo;
        this.zoomFromOrigin && i && (this.currentImageSize = Ie.getSize(i, this.outer, d + v, b && this.settings.videoMaxSize), l = Ie.getTransform(i, this.outer, d, v, this.currentImageSize)), (!this.zoomFromOrigin || !l) && (this.outer.addClass(this.settings.startClass), this.getSlideItem(e).removeClass("lg-complete"));
        var y = this.settings.zoomFromOrigin ? 100 : this.settings.backdropDuration;
        setTimeout(function() {
          n.outer.addClass("lg-components-open");
        }, y), this.index = e, this.LGel.trigger(pe.beforeOpen), this.getSlideItem(e).addClass("lg-current"), this.lGalleryOn = false, this.prevScrollTop = se(window).scrollTop(), setTimeout(function() {
          if (n.zoomFromOrigin && l) {
            var _ = n.getSlideItem(e);
            _.css("transform", l), setTimeout(function() {
              _.addClass("lg-start-progress lg-start-end-progress").css("transition-duration", n.settings.startAnimationDuration + "ms"), n.outer.addClass("lg-zoom-from-image");
            }), setTimeout(function() {
              _.css("transform", "translate3d(0, 0, 0)");
            }, 100);
          }
          setTimeout(function() {
            n.$backdrop.addClass("in"), n.$container.addClass("lg-show-in");
          }, 10), setTimeout(function() {
            n.settings.trapFocus && document.body === n.settings.container && n.trapFocus();
          }, n.settings.backdropDuration + 50), (!n.zoomFromOrigin || !l) && setTimeout(function() {
            n.outer.addClass("lg-visible");
          }, n.settings.backdropDuration), n.slide(e, false, false, false), n.LGel.trigger(pe.afterOpen);
        }), document.body === this.settings.container && se("html").addClass("lg-on");
      }
    }, t.prototype.getMediaContainerPosition = function() {
      if (this.settings.allowMediaOverlap) return { top: 0, bottom: 0 };
      var e = this.$toolbar.get().clientHeight || 0, i = this.outer.find(".lg-components .lg-sub-html").get(), n = this.settings.defaultCaptionHeight || i && i.clientHeight || 0, r = this.outer.find(".lg-thumb-outer").get(), o = r ? r.clientHeight : 0, l = o + n;
      return { top: e, bottom: l };
    }, t.prototype.setMediaContainerPosition = function(e, i) {
      e === void 0 && (e = 0), i === void 0 && (i = 0), this.$content.css("top", e + "px").css("bottom", i + "px");
    }, t.prototype.hideBars = function() {
      var e = this;
      setTimeout(function() {
        e.outer.removeClass("lg-hide-items"), e.settings.hideBarsDelay > 0 && (e.outer.on("mousemove.lg click.lg touchstart.lg", function() {
          e.outer.removeClass("lg-hide-items"), clearTimeout(e.hideBarTimeout), e.hideBarTimeout = setTimeout(function() {
            e.outer.addClass("lg-hide-items");
          }, e.settings.hideBarsDelay);
        }), e.outer.trigger("mousemove.lg"));
      }, this.settings.showBarsAfter);
    }, t.prototype.initPictureFill = function(e) {
      if (this.settings.supportLegacyBrowser) try {
        picturefill({ elements: [e.get()] });
      } catch (i) {
        console.warn("lightGallery :- If you want srcset or picture tag to be supported for older browser please include picturefil javascript library in your document.");
      }
    }, t.prototype.counter = function() {
      if (this.settings.counter) {
        var e = `<div class="lg-counter" role="status" aria-live="polite">
                <span id="` + this.getIdName("lg-counter-current") + '" class="lg-counter-current">' + (this.index + 1) + ` </span> /
                <span id="` + this.getIdName("lg-counter-all") + '" class="lg-counter-all">' + this.galleryItems.length + " </span></div>";
        this.outer.find(this.settings.appendCounterTo).append(e);
      }
    }, t.prototype.addHtml = function(e) {
      var i, n;
      if (this.galleryItems[e].subHtmlUrl ? n = this.galleryItems[e].subHtmlUrl : i = this.galleryItems[e].subHtml, !n) if (i) {
        var r = i.substring(0, 1);
        if (r === "." || r === "#") try {
          this.settings.subHtmlSelectorRelative && !this.settings.dynamic ? i = se(this.items).eq(e).find(i).first().html() : i = se(i).first().html();
        } catch (l) {
          console.warn('Error processing subHtml selector "' + i + '"'), i = "";
        }
      } else i = "";
      if (this.settings.appendSubHtmlTo !== ".lg-item") n ? Ie.fetchCaptionFromUrl(n, this.outer.find(".lg-sub-html"), "replace") : this.outer.find(".lg-sub-html").html(i);
      else {
        var o = se(this.getSlideItemId(e));
        n ? Ie.fetchCaptionFromUrl(n, o, "append") : o.append('<div class="lg-sub-html">' + i + "</div>");
      }
      typeof i != "undefined" && i !== null && (i === "" ? this.outer.find(this.settings.appendSubHtmlTo).addClass("lg-empty-html") : this.outer.find(this.settings.appendSubHtmlTo).removeClass("lg-empty-html")), this.LGel.trigger(pe.afterAppendSubHtml, { index: e });
    }, t.prototype.preload = function(e) {
      for (var i = 1; i <= this.settings.preload && !(i >= this.galleryItems.length - e); i++) this.loadContent(e + i, false);
      for (var n = 1; n <= this.settings.preload && !(e - n < 0); n++) this.loadContent(e - n, false);
    }, t.prototype.getDummyImgStyles = function(e) {
      return e ? "width:" + e.width + `px;
                margin-left: -` + e.width / 2 + `px;
                margin-top: -` + e.height / 2 + `px;
                height:` + e.height + "px" : "";
    }, t.prototype.getVideoContStyle = function(e) {
      return e ? "width:" + e.width + `px;
                height:` + e.height + "px" : "";
    }, t.prototype.getDummyImageContent = function(e, i, n) {
      var r;
      if (this.settings.dynamic || (r = se(this.items).eq(i)), r) {
        var o = void 0;
        if (this.settings.exThumbImage ? o = r.attr(this.settings.exThumbImage) : o = r.find("img").first().attr("src"), !o) return "";
        var l = this.getDummyImgStyles(this.currentImageSize), c = document.createElement("img");
        return c.alt = n || "", c.src = o, c.className = "lg-dummy-img", c.style.cssText = l, e.addClass("lg-first-slide"), this.outer.addClass("lg-first-slide-loading"), c;
      }
      return "";
    }, t.prototype.setImgMarkup = function(e, i, n) {
      var r = this.galleryItems[n], o = r.alt, l = r.srcset, c = r.sizes, d = r.sources, v = "", b = o ? 'alt="' + o + '"' : "";
      this.isFirstSlideWithZoomAnimation() ? v = this.getDummyImageContent(i, n, b) : v = Ie.getImgMarkup(n, e, b, l, c, d);
      var y = document.createElement("picture");
      y.className = "lg-img-wrap", se(y).append(v), i.prepend(y);
    }, t.prototype.onSlideObjectLoad = function(e, i, n, r) {
      var o = e.find(".lg-object").first();
      Ie.isImageLoaded(o.get()) || i ? n() : (o.on("load.lg error.lg", function() {
        n && n();
      }), o.on("error.lg", function() {
        r && r();
      }));
    }, t.prototype.onLgObjectLoad = function(e, i, n, r, o, l) {
      var c = this;
      this.onSlideObjectLoad(e, l, function() {
        c.triggerSlideItemLoad(e, i, n, r, o);
      }, function() {
        e.addClass("lg-complete lg-complete_"), e.html('<span class="lg-error-msg">' + c.settings.strings.mediaLoadingFailed + "</span>");
      });
    }, t.prototype.triggerSlideItemLoad = function(e, i, n, r, o) {
      var l = this, c = this.galleryItems[i], d = o && this.getSlideType(c) === "video" && !c.poster ? r : 0;
      setTimeout(function() {
        e.addClass("lg-complete lg-complete_"), l.LGel.trigger(pe.slideItemLoad, { index: i, delay: n || 0, isFirstSlide: o });
      }, d);
    }, t.prototype.isFirstSlideWithZoomAnimation = function() {
      return !!(!this.lGalleryOn && this.zoomFromOrigin && this.currentImageSize);
    }, t.prototype.addSlideVideoInfo = function(e) {
      var i = this;
      e.forEach(function(n, r) {
        n.__slideVideoInfo = Ie.isVideo(n.src, !!n.video, r), n.__slideVideoInfo && i.settings.loadYouTubePoster && !n.poster && n.__slideVideoInfo.youtube && (n.poster = "//img.youtube.com/vi/" + n.__slideVideoInfo.youtube[1] + "/maxresdefault.jpg");
      });
    }, t.prototype.loadContent = function(e, i) {
      var n = this, r = this.galleryItems[e], o = se(this.getSlideItemId(e)), l = r.poster, c = r.srcset, d = r.sizes, v = r.sources, b = r.src, y = r.video, _ = y && typeof y == "string" ? JSON.parse(y) : y;
      if (r.responsive) {
        var p = r.responsive.split(",");
        b = Ie.getResponsiveSrc(p) || b;
      }
      var m = r.__slideVideoInfo, C = "", S = !!r.iframe, h = !this.lGalleryOn, E = 0;
      if (h && (this.zoomFromOrigin && this.currentImageSize ? E = this.settings.startAnimationDuration + 10 : E = this.settings.backdropDuration + 10), !o.hasClass("lg-loaded")) {
        if (m) {
          var I = this.mediaContainerPosition, O = I.top, L = I.bottom, f = Ie.getSize(this.items[e], this.outer, O + L, m && this.settings.videoMaxSize);
          C = this.getVideoContStyle(f);
        }
        if (S) {
          var P = Ie.getIframeMarkup(this.settings.iframeWidth, this.settings.iframeHeight, this.settings.iframeMaxWidth, this.settings.iframeMaxHeight, b, r.iframeTitle);
          o.prepend(P);
        } else if (l) {
          var D = "", H = h && this.zoomFromOrigin && this.currentImageSize;
          H && (D = this.getDummyImageContent(o, e, ""));
          var P = Ie.getVideoPosterMarkup(l, D || "", C, this.settings.strings.playVideo, m);
          o.prepend(P);
        } else if (m) {
          var P = '<div class="lg-video-cont " style="' + C + '"></div>';
          o.prepend(P);
        } else if (this.setImgMarkup(b, o, e), c || v) {
          var k = o.find(".lg-object");
          this.initPictureFill(k);
        }
        (l || m) && this.LGel.trigger(pe.hasVideo, { index: e, src: b, html5Video: _, hasPoster: !!l }), this.LGel.trigger(pe.afterAppendSlide, { index: e }), this.lGalleryOn && this.settings.appendSubHtmlTo === ".lg-item" && this.addHtml(e);
      }
      var z = 0;
      E && !se(document.body).hasClass("lg-from-hash") && (z = E), this.isFirstSlideWithZoomAnimation() && (setTimeout(function() {
        o.removeClass("lg-start-end-progress lg-start-progress").removeAttr("style");
      }, this.settings.startAnimationDuration + 100), o.hasClass("lg-loaded") || setTimeout(function() {
        if (n.getSlideType(r) === "image") {
          var B = r.alt, V = B ? 'alt="' + B + '"' : "";
          if (o.find(".lg-img-wrap").append(Ie.getImgMarkup(e, b, V, c, d, r.sources)), c || v) {
            var X = o.find(".lg-object");
            n.initPictureFill(X);
          }
        }
        (n.getSlideType(r) === "image" || n.getSlideType(r) === "video" && l) && (n.onLgObjectLoad(o, e, E, z, true, false), n.onSlideObjectLoad(o, !!(m && m.html5 && !l), function() {
          n.loadContentOnFirstSlideLoad(e, o, z);
        }, function() {
          n.loadContentOnFirstSlideLoad(e, o, z);
        }));
      }, this.settings.startAnimationDuration + 100)), o.addClass("lg-loaded"), (!this.isFirstSlideWithZoomAnimation() || this.getSlideType(r) === "video" && !l) && this.onLgObjectLoad(o, e, E, z, h, !!(m && m.html5 && !l)), (!this.zoomFromOrigin || !this.currentImageSize) && o.hasClass("lg-complete_") && !this.lGalleryOn && setTimeout(function() {
        o.addClass("lg-complete");
      }, this.settings.backdropDuration), this.lGalleryOn = true, i === true && (o.hasClass("lg-complete_") ? this.preload(e) : o.find(".lg-object").first().on("load.lg error.lg", function() {
        n.preload(e);
      }));
    }, t.prototype.loadContentOnFirstSlideLoad = function(e, i, n) {
      var r = this;
      setTimeout(function() {
        i.find(".lg-dummy-img").remove(), i.removeClass("lg-first-slide"), r.outer.removeClass("lg-first-slide-loading"), r.isDummyImageRemoved = true, r.preload(e);
      }, n + 300);
    }, t.prototype.getItemsToBeInsertedToDom = function(e, i, n) {
      var r = this;
      n === void 0 && (n = 0);
      var o = [], l = Math.max(n, 3);
      l = Math.min(l, this.galleryItems.length);
      var c = "lg-item-" + this.lgId + "-" + i;
      if (this.galleryItems.length <= 3) return this.galleryItems.forEach(function(b, y) {
        o.push("lg-item-" + r.lgId + "-" + y);
      }), o;
      if (e < (this.galleryItems.length - 1) / 2) {
        for (var d = e; d > e - l / 2 && d >= 0; d--) o.push("lg-item-" + this.lgId + "-" + d);
        for (var v = o.length, d = 0; d < l - v; d++) o.push("lg-item-" + this.lgId + "-" + (e + d + 1));
      } else {
        for (var d = e; d <= this.galleryItems.length - 1 && d < e + l / 2; d++) o.push("lg-item-" + this.lgId + "-" + d);
        for (var v = o.length, d = 0; d < l - v; d++) o.push("lg-item-" + this.lgId + "-" + (e - d - 1));
      }
      return this.settings.loop && (e === this.galleryItems.length - 1 ? o.push("lg-item-" + this.lgId + "-0") : e === 0 && o.push("lg-item-" + this.lgId + "-" + (this.galleryItems.length - 1))), o.indexOf(c) === -1 && o.push("lg-item-" + this.lgId + "-" + i), o;
    }, t.prototype.organizeSlideItems = function(e, i) {
      var n = this, r = this.getItemsToBeInsertedToDom(e, i, this.settings.numberOfSlideItemsInDom);
      return r.forEach(function(o) {
        n.currentItemsInDom.indexOf(o) === -1 && n.$inner.append('<div id="' + o + '" class="lg-item"></div>');
      }), this.currentItemsInDom.forEach(function(o) {
        r.indexOf(o) === -1 && se("#" + o).remove();
      }), r;
    }, t.prototype.getPreviousSlideIndex = function() {
      var e = 0;
      try {
        var i = this.outer.find(".lg-current").first().attr("id");
        e = parseInt(i.split("-")[3]) || 0;
      } catch (n) {
        e = 0;
      }
      return e;
    }, t.prototype.setDownloadValue = function(e) {
      if (this.settings.download) {
        var i = this.galleryItems[e], n = i.downloadUrl === false || i.downloadUrl === "false";
        if (n) this.outer.addClass("lg-hide-download");
        else {
          var r = this.getElementById("lg-download");
          this.outer.removeClass("lg-hide-download"), r.attr("href", i.downloadUrl || i.src), i.download && r.attr("download", i.download);
        }
      }
    }, t.prototype.makeSlideAnimation = function(e, i, n) {
      var r = this;
      this.lGalleryOn && n.addClass("lg-slide-progress"), setTimeout(function() {
        r.outer.addClass("lg-no-trans"), r.outer.find(".lg-item").removeClass("lg-prev-slide lg-next-slide"), e === "prev" ? (i.addClass("lg-prev-slide"), n.addClass("lg-next-slide")) : (i.addClass("lg-next-slide"), n.addClass("lg-prev-slide")), setTimeout(function() {
          r.outer.find(".lg-item").removeClass("lg-current"), i.addClass("lg-current"), r.outer.removeClass("lg-no-trans");
        }, 50);
      }, this.lGalleryOn ? this.settings.slideDelay : 0);
    }, t.prototype.slide = function(e, i, n, r) {
      var o = this, l = this.getPreviousSlideIndex();
      if (this.currentItemsInDom = this.organizeSlideItems(e, l), !(this.lGalleryOn && l === e)) {
        var c = this.galleryItems.length;
        if (!this.lgBusy) {
          this.settings.counter && this.updateCurrentCounter(e);
          var d = this.getSlideItem(e), v = this.getSlideItem(l), b = this.galleryItems[e], y = b.__slideVideoInfo;
          if (this.outer.attr("data-lg-slide-type", this.getSlideType(b)), this.setDownloadValue(e), y) {
            var _ = this.mediaContainerPosition, p = _.top, m = _.bottom, C = Ie.getSize(this.items[e], this.outer, p + m, y && this.settings.videoMaxSize);
            this.resizeVideoSlide(e, C);
          }
          if (this.LGel.trigger(pe.beforeSlide, { prevIndex: l, index: e, fromTouch: !!i, fromThumb: !!n }), this.lgBusy = true, clearTimeout(this.hideBarTimeout), this.arrowDisable(e), r || (e < l ? r = "prev" : e > l && (r = "next")), !i) this.makeSlideAnimation(r, d, v);
          else {
            this.outer.find(".lg-item").removeClass("lg-prev-slide lg-current lg-next-slide");
            var S = void 0, h = void 0;
            c > 2 ? (S = e - 1, h = e + 1, (e === 0 && l === c - 1 || e === c - 1 && l === 0) && (h = 0, S = c - 1)) : (S = 0, h = 1), r === "prev" ? this.getSlideItem(h).addClass("lg-next-slide") : this.getSlideItem(S).addClass("lg-prev-slide"), d.addClass("lg-current");
          }
          this.lGalleryOn ? setTimeout(function() {
            o.loadContent(e, true), o.settings.appendSubHtmlTo !== ".lg-item" && o.addHtml(e);
          }, this.settings.speed + 50 + (i ? 0 : this.settings.slideDelay)) : this.loadContent(e, true), setTimeout(function() {
            o.lgBusy = false, v.removeClass("lg-slide-progress"), o.LGel.trigger(pe.afterSlide, { prevIndex: l, index: e, fromTouch: i, fromThumb: n });
          }, (this.lGalleryOn ? this.settings.speed + 100 : 100) + (i ? 0 : this.settings.slideDelay));
        }
        this.index = e;
      }
    }, t.prototype.updateCurrentCounter = function(e) {
      this.getElementById("lg-counter-current").html(e + 1 + "");
    }, t.prototype.updateCounterTotal = function() {
      this.getElementById("lg-counter-all").html(this.galleryItems.length + "");
    }, t.prototype.getSlideType = function(e) {
      return e.__slideVideoInfo ? "video" : e.iframe ? "iframe" : "image";
    }, t.prototype.touchMove = function(e, i, n) {
      var r = i.pageX - e.pageX, o = i.pageY - e.pageY, l = false;
      if (this.swipeDirection ? l = true : Math.abs(r) > 15 ? (this.swipeDirection = "horizontal", l = true) : Math.abs(o) > 15 && (this.swipeDirection = "vertical", l = true), !!l) {
        var c = this.getSlideItem(this.index);
        if (this.swipeDirection === "horizontal") {
          n == null || n.preventDefault(), this.outer.addClass("lg-dragging"), this.setTranslate(c, r, 0);
          var d = c.get().offsetWidth, v = d * 15 / 100, b = v - Math.abs(r * 10 / 100);
          this.setTranslate(this.outer.find(".lg-prev-slide").first(), -d + r - b, 0), this.setTranslate(this.outer.find(".lg-next-slide").first(), d + r + b, 0);
        } else if (this.swipeDirection === "vertical" && this.settings.swipeToClose) {
          n == null || n.preventDefault(), this.$container.addClass("lg-dragging-vertical");
          var y = 1 - Math.abs(o) / window.innerHeight;
          this.$backdrop.css("opacity", y);
          var _ = 1 - Math.abs(o) / (window.innerWidth * 2);
          this.setTranslate(c, 0, o, _, _), Math.abs(o) > 100 && this.outer.addClass("lg-hide-items").removeClass("lg-components-open");
        }
      }
    }, t.prototype.touchEnd = function(e, i, n) {
      var r = this, o;
      this.settings.mode !== "lg-slide" && this.outer.addClass("lg-slide"), setTimeout(function() {
        r.$container.removeClass("lg-dragging-vertical"), r.outer.removeClass("lg-dragging lg-hide-items").addClass("lg-components-open");
        var l = true;
        if (r.swipeDirection === "horizontal") {
          o = e.pageX - i.pageX;
          var c = Math.abs(e.pageX - i.pageX);
          o < 0 && c > r.settings.swipeThreshold ? (r.goToNextSlide(true), l = false) : o > 0 && c > r.settings.swipeThreshold && (r.goToPrevSlide(true), l = false);
        } else if (r.swipeDirection === "vertical") if (o = Math.abs(e.pageY - i.pageY), r.settings.closable && r.settings.swipeToClose && o > 100) {
          r.closeGallery();
          return;
        } else r.$backdrop.css("opacity", 1);
        if (r.outer.find(".lg-item").removeAttr("style"), l && Math.abs(e.pageX - i.pageX) < 5) {
          var d = se(n.target);
          r.isPosterElement(d) && r.LGel.trigger(pe.posterClick);
        }
        r.swipeDirection = void 0;
      }), setTimeout(function() {
        !r.outer.hasClass("lg-dragging") && r.settings.mode !== "lg-slide" && r.outer.removeClass("lg-slide");
      }, this.settings.speed + 100);
    }, t.prototype.enableSwipe = function() {
      var e = this, i = {}, n = {}, r = false, o = false;
      this.settings.enableSwipe && (this.$inner.on("touchstart.lg", function(l) {
        e.dragOrSwipeEnabled = true;
        var c = e.getSlideItem(e.index);
        (se(l.target).hasClass("lg-item") || c.get().contains(l.target)) && !e.outer.hasClass("lg-zoomed") && !e.lgBusy && l.touches.length === 1 && (o = true, e.touchAction = "swipe", e.manageSwipeClass(), i = { pageX: l.touches[0].pageX, pageY: l.touches[0].pageY });
      }), this.$inner.on("touchmove.lg", function(l) {
        o && e.touchAction === "swipe" && l.touches.length === 1 && (n = { pageX: l.touches[0].pageX, pageY: l.touches[0].pageY }, e.touchMove(i, n, l), r = true);
      }), this.$inner.on("touchend.lg", function(l) {
        if (e.touchAction === "swipe") {
          if (r) r = false, e.touchEnd(n, i, l);
          else if (o) {
            var c = se(l.target);
            e.isPosterElement(c) && e.LGel.trigger(pe.posterClick);
          }
          e.touchAction = void 0, o = false;
        }
      }));
    }, t.prototype.enableDrag = function() {
      var e = this, i = {}, n = {}, r = false, o = false;
      this.settings.enableDrag && (this.outer.on("mousedown.lg", function(l) {
        e.dragOrSwipeEnabled = true;
        var c = e.getSlideItem(e.index);
        (se(l.target).hasClass("lg-item") || c.get().contains(l.target)) && !e.outer.hasClass("lg-zoomed") && !e.lgBusy && (l.preventDefault(), e.lgBusy || (e.manageSwipeClass(), i = { pageX: l.pageX, pageY: l.pageY }, r = true, e.outer.get().scrollLeft += 1, e.outer.get().scrollLeft -= 1, e.outer.removeClass("lg-grab").addClass("lg-grabbing"), e.LGel.trigger(pe.dragStart)));
      }), se(window).on("mousemove.lg.global" + this.lgId, function(l) {
        r && e.lgOpened && (o = true, n = { pageX: l.pageX, pageY: l.pageY }, e.touchMove(i, n), e.LGel.trigger(pe.dragMove));
      }), se(window).on("mouseup.lg.global" + this.lgId, function(l) {
        if (e.lgOpened) {
          var c = se(l.target);
          o ? (o = false, e.touchEnd(n, i, l), e.LGel.trigger(pe.dragEnd)) : e.isPosterElement(c) && e.LGel.trigger(pe.posterClick), r && (r = false, e.outer.removeClass("lg-grabbing").addClass("lg-grab"));
        }
      }));
    }, t.prototype.triggerPosterClick = function() {
      var e = this;
      this.$inner.on("click.lg", function(i) {
        !e.dragOrSwipeEnabled && e.isPosterElement(se(i.target)) && e.LGel.trigger(pe.posterClick);
      });
    }, t.prototype.manageSwipeClass = function() {
      var e = this.index + 1, i = this.index - 1;
      this.settings.loop && this.galleryItems.length > 2 && (this.index === 0 ? i = this.galleryItems.length - 1 : this.index === this.galleryItems.length - 1 && (e = 0)), this.outer.find(".lg-item").removeClass("lg-next-slide lg-prev-slide"), i > -1 && this.getSlideItem(i).addClass("lg-prev-slide"), this.getSlideItem(e).addClass("lg-next-slide");
    }, t.prototype.goToNextSlide = function(e) {
      var i = this, n = this.settings.loop;
      e && this.galleryItems.length < 3 && (n = false), this.lgBusy || (this.index + 1 < this.galleryItems.length ? (this.index++, this.LGel.trigger(pe.beforeNextSlide, { index: this.index }), this.slide(this.index, !!e, false, "next")) : n ? (this.index = 0, this.LGel.trigger(pe.beforeNextSlide, { index: this.index }), this.slide(this.index, !!e, false, "next")) : this.settings.slideEndAnimation && !e && (this.outer.addClass("lg-right-end"), setTimeout(function() {
        i.outer.removeClass("lg-right-end");
      }, 400)));
    }, t.prototype.goToPrevSlide = function(e) {
      var i = this, n = this.settings.loop;
      e && this.galleryItems.length < 3 && (n = false), this.lgBusy || (this.index > 0 ? (this.index--, this.LGel.trigger(pe.beforePrevSlide, { index: this.index, fromTouch: e }), this.slide(this.index, !!e, false, "prev")) : n ? (this.index = this.galleryItems.length - 1, this.LGel.trigger(pe.beforePrevSlide, { index: this.index, fromTouch: e }), this.slide(this.index, !!e, false, "prev")) : this.settings.slideEndAnimation && !e && (this.outer.addClass("lg-left-end"), setTimeout(function() {
        i.outer.removeClass("lg-left-end");
      }, 400)));
    }, t.prototype.keyPress = function() {
      var e = this;
      se(window).on("keydown.lg.global" + this.lgId, function(i) {
        e.lgOpened && e.settings.escKey === true && i.keyCode === 27 && (i.preventDefault(), e.settings.allowMediaOverlap && e.outer.hasClass("lg-can-toggle") && e.outer.hasClass("lg-components-open") ? e.outer.removeClass("lg-components-open") : e.closeGallery()), e.lgOpened && e.galleryItems.length > 1 && (i.keyCode === 37 && (i.preventDefault(), e.goToPrevSlide()), i.keyCode === 39 && (i.preventDefault(), e.goToNextSlide()));
      });
    }, t.prototype.arrow = function() {
      var e = this;
      this.getElementById("lg-prev").on("click.lg", function() {
        e.goToPrevSlide();
      }), this.getElementById("lg-next").on("click.lg", function() {
        e.goToNextSlide();
      });
    }, t.prototype.arrowDisable = function(e) {
      if (!this.settings.loop && this.settings.hideControlOnEnd) {
        var i = this.getElementById("lg-prev"), n = this.getElementById("lg-next");
        e + 1 === this.galleryItems.length ? n.attr("disabled", "disabled").addClass("disabled") : n.removeAttr("disabled").removeClass("disabled"), e === 0 ? i.attr("disabled", "disabled").addClass("disabled") : i.removeAttr("disabled").removeClass("disabled");
      }
    }, t.prototype.setTranslate = function(e, i, n, r, o) {
      r === void 0 && (r = 1), o === void 0 && (o = 1), e.css("transform", "translate3d(" + i + "px, " + n + "px, 0px) scale3d(" + r + ", " + o + ", 1)");
    }, t.prototype.mousewheel = function() {
      var e = this, i = 0;
      this.outer.on("wheel.lg", function(n) {
        if (!(!n.deltaY || e.galleryItems.length < 2)) {
          n.preventDefault();
          var r = (/* @__PURE__ */ new Date()).getTime();
          r - i < 1e3 || (i = r, n.deltaY > 0 ? e.goToNextSlide() : n.deltaY < 0 && e.goToPrevSlide());
        }
      });
    }, t.prototype.isSlideElement = function(e) {
      return e.hasClass("lg-outer") || e.hasClass("lg-item") || e.hasClass("lg-img-wrap") || e.hasClass("lg-img-rotate");
    }, t.prototype.isPosterElement = function(e) {
      var i = this.getSlideItem(this.index).find(".lg-video-play-button").get();
      return e.hasClass("lg-video-poster") || e.hasClass("lg-video-play-button") || i && i.contains(e.get());
    }, t.prototype.toggleMaximize = function() {
      var e = this;
      this.getElementById("lg-maximize").on("click.lg", function() {
        e.$container.toggleClass("lg-inline"), e.refreshOnResize();
      });
    }, t.prototype.invalidateItems = function() {
      for (var e = 0; e < this.items.length; e++) {
        var i = this.items[e], n = se(i);
        n.off("click.lgcustom-item-" + n.attr("data-lg-id"));
      }
    }, t.prototype.trapFocus = function() {
      var e = this;
      this.$container.get().focus({ preventScroll: true }), se(window).on("keydown.lg.global" + this.lgId, function(i) {
        if (e.lgOpened) {
          var n = i.key === "Tab" || i.keyCode === 9;
          if (n) {
            var r = Ie.getFocusableElements(e.$container.get()), o = r[0], l = r[r.length - 1];
            i.shiftKey ? document.activeElement === o && (l.focus(), i.preventDefault()) : document.activeElement === l && (o.focus(), i.preventDefault());
          }
        }
      });
    }, t.prototype.manageCloseGallery = function() {
      var e = this;
      if (this.settings.closable) {
        var i = false;
        this.getElementById("lg-close").on("click.lg", function() {
          e.closeGallery();
        }), this.settings.closeOnTap && (this.outer.on("mousedown.lg", function(n) {
          var r = se(n.target);
          e.isSlideElement(r) ? i = true : i = false;
        }), this.outer.on("mousemove.lg", function() {
          i = false;
        }), this.outer.on("mouseup.lg", function(n) {
          var r = se(n.target);
          e.isSlideElement(r) && i && (e.outer.hasClass("lg-dragging") || e.closeGallery());
        }));
      }
    }, t.prototype.closeGallery = function(e) {
      var i = this;
      if (!this.lgOpened || !this.settings.closable && !e) return 0;
      this.LGel.trigger(pe.beforeClose), this.settings.resetScrollPosition && !this.settings.hideScrollbar && se(window).scrollTop(this.prevScrollTop);
      var n = this.items[this.index], r;
      if (this.zoomFromOrigin && n) {
        var o = this.mediaContainerPosition, l = o.top, c = o.bottom, d = this.galleryItems[this.index], v = d.__slideVideoInfo, b = d.poster, y = Ie.getSize(n, this.outer, l + c, v && b && this.settings.videoMaxSize);
        r = Ie.getTransform(n, this.outer, l, c, y);
      }
      this.zoomFromOrigin && r ? (this.outer.addClass("lg-closing lg-zoom-from-image"), this.getSlideItem(this.index).addClass("lg-start-end-progress").css("transition-duration", this.settings.startAnimationDuration + "ms").css("transform", r)) : (this.outer.addClass("lg-hide-items"), this.outer.removeClass("lg-zoom-from-image")), this.destroyModules(), this.lGalleryOn = false, this.isDummyImageRemoved = false, this.zoomFromOrigin = this.settings.zoomFromOrigin, clearTimeout(this.hideBarTimeout), this.hideBarTimeout = false, se("html").removeClass("lg-on"), this.outer.removeClass("lg-visible lg-components-open"), this.$backdrop.removeClass("in").css("opacity", 0);
      var _ = this.zoomFromOrigin && r ? Math.max(this.settings.startAnimationDuration, this.settings.backdropDuration) : this.settings.backdropDuration;
      return this.$container.removeClass("lg-show-in"), setTimeout(function() {
        i.zoomFromOrigin && r && i.outer.removeClass("lg-zoom-from-image"), i.$container.removeClass("lg-show"), i.resetScrollBar(), i.$backdrop.removeAttr("style").css("transition-duration", i.settings.backdropDuration + "ms"), i.outer.removeClass("lg-closing " + i.settings.startClass), i.getSlideItem(i.index).removeClass("lg-start-end-progress"), i.$inner.empty(), i.lgOpened && i.LGel.trigger(pe.afterClose, { instance: i }), i.$container.get() && i.$container.get().blur(), i.lgOpened = false;
      }, _ + 100), _ + 100;
    }, t.prototype.initModules = function() {
      this.plugins.forEach(function(e) {
        try {
          e.init();
        } catch (i) {
          console.warn("lightGallery:- make sure lightGallery module is properly initiated");
        }
      });
    }, t.prototype.destroyModules = function(e) {
      this.plugins.forEach(function(i) {
        try {
          e ? i.destroy() : i.closeGallery && i.closeGallery();
        } catch (n) {
          console.warn("lightGallery:- make sure lightGallery module is properly destroyed");
        }
      });
    }, t.prototype.refresh = function(e) {
      this.settings.dynamic || this.invalidateItems(), e ? this.galleryItems = e : this.galleryItems = this.getItems(), this.updateControls(), this.openGalleryOnItemClick(), this.LGel.trigger(pe.updateSlides);
    }, t.prototype.updateControls = function() {
      this.addSlideVideoInfo(this.galleryItems), this.updateCounterTotal(), this.manageSingleSlideClassName();
    }, t.prototype.destroyGallery = function() {
      this.destroyModules(true), this.settings.dynamic || this.invalidateItems(), se(window).off(".lg.global" + this.lgId), this.LGel.off(".lg"), this.$container.remove();
    }, t.prototype.destroy = function() {
      var e = this.closeGallery(true);
      return e ? setTimeout(this.destroyGallery.bind(this), e) : this.destroyGallery(), e;
    }, t;
  })();
  function pv(t, e) {
    return new hv(t, e);
  }
  var Rn = function() {
    return Rn = Object.assign || function(e) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (e[o] = i[o]);
      }
      return e;
    }, Rn.apply(this, arguments);
  }, gv = { thumbnail: true, animateThumb: true, currentPagerPosition: "middle", alignThumbnails: "middle", thumbWidth: 100, thumbHeight: "80px", thumbMargin: 5, appendThumbnailsTo: ".lg-components", toggleThumb: false, enableThumbDrag: true, enableThumbSwipe: true, thumbnailSwipeThreshold: 10, loadYouTubeThumbnail: true, youTubeThumbSize: 1, thumbnailPluginStrings: { toggleThumbnails: "Toggle thumbnails" } }, Gi = { containerResize: "lgContainerResize", updateSlides: "lgUpdateSlides", beforeOpen: "lgBeforeOpen", beforeSlide: "lgBeforeSlide" }, mv = (function() {
    function t(e, i) {
      return this.thumbOuterWidth = 0, this.thumbTotalWidth = 0, this.translateX = 0, this.thumbClickable = false, this.core = e, this.$LG = i, this;
    }
    return t.prototype.init = function() {
      this.settings = Rn(Rn({}, gv), this.core.settings), this.thumbOuterWidth = 0, this.thumbTotalWidth = this.core.galleryItems.length * (this.settings.thumbWidth + this.settings.thumbMargin), this.translateX = 0, this.setAnimateThumbStyles(), this.core.settings.allowMediaOverlap || (this.settings.toggleThumb = false), this.settings.thumbnail && (this.build(), this.settings.animateThumb ? (this.settings.enableThumbDrag && this.enableThumbDrag(), this.settings.enableThumbSwipe && this.enableThumbSwipe(), this.thumbClickable = false) : this.thumbClickable = true, this.toggleThumbBar(), this.thumbKeyPress());
    }, t.prototype.build = function() {
      var e = this;
      this.setThumbMarkup(), this.manageActiveClassOnSlideChange(), this.$lgThumb.first().on("click.lg touchend.lg", function(i) {
        var n = e.$LG(i.target);
        n.hasAttribute("data-lg-item-id") && setTimeout(function() {
          if (e.thumbClickable && !e.core.lgBusy) {
            var r = parseInt(n.attr("data-lg-item-id"));
            e.core.slide(r, false, true, false);
          }
        }, 50);
      }), this.core.LGel.on(Gi.beforeSlide + ".thumb", function(i) {
        var n = i.detail.index;
        e.animateThumb(n);
      }), this.core.LGel.on(Gi.beforeOpen + ".thumb", function() {
        e.thumbOuterWidth = e.core.outer.get().offsetWidth;
      }), this.core.LGel.on(Gi.updateSlides + ".thumb", function() {
        e.rebuildThumbnails();
      }), this.core.LGel.on(Gi.containerResize + ".thumb", function() {
        e.core.lgOpened && setTimeout(function() {
          e.thumbOuterWidth = e.core.outer.get().offsetWidth, e.animateThumb(e.core.index), e.thumbOuterWidth = e.core.outer.get().offsetWidth;
        }, 50);
      });
    }, t.prototype.setThumbMarkup = function() {
      var e = "lg-thumb-outer ";
      this.settings.alignThumbnails && (e += "lg-thumb-align-" + this.settings.alignThumbnails);
      var i = '<div class="' + e + `">
        <div class="lg-thumb lg-group">
        </div>
        </div>`;
      this.core.outer.addClass("lg-has-thumb"), this.settings.appendThumbnailsTo === ".lg-components" ? this.core.$lgComponents.append(i) : this.core.outer.append(i), this.$thumbOuter = this.core.outer.find(".lg-thumb-outer").first(), this.$lgThumb = this.core.outer.find(".lg-thumb").first(), this.settings.animateThumb && this.core.outer.find(".lg-thumb").css("transition-duration", this.core.settings.speed + "ms").css("width", this.thumbTotalWidth + "px").css("position", "relative"), this.setThumbItemHtml(this.core.galleryItems);
    }, t.prototype.enableThumbDrag = function() {
      var e = this, i = { cords: { startX: 0, endX: 0 }, isMoved: false, newTranslateX: 0, startTime: /* @__PURE__ */ new Date(), endTime: /* @__PURE__ */ new Date(), touchMoveTime: 0 }, n = false;
      this.$thumbOuter.addClass("lg-grab"), this.core.outer.find(".lg-thumb").first().on("mousedown.lg.thumb", function(r) {
        e.thumbTotalWidth > e.thumbOuterWidth && (r.preventDefault(), i.cords.startX = r.pageX, i.startTime = /* @__PURE__ */ new Date(), e.thumbClickable = false, n = true, e.core.outer.get().scrollLeft += 1, e.core.outer.get().scrollLeft -= 1, e.$thumbOuter.removeClass("lg-grab").addClass("lg-grabbing"));
      }), this.$LG(window).on("mousemove.lg.thumb.global" + this.core.lgId, function(r) {
        e.core.lgOpened && n && (i.cords.endX = r.pageX, i = e.onThumbTouchMove(i));
      }), this.$LG(window).on("mouseup.lg.thumb.global" + this.core.lgId, function() {
        e.core.lgOpened && (i.isMoved ? i = e.onThumbTouchEnd(i) : e.thumbClickable = true, n && (n = false, e.$thumbOuter.removeClass("lg-grabbing").addClass("lg-grab")));
      });
    }, t.prototype.enableThumbSwipe = function() {
      var e = this, i = { cords: { startX: 0, endX: 0 }, isMoved: false, newTranslateX: 0, startTime: /* @__PURE__ */ new Date(), endTime: /* @__PURE__ */ new Date(), touchMoveTime: 0 };
      this.$lgThumb.on("touchstart.lg", function(n) {
        e.thumbTotalWidth > e.thumbOuterWidth && (n.preventDefault(), i.cords.startX = n.targetTouches[0].pageX, e.thumbClickable = false, i.startTime = /* @__PURE__ */ new Date());
      }), this.$lgThumb.on("touchmove.lg", function(n) {
        e.thumbTotalWidth > e.thumbOuterWidth && (n.preventDefault(), i.cords.endX = n.targetTouches[0].pageX, i = e.onThumbTouchMove(i));
      }), this.$lgThumb.on("touchend.lg", function() {
        i.isMoved ? i = e.onThumbTouchEnd(i) : e.thumbClickable = true;
      });
    }, t.prototype.rebuildThumbnails = function() {
      var e = this;
      this.$thumbOuter.addClass("lg-rebuilding-thumbnails"), setTimeout(function() {
        e.thumbTotalWidth = e.core.galleryItems.length * (e.settings.thumbWidth + e.settings.thumbMargin), e.$lgThumb.css("width", e.thumbTotalWidth + "px"), e.$lgThumb.empty(), e.setThumbItemHtml(e.core.galleryItems), e.animateThumb(e.core.index);
      }, 50), setTimeout(function() {
        e.$thumbOuter.removeClass("lg-rebuilding-thumbnails");
      }, 200);
    }, t.prototype.setTranslate = function(e) {
      this.$lgThumb.css("transform", "translate3d(-" + e + "px, 0px, 0px)");
    }, t.prototype.getPossibleTransformX = function(e) {
      return e > this.thumbTotalWidth - this.thumbOuterWidth && (e = this.thumbTotalWidth - this.thumbOuterWidth), e < 0 && (e = 0), e;
    }, t.prototype.animateThumb = function(e) {
      if (this.$lgThumb.css("transition-duration", this.core.settings.speed + "ms"), this.settings.animateThumb) {
        var i = 0;
        switch (this.settings.currentPagerPosition) {
          case "left":
            i = 0;
            break;
          case "middle":
            i = this.thumbOuterWidth / 2 - this.settings.thumbWidth / 2;
            break;
          case "right":
            i = this.thumbOuterWidth - this.settings.thumbWidth;
        }
        this.translateX = (this.settings.thumbWidth + this.settings.thumbMargin) * e - 1 - i, this.translateX > this.thumbTotalWidth - this.thumbOuterWidth && (this.translateX = this.thumbTotalWidth - this.thumbOuterWidth), this.translateX < 0 && (this.translateX = 0), this.setTranslate(this.translateX);
      }
    }, t.prototype.onThumbTouchMove = function(e) {
      return e.newTranslateX = this.translateX, e.isMoved = true, e.touchMoveTime = (/* @__PURE__ */ new Date()).valueOf(), e.newTranslateX -= e.cords.endX - e.cords.startX, e.newTranslateX = this.getPossibleTransformX(e.newTranslateX), this.setTranslate(e.newTranslateX), this.$thumbOuter.addClass("lg-dragging"), e;
    }, t.prototype.onThumbTouchEnd = function(e) {
      e.isMoved = false, e.endTime = /* @__PURE__ */ new Date(), this.$thumbOuter.removeClass("lg-dragging");
      var i = e.endTime.valueOf() - e.startTime.valueOf(), n = e.cords.endX - e.cords.startX, r = Math.abs(n) / i;
      return r > 0.15 && e.endTime.valueOf() - e.touchMoveTime < 30 ? (r += 1, r > 2 && (r += 1), r = r + r * (Math.abs(n) / this.thumbOuterWidth), this.$lgThumb.css("transition-duration", Math.min(r - 1, 2) + "settings"), n = n * r, this.translateX = this.getPossibleTransformX(this.translateX - n), this.setTranslate(this.translateX)) : this.translateX = e.newTranslateX, Math.abs(e.cords.endX - e.cords.startX) < this.settings.thumbnailSwipeThreshold && (this.thumbClickable = true), e;
    }, t.prototype.getThumbHtml = function(e, i, n) {
      var r = this.core.galleryItems[i].__slideVideoInfo || {}, o;
      r.youtube && this.settings.loadYouTubeThumbnail ? o = "//img.youtube.com/vi/" + r.youtube[1] + "/" + this.settings.youTubeThumbSize + ".jpg" : o = e;
      var l = document.createElement("div");
      l.setAttribute("data-lg-item-id", i + ""), l.className = "lg-thumb-item " + (i === this.core.index ? "active" : ""), l.style.cssText = "width: " + this.settings.thumbWidth + "px; height: " + this.settings.thumbHeight + "; margin-right: " + this.settings.thumbMargin + "px;";
      var c = document.createElement("img");
      return c.alt = n || "", c.setAttribute("data-lg-item-id", i + ""), c.src = o, l.appendChild(c), l;
    }, t.prototype.setThumbItemHtml = function(e) {
      for (var i = 0; i < e.length; i++) {
        var n = this.getThumbHtml(e[i].thumb, i, e[i].alt);
        this.$lgThumb.append(n);
      }
    }, t.prototype.setAnimateThumbStyles = function() {
      this.settings.animateThumb && this.core.outer.addClass("lg-animate-thumb");
    }, t.prototype.manageActiveClassOnSlideChange = function() {
      var e = this;
      this.core.LGel.on(Gi.beforeSlide + ".thumb", function(i) {
        var n = e.core.outer.find(".lg-thumb-item"), r = i.detail.index;
        n.removeClass("active"), n.eq(r).addClass("active");
      });
    }, t.prototype.toggleThumbBar = function() {
      var e = this;
      this.settings.toggleThumb && (this.core.outer.addClass("lg-can-toggle"), this.core.$toolbar.append('<button type="button" aria-label="' + this.settings.thumbnailPluginStrings.toggleThumbnails + '" class="lg-toggle-thumb lg-icon"></button>'), this.core.outer.find(".lg-toggle-thumb").first().on("click.lg", function() {
        e.core.outer.toggleClass("lg-components-open");
      }));
    }, t.prototype.thumbKeyPress = function() {
      var e = this;
      this.$LG(window).on("keydown.lg.thumb.global" + this.core.lgId, function(i) {
        !e.core.lgOpened || !e.settings.toggleThumb || (i.keyCode === 38 ? (i.preventDefault(), e.core.outer.addClass("lg-components-open")) : i.keyCode === 40 && (i.preventDefault(), e.core.outer.removeClass("lg-components-open")));
      });
    }, t.prototype.destroy = function() {
      this.settings.thumbnail && (this.$LG(window).off(".lg.thumb.global" + this.core.lgId), this.core.LGel.off(".lg.thumb"), this.core.LGel.off(".thumb"), this.$thumbOuter.remove(), this.core.outer.removeClass("lg-has-thumb"));
    }, t;
  })();
  var Hn = function() {
    return Hn = Object.assign || function(e) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (e[o] = i[o]);
      }
      return e;
    }, Hn.apply(this, arguments);
  }, vv = { scale: 1, zoom: true, infiniteZoom: true, actualSize: true, showZoomInOutIcons: false, actualSizeIcons: { zoomIn: "lg-zoom-in", zoomOut: "lg-zoom-out" }, enableZoomAfter: 300, zoomPluginStrings: { zoomIn: "Zoom in", zoomOut: "Zoom out", viewActualSize: "View actual size" } }, _t = { containerResize: "lgContainerResize", beforeOpen: "lgBeforeOpen", afterOpen: "lgAfterOpen", slideItemLoad: "lgSlideItemLoad", afterSlide: "lgAfterSlide", rotateLeft: "lgRotateLeft", rotateRight: "lgRotateRight", flipHorizontal: "lgFlipHorizontal", flipVertical: "lgFlipVertical" }, er = 500, yv = (function() {
    function t(e, i) {
      return this.core = e, this.$LG = i, this.settings = Hn(Hn({}, vv), this.core.settings), this;
    }
    return t.prototype.buildTemplates = function() {
      var e = this.settings.showZoomInOutIcons ? '<button id="' + this.core.getIdName("lg-zoom-in") + '" type="button" aria-label="' + this.settings.zoomPluginStrings.zoomIn + '" class="lg-zoom-in lg-icon"></button><button id="' + this.core.getIdName("lg-zoom-out") + '" type="button" aria-label="' + this.settings.zoomPluginStrings.zoomOut + '" class="lg-zoom-out lg-icon"></button>' : "";
      this.settings.actualSize && (e += '<button id="' + this.core.getIdName("lg-actual-size") + '" type="button" aria-label="' + this.settings.zoomPluginStrings.viewActualSize + '" class="' + this.settings.actualSizeIcons.zoomIn + ' lg-icon"></button>'), this.core.outer.addClass("lg-use-transition-for-zoom"), this.core.$toolbar.first().append(e);
    }, t.prototype.enableZoom = function(e) {
      var i = this, n = this.settings.enableZoomAfter + e.detail.delay;
      this.$LG("body").first().hasClass("lg-from-hash") && e.detail.delay ? n = 0 : this.$LG("body").first().removeClass("lg-from-hash"), this.zoomableTimeout = setTimeout(function() {
        i.isImageSlide(i.core.index) && (i.core.getSlideItem(e.detail.index).addClass("lg-zoomable"), e.detail.index === i.core.index && i.setZoomEssentials());
      }, n + 30);
    }, t.prototype.enableZoomOnSlideItemLoad = function() {
      this.core.LGel.on(_t.slideItemLoad + ".zoom", this.enableZoom.bind(this));
    }, t.prototype.getDragCords = function(e) {
      return { x: e.pageX, y: e.pageY };
    }, t.prototype.getSwipeCords = function(e) {
      var i = e.touches[0].pageX, n = e.touches[0].pageY;
      return { x: i, y: n };
    }, t.prototype.getDragAllowedAxises = function(e, i) {
      if (!this.containerRect) return { allowX: false, allowY: false };
      var n = this.core.getSlideItem(this.core.index).find(".lg-image").first().get(), r = 0, o = 0, l = n.getBoundingClientRect();
      e ? (r = n.offsetHeight * e, o = n.offsetWidth * e) : i ? (r = l.height + i * l.height, o = l.width + i * l.width) : (r = l.height, o = l.width);
      var c = r > this.containerRect.height, d = o > this.containerRect.width;
      return { allowX: d, allowY: c };
    }, t.prototype.setZoomEssentials = function() {
      this.containerRect = this.core.$content.get().getBoundingClientRect();
    }, t.prototype.zoomImage = function(e, i, n, r) {
      if (!(!this.containerRect || Math.abs(i) <= 0)) {
        var o = this.containerRect.width / 2 + this.containerRect.left, l = this.containerRect.height / 2 + this.containerRect.top + this.scrollTop, c, d;
        e === 1 && (this.positionChanged = false);
        var v = this.getDragAllowedAxises(0, i), b = v.allowY, y = v.allowX;
        this.positionChanged && (c = this.left / (this.scale - i), d = this.top / (this.scale - i), this.pageX = o - c, this.pageY = l - d, this.positionChanged = false);
        var _ = this.getPossibleSwipeDragCords(i), p, m, C = o - this.pageX, S = l - this.pageY;
        if (e - i > 1) {
          var h = (e - i) / Math.abs(i);
          C = (i < 0 ? -C : C) + this.left * (h + (i < 0 ? -1 : 1)), S = (i < 0 ? -S : S) + this.top * (h + (i < 0 ? -1 : 1)), p = C / h, m = S / h;
        } else {
          var h = (e - i) * i;
          p = C * h, m = S * h;
        }
        n && (y ? this.isBeyondPossibleLeft(p, _.minX) ? p = _.minX : this.isBeyondPossibleRight(p, _.maxX) && (p = _.maxX) : e > 1 && (p < _.minX ? p = _.minX : p > _.maxX && (p = _.maxX)), b ? this.isBeyondPossibleTop(m, _.minY) ? m = _.minY : this.isBeyondPossibleBottom(m, _.maxY) && (m = _.maxY) : e > 1 && (m < _.minY ? m = _.minY : m > _.maxY && (m = _.maxY))), this.setZoomStyles({ x: p, y: m, scale: e }), this.left = p, this.top = m, r && this.setZoomImageSize();
      }
    }, t.prototype.resetImageTranslate = function(e) {
      if (this.isImageSlide(e)) {
        var i = this.core.getSlideItem(e).find(".lg-image").first();
        this.imageReset = false, i.removeClass("reset-transition reset-transition-y reset-transition-x"), this.core.outer.removeClass("lg-actual-size"), i.css("width", "auto").css("height", "auto"), setTimeout(function() {
          i.removeClass("no-transition");
        }, 10);
      }
    }, t.prototype.setZoomImageSize = function() {
      var e = this, i = this.core.getSlideItem(this.core.index).find(".lg-image").first();
      setTimeout(function() {
        var n = e.getCurrentImageActualSizeScale();
        e.scale >= n && (i.addClass("no-transition"), e.imageReset = true);
      }, er), setTimeout(function() {
        var n = e.getCurrentImageActualSizeScale();
        if (e.scale >= n) {
          var r = e.getDragAllowedAxises(e.scale);
          i.css("width", i.get().naturalWidth + "px").css("height", i.get().naturalHeight + "px"), e.core.outer.addClass("lg-actual-size"), r.allowX && r.allowY ? i.addClass("reset-transition") : r.allowX && !r.allowY ? i.addClass("reset-transition-x") : !r.allowX && r.allowY && i.addClass("reset-transition-y");
        }
      }, er + 50);
    }, t.prototype.setZoomStyles = function(e) {
      var i = this.core.getSlideItem(this.core.index).find(".lg-img-wrap").first(), n = this.core.getSlideItem(this.core.index).find(".lg-image").first(), r = this.core.outer.find(".lg-current .lg-dummy-img").first();
      this.scale = e.scale, n.css("transform", "scale3d(" + e.scale + ", " + e.scale + ", 1)"), r.css("transform", "scale3d(" + e.scale + ", " + e.scale + ", 1)");
      var o = "translate3d(" + e.x + "px, " + e.y + "px, 0)";
      i.css("transform", o);
    }, t.prototype.setActualSize = function(e, i) {
      var n = this;
      if (!this.zoomInProgress) {
        this.zoomInProgress = true;
        var r = this.core.galleryItems[this.core.index];
        this.resetImageTranslate(e), setTimeout(function() {
          if (!(!r.src || n.core.outer.hasClass("lg-first-slide-loading"))) {
            var o = n.getCurrentImageActualSizeScale(), l = n.scale;
            n.core.outer.hasClass("lg-zoomed") ? n.scale = 1 : n.scale = n.getScale(o), n.setPageCords(i), n.beginZoom(n.scale), n.zoomImage(n.scale, n.scale - l, true, true);
          }
        }, 50), setTimeout(function() {
          n.core.outer.removeClass("lg-grabbing").addClass("lg-grab");
        }, 60), setTimeout(function() {
          n.zoomInProgress = false;
        }, er + 110);
      }
    }, t.prototype.getNaturalWidth = function(e) {
      var i = this.core.getSlideItem(e).find(".lg-image").first(), n = this.core.galleryItems[e].width;
      return n ? parseFloat(n) : i.get().naturalWidth;
    }, t.prototype.getActualSizeScale = function(e, i) {
      var n, r;
      return e >= i ? (n = e / i, r = n || 2) : r = 1, r;
    }, t.prototype.getCurrentImageActualSizeScale = function() {
      var e = this.core.getSlideItem(this.core.index).find(".lg-image").first(), i = e.get().offsetWidth, n = this.getNaturalWidth(this.core.index) || i;
      return this.getActualSizeScale(n, i);
    }, t.prototype.getPageCords = function(e) {
      var i = {};
      if (e) i.x = e.pageX || e.touches[0].pageX, i.y = e.pageY || e.touches[0].pageY;
      else {
        var n = this.core.$content.get().getBoundingClientRect();
        i.x = n.width / 2 + n.left, i.y = n.height / 2 + this.scrollTop + n.top;
      }
      return i;
    }, t.prototype.setPageCords = function(e) {
      var i = this.getPageCords(e);
      this.pageX = i.x, this.pageY = i.y;
    }, t.prototype.manageActualPixelClassNames = function() {
      var e = this.core.getElementById("lg-actual-size");
      e.removeClass(this.settings.actualSizeIcons.zoomIn).addClass(this.settings.actualSizeIcons.zoomOut);
    }, t.prototype.beginZoom = function(e) {
      return this.core.outer.removeClass("lg-zoom-drag-transition lg-zoom-dragging"), e > 1 ? (this.core.outer.addClass("lg-zoomed"), this.manageActualPixelClassNames()) : this.resetZoom(), e > 1;
    }, t.prototype.getScale = function(e) {
      var i = this.getCurrentImageActualSizeScale();
      return e < 1 ? e = 1 : e > i && (e = i), e;
    }, t.prototype.init = function() {
      var e = this;
      if (this.settings.zoom) {
        this.buildTemplates(), this.enableZoomOnSlideItemLoad();
        var i = null;
        this.core.outer.on("dblclick.lg", function(n) {
          e.$LG(n.target).hasClass("lg-image") && e.setActualSize(e.core.index, n);
        }), this.core.outer.on("touchstart.lg", function(n) {
          var r = e.$LG(n.target);
          n.touches.length === 1 && r.hasClass("lg-image") && (i ? (clearTimeout(i), i = null, n.preventDefault(), e.setActualSize(e.core.index, n)) : i = setTimeout(function() {
            i = null;
          }, 300));
        }), this.core.LGel.on(_t.containerResize + ".zoom " + _t.rotateRight + ".zoom " + _t.rotateLeft + ".zoom " + _t.flipHorizontal + ".zoom " + _t.flipVertical + ".zoom", function() {
          if (!(!e.core.lgOpened || !e.isImageSlide(e.core.index) || e.core.touchAction)) {
            var n = e.core.getSlideItem(e.core.index).find(".lg-img-wrap").first();
            e.top = 0, e.left = 0, e.setZoomEssentials(), e.setZoomSwipeStyles(n, { x: 0, y: 0 }), e.positionChanged = true;
          }
        }), this.$LG(window).on("scroll.lg.zoom.global" + this.core.lgId, function() {
          e.core.lgOpened && (e.scrollTop = e.$LG(window).scrollTop());
        }), this.core.getElementById("lg-zoom-out").on("click.lg", function() {
          if (e.isImageSlide(e.core.index)) {
            var n = 0;
            e.imageReset && (e.resetImageTranslate(e.core.index), n = 50), setTimeout(function() {
              var r = e.scale - e.settings.scale;
              r < 1 && (r = 1), e.beginZoom(r), e.zoomImage(r, -e.settings.scale, true, !e.settings.infiniteZoom);
            }, n);
          }
        }), this.core.getElementById("lg-zoom-in").on("click.lg", function() {
          e.zoomIn();
        }), this.core.getElementById("lg-actual-size").on("click.lg", function() {
          e.setActualSize(e.core.index);
        }), this.core.LGel.on(_t.beforeOpen + ".zoom", function() {
          e.core.outer.find(".lg-item").removeClass("lg-zoomable");
        }), this.core.LGel.on(_t.afterOpen + ".zoom", function() {
          e.scrollTop = e.$LG(window).scrollTop(), e.pageX = e.core.outer.width() / 2, e.pageY = e.core.outer.height() / 2 + e.scrollTop, e.scale = 1;
        }), this.core.LGel.on(_t.afterSlide + ".zoom", function(n) {
          var r = n.detail.prevIndex;
          e.scale = 1, e.positionChanged = false, e.zoomInProgress = false, e.resetZoom(r), e.resetImageTranslate(r), e.isImageSlide(e.core.index) && e.setZoomEssentials();
        }), this.zoomDrag(), this.pinchZoom(), this.zoomSwipe(), this.zoomableTimeout = false, this.positionChanged = false, this.zoomInProgress = false;
      }
    }, t.prototype.zoomIn = function() {
      if (this.isImageSlide(this.core.index)) {
        var e = this.scale + this.settings.scale;
        this.settings.infiniteZoom || (e = this.getScale(e)), this.beginZoom(e), this.zoomImage(e, Math.min(this.settings.scale, e - this.scale), true, !this.settings.infiniteZoom);
      }
    }, t.prototype.resetZoom = function(e) {
      this.core.outer.removeClass("lg-zoomed lg-zoom-drag-transition");
      var i = this.core.getElementById("lg-actual-size"), n = this.core.getSlideItem(e !== void 0 ? e : this.core.index);
      i.removeClass(this.settings.actualSizeIcons.zoomOut).addClass(this.settings.actualSizeIcons.zoomIn), n.find(".lg-img-wrap").first().removeAttr("style"), n.find(".lg-image").first().removeAttr("style"), this.scale = 1, this.left = 0, this.top = 0, this.setPageCords();
    }, t.prototype.getTouchDistance = function(e) {
      return Math.sqrt((e.touches[0].pageX - e.touches[1].pageX) * (e.touches[0].pageX - e.touches[1].pageX) + (e.touches[0].pageY - e.touches[1].pageY) * (e.touches[0].pageY - e.touches[1].pageY));
    }, t.prototype.pinchZoom = function() {
      var e = this, i = 0, n = false, r = 1, o = 0, l = this.core.getSlideItem(this.core.index);
      this.core.outer.on("touchstart.lg", function(c) {
        if (l = e.core.getSlideItem(e.core.index), !!e.isImageSlide(e.core.index) && c.touches.length === 2) {
          if (c.preventDefault(), e.core.outer.hasClass("lg-first-slide-loading")) return;
          r = e.scale || 1, e.core.outer.removeClass("lg-zoom-drag-transition lg-zoom-dragging"), e.setPageCords(c), e.resetImageTranslate(e.core.index), e.core.touchAction = "pinch", i = e.getTouchDistance(c);
        }
      }), this.core.$inner.on("touchmove.lg", function(c) {
        if (c.touches.length === 2 && e.core.touchAction === "pinch" && (e.$LG(c.target).hasClass("lg-item") || l.get().contains(c.target))) {
          c.preventDefault();
          var d = e.getTouchDistance(c), v = i - d;
          if (!n && Math.abs(v) > 5 && (n = true), n) {
            o = e.scale;
            var b = Math.max(1, r + -v * 0.02);
            e.scale = Math.round((b + Number.EPSILON) * 100) / 100;
            var y = e.scale - o;
            e.zoomImage(e.scale, Math.round((y + Number.EPSILON) * 100) / 100, false, false);
          }
        }
      }), this.core.$inner.on("touchend.lg", function(c) {
        if (e.core.touchAction === "pinch" && (e.$LG(c.target).hasClass("lg-item") || l.get().contains(c.target))) {
          if (n = false, i = 0, e.scale <= 1) e.resetZoom();
          else {
            var d = e.getCurrentImageActualSizeScale();
            if (e.scale >= d) {
              var v = d - e.scale;
              v === 0 && (v = 0.01), e.zoomImage(d, v, false, true);
            }
            e.manageActualPixelClassNames(), e.core.outer.addClass("lg-zoomed");
          }
          e.core.touchAction = void 0;
        }
      });
    }, t.prototype.touchendZoom = function(e, i, n, r, o) {
      var l = i.x - e.x, c = i.y - e.y, d = Math.abs(l) / o + 1, v = Math.abs(c) / o + 1;
      d > 2 && (d += 1), v > 2 && (v += 1), l = l * d, c = c * v;
      var b = this.core.getSlideItem(this.core.index).find(".lg-img-wrap").first(), y = {};
      y.x = this.left + l, y.y = this.top + c;
      var _ = this.getPossibleSwipeDragCords();
      (Math.abs(l) > 15 || Math.abs(c) > 15) && (r && (this.isBeyondPossibleTop(y.y, _.minY) ? y.y = _.minY : this.isBeyondPossibleBottom(y.y, _.maxY) && (y.y = _.maxY)), n && (this.isBeyondPossibleLeft(y.x, _.minX) ? y.x = _.minX : this.isBeyondPossibleRight(y.x, _.maxX) && (y.x = _.maxX)), r ? this.top = y.y : y.y = this.top, n ? this.left = y.x : y.x = this.left, this.setZoomSwipeStyles(b, y), this.positionChanged = true);
    }, t.prototype.getZoomSwipeCords = function(e, i, n, r, o) {
      var l = {};
      if (r) {
        if (l.y = this.top + (i.y - e.y), this.isBeyondPossibleTop(l.y, o.minY)) {
          var c = o.minY - l.y;
          l.y = o.minY - c / 6;
        } else if (this.isBeyondPossibleBottom(l.y, o.maxY)) {
          var d = l.y - o.maxY;
          l.y = o.maxY + d / 6;
        }
      } else l.y = this.top;
      if (n) {
        if (l.x = this.left + (i.x - e.x), this.isBeyondPossibleLeft(l.x, o.minX)) {
          var v = o.minX - l.x;
          l.x = o.minX - v / 6;
        } else if (this.isBeyondPossibleRight(l.x, o.maxX)) {
          var b = l.x - o.maxX;
          l.x = o.maxX + b / 6;
        }
      } else l.x = this.left;
      return l;
    }, t.prototype.isBeyondPossibleLeft = function(e, i) {
      return e >= i;
    }, t.prototype.isBeyondPossibleRight = function(e, i) {
      return e <= i;
    }, t.prototype.isBeyondPossibleTop = function(e, i) {
      return e >= i;
    }, t.prototype.isBeyondPossibleBottom = function(e, i) {
      return e <= i;
    }, t.prototype.isImageSlide = function(e) {
      var i = this.core.galleryItems[e];
      return this.core.getSlideType(i) === "image";
    }, t.prototype.getPossibleSwipeDragCords = function(e) {
      var i = this.core.getSlideItem(this.core.index).find(".lg-image").first(), n = this.core.mediaContainerPosition.bottom, r = i.get().getBoundingClientRect(), o = r.height, l = r.width;
      e && (o = o + e * o, l = l + e * l);
      var c = (o - this.containerRect.height) / 2, d = (this.containerRect.height - o) / 2 + n, v = (l - this.containerRect.width) / 2, b = (this.containerRect.width - l) / 2, y = { minY: c, maxY: d, minX: v, maxX: b };
      return y;
    }, t.prototype.setZoomSwipeStyles = function(e, i) {
      e.css("transform", "translate3d(" + i.x + "px, " + i.y + "px, 0)");
    }, t.prototype.zoomSwipe = function() {
      var e = this, i = {}, n = {}, r = false, o = false, l = false, c = /* @__PURE__ */ new Date(), d = /* @__PURE__ */ new Date(), v, b, y = this.core.getSlideItem(this.core.index);
      this.core.$inner.on("touchstart.lg", function(_) {
        if (e.isImageSlide(e.core.index) && (y = e.core.getSlideItem(e.core.index), (e.$LG(_.target).hasClass("lg-item") || y.get().contains(_.target)) && _.touches.length === 1 && e.core.outer.hasClass("lg-zoomed"))) {
          _.preventDefault(), c = /* @__PURE__ */ new Date(), e.core.touchAction = "zoomSwipe", b = e.core.getSlideItem(e.core.index).find(".lg-img-wrap").first();
          var p = e.getDragAllowedAxises(0);
          l = p.allowY, o = p.allowX, (o || l) && (i = e.getSwipeCords(_)), v = e.getPossibleSwipeDragCords(), e.core.outer.addClass("lg-zoom-dragging lg-zoom-drag-transition");
        }
      }), this.core.$inner.on("touchmove.lg", function(_) {
        if (_.touches.length === 1 && e.core.touchAction === "zoomSwipe" && (e.$LG(_.target).hasClass("lg-item") || y.get().contains(_.target))) {
          _.preventDefault(), e.core.touchAction = "zoomSwipe", n = e.getSwipeCords(_);
          var p = e.getZoomSwipeCords(i, n, o, l, v);
          (Math.abs(n.x - i.x) > 15 || Math.abs(n.y - i.y) > 15) && (r = true, e.setZoomSwipeStyles(b, p));
        }
      }), this.core.$inner.on("touchend.lg", function(_) {
        if (e.core.touchAction === "zoomSwipe" && (e.$LG(_.target).hasClass("lg-item") || y.get().contains(_.target))) {
          if (_.preventDefault(), e.core.touchAction = void 0, e.core.outer.removeClass("lg-zoom-dragging"), !r) return;
          r = false, d = /* @__PURE__ */ new Date();
          var p = d.valueOf() - c.valueOf();
          e.touchendZoom(i, n, o, l, p);
        }
      });
    }, t.prototype.zoomDrag = function() {
      var e = this, i = {}, n = {}, r = false, o = false, l = false, c = false, d, v, b, y;
      this.core.outer.on("mousedown.lg.zoom", function(_) {
        if (e.isImageSlide(e.core.index)) {
          var p = e.core.getSlideItem(e.core.index);
          if (e.$LG(_.target).hasClass("lg-item") || p.get().contains(_.target)) {
            d = /* @__PURE__ */ new Date(), y = e.core.getSlideItem(e.core.index).find(".lg-img-wrap").first();
            var m = e.getDragAllowedAxises(0);
            c = m.allowY, l = m.allowX, e.core.outer.hasClass("lg-zoomed") && e.$LG(_.target).hasClass("lg-object") && (l || c) && (_.preventDefault(), i = e.getDragCords(_), b = e.getPossibleSwipeDragCords(), r = true, e.core.outer.removeClass("lg-grab").addClass("lg-grabbing lg-zoom-drag-transition lg-zoom-dragging"));
          }
        }
      }), this.$LG(window).on("mousemove.lg.zoom.global" + this.core.lgId, function(_) {
        if (r) {
          o = true, n = e.getDragCords(_);
          var p = e.getZoomSwipeCords(i, n, l, c, b);
          e.setZoomSwipeStyles(y, p);
        }
      }), this.$LG(window).on("mouseup.lg.zoom.global" + this.core.lgId, function(_) {
        if (r) {
          if (v = /* @__PURE__ */ new Date(), r = false, e.core.outer.removeClass("lg-zoom-dragging"), o && (i.x !== n.x || i.y !== n.y)) {
            n = e.getDragCords(_);
            var p = v.valueOf() - d.valueOf();
            e.touchendZoom(i, n, l, c, p);
          }
          o = false;
        }
        e.core.outer.removeClass("lg-grabbing").addClass("lg-grab");
      });
    }, t.prototype.closeGallery = function() {
      this.resetZoom(), this.zoomInProgress = false;
    }, t.prototype.destroy = function() {
      this.$LG(window).off(".lg.zoom.global" + this.core.lgId), this.core.LGel.off(".lg.zoom"), this.core.LGel.off(".zoom"), clearTimeout(this.zoomableTimeout), this.zoomableTimeout = false;
    }, t;
  })();
  var Zt = function() {
    return Zt = Object.assign || function(e) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (e[o] = i[o]);
      }
      return e;
    }, Zt.apply(this, arguments);
  }, bv = { autoplayFirstVideo: true, youTubePlayerParams: false, vimeoPlayerParams: false, wistiaPlayerParams: false, gotoNextSlideOnVideoEnd: true, autoplayVideoOnSlide: false, videojs: false, videojsTheme: "", videojsOptions: {} }, ji = { hasVideo: "lgHasVideo", slideItemLoad: "lgSlideItemLoad", beforeSlide: "lgBeforeSlide", afterSlide: "lgAfterSlide", posterClick: "lgPosterClick" }, wr = function(t) {
    return Object.keys(t).map(function(e) {
      return encodeURIComponent(e) + "=" + encodeURIComponent(t[e]);
    }).join("&");
  }, Ev = function(t) {
    var e = t.slice(1).split("&").map(function(i) {
      return i.split("=");
    }).reduce(function(i, n) {
      var r = n.map(decodeURIComponent), o = r[0], l = r[1];
      return i[o] = l, i;
    }, {});
    return e;
  }, Tv = function(t, e) {
    if (!t.youtube) return "";
    var i = t.youtube[2] ? Ev(t.youtube[2]) : "", n = { wmode: "opaque", autoplay: 0, mute: 1, enablejsapi: 1 }, r = e || {}, o = Zt(Zt(Zt({}, n), r), i), l = "?" + wr(o);
    return l;
  }, _v = function(t) {
    return t.includes("youtube-nocookie.com");
  }, Sv = function(t, e) {
    if (!e || !e.vimeo) return "";
    var i = e.vimeo[2] || "", n = Object.assign({}, { autoplay: 0, muted: 1 }, t), r = n && Object.keys(n).length !== 0 ? wr(n) : "", o = e.vimeo[0].split("/").pop() || "", l = o.split("?")[0] || "", c = l.split("#")[0], d = e.vimeo[1] !== c;
    d && (i = i.replace("/" + c, "")), i = i[0] == "?" ? "&" + i.slice(1) : i || "";
    var v = d ? "h=" + c : "";
    r = v ? "&" + r : r;
    var b = "?" + v + r + i;
    return b;
  }, xv = (function() {
    function t(e) {
      return this.core = e, this.settings = Zt(Zt({}, bv), this.core.settings), this;
    }
    return t.prototype.init = function() {
      var e = this;
      this.core.LGel.on(ji.hasVideo + ".video", this.onHasVideo.bind(this)), this.core.LGel.on(ji.posterClick + ".video", function() {
        var i = e.core.getSlideItem(e.core.index);
        e.loadVideoOnPosterClick(i);
      }), this.core.LGel.on(ji.slideItemLoad + ".video", this.onSlideItemLoad.bind(this)), this.core.LGel.on(ji.beforeSlide + ".video", this.onBeforeSlide.bind(this)), this.core.LGel.on(ji.afterSlide + ".video", this.onAfterSlide.bind(this));
    }, t.prototype.onSlideItemLoad = function(e) {
      var i = this, n = e.detail, r = n.isFirstSlide, o = n.index;
      this.settings.autoplayFirstVideo && r && o === this.core.index && setTimeout(function() {
        i.loadAndPlayVideo(o);
      }, 200), !r && this.settings.autoplayVideoOnSlide && o === this.core.index && this.loadAndPlayVideo(o);
    }, t.prototype.onHasVideo = function(e) {
      var i = e.detail, n = i.index, r = i.src, o = i.html5Video, l = i.hasPoster;
      l || (this.appendVideos(this.core.getSlideItem(n), { src: r, addClass: "lg-object", index: n, html5Video: o }), this.gotoNextSlideOnVideoEnd(r, n));
    }, t.prototype.onBeforeSlide = function(e) {
      if (this.core.lGalleryOn) {
        var i = e.detail.prevIndex;
        this.pauseVideo(i);
      }
    }, t.prototype.onAfterSlide = function(e) {
      var i = this, n = e.detail, r = n.index, o = n.prevIndex, l = this.core.getSlideItem(r);
      this.settings.autoplayVideoOnSlide && r !== o && l.hasClass("lg-complete") && setTimeout(function() {
        i.loadAndPlayVideo(r);
      }, 100);
    }, t.prototype.loadAndPlayVideo = function(e) {
      var i = this.core.getSlideItem(e), n = this.core.galleryItems[e];
      n.poster ? this.loadVideoOnPosterClick(i, true) : this.playVideo(e);
    }, t.prototype.playVideo = function(e) {
      this.controlVideo(e, "play");
    }, t.prototype.pauseVideo = function(e) {
      this.controlVideo(e, "pause");
    }, t.prototype.getVideoHtml = function(e, i, n, r) {
      var o = "", l = this.core.galleryItems[n].__slideVideoInfo || {}, c = this.core.galleryItems[n], d = c.title || c.alt;
      d = d ? 'title="' + d + '"' : "";
      var v = `allowtransparency="true"
            frameborder="0"
            scrolling="no"
            allowfullscreen
            mozallowfullscreen
            webkitallowfullscreen
            oallowfullscreen
            msallowfullscreen`;
      if (l.youtube) {
        var b = "lg-youtube" + n, y = Tv(l, this.settings.youTubePlayerParams), _ = _v(e), p = _ ? "//www.youtube-nocookie.com/" : "//www.youtube.com/";
        o = '<iframe allow="autoplay" id=' + b + ' class="lg-video-object lg-youtube ' + i + '" ' + d + ' src="' + p + "embed/" + (l.youtube[1] + y) + '" ' + v + "></iframe>";
      } else if (l.vimeo) {
        var b = "lg-vimeo" + n, m = Sv(this.settings.vimeoPlayerParams, l);
        o = '<iframe allow="autoplay" id=' + b + ' class="lg-video-object lg-vimeo ' + i + '" ' + d + ' src="//player.vimeo.com/video/' + (l.vimeo[1] + m) + '" ' + v + "></iframe>";
      } else if (l.wistia) {
        var C = "lg-wistia" + n, m = wr(this.settings.wistiaPlayerParams);
        m = m ? "?" + m : "", o = '<iframe allow="autoplay" id="' + C + '" src="//fast.wistia.net/embed/iframe/' + (l.wistia[4] + m) + '" ' + d + ' class="wistia_embed lg-video-object lg-wistia ' + i + '" name="wistia_embed" ' + v + "></iframe>";
      } else if (l.html5) {
        for (var S = "", h = 0; h < r.source.length; h++) {
          var E = r.source[h].type, I = E ? 'type="' + E + '"' : "";
          S += '<source src="' + r.source[h].src + '" ' + I + ">";
        }
        if (r.tracks) for (var O = function(P) {
          var D = "", H = r.tracks[P];
          Object.keys(H || {}).forEach(function(k) {
            D += k + '="' + H[k] + '" ';
          }), S += "<track " + D + ">";
        }, h = 0; h < r.tracks.length; h++) O(h);
        var L = "", f = r.attributes || {};
        Object.keys(f || {}).forEach(function(P) {
          L += P + '="' + f[P] + '" ';
        }), o = '<video class="lg-video-object lg-html5 ' + (this.settings.videojs && this.settings.videojsTheme ? this.settings.videojsTheme + " " : "") + " " + (this.settings.videojs ? " video-js" : "") + '" ' + L + `>
                ` + S + `
                Your browser does not support HTML5 video.
            </video>`;
      }
      return o;
    }, t.prototype.appendVideos = function(e, i) {
      var n, r = this.getVideoHtml(i.src, i.addClass, i.index, i.html5Video);
      e.find(".lg-video-cont").append(r);
      var o = e.find(".lg-video-object").first();
      if (i.html5Video && o.on("mousedown.lg.video", function(l) {
        l.stopPropagation();
      }), this.settings.videojs && (!((n = this.core.galleryItems[i.index].__slideVideoInfo) === null || n === void 0) && n.html5)) try {
        return videojs(o.get(), this.settings.videojsOptions);
      } catch (l) {
        console.error("lightGallery:- Make sure you have included videojs");
      }
    }, t.prototype.gotoNextSlideOnVideoEnd = function(e, i) {
      var n = this, r = this.core.getSlideItem(i).find(".lg-video-object").first(), o = this.core.galleryItems[i].__slideVideoInfo || {};
      if (this.settings.gotoNextSlideOnVideoEnd) {
        if (o.html5) r.on("ended", function() {
          n.core.goToNextSlide();
        });
        else if (o.vimeo) try {
          new Vimeo.Player(r.get()).on("ended", function() {
            n.core.goToNextSlide();
          });
        } catch (l) {
          console.error("lightGallery:- Make sure you have included //github.com/vimeo/player.js");
        }
        else if (o.wistia) try {
          window._wq = window._wq || [], window._wq.push({ id: r.attr("id"), onReady: function(l) {
            l.bind("end", function() {
              n.core.goToNextSlide();
            });
          } });
        } catch (l) {
          console.error("lightGallery:- Make sure you have included //fast.wistia.com/assets/external/E-v1.js");
        }
      }
    }, t.prototype.controlVideo = function(e, i) {
      var n = this.core.getSlideItem(e).find(".lg-video-object").first(), r = this.core.galleryItems[e].__slideVideoInfo || {};
      if (n.get()) {
        if (r.youtube) try {
          n.get().contentWindow.postMessage('{"event":"command","func":"' + i + 'Video","args":""}', "*");
        } catch (o) {
          console.error("lightGallery:- " + o);
        }
        else if (r.vimeo) try {
          new Vimeo.Player(n.get())[i]();
        } catch (o) {
          console.error("lightGallery:- Make sure you have included //github.com/vimeo/player.js");
        }
        else if (r.html5) if (this.settings.videojs) try {
          videojs(n.get())[i]();
        } catch (o) {
          console.error("lightGallery:- Make sure you have included videojs");
        }
        else n.get()[i]();
        else if (r.wistia) try {
          window._wq = window._wq || [], window._wq.push({ id: n.attr("id"), onReady: function(o) {
            o[i]();
          } });
        } catch (o) {
          console.error("lightGallery:- Make sure you have included //fast.wistia.com/assets/external/E-v1.js");
        }
      }
    }, t.prototype.loadVideoOnPosterClick = function(e, i) {
      var n = this;
      if (e.hasClass("lg-video-loaded")) i && this.playVideo(this.core.index);
      else if (e.hasClass("lg-has-video")) this.playVideo(this.core.index);
      else {
        e.addClass("lg-has-video");
        var r = void 0, o = this.core.galleryItems[this.core.index].src, l = this.core.galleryItems[this.core.index].video;
        l && (r = typeof l == "string" ? JSON.parse(l) : l);
        var c = this.appendVideos(e, { src: o, addClass: "", index: this.core.index, html5Video: r });
        this.gotoNextSlideOnVideoEnd(o, this.core.index);
        var d = e.find(".lg-object").first().get();
        e.find(".lg-video-cont").first().append(d), e.addClass("lg-video-loading"), c && c.ready(function() {
          c.on("loadedmetadata", function() {
            n.onVideoLoadAfterPosterClick(e, n.core.index);
          });
        }), e.find(".lg-video-object").first().on("load.lg error.lg loadedmetadata.lg", function() {
          setTimeout(function() {
            n.onVideoLoadAfterPosterClick(e, n.core.index);
          }, 50);
        });
      }
    }, t.prototype.onVideoLoadAfterPosterClick = function(e, i) {
      e.addClass("lg-video-loaded"), this.playVideo(i);
    }, t.prototype.destroy = function() {
      this.core.LGel.off(".lg.video"), this.core.LGel.off(".video");
    }, t;
  })();
  var Bn = function() {
    return Bn = Object.assign || function(e) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (e[o] = i[o]);
      }
      return e;
    }, Bn.apply(this, arguments);
  };
  function Cv(t, e, i, n) {
    function r(o) {
      return o instanceof i ? o : new i(function(l) {
        l(o);
      });
    }
    return new (i || (i = Promise))(function(o, l) {
      function c(b) {
        try {
          v(n.next(b));
        } catch (y) {
          l(y);
        }
      }
      function d(b) {
        try {
          v(n.throw(b));
        } catch (y) {
          l(y);
        }
      }
      function v(b) {
        b.done ? o(b.value) : r(b.value).then(c, d);
      }
      v((n = n.apply(t, [])).next());
    });
  }
  function Iv(t, e) {
    var i = { label: 0, sent: function() {
      if (o[0] & 1) throw o[1];
      return o[1];
    }, trys: [], ops: [] }, n, r, o, l;
    return l = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
      return this;
    }), l;
    function c(v) {
      return function(b) {
        return d([v, b]);
      };
    }
    function d(v) {
      if (n) throw new TypeError("Generator is already executing.");
      for (; i; ) try {
        if (n = 1, r && (o = v[0] & 2 ? r.return : v[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, v[1])).done) return o;
        switch (r = 0, o && (v = [v[0] & 2, o.value]), v[0]) {
          case 0:
          case 1:
            o = v;
            break;
          case 4:
            return i.label++, { value: v[1], done: false };
          case 5:
            i.label++, r = v[1], v = [0];
            continue;
          case 7:
            v = i.ops.pop(), i.trys.pop();
            continue;
          default:
            if (o = i.trys, !(o = o.length > 0 && o[o.length - 1]) && (v[0] === 6 || v[0] === 2)) {
              i = 0;
              continue;
            }
            if (v[0] === 3 && (!o || v[1] > o[0] && v[1] < o[3])) {
              i.label = v[1];
              break;
            }
            if (v[0] === 6 && i.label < o[1]) {
              i.label = o[1], o = v;
              break;
            }
            if (o && i.label < o[2]) {
              i.label = o[2], i.ops.push(v);
              break;
            }
            o[2] && i.ops.pop(), i.trys.pop();
            continue;
        }
        v = e.call(t, i);
      } catch (b) {
        v = [6, b], r = 0;
      } finally {
        n = o = 0;
      }
      if (v[0] & 5) throw v[1];
      return { value: v[0] ? v[1] : void 0, done: true };
    }
  }
  var Av = { init: "lgInit" }, wv = { showVimeoThumbnails: true, showThumbnailWithPlayButton: false }, Ov = (function() {
    function t(e) {
      return this.core = e, this.settings = Bn(Bn({}, wv), this.core.settings), this;
    }
    return t.prototype.init = function() {
      var e = this;
      this.settings.showVimeoThumbnails && this.core.LGel.on(Av.init + ".vimeothumbnails", function(i) {
        var n = i.detail.instance, r = n.$container.find(".lg-thumb-outer").get();
        r && e.setVimeoThumbnails(n);
      });
    }, t.prototype.setVimeoThumbnails = function(e) {
      return Cv(this, void 0, void 0, function() {
        var i, n, r, o, l;
        return Iv(this, function(c) {
          switch (c.label) {
            case 0:
              i = 0, c.label = 1;
            case 1:
              return i < e.galleryItems.length ? (n = e.galleryItems[i], r = n.__slideVideoInfo || {}, r.vimeo ? [4, fetch("https://vimeo.com/api/oembed.json?url=" + encodeURIComponent(n.src))] : [3, 4]) : [3, 5];
            case 2:
              return o = c.sent(), [4, o.json()];
            case 3:
              l = c.sent(), e.$container.find(".lg-thumb-item").eq(i).find("img").attr("src", this.settings.showThumbnailWithPlayButton ? l.thumbnail_url_with_play_button : l.thumbnail_url), c.label = 4;
            case 4:
              return i++, [3, 1];
            case 5:
              return [2];
          }
        });
      });
    }, t.prototype.destroy = function() {
      this.core.LGel.off(".lg.vimeothumbnails"), this.core.LGel.off(".vimeothumbnails");
    }, t;
  })();
  window.lightGallery = pv;
  window.lgThumbnail = mv;
  window.lgZoom = yv;
  window.lgVideo = xv;
  window.lgVimeoThumbnail = Ov;
  function Vn(t) {
    "@babel/helpers - typeof";
    return Vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
      return typeof e;
    } : function(e) {
      return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, Vn(t);
  }
  var Mv = (typeof HTMLElement == "undefined" ? "undefined" : Vn(HTMLElement)) === "object";
  function tr(t) {
    return Mv ? t instanceof HTMLElement : t && Vn(t) === "object" && t !== null && t.nodeType === 1 && typeof t.nodeName == "string";
  }
  function St(t, e) {
    e.forEach(function(i) {
      t.classList.add(i);
    });
  }
  function gt(t, e) {
    e.forEach(function(i) {
      t.classList.remove(i);
    });
  }
  var Lv = ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}";
  function Pv() {
    if (!document.querySelector(".drift-base-styles")) {
      var t = document.createElement("style");
      t.type = "text/css", t.classList.add("drift-base-styles"), t.appendChild(document.createTextNode(Lv));
      var e = document.head;
      e.insertBefore(t, e.firstChild);
    }
  }
  function Ve() {
    throw new Error("Missing parameter");
  }
  function Dv(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function $v(t, e) {
    for (var i = 0; i < e.length; i++) {
      var n = e[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(t, n.key, n);
    }
  }
  function zv(t, e, i) {
    return e && $v(t.prototype, e), Object.defineProperty(t, "prototype", { writable: false }), t;
  }
  var kv = (function() {
    function t(e) {
      Dv(this, t), this.isShowing = false;
      var i = e.namespace, n = i === void 0 ? null : i, r = e.zoomFactor, o = r === void 0 ? Ve() : r, l = e.containerEl, c = l === void 0 ? Ve() : l;
      this.settings = { namespace: n, zoomFactor: o, containerEl: c }, this.openClasses = this._buildClasses("open"), this._buildElement();
    }
    return zv(t, [{ key: "_buildClasses", value: function(i) {
      var n = ["drift-".concat(i)], r = this.settings.namespace;
      return r && n.push("".concat(r, "-").concat(i)), n;
    } }, { key: "_buildElement", value: function() {
      this.el = document.createElement("div"), St(this.el, this._buildClasses("bounding-box"));
    } }, { key: "show", value: function(i, n) {
      this.isShowing = true, this.settings.containerEl.appendChild(this.el);
      var r = this.el.style;
      r.width = "".concat(Math.round(i / this.settings.zoomFactor), "px"), r.height = "".concat(Math.round(n / this.settings.zoomFactor), "px"), St(this.el, this.openClasses);
    } }, { key: "hide", value: function() {
      this.isShowing && this.settings.containerEl.removeChild(this.el), this.isShowing = false, gt(this.el, this.openClasses);
    } }, { key: "setPosition", value: function(i, n, r) {
      var o = window.pageXOffset, l = window.pageYOffset, c = r.left + i * r.width - this.el.clientWidth / 2 + o, d = r.top + n * r.height - this.el.clientHeight / 2 + l;
      c < r.left + o ? c = r.left + o : c + this.el.clientWidth > r.left + r.width + o && (c = r.left + r.width - this.el.clientWidth + o), d < r.top + l ? d = r.top + l : d + this.el.clientHeight > r.top + r.height + l && (d = r.top + r.height - this.el.clientHeight + l), this.el.style.left = "".concat(c, "px"), this.el.style.top = "".concat(d, "px");
    } }]), t;
  })();
  function Nv(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Rv(t, e) {
    for (var i = 0; i < e.length; i++) {
      var n = e[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(t, n.key, n);
    }
  }
  function Hv(t, e, i) {
    return e && Rv(t.prototype, e), Object.defineProperty(t, "prototype", { writable: false }), t;
  }
  var Bv = (function() {
    function t() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      Nv(this, t), this._show = this._show.bind(this), this._hide = this._hide.bind(this), this._handleEntry = this._handleEntry.bind(this), this._handleMovement = this._handleMovement.bind(this);
      var i = e.el, n = i === void 0 ? Ve() : i, r = e.zoomPane, o = r === void 0 ? Ve() : r, l = e.sourceAttribute, c = l === void 0 ? Ve() : l, d = e.handleTouch, v = d === void 0 ? Ve() : d, b = e.onShow, y = b === void 0 ? null : b, _ = e.onHide, p = _ === void 0 ? null : _, m = e.hoverDelay, C = m === void 0 ? 0 : m, S = e.touchDelay, h = S === void 0 ? 0 : S, E = e.hoverBoundingBox, I = E === void 0 ? Ve() : E, O = e.touchBoundingBox, L = O === void 0 ? Ve() : O, f = e.namespace, P = f === void 0 ? null : f, D = e.zoomFactor, H = D === void 0 ? Ve() : D, k = e.boundingBoxContainer, z = k === void 0 ? Ve() : k, B = e.passive, V = B === void 0 ? false : B;
      this.settings = { el: n, zoomPane: o, sourceAttribute: c, handleTouch: v, onShow: y, onHide: p, hoverDelay: C, touchDelay: h, hoverBoundingBox: I, touchBoundingBox: L, namespace: P, zoomFactor: H, boundingBoxContainer: z, passive: V }, (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) && (this.boundingBox = new kv({ namespace: this.settings.namespace, zoomFactor: this.settings.zoomFactor, containerEl: this.settings.boundingBoxContainer })), this.enabled = true, this._bindEvents();
    }
    return Hv(t, [{ key: "_preventDefault", value: function(i) {
      i.preventDefault();
    } }, { key: "_preventDefaultAllowTouchScroll", value: function(i) {
      (!this.settings.touchDelay || !this._isTouchEvent(i) || this.isShowing) && i.preventDefault();
    } }, { key: "_isTouchEvent", value: function(i) {
      return !!i.touches;
    } }, { key: "_bindEvents", value: function() {
      this.settings.el.addEventListener("mouseenter", this._handleEntry), this.settings.el.addEventListener("mouseleave", this._hide), this.settings.el.addEventListener("mousemove", this._handleMovement);
      var i = { passive: this.settings.passive };
      this.settings.handleTouch ? (this.settings.el.addEventListener("touchstart", this._handleEntry, i), this.settings.el.addEventListener("touchend", this._hide), this.settings.el.addEventListener("touchmove", this._handleMovement, i)) : (this.settings.el.addEventListener("touchstart", this._preventDefault, i), this.settings.el.addEventListener("touchend", this._preventDefault), this.settings.el.addEventListener("touchmove", this._preventDefault, i));
    } }, { key: "_unbindEvents", value: function() {
      this.settings.el.removeEventListener("mouseenter", this._handleEntry), this.settings.el.removeEventListener("mouseleave", this._hide), this.settings.el.removeEventListener("mousemove", this._handleMovement), this.settings.handleTouch ? (this.settings.el.removeEventListener("touchstart", this._handleEntry), this.settings.el.removeEventListener("touchend", this._hide), this.settings.el.removeEventListener("touchmove", this._handleMovement)) : (this.settings.el.removeEventListener("touchstart", this._preventDefault), this.settings.el.removeEventListener("touchend", this._preventDefault), this.settings.el.removeEventListener("touchmove", this._preventDefault));
    } }, { key: "_handleEntry", value: function(i) {
      this._preventDefaultAllowTouchScroll(i), this._lastMovement = i, i.type == "mouseenter" && this.settings.hoverDelay ? this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay) : this.settings.touchDelay ? this.entryTimeout = setTimeout(this._show, this.settings.touchDelay) : this._show();
    } }, { key: "_show", value: function() {
      if (this.enabled) {
        var i = this.settings.onShow;
        if (i && typeof i == "function" && i(), this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight), this._lastMovement) {
          var n = this._lastMovement.touches;
          (n && this.settings.touchBoundingBox || !n && this.settings.hoverBoundingBox) && this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight);
        }
        this._handleMovement();
      }
    } }, { key: "_hide", value: function(i) {
      i && this._preventDefaultAllowTouchScroll(i), this._lastMovement = null, this.entryTimeout && clearTimeout(this.entryTimeout), this.boundingBox && this.boundingBox.hide();
      var n = this.settings.onHide;
      n && typeof n == "function" && n(), this.settings.zoomPane.hide();
    } }, { key: "_handleMovement", value: function(i) {
      if (i) this._preventDefaultAllowTouchScroll(i), this._lastMovement = i;
      else if (this._lastMovement) i = this._lastMovement;
      else return;
      var n, r;
      if (i.touches) {
        var o = i.touches[0];
        n = o.clientX, r = o.clientY;
      } else n = i.clientX, r = i.clientY;
      var l = this.settings.el, c = l.getBoundingClientRect(), d = n - c.left, v = r - c.top, b = d / this.settings.el.clientWidth, y = v / this.settings.el.clientHeight;
      this.boundingBox && this.boundingBox.setPosition(b, y, c), this.settings.zoomPane.setPosition(b, y, c);
    } }, { key: "isShowing", get: function() {
      return this.settings.zoomPane.isShowing;
    } }]), t;
  })();
  function Vv(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Wv(t, e) {
    for (var i = 0; i < e.length; i++) {
      var n = e[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(t, n.key, n);
    }
  }
  function Fv(t, e, i) {
    return e && Wv(t.prototype, e), Object.defineProperty(t, "prototype", { writable: false }), t;
  }
  var Gv = (function() {
    function t() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (Vv(this, t), this.HAS_ANIMATION = false, typeof document != "undefined") {
        var i = document.createElement("div").style;
        this.HAS_ANIMATION = "animation" in i || "webkitAnimation" in i;
      }
      this._completeShow = this._completeShow.bind(this), this._completeHide = this._completeHide.bind(this), this._handleLoad = this._handleLoad.bind(this), this.isShowing = false;
      var n = e.container, r = n === void 0 ? null : n, o = e.zoomFactor, l = o === void 0 ? Ve() : o, c = e.inline, d = c === void 0 ? Ve() : c, v = e.namespace, b = v === void 0 ? null : v, y = e.showWhitespaceAtEdges, _ = y === void 0 ? Ve() : y, p = e.containInline, m = p === void 0 ? Ve() : p, C = e.inlineOffsetX, S = C === void 0 ? 0 : C, h = e.inlineOffsetY, E = h === void 0 ? 0 : h, I = e.inlineContainer, O = I === void 0 ? document.body : I;
      this.settings = { container: r, zoomFactor: l, inline: d, namespace: b, showWhitespaceAtEdges: _, containInline: m, inlineOffsetX: S, inlineOffsetY: E, inlineContainer: O }, this.openClasses = this._buildClasses("open"), this.openingClasses = this._buildClasses("opening"), this.closingClasses = this._buildClasses("closing"), this.inlineClasses = this._buildClasses("inline"), this.loadingClasses = this._buildClasses("loading"), this._buildElement();
    }
    return Fv(t, [{ key: "_buildClasses", value: function(i) {
      var n = ["drift-".concat(i)], r = this.settings.namespace;
      return r && n.push("".concat(r, "-").concat(i)), n;
    } }, { key: "_buildElement", value: function() {
      this.el = document.createElement("div"), St(this.el, this._buildClasses("zoom-pane"));
      var i = document.createElement("div");
      St(i, this._buildClasses("zoom-pane-loader")), this.el.appendChild(i), this.imgEl = document.createElement("img"), this.el.appendChild(this.imgEl);
    } }, { key: "_setImageURL", value: function(i) {
      this.imgEl.setAttribute("src", i);
    } }, { key: "_setImageSize", value: function(i, n) {
      this.imgEl.style.width = "".concat(i * this.settings.zoomFactor, "px"), this.imgEl.style.height = "".concat(n * this.settings.zoomFactor, "px");
    } }, { key: "setPosition", value: function(i, n, r) {
      var o = this.imgEl.offsetWidth, l = this.imgEl.offsetHeight, c = this.el.offsetWidth, d = this.el.offsetHeight, v = c / 2, b = d / 2, y = o * i, _ = l * n, p = v - y, m = b - _, C = c - o, S = d - l, h = C > 0, E = S > 0, I = h ? C / 2 : 0, O = E ? S / 2 : 0, L = h ? C / 2 : C, f = E ? S / 2 : S;
      if (this.el.parentElement === this.settings.inlineContainer) {
        var P = window.pageXOffset, D = window.pageYOffset, H = r.left + i * r.width - c / 2 + this.settings.inlineOffsetX + P, k = r.top + n * r.height - d / 2 + this.settings.inlineOffsetY + D;
        this.settings.containInline && (H < r.left + P ? H = r.left + P : H + c > r.left + r.width + P && (H = r.left + r.width - c + P), k < r.top + D ? k = r.top + D : k + d > r.top + r.height + D && (k = r.top + r.height - d + D)), this.el.style.left = "".concat(H, "px"), this.el.style.top = "".concat(k, "px");
      }
      this.settings.showWhitespaceAtEdges || (p > I ? p = I : p < L && (p = L), m > O ? m = O : m < f && (m = f)), this.imgEl.style.transform = "translate(".concat(p, "px, ").concat(m, "px)"), this.imgEl.style.webkitTransform = "translate(".concat(p, "px, ").concat(m, "px)");
    } }, { key: "_removeListenersAndResetClasses", value: function() {
      this.el.removeEventListener("animationend", this._completeShow), this.el.removeEventListener("animationend", this._completeHide), this.el.removeEventListener("webkitAnimationEnd", this._completeShow), this.el.removeEventListener("webkitAnimationEnd", this._completeHide), gt(this.el, this.openClasses), gt(this.el, this.closingClasses);
    } }, { key: "show", value: function(i, n, r) {
      this._removeListenersAndResetClasses(), this.isShowing = true, St(this.el, this.openClasses), this.imgEl.getAttribute("src") != i && (St(this.el, this.loadingClasses), this.imgEl.addEventListener("load", this._handleLoad), this._setImageURL(i)), this._setImageSize(n, r), this._isInline ? this._showInline() : this._showInContainer(), this.HAS_ANIMATION && (this.el.addEventListener("animationend", this._completeShow), this.el.addEventListener("webkitAnimationEnd", this._completeShow), St(this.el, this.openingClasses));
    } }, { key: "_showInline", value: function() {
      this.settings.inlineContainer.appendChild(this.el), St(this.el, this.inlineClasses);
    } }, { key: "_showInContainer", value: function() {
      this.settings.container.appendChild(this.el);
    } }, { key: "hide", value: function() {
      this._removeListenersAndResetClasses(), this.isShowing = false, this.HAS_ANIMATION ? (this.el.addEventListener("animationend", this._completeHide), this.el.addEventListener("webkitAnimationEnd", this._completeHide), St(this.el, this.closingClasses)) : (gt(this.el, this.openClasses), gt(this.el, this.inlineClasses));
    } }, { key: "_completeShow", value: function() {
      this.el.removeEventListener("animationend", this._completeShow), this.el.removeEventListener("webkitAnimationEnd", this._completeShow), gt(this.el, this.openingClasses);
    } }, { key: "_completeHide", value: function() {
      this.el.removeEventListener("animationend", this._completeHide), this.el.removeEventListener("webkitAnimationEnd", this._completeHide), gt(this.el, this.openClasses), gt(this.el, this.closingClasses), gt(this.el, this.inlineClasses), this.el.style.left = "", this.el.style.top = "", this.el.parentElement === this.settings.container ? this.settings.container.removeChild(this.el) : this.el.parentElement === this.settings.inlineContainer && this.settings.inlineContainer.removeChild(this.el);
    } }, { key: "_handleLoad", value: function() {
      this.imgEl.removeEventListener("load", this._handleLoad), gt(this.el, this.loadingClasses);
    } }, { key: "_isInline", get: function() {
      var i = this.settings.inline;
      return i === true || typeof i == "number" && window.innerWidth <= i;
    } }]), t;
  })();
  function jv(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Yv(t, e) {
    for (var i = 0; i < e.length; i++) {
      var n = e[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(t, n.key, n);
    }
  }
  function Xv(t, e, i) {
    return e && Yv(t.prototype, e), Object.defineProperty(t, "prototype", { writable: false }), t;
  }
  var lt = (function() {
    function t(e) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (jv(this, t), this.VERSION = "1.5.1", this.triggerEl = e, this.destroy = this.destroy.bind(this), !tr(this.triggerEl)) throw new TypeError("`new Drift` requires a DOM element as its first argument.");
      var n = i.namespace || null, r = i.showWhitespaceAtEdges || false, o = i.containInline || false, l = i.inlineOffsetX || 0, c = i.inlineOffsetY || 0, d = i.inlineContainer || document.body, v = i.sourceAttribute || "data-zoom", b = i.zoomFactor || 3, y = i.paneContainer === void 0 ? document.body : i.paneContainer, _ = i.inlinePane || 375, p = "handleTouch" in i ? !!i.handleTouch : true, m = i.onShow || null, C = i.onHide || null, S = "injectBaseStyles" in i ? !!i.injectBaseStyles : true, h = i.hoverDelay || 0, E = i.touchDelay || 0, I = i.hoverBoundingBox || false, O = i.touchBoundingBox || false, L = i.boundingBoxContainer || document.body, f = i.passive || false;
      if (_ !== true && !tr(y)) throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
      if (!tr(d)) throw new TypeError("`inlineContainer` must be a DOM element");
      this.settings = { namespace: n, showWhitespaceAtEdges: r, containInline: o, inlineOffsetX: l, inlineOffsetY: c, inlineContainer: d, sourceAttribute: v, zoomFactor: b, paneContainer: y, inlinePane: _, handleTouch: p, onShow: m, onHide: C, injectBaseStyles: S, hoverDelay: h, touchDelay: E, hoverBoundingBox: I, touchBoundingBox: O, boundingBoxContainer: L, passive: f }, this.settings.injectBaseStyles && Pv(), this._buildZoomPane(), this._buildTrigger();
    }
    return Xv(t, [{ key: "_buildZoomPane", value: function() {
      this.zoomPane = new Gv({ container: this.settings.paneContainer, zoomFactor: this.settings.zoomFactor, showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges, containInline: this.settings.containInline, inline: this.settings.inlinePane, namespace: this.settings.namespace, inlineOffsetX: this.settings.inlineOffsetX, inlineOffsetY: this.settings.inlineOffsetY, inlineContainer: this.settings.inlineContainer });
    } }, { key: "_buildTrigger", value: function() {
      this.trigger = new Bv({ el: this.triggerEl, zoomPane: this.zoomPane, handleTouch: this.settings.handleTouch, onShow: this.settings.onShow, onHide: this.settings.onHide, sourceAttribute: this.settings.sourceAttribute, hoverDelay: this.settings.hoverDelay, touchDelay: this.settings.touchDelay, hoverBoundingBox: this.settings.hoverBoundingBox, touchBoundingBox: this.settings.touchBoundingBox, namespace: this.settings.namespace, zoomFactor: this.settings.zoomFactor, boundingBoxContainer: this.settings.boundingBoxContainer, passive: this.settings.passive });
    } }, { key: "setZoomImageURL", value: function(i) {
      this.zoomPane._setImageURL(i);
    } }, { key: "disable", value: function() {
      this.trigger.enabled = false;
    } }, { key: "enable", value: function() {
      this.trigger.enabled = true;
    } }, { key: "destroy", value: function() {
      this.trigger._hide(), this.trigger._unbindEvents();
    } }, { key: "isShowing", get: function() {
      return this.zoomPane.isShowing;
    } }, { key: "zoomFactor", get: function() {
      return this.settings.zoomFactor;
    }, set: function(i) {
      this.settings.zoomFactor = i, this.zoomPane.settings.zoomFactor = i, this.trigger.settings.zoomFactor = i, this.boundingBox.settings.zoomFactor = i;
    } }]), t;
  })();
  Object.defineProperty(lt.prototype, "isShowing", { get: function() {
    return this.isShowing;
  } });
  Object.defineProperty(lt.prototype, "zoomFactor", { get: function() {
    return this.zoomFactor;
  }, set: function(e) {
    this.zoomFactor = e;
  } });
  lt.prototype.setZoomImageURL = lt.prototype.setZoomImageURL;
  lt.prototype.disable = lt.prototype.disable;
  lt.prototype.enable = lt.prototype.enable;
  lt.prototype.destroy = lt.prototype.destroy;
  window.Drift = lt;
})();
